{
  "level": "mt12",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt12",
    "objects": "AREAS.E3:mt12.e3",
    "mesh": "TREES.E3:mt12.e3"
  },
  "spawn_point": {
    "position": [
      -393.3248045751226,
      -2096.747839007461,
      24.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -393.3248045751226,
      -1996.7478390074612,
      24.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -4205.05908203125,
      -3796.41357421875,
      0.0
    ],
    "bbox_max": [
      435.65338134765625,
      -1766.85400390625,
      1757.6214599609375
    ],
    "vertex_count": 2736,
    "vertices": [
      [
        -3714.02392578125,
        -2323.554931640625,
        1179.126953125
      ],
      [
        -4000.395751953125,
        -3169.967041015625,
        1401.26220703125
      ],
      [
        -3953.776123046875,
        -3271.534912109375,
        1398.1876220703125
      ],
      [
        -4204.98828125,
        -2619.663330078125,
        1400.3001708984375
      ],
      [
        -4000.395751953125,
        -3169.967041015625,
        1401.26220703125
      ],
      [
        -3861.128173828125,
        -3360.06591796875,
        1376.4132080078125
      ],
      [
        -3953.776123046875,
        -3271.534912109375,
        1398.1876220703125
      ],
      [
        -3790.39453125,
        -2416.412353515625,
        1220.0
      ],
      [
        -3902.9365234375,
        -2462.454833984375,
        1267.6805419921875
      ],
      [
        -3902.9365234375,
        -2462.454833984375,
        1267.6805419921875
      ],
      [
        -4205.05908203125,
        -2619.064208984375,
        1400.243408203125
      ],
      [
        -3614.939453125,
        -3588.4169921875,
        1317.599365234375
      ],
      [
        -3861.128173828125,
        -3360.06591796875,
        1376.4132080078125
      ],
      [
        -3685.231201171875,
        -2364.646728515625,
        1174.237060546875
      ],
      [
        -3714.02392578125,
        -2323.554931640625,
        1179.126953125
      ],
      [
        -3685.231201171875,
        -2364.646728515625,
        1174.237060546875
      ],
      [
        -3699.87890625,
        -2376.406982421875,
        1181.2401123046875
      ],
      [
        -3699.87890625,
        -2376.406982421875,
        1181.2401123046875
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.5367431640625
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.5367431640625
      ],
      [
        -3288.09619140625,
        -2864.23095703125,
        735.013427734375
      ],
      [
        -3452.950927734375,
        -2668.90283203125,
        984.034423828125
      ],
      [
        -3662.39306640625,
        -2424.958984375,
        1174.1900634765625
      ],
      [
        -3662.39306640625,
        -2424.958984375,
        1174.1900634765625
      ],
      [
        -3452.950927734375,
        -2668.90283203125,
        984.034423828125
      ],
      [
        -3547.5966796875,
        -2561.07373046875,
        1150.8623046875
      ],
      [
        -3288.09619140625,
        -2864.23095703125,
        735.013427734375
      ],
      [
        -3348.958251953125,
        -2753.041015625,
        610.7307739257812
      ],
      [
        -3348.958251953125,
        -2753.041015625,
        610.7307739257812
      ],
      [
        -3070.88916015625,
        -3126.308349609375,
        1053.9906005859375
      ],
      [
        -3299.01806640625,
        -2844.277587890625,
        712.7105102539062
      ],
      [
        -567.1976928710938,
        -2150.822998046875,
        0.0
      ],
      [
        -648.268798828125,
        -1935.5194091796875,
        0.0
      ],
      [
        -659.8515014648438,
        -2403.476806640625,
        68.94024658203125
      ],
      [
        -694.7417602539062,
        -2341.75634765625,
        73.2170639038086
      ],
      [
        -704.1276245117188,
        -2329.093994140625,
        74.912353515625
      ],
      [
        -736.9667358398438,
        -2295.76318359375,
        82.36070251464844
      ],
      [
        -736.9667358398438,
        -2295.76318359375,
        82.3607177734375
      ],
      [
        -739.388427734375,
        -2289.004638671875,
        82.31546020507812
      ],
      [
        -699.4265747070312,
        -2333.46923828125,
        73.79135131835938
      ],
      [
        -704.1276245117188,
        -2329.093994140625,
        74.91236877441406
      ],
      [
        -699.1730346679688,
        -2333.705078125,
        73.73089599609375
      ],
      [
        -694.7417602539062,
        -2341.75634765625,
        73.21707153320312
      ],
      [
        -699.1730346679688,
        -2333.705078125,
        73.73089599609375
      ],
      [
        -659.8515014648438,
        -2403.476806640625,
        68.94023895263672
      ],
      [
        -645.88818359375,
        -2424.544921875,
        66.72640991210938
      ],
      [
        -508.6903991699219,
        -2419.84619140625,
        15.709417343139648
      ],
      [
        -508.5000305175781,
        -2419.364501953125,
        15.57293701171875
      ],
      [
        -4203.63427734375,
        -2623.38720703125,
        1400.5242919921875
      ],
      [
        -3970.641357421875,
        -3262.205078125,
        1433.9918212890625
      ],
      [
        -3699.880615234375,
        -3544.43603515625,
        1424.3941650390625
      ],
      [
        -3956.019775390625,
        -3286.26123046875,
        1434.4024658203125
      ],
      [
        -3699.20947265625,
        -2378.998046875,
        1181.5616455078125
      ],
      [
        -3956.019775390625,
        -3286.26123046875,
        1434.4024658203125
      ],
      [
        -3963.7255859375,
        -3278.16796875,
        1434.669189453125
      ],
      [
        -3970.641357421875,
        -3262.205078125,
        1433.9918212890625
      ],
      [
        -3963.7255859375,
        -3278.16796875,
        1434.669189453125
      ],
      [
        -3697.77392578125,
        -2384.5537109375,
        1182.2510986328125
      ],
      [
        -3697.77392578125,
        -2384.5537109375,
        1182.2510986328125
      ],
      [
        -3702.43359375,
        -2378.32275390625,
        1210.5433349609375
      ],
      [
        -3702.43359375,
        -2378.32275390625,
        1210.5433349609375
      ],
      [
        -3703.786865234375,
        -2376.991455078125,
        1220.0
      ],
      [
        -3698.14501953125,
        -2382.568603515625,
        1181.455322265625
      ],
      [
        -3698.34423828125,
        -2382.34619140625,
        1181.9771728515625
      ],
      [
        -362.50360107421875,
        -2639.890625,
        844.1766357421875
      ],
      [
        -351.6813049316406,
        -2614.744873046875,
        839.954345703125
      ],
      [
        -24.536930084228516,
        -3165.64599609375,
        850.4774169921875
      ],
      [
        161.8573760986328,
        -3463.04833984375,
        854.7364501953125
      ],
      [
        -55.04106140136719,
        -3144.068603515625,
        852.6356201171875
      ],
      [
        -233.4002685546875,
        -3018.20361328125,
        865.2860107421875
      ],
      [
        196.0666046142578,
        -3518.638427734375,
        855.624267578125
      ],
      [
        161.8573760986328,
        -3463.04833984375,
        854.7364501953125
      ],
      [
        -24.536930084228516,
        -3165.64599609375,
        850.4774780273438
      ],
      [
        -55.04105758666992,
        -3144.068603515625,
        852.6356201171875
      ],
      [
        263.3183288574219,
        -3738.829833984375,
        869.05712890625
      ],
      [
        284.8452453613281,
        -3742.4970703125,
        866.31591796875
      ],
      [
        -392.1393737792969,
        -2833.755615234375,
        868.912109375
      ],
      [
        -439.5000305175781,
        -2818.79248046875,
        874.2164306640625
      ],
      [
        -485.4504089355469,
        -2801.845947265625,
        696.4218139648438
      ],
      [
        -352.2469787597656,
        -2848.093017578125,
        864.626953125
      ],
      [
        -392.1393737792969,
        -2833.755615234375,
        868.912109375
      ],
      [
        -326.8922119140625,
        -2904.17919921875,
        866.8536376953125
      ],
      [
        -352.2469787597656,
        -2848.093017578125,
        864.626953125
      ],
      [
        -318.19537353515625,
        -2926.5478515625,
        867.947265625
      ],
      [
        -326.8922119140625,
        -2904.17919921875,
        866.8536376953125
      ],
      [
        -315.3895263671875,
        -2929.62353515625,
        867.8637084960938
      ],
      [
        -318.19537353515625,
        -2926.5478515625,
        867.947265625
      ],
      [
        -257.3710632324219,
        -2993.223876953125,
        866.1363525390625
      ],
      [
        -233.4002685546875,
        -3018.20361328125,
        865.2859497070312
      ],
      [
        -257.3710632324219,
        -2993.223876953125,
        866.1363525390625
      ],
      [
        -485.4504089355469,
        -2801.845947265625,
        696.4218139648438
      ],
      [
        -494.71826171875,
        -2772.468017578125,
        619.49169921875
      ],
      [
        -508.76104736328125,
        -2729.926025390625,
        506.04541015625
      ],
      [
        -494.71826171875,
        -2772.468017578125,
        619.49169921875
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        623.6862182617188
      ],
      [
        -105.300048828125,
        -2181.199951171875,
        622.6664428710938
      ],
      [
        -66.12939453125,
        -2138.030517578125,
        618.63818359375
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        620.4703369140625
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        623.762939453125
      ],
      [
        -105.2154541015625,
        -2059.421630859375,
        624.7360229492188
      ],
      [
        -105.2154541015625,
        -2059.421630859375,
        618.412841796875
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        624.461181640625
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        623.0650024414062
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        618.5244140625
      ],
      [
        -92.5,
        -2071.60009765625,
        623.2898559570312
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        623.3185424804688
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        622.0928955078125
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        623.4249877929688
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        620.4703369140625
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        622.0928955078125
      ],
      [
        -92.5,
        -2138.245849609375,
        622.3040161132812
      ],
      [
        -92.20442199707031,
        -2136.069580078125,
        618.5244140625
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        622.3348388671875
      ],
      [
        -91.10107421875,
        -2081.89990234375,
        623.3673095703125
      ],
      [
        -91.25299072265625,
        -2080.781494140625,
        623.4108276367188
      ],
      [
        -91.10107421875,
        -2127.946044921875,
        622.4420776367188
      ],
      [
        -91.18179321289062,
        -2128.540283203125,
        622.4413452148438
      ],
      [
        -91.10107421875,
        -2127.946044921875,
        622.4420776367188
      ],
      [
        -89.30126953125,
        -2127.946044921875,
        622.1928100585938
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        624.461181640625
      ],
      [
        -105.22237396240234,
        -2069.38525390625,
        618.412841796875
      ],
      [
        -105.22237396240234,
        -2069.38525390625,
        625.0650024414062
      ],
      [
        -105.2717514038086,
        -2140.4697265625,
        618.412841796875
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        623.4249877929688
      ],
      [
        -105.2717514038086,
        -2140.4697265625,
        624.0093994140625
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        624.7501831054688
      ],
      [
        -109.34033203125,
        -2064.5546875,
        625.504150390625
      ],
      [
        -109.34033203125,
        -2064.5546875,
        625.504150390625
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        625.3372802734375
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        625.3372802734375
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        624.4166259765625
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        623.6862182617188
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        624.2633666992188
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        624.4166259765625
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        624.2633666992188
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        624.7501831054688
      ],
      [
        26.906936645507812,
        -2132.77880859375,
        606.0013427734375
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        623.95703125
      ],
      [
        -105.300048828125,
        -2181.199951171875,
        623.3385620117188
      ],
      [
        -66.12939453125,
        -2138.030517578125,
        618.7809448242188
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        620.623779296875
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        622.1810302734375
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        623.5617065429688
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        620.623779296875
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        622.1810302734375
      ],
      [
        -92.5,
        -2138.245849609375,
        622.4288940429688
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        622.3347778320312
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        622.4317016601562
      ],
      [
        -91.47808074951172,
        -2130.7216796875,
        622.4104614257812
      ],
      [
        -91.48384094238281,
        -2130.76416015625,
        622.4384765625
      ],
      [
        -105.2717514038086,
        -2140.4697265625,
        624.0093994140625
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        623.5617065429688
      ],
      [
        -105.2717514038086,
        -2140.4697265625,
        624.153076171875
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        624.61962890625
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        623.95703125
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        624.4100341796875
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        624.61962890625
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        624.4100341796875
      ],
      [
        27.273828506469727,
        -2132.59033203125,
        605.9542846679688
      ],
      [
        26.906936645507812,
        -2132.77880859375,
        606.0013427734375
      ],
      [
        27.273826599121094,
        -2132.59033203125,
        605.9542846679688
      ],
      [
        149.87228393554688,
        -2063.799072265625,
        590.357177734375
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        625.3842163085938
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        625.7794799804688
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        624.9579467773438
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        623.4006958007812
      ],
      [
        -92.5,
        -2071.60009765625,
        623.7680053710938
      ],
      [
        -92.20443725585938,
        -2073.7763671875,
        623.683349609375
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        623.3185424804688
      ],
      [
        -108.26380157470703,
        -2066.781005859375,
        626.048095703125
      ],
      [
        -108.0561752319336,
        -2067.21044921875,
        626.0107421875
      ],
      [
        -108.0561752319336,
        -2067.21044921875,
        625.405029296875
      ],
      [
        -108.26380157470703,
        -2066.781005859375,
        625.4210815429688
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        624.9579467773438
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        625.8526000976562
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        625.8526000976562
      ],
      [
        -91.76782989501953,
        -2076.990966796875,
        623.5582885742188
      ],
      [
        -91.75545501708984,
        -2077.08203125,
        623.362060546875
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        625.7794799804688
      ],
      [
        -109.34033203125,
        -2064.5546875,
        626.241943359375
      ],
      [
        -109.34033203125,
        -2064.5546875,
        626.241943359375
      ],
      [
        149.87228393554688,
        -2063.799072265625,
        590.357177734375
      ],
      [
        -103.1811294555664,
        -2002.6787109375,
        688.1463012695312
      ],
      [
        -83.94761657714844,
        -1974.324462890625,
        706.4854125976562
      ],
      [
        -147.53836059570312,
        -2059.9091796875,
        632.9395751953125
      ],
      [
        -124.3460693359375,
        -2031.221435546875,
        663.7589111328125
      ],
      [
        -96.97359466552734,
        -2047.9700927734375,
        652.5131225585938
      ],
      [
        -98.16727447509766,
        -1998.9012451171875,
        690.3648681640625
      ],
      [
        -97.80713653564453,
        -2033.1209716796875,
        666.0712890625
      ],
      [
        -96.92050170898438,
        -2047.3251953125,
        652.7044067382812
      ],
      [
        -90.278564453125,
        -2045.857666015625,
        653.890380859375
      ],
      [
        -96.99674224853516,
        -2047.5574951171875,
        652.889892578125
      ],
      [
        -85.1344985961914,
        -2046.704833984375,
        652.7044067382812
      ],
      [
        -90.278564453125,
        -2045.857666015625,
        653.890380859375
      ],
      [
        -91.76782989501953,
        -2076.99072265625,
        623.5582885742188
      ],
      [
        -92.5,
        -2071.60009765625,
        630.682861328125
      ],
      [
        -92.00621032714844,
        -2075.235595703125,
        627.3399658203125
      ],
      [
        -92.20442199707031,
        -2073.7763671875,
        628.6817016601562
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        627.8010864257812
      ],
      [
        -92.20443725585938,
        -2073.7763671875,
        623.6834716796875
      ],
      [
        -95.60404205322266,
        -2072.3681640625,
        630.2362670898438
      ],
      [
        -94.2827377319336,
        -2072.91552734375,
        623.9885864257812
      ],
      [
        -103.1811294555664,
        -2002.6787109375,
        688.1463012695312
      ],
      [
        -114.53120422363281,
        -2019.0810546875,
        676.8016357421875
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        651.9237060546875
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        642.64306640625
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        632.6511840820312
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        634.2090454101562
      ],
      [
        -108.26380157470703,
        -2066.781005859375,
        636.3370361328125
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        634.2090454101562
      ],
      [
        -108.26380157470703,
        -2066.781005859375,
        626.048095703125
      ],
      [
        -98.24224853515625,
        -2047.8726806640625,
        652.7044067382812
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        632.6511840820312
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        642.64306640625
      ],
      [
        -109.34033203125,
        -2064.5546875,
        638.4468383789062
      ],
      [
        -109.34033203125,
        -2064.5546875,
        638.4468383789062
      ],
      [
        -147.53836059570312,
        -2059.9091796875,
        632.9395751953125
      ],
      [
        -154.93328857421875,
        -2075.052734375,
        632.599609375
      ],
      [
        -119.8541488647461,
        -2026.7733154296875,
        671.481201171875
      ],
      [
        -119.8541488647461,
        -2026.7733154296875,
        671.481201171875
      ],
      [
        -124.34606170654297,
        -2031.221435546875,
        663.7589111328125
      ],
      [
        -83.94761657714844,
        -1974.324462890625,
        706.4854125976562
      ],
      [
        -80.52005767822266,
        -1974.461669921875,
        717.9649047851562
      ],
      [
        -98.77880096435547,
        -1997.3214111328125,
        694.1359252929688
      ],
      [
        -99.6484375,
        -2000.3193359375,
        696.0213623046875
      ],
      [
        -76.1886215209961,
        -1974.6351318359375,
        732.4716186523438
      ],
      [
        31.66730499267578,
        -2009.6890869140625,
        720.4949951171875
      ],
      [
        31.66730499267578,
        -2009.6890869140625,
        720.4949951171875
      ],
      [
        43.42918395996094,
        -2015.640380859375,
        719.4132080078125
      ],
      [
        -107.84963989257812,
        -2028.5911865234375,
        713.8018798828125
      ],
      [
        -98.96548461914062,
        -2058.040283203125,
        665.5609741210938
      ],
      [
        -107.84963989257812,
        -2028.5911865234375,
        713.8018798828125
      ],
      [
        -103.80906677246094,
        -2029.1715087890625,
        727.9965209960938
      ],
      [
        -80.69474792480469,
        -2059.564208984375,
        657.7044067382812
      ],
      [
        -98.35603332519531,
        -2061.6728515625,
        657.7044067382812
      ],
      [
        -96.99674224853516,
        -2047.5574951171875,
        652.889892578125
      ],
      [
        -98.30574798583984,
        -2051.547119140625,
        656.0746459960938
      ],
      [
        -98.30574798583984,
        -2051.547119140625,
        656.0746459960938
      ],
      [
        -96.63316345214844,
        -2071.94189453125,
        635.4951171875
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        628.3058471679688
      ],
      [
        -95.60404205322266,
        -2072.3681640625,
        630.2362670898438
      ],
      [
        -96.68566131591797,
        -2071.920166015625,
        635.3507080078125
      ],
      [
        -92.5,
        -2071.60009765625,
        635.1734008789062
      ],
      [
        -92.20441436767578,
        -2073.7763671875,
        630.4842529296875
      ],
      [
        -92.20441436767578,
        -2073.7763671875,
        628.6817626953125
      ],
      [
        -98.96705627441406,
        -2061.745849609375,
        657.7044067382812
      ],
      [
        -100.01698303222656,
        -2062.45703125,
        656.4622192382812
      ],
      [
        -98.96705627441406,
        -2061.745849609375,
        657.7044067382812
      ],
      [
        -96.74231719970703,
        -2071.896728515625,
        635.6185913085938
      ],
      [
        -155.26504516601562,
        -2075.732177734375,
        632.5843505859375
      ],
      [
        -157.4827117919922,
        -2080.4765625,
        632.803466796875
      ],
      [
        -155.26504516601562,
        -2075.732177734375,
        632.5843505859375
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        640.3057250976562
      ],
      [
        -107.14860534667969,
        -2069.031982421875,
        644.3267211914062
      ],
      [
        -103.19319152832031,
        -2064.608642578125,
        652.7044067382812
      ],
      [
        -105.54733276367188,
        -2067.07861328125,
        648.0633544921875
      ],
      [
        -108.26380157470703,
        -2066.781005859375,
        644.2874145507812
      ],
      [
        -108.26380157470703,
        -2066.781005859375,
        636.3370361328125
      ],
      [
        -103.19319152832031,
        -2064.608642578125,
        652.7044067382812
      ],
      [
        -107.14860534667969,
        -2069.031982421875,
        644.3267211914062
      ],
      [
        -108.26380157470703,
        -2066.781005859375,
        644.2874145507812
      ],
      [
        -107.77347564697266,
        -2065.597412109375,
        645.8472290039062
      ],
      [
        -105.54733276367188,
        -2067.07861328125,
        648.0633544921875
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        640.3057250976562
      ],
      [
        -54.30730056762695,
        -2189.92578125,
        751.9800415039062
      ],
      [
        108.4993896484375,
        -2158.119384765625,
        724.9736938476562
      ],
      [
        115.1250991821289,
        -2156.200927734375,
        723.808837890625
      ],
      [
        110.78500366210938,
        -2156.85595703125,
        724.5084228515625
      ],
      [
        108.4993896484375,
        -2158.119384765625,
        724.9736938476562
      ],
      [
        110.78500366210938,
        -2156.85595703125,
        724.5084228515625
      ],
      [
        -137.87796020507812,
        -2165.193115234375,
        660.0780029296875
      ],
      [
        -133.8499755859375,
        -2167.284912109375,
        669.0949096679688
      ],
      [
        -95.86370849609375,
        -2187.012451171875,
        754.1383056640625
      ],
      [
        -84.30427551269531,
        -2188.33935546875,
        756.1712646484375
      ],
      [
        -94.33013153076172,
        -2187.80908203125,
        757.572021484375
      ],
      [
        -133.8499755859375,
        -2167.284912109375,
        669.0949096679688
      ],
      [
        -95.86370849609375,
        -2187.012451171875,
        754.1383056640625
      ],
      [
        -84.30427551269531,
        -2188.33935546875,
        756.1712646484375
      ],
      [
        -54.30730056762695,
        -2189.92578125,
        751.9800415039062
      ],
      [
        -138.92935180664062,
        -2164.698486328125,
        657.9076538085938
      ],
      [
        -137.87796020507812,
        -2165.193115234375,
        660.0780029296875
      ],
      [
        -105.28976440429688,
        -2166.400146484375,
        652.7044067382812
      ],
      [
        -105.28595733642578,
        -2160.9189453125,
        623.7440795898438
      ],
      [
        -99.88549041748047,
        -2167.778076171875,
        657.7044067382812
      ],
      [
        -99.88970184326172,
        -2171.7001953125,
        677.7044067382812
      ],
      [
        -80.69756317138672,
        -2173.240966796875,
        677.7044067382812
      ],
      [
        -99.88970184326172,
        -2171.7001953125,
        677.7044067382812
      ],
      [
        -81.60009765625,
        -2169.029541015625,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2167.647705078125,
        656.5999755859375
      ],
      [
        -102.34300994873047,
        -2167.15185546875,
        655.4332885742188
      ],
      [
        -105.28976440429688,
        -2166.400146484375,
        652.7044067382812
      ],
      [
        -99.88549041748047,
        -2167.778076171875,
        657.7044067382812
      ],
      [
        -102.34300994873047,
        -2167.15185546875,
        655.4332885742188
      ],
      [
        -139.03753662109375,
        -2164.591064453125,
        657.4825439453125
      ],
      [
        -138.92935180664062,
        -2164.698486328125,
        657.9076538085938
      ],
      [
        -105.28579711914062,
        -2160.685546875,
        623.748779296875
      ],
      [
        -105.28959655761719,
        -2166.156982421875,
        651.650146484375
      ],
      [
        -98.89990234375,
        -2167.640869140625,
        656.5999755859375
      ],
      [
        -102.34597778320312,
        -2167.134765625,
        655.4305419921875
      ],
      [
        -105.28974151611328,
        -2166.36376953125,
        652.7044067382812
      ],
      [
        -101.08056640625,
        -2167.4736328125,
        656.5999755859375
      ],
      [
        -102.34597778320312,
        -2167.134765625,
        655.4305419921875
      ],
      [
        -101.08056640625,
        -2167.465576171875,
        656.5999755859375
      ],
      [
        -105.28974151611328,
        -2166.36376953125,
        652.7044067382812
      ],
      [
        -139.03756713867188,
        -2164.591064453125,
        657.4825439453125
      ],
      [
        -70.35136413574219,
        -2150.10498046875,
        631.6541748046875
      ],
      [
        -105.28959655761719,
        -2166.156005859375,
        651.6453247070312
      ],
      [
        -105.2795181274414,
        -2151.646240234375,
        623.9295654296875
      ],
      [
        -105.2835693359375,
        -2157.47216796875,
        644.7898559570312
      ],
      [
        26.063024520874023,
        -2132.764404296875,
        606.1185302734375
      ],
      [
        -70.35136413574219,
        -2150.10498046875,
        631.6541748046875
      ],
      [
        -99.877685546875,
        -2160.506591796875,
        657.7044067382812
      ],
      [
        -99.88368225097656,
        -2166.092529296875,
        677.7044067382812
      ],
      [
        -80.69480895996094,
        -2164.060546875,
        677.7044067382812
      ],
      [
        -99.88368225097656,
        -2166.092529296875,
        677.7044067382812
      ],
      [
        -81.60009765625,
        -2158.262451171875,
        656.5999755859375
      ],
      [
        -98.89990234375,
        -2160.094482421875,
        656.5999755859375
      ],
      [
        -105.28510284423828,
        -2159.6826171875,
        652.7044067382812
      ],
      [
        -103.59712219238281,
        -2159.9404296875,
        654.2674560546875
      ],
      [
        -105.28510284423828,
        -2159.6826171875,
        652.7044067382812
      ],
      [
        -99.877685546875,
        -2160.506591796875,
        657.7044067382812
      ],
      [
        -103.59712219238281,
        -2159.9404296875,
        654.2674560546875
      ],
      [
        115.1250991821289,
        -2156.200927734375,
        723.808837890625
      ],
      [
        138.8248291015625,
        -2079.12548828125,
        712.2431640625
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        636.99072265625
      ],
      [
        -105.2828140258789,
        -2156.387451171875,
        640.90576171875
      ],
      [
        -66.12939453125,
        -2138.030517578125,
        623.2932739257812
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        626.367431640625
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        625.1433715820312
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        629.5436401367188
      ],
      [
        -79.672119140625,
        -2139.665283203125,
        626.367431640625
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        625.1433715820312
      ],
      [
        -92.5,
        -2138.245849609375,
        627.3795776367188
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        622.4317016601562
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        625.9423828125
      ],
      [
        -105.2717514038086,
        -2140.4697265625,
        624.153076171875
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        629.5436401367188
      ],
      [
        -105.2717514038086,
        -2140.4697265625,
        630.7153930664062
      ],
      [
        -91.48381042480469,
        -2130.763916015625,
        622.4384765625
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        634.4107666015625
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        636.99072265625
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        631.224609375
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        634.4107666015625
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        631.224609375
      ],
      [
        138.8248291015625,
        -2079.12548828125,
        712.2431640625
      ],
      [
        126.47466278076172,
        -2057.659423828125,
        711.775390625
      ],
      [
        126.47466278076172,
        -2057.659423828125,
        711.775390625
      ],
      [
        -160.2327880859375,
        -2184.0478515625,
        766.7507934570312
      ],
      [
        -166.15965270996094,
        -2183.68359375,
        767.5735473632812
      ],
      [
        -175.79905700683594,
        -2173.636962890625,
        720.0060424804688
      ],
      [
        -137.9745330810547,
        -2185.415771484375,
        763.6610107421875
      ],
      [
        -160.2327880859375,
        -2184.0478515625,
        766.7507934570312
      ],
      [
        -175.79905700683594,
        -2173.636962890625,
        720.0060424804688
      ],
      [
        -179.54037475585938,
        -2169.73779296875,
        701.5438232421875
      ],
      [
        -137.9745330810547,
        -2185.415771484375,
        763.6610107421875
      ],
      [
        -128.04714965820312,
        -2186.02587890625,
        762.282958984375
      ],
      [
        -95.67296600341797,
        -2187.738037109375,
        757.7596435546875
      ],
      [
        -128.04714965820312,
        -2186.02587890625,
        762.282958984375
      ],
      [
        -95.67296600341797,
        -2187.738037109375,
        757.7596435546875
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        636.0255737304688
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        639.1056518554688
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        632.0427856445312
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        629.813232421875
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        632.0427856445312
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        636.0255737304688
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        629.813232421875
      ],
      [
        -98.66907501220703,
        -2138.747314453125,
        628.624267578125
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        639.1056518554688
      ],
      [
        -105.2835693359375,
        -2157.47216796875,
        644.7898559570312
      ],
      [
        -90.22783660888672,
        -2043.1693115234375,
        741.733642578125
      ],
      [
        -99.90170288085938,
        -2029.7327880859375,
        741.7232055664062
      ],
      [
        -90.37528991699219,
        -2074.533935546875,
        652.7044067382812
      ],
      [
        -96.63314819335938,
        -2071.94189453125,
        635.4951171875
      ],
      [
        -94.10701751708984,
        -2067.576171875,
        657.7044067382812
      ],
      [
        -98.35603332519531,
        -2061.6728515625,
        657.7044067382812
      ],
      [
        -90.37528991699219,
        -2074.533935546875,
        652.7044067382812
      ],
      [
        -94.10701751708984,
        -2067.576171875,
        657.7044067382812
      ],
      [
        -92.20442199707031,
        -2073.7763671875,
        641.2166748046875
      ],
      [
        -92.20442199707031,
        -2073.7763671875,
        645.4983520507812
      ],
      [
        -92.20442199707031,
        -2073.7763671875,
        645.4983520507812
      ],
      [
        -92.25763702392578,
        -2073.384521484375,
        648.5706787109375
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        647.6743774414062
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        636.5319213867188
      ],
      [
        -92.20442199707031,
        -2073.7763671875,
        641.2166748046875
      ],
      [
        -92.25763702392578,
        -2073.384521484375,
        648.5706787109375
      ],
      [
        -92.4161148071289,
        -2072.2177734375,
        651.2399291992188
      ],
      [
        -92.20442199707031,
        -2073.7763671875,
        630.484375
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        636.5319213867188
      ],
      [
        -92.4161148071289,
        -2072.2177734375,
        651.2399291992188
      ],
      [
        -88.47032928466797,
        -2075.322998046875,
        651.2399291992188
      ],
      [
        -90.90784454345703,
        -2074.313232421875,
        651.2399291992188
      ],
      [
        -91.82108306884766,
        -2076.5986328125,
        641.2166748046875
      ],
      [
        -92.07524871826172,
        -2074.727294921875,
        645.4983520507812
      ],
      [
        -92.07524871826172,
        -2074.727294921875,
        645.4983520507812
      ],
      [
        -91.5429916381836,
        -2078.646240234375,
        636.5319213867188
      ],
      [
        -91.82108306884766,
        -2076.5986328125,
        641.2166748046875
      ],
      [
        -91.10107421875,
        -2081.89990234375,
        629.0875244140625
      ],
      [
        -91.5429916381836,
        -2078.646240234375,
        636.5319213867188
      ],
      [
        -88.72579193115234,
        -2077.344970703125,
        651.2399291992188
      ],
      [
        -89.25543975830078,
        -2081.537353515625,
        637.3416748046875
      ],
      [
        -89.51535034179688,
        -2079.802001953125,
        641.2166748046875
      ],
      [
        -169.76649475097656,
        -2106.755859375,
        634.0169677734375
      ],
      [
        -180.41281127929688,
        -2144.25439453125,
        658.3607177734375
      ],
      [
        -184.84814453125,
        -2157.106201171875,
        664.1196899414062
      ],
      [
        -180.4127960205078,
        -2144.25439453125,
        658.3607177734375
      ],
      [
        -184.84814453125,
        -2157.106201171875,
        664.1196899414062
      ],
      [
        -184.38143920898438,
        -2158.232666015625,
        667.4351806640625
      ],
      [
        -169.7664794921875,
        -2106.755859375,
        634.0169677734375
      ],
      [
        -179.54037475585938,
        -2169.73779296875,
        701.5438232421875
      ],
      [
        -179.99105834960938,
        -2168.828369140625,
        698.6240844726562
      ],
      [
        -179.99105834960938,
        -2168.828369140625,
        698.6240844726562
      ],
      [
        -99.8548583984375,
        -2139.238525390625,
        652.7044067382812
      ],
      [
        -99.8548583984375,
        -2139.238525390625,
        629.2604370117188
      ],
      [
        -79.4952163696289,
        -2150.27197265625,
        656.5999755859375
      ],
      [
        -82.6537094116211,
        -2142.64697265625,
        656.5999755859375
      ],
      [
        -82.6537094116211,
        -2142.64697265625,
        656.5999755859375
      ],
      [
        -90.278564453125,
        -2139.488525390625,
        656.5999755859375
      ],
      [
        -90.278564453125,
        -2139.488525390625,
        656.5999755859375
      ],
      [
        -97.9036636352539,
        -2142.64697265625,
        656.5999755859375
      ],
      [
        -99.8564224243164,
        -2140.694091796875,
        654.0486450195312
      ],
      [
        -99.8548583984375,
        -2139.238525390625,
        652.7044067382812
      ],
      [
        -92.20441436767578,
        -2136.069580078125,
        645.4983520507812
      ],
      [
        -92.20441436767578,
        -2136.069580078125,
        641.2166748046875
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        648.5706787109375
      ],
      [
        -92.20441436767578,
        -2136.069580078125,
        645.4983520507812
      ],
      [
        -92.20441436767578,
        -2136.069580078125,
        641.2166748046875
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        636.5319213867188
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        651.2399291992188
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        648.5706787109375
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        636.5319213867188
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        625.9423828125
      ],
      [
        -88.2706298828125,
        -2136.103759765625,
        651.2399291992188
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        651.2399291992188
      ],
      [
        -90.2786636352539,
        -2135.27197265625,
        651.2399291992188
      ],
      [
        -99.8564224243164,
        -2140.694091796875,
        654.0486450195312
      ],
      [
        -97.9036636352539,
        -2142.64697265625,
        656.5999755859375
      ],
      [
        -99.86359405517578,
        -2147.37841796875,
        656.5999755859375
      ],
      [
        -70.26387023925781,
        -2143.5625,
        648.0910034179688
      ],
      [
        -68.04356384277344,
        -2144.48193359375,
        647.041748046875
      ],
      [
        -70.26387023925781,
        -2143.5625,
        648.0910034179688
      ],
      [
        -84.69074249267578,
        -2142.99853515625,
        659.7044067382812
      ],
      [
        -82.05598449707031,
        -2144.08984375,
        656.5999755859375
      ],
      [
        -91.48558807373047,
        -2141.183837890625,
        659.7044067382812
      ],
      [
        -98.33621978759766,
        -2146.5771484375,
        659.7044067382812
      ],
      [
        -97.0795669555664,
        -2146.0439453125,
        659.7044067382812
      ],
      [
        -88.835693359375,
        -2140.086181640625,
        656.5999755859375
      ],
      [
        -96.46065521240234,
        -2142.04931640625,
        656.5999755859375
      ],
      [
        -91.99927520751953,
        -2134.559326171875,
        645.4983520507812
      ],
      [
        -91.99927520751953,
        -2134.559326171875,
        641.2166748046875
      ],
      [
        -91.9992904663086,
        -2134.559326171875,
        648.5706787109375
      ],
      [
        -91.99927520751953,
        -2134.559326171875,
        645.4983520507812
      ],
      [
        -91.99927520751953,
        -2134.559326171875,
        641.2166748046875
      ],
      [
        -91.9992904663086,
        -2134.559326171875,
        636.5319213867188
      ],
      [
        -91.9992904663086,
        -2134.559326171875,
        651.2399291992188
      ],
      [
        -91.9992904663086,
        -2134.559326171875,
        648.5706787109375
      ],
      [
        -91.9992904663086,
        -2134.559326171875,
        636.5319213867188
      ],
      [
        -91.99929809570312,
        -2134.559326171875,
        624.9449462890625
      ],
      [
        -91.9992904663086,
        -2134.559326171875,
        651.2399291992188
      ],
      [
        -105.27245330810547,
        -2141.482421875,
        647.5548095703125
      ],
      [
        -105.27322387695312,
        -2142.5849609375,
        648.336181640625
      ],
      [
        -108.05611419677734,
        -2142.635498046875,
        644.2874145507812
      ],
      [
        -108.05611419677734,
        -2142.635498046875,
        633.6602172851562
      ],
      [
        -108.05611419677734,
        -2142.635498046875,
        644.2874145507812
      ],
      [
        -106.26387786865234,
        -2067.95263671875,
        646.3912353515625
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        647.6743774414062
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        648.5706787109375
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        648.5706787109375
      ],
      [
        -92.20443725585938,
        -2073.7763671875,
        651.2399291992188
      ],
      [
        -92.20443725585938,
        -2073.7763671875,
        651.2399291992188
      ],
      [
        -90.90784454345703,
        -2074.313232421875,
        651.2399291992188
      ],
      [
        -542.7431640625,
        -2638.9052734375,
        475.2272644042969
      ],
      [
        -529.8307495117188,
        -2692.434326171875,
        874.0250244140625
      ],
      [
        -542.2257690429688,
        -2659.7041015625,
        872.3767700195312
      ],
      [
        -689.266845703125,
        -2391.343994140625,
        865.4605712890625
      ],
      [
        -703.939208984375,
        -2371.302734375,
        865.4804077148438
      ],
      [
        -488.8430480957031,
        -2803.202880859375,
        879.7427368164062
      ],
      [
        -529.8307495117188,
        -2692.434326171875,
        874.0250244140625
      ],
      [
        -713.2835083007812,
        -2363.59228515625,
        866.0255737304688
      ],
      [
        -703.939208984375,
        -2371.302734375,
        865.4804077148438
      ],
      [
        -758.4019775390625,
        -2314.277587890625,
        639.3778686523438
      ],
      [
        -754.6287231445312,
        -2317.40283203125,
        639.38037109375
      ],
      [
        -714.7833862304688,
        -2350.402099609375,
        639.3530883789062
      ],
      [
        -714.5018920898438,
        -2350.78662109375,
        639.3538208007812
      ],
      [
        -754.6287231445312,
        -2317.40283203125,
        639.38037109375
      ],
      [
        -714.5018920898438,
        -2350.78662109375,
        639.3538208007812
      ],
      [
        -714.4843139648438,
        -2350.81201171875,
        639.4075927734375
      ],
      [
        -762.5053100585938,
        -2311.39697265625,
        649.1970825195312
      ],
      [
        -763.1380615234375,
        -2310.982666015625,
        651.2776489257812
      ],
      [
        -763.1380615234375,
        -2310.982421875,
        651.2776489257812
      ],
      [
        -765.279052734375,
        -2310.43701171875,
        674.5700073242188
      ],
      [
        -765.279052734375,
        -2310.43701171875,
        674.5700073242188
      ],
      [
        -754.98779296875,
        -2319.55615234375,
        685.8677978515625
      ],
      [
        -885.3728637695312,
        -2471.9287109375,
        661.1228637695312
      ],
      [
        -896.314453125,
        -2488.22265625,
        660.5962524414062
      ],
      [
        -885.3728637695312,
        -2471.9287109375,
        661.1228637695312
      ],
      [
        -758.4019775390625,
        -2314.277587890625,
        639.3778686523438
      ],
      [
        -762.5053100585938,
        -2311.39697265625,
        649.1970825195312
      ],
      [
        -711.3695678710938,
        -2355.322998046875,
        648.9346923828125
      ],
      [
        -847.2936401367188,
        -2516.7783203125,
        641.796875
      ],
      [
        -860.583251953125,
        -2509.036865234375,
        641.796875
      ],
      [
        -711.3695678710938,
        -2355.322998046875,
        648.9346923828125
      ],
      [
        -743.80419921875,
        -2328.31640625,
        866.7424926757812
      ],
      [
        -756.9921875,
        -2314.733154296875,
        867.2271728515625
      ],
      [
        -713.2835083007812,
        -2363.59228515625,
        866.0255126953125
      ],
      [
        -720.4447631835938,
        -2352.376220703125,
        865.884033203125
      ],
      [
        -926.8214111328125,
        -2137.733642578125,
        583.9189453125
      ],
      [
        -924.068359375,
        -2143.761474609375,
        682.6480712890625
      ],
      [
        -926.8214111328125,
        -2137.733642578125,
        583.9189453125
      ],
      [
        -924.7866821289062,
        -2135.580078125,
        467.370361328125
      ],
      [
        -734.5917358398438,
        -2333.9970703125,
        639.3666381835938
      ],
      [
        -753.7207641601562,
        -2314.28271484375,
        639.3558349609375
      ],
      [
        -756.310791015625,
        -2311.613525390625,
        639.3507080078125
      ],
      [
        -753.7207641601562,
        -2314.28271484375,
        639.3558349609375
      ],
      [
        -756.310791015625,
        -2311.613525390625,
        639.3507080078125
      ],
      [
        -758.4041137695312,
        -2314.276123046875,
        639.3829345703125
      ],
      [
        -760.370361328125,
        -2307.621826171875,
        650.8119506835938
      ],
      [
        -762.0160522460938,
        -2306.33251953125,
        675.0604858398438
      ],
      [
        -762.0160522460938,
        -2306.33251953125,
        675.0604858398438
      ],
      [
        -760.0313110351562,
        -2307.949462890625,
        649.5208740234375
      ],
      [
        -760.0313110351562,
        -2307.949462890625,
        649.5208740234375
      ],
      [
        -760.3702392578125,
        -2307.621826171875,
        650.8118896484375
      ],
      [
        -924.068359375,
        -2143.761474609375,
        682.6480712890625
      ],
      [
        -925.69384765625,
        -2144.2890625,
        741.552734375
      ],
      [
        -728.7424926757812,
        -2339.38037109375,
        865.7201538085938
      ],
      [
        -743.80419921875,
        -2328.31640625,
        866.7424926757812
      ],
      [
        -728.7424926757812,
        -2339.38037109375,
        865.7201538085938
      ],
      [
        -756.9921875,
        -2314.733154296875,
        867.2271728515625
      ],
      [
        -760.50927734375,
        -2303.75732421875,
        866.58154296875
      ],
      [
        -758.6404418945312,
        -2301.78271484375,
        759.6312255859375
      ],
      [
        -755.9369506835938,
        -2302.220703125,
        650.1961669921875
      ],
      [
        -765.0918579101562,
        -2295.123779296875,
        742.3956298828125
      ],
      [
        -757.0103149414062,
        -2300.06005859375,
        666.3358764648438
      ],
      [
        -755.9306640625,
        -2302.23095703125,
        650.0648803710938
      ],
      [
        -755.9369506835938,
        -2302.220703125,
        650.1961669921875
      ],
      [
        -759.2736206054688,
        -2308.695556640625,
        647.44970703125
      ],
      [
        -755.9295654296875,
        -2302.23388671875,
        650.0578002929688
      ],
      [
        -755.9295654296875,
        -2302.23388671875,
        650.0578002929688
      ],
      [
        -755.9306640625,
        -2302.23095703125,
        650.0648803710938
      ],
      [
        -761.9382934570312,
        -2306.4140625,
        675.1514892578125
      ],
      [
        -758.6404418945312,
        -2301.78271484375,
        759.6312255859375
      ],
      [
        -765.0918579101562,
        -2295.123779296875,
        742.3956298828125
      ],
      [
        -753.7212524414062,
        -2308.314453125,
        639.3170776367188
      ],
      [
        -750.8490600585938,
        -2317.2421875,
        639.3574829101562
      ],
      [
        -752.8091430664062,
        -2311.149658203125,
        639.3311767578125
      ],
      [
        -753.7212524414062,
        -2308.314453125,
        639.3170776367188
      ],
      [
        -752.8091430664062,
        -2311.149658203125,
        639.3311767578125
      ],
      [
        -742.0281372070312,
        -2313.18505859375,
        639.28125
      ],
      [
        -756.3975830078125,
        -2299.9072265625,
        645.4570922851562
      ],
      [
        -756.9557495117188,
        -2300.09326171875,
        665.8224487304688
      ],
      [
        -756.9557495117188,
        -2300.09326171875,
        665.8224487304688
      ],
      [
        -755.6077270507812,
        -2303.119873046875,
        648.4926147460938
      ],
      [
        -756.3975830078125,
        -2299.9072265625,
        645.4570922851562
      ],
      [
        -487.7523193359375,
        -2803.547607421875,
        879.6206665039062
      ],
      [
        -488.8430480957031,
        -2803.202880859375,
        879.7427978515625
      ],
      [
        -484.9613342285156,
        -2802.0263671875,
        698.314208984375
      ],
      [
        -458.3141784667969,
        -2812.848388671875,
        876.3236083984375
      ],
      [
        -456.6446533203125,
        -2812.469482421875,
        807.879150390625
      ],
      [
        -984.291259765625,
        -2165.07177734375,
        884.4805297851562
      ],
      [
        -928.2157592773438,
        -2145.107666015625,
        832.9412231445312
      ],
      [
        -924.2988891601562,
        -2150.224365234375,
        874.1994018554688
      ],
      [
        -928.2157592773438,
        -2145.107666015625,
        832.941162109375
      ],
      [
        -550.1890869140625,
        -2618.96142578125,
        468.4746398925781
      ],
      [
        -548.7310791015625,
        -2642.526123046875,
        871.51171875
      ],
      [
        -451.7451171875,
        -2814.923828125,
        875.587890625
      ],
      [
        -450.5697021484375,
        -2814.7099609375,
        831.3848266601562
      ],
      [
        -579.789306640625,
        -2560.513427734375,
        867.3816528320312
      ],
      [
        -585.7559204101562,
        -2544.7578125,
        866.5881958007812
      ],
      [
        -585.7559204101562,
        -2544.7578125,
        866.5881958007812
      ],
      [
        -642.5033569335938,
        -2459.815673828125,
        865.8818359375
      ],
      [
        -678.7124633789062,
        -2405.76025390625,
        865.4462890625
      ],
      [
        -642.5032958984375,
        -2459.815673828125,
        865.8818359375
      ],
      [
        -678.7124633789062,
        -2405.76025390625,
        865.4462890625
      ],
      [
        -708.7366943359375,
        -2344.52734375,
        641.6248779296875
      ],
      [
        -704.5856323242188,
        -2348.42529296875,
        641.6248779296875
      ],
      [
        -909.4484252929688,
        -2152.20458984375,
        872.2504272460938
      ],
      [
        -919.112548828125,
        -2148.940673828125,
        873.3106079101562
      ],
      [
        -903.4149169921875,
        -2151.04931640625,
        697.4168701171875
      ],
      [
        -757.1561889648438,
        -2299.6904296875,
        668.8338012695312
      ],
      [
        -765.2636108398438,
        -2294.6083984375,
        745.6580810546875
      ],
      [
        -919.1124877929688,
        -2148.940673828125,
        873.3106079101562
      ],
      [
        -756.52685546875,
        -2299.30322265625,
        644.2452392578125
      ],
      [
        -757.1561889648438,
        -2299.6904296875,
        668.8338012695312
      ],
      [
        -754.571533203125,
        -2301.549560546875,
        643.3828735351562
      ],
      [
        -756.52685546875,
        -2299.30322265625,
        644.2452392578125
      ],
      [
        -754.3570556640625,
        -2301.44482421875,
        642.3101806640625
      ],
      [
        -765.2636108398438,
        -2294.6083984375,
        745.6580810546875
      ],
      [
        -760.5296630859375,
        -2299.832763671875,
        754.5840454101562
      ],
      [
        -904.4052734375,
        -2147.172119140625,
        629.1983032226562
      ],
      [
        -899.52685546875,
        -2144.3037109375,
        441.74444580078125
      ],
      [
        -904.4052734375,
        -2147.172119140625,
        629.1983032226562
      ],
      [
        -903.4149169921875,
        -2151.04931640625,
        697.4168701171875
      ],
      [
        -770.2017211914062,
        -2273.4775390625,
        864.7988891601562
      ],
      [
        -773.5365600585938,
        -2261.221435546875,
        863.9918212890625
      ],
      [
        -770.2017211914062,
        -2273.4775390625,
        864.7988891601562
      ],
      [
        -771.5575561523438,
        -2275.722412109375,
        865.232421875
      ],
      [
        -881.6675415039062,
        -2161.587646484375,
        869.2028198242188
      ],
      [
        -768.5449829101562,
        -2279.56591796875,
        865.1997680664062
      ],
      [
        -771.5575561523438,
        -2275.722412109375,
        865.232421875
      ],
      [
        -759.466064453125,
        -2300.9306640625,
        757.425537109375
      ],
      [
        -768.0648193359375,
        -2280.178466796875,
        865.194580078125
      ],
      [
        -768.0648193359375,
        -2280.178466796875,
        865.194580078125
      ],
      [
        -753.871826171875,
        -2300.73193359375,
        638.5557861328125
      ],
      [
        -752.4913940429688,
        -2299.746337890625,
        630.2252807617188
      ],
      [
        -752.50732421875,
        -2299.7578125,
        630.8724975585938
      ],
      [
        -752.7722778320312,
        -2299.947021484375,
        641.6248779296875
      ],
      [
        -752.7722778320312,
        -2299.947021484375,
        641.6248779296875
      ],
      [
        -751.1085205078125,
        -2304.58740234375,
        641.6248779296875
      ],
      [
        -856.5706787109375,
        -2170.06396484375,
        866.44970703125
      ],
      [
        -774.0728149414062,
        -2259.71875,
        863.911376953125
      ],
      [
        -808.619384765625,
        -2222.050537109375,
        864.9612426757812
      ],
      [
        -856.1751708984375,
        -2170.197509765625,
        866.4063110351562
      ],
      [
        -855.3778076171875,
        -2170.466796875,
        866.31884765625
      ],
      [
        -808.619384765625,
        -2222.050537109375,
        864.9612426757812
      ],
      [
        -855.3778076171875,
        -2170.466796875,
        866.31884765625
      ],
      [
        -773.8917236328125,
        -2259.916259765625,
        863.9058837890625
      ],
      [
        -773.8917236328125,
        -2259.916259765625,
        863.9058837890625
      ],
      [
        -600.7138061523438,
        -2191.3798828125,
        638.8302612304688
      ],
      [
        -726.714599609375,
        -2281.34228515625,
        630.2252807617188
      ],
      [
        -412.7320861816406,
        -2068.68115234375,
        639.28125
      ],
      [
        -417.841796875,
        -2072.005126953125,
        639.28125
      ],
      [
        -417.841796875,
        -2072.005126953125,
        639.28125
      ],
      [
        -283.0,
        -1979.0,
        639.28125
      ],
      [
        -275.0,
        -1979.0,
        639.28125
      ],
      [
        -283.0,
        -1979.0,
        639.28125
      ],
      [
        -283.0,
        -1984.2923583984375,
        639.28125
      ],
      [
        -283.0,
        -1987.0,
        636.369140625
      ],
      [
        -281.0429382324219,
        -1987.0,
        635.0
      ],
      [
        -283.0,
        -1987.0,
        636.369140625
      ],
      [
        -419.7073059082031,
        -2062.144287109375,
        644.5288696289062
      ],
      [
        -508.4297790527344,
        -2125.49072265625,
        645.13232421875
      ],
      [
        -388.1926574707031,
        -2051.13671875,
        640.9827270507812
      ],
      [
        -405.201171875,
        -2051.787353515625,
        648.85546875
      ],
      [
        -393.708740234375,
        -2043.58203125,
        652.9671630859375
      ],
      [
        -283.0,
        -1979.0,
        644.9732055664062
      ],
      [
        -275.0,
        -1979.0,
        639.3763427734375
      ],
      [
        -283.0,
        -1979.0,
        644.9732055664062
      ],
      [
        -388.1926574707031,
        -2051.13671875,
        640.9827270507812
      ],
      [
        -409.1650085449219,
        -2066.103271484375,
        639.5584106445312
      ],
      [
        -412.7320861816406,
        -2068.681396484375,
        639.28125
      ],
      [
        -409.1650085449219,
        -2066.103271484375,
        639.5584106445312
      ],
      [
        -419.70733642578125,
        -2062.144287109375,
        644.52880859375
      ],
      [
        -405.201171875,
        -2051.787353515625,
        648.85546875
      ],
      [
        -442.0,
        -1928.0,
        780.706787109375
      ],
      [
        -430.0,
        -1939.0,
        780.1223754882812
      ],
      [
        -430.0,
        -1939.0,
        780.1223754882812
      ],
      [
        -422.5,
        -1939.0,
        779.0327758789062
      ],
      [
        -422.5,
        -1945.875,
        766.0
      ],
      [
        -422.5,
        -1939.0,
        779.03271484375
      ],
      [
        -422.5,
        -1943.9227294921875,
        779.551513671875
      ],
      [
        -422.5,
        -1945.875,
        777.359130859375
      ],
      [
        -414.1811828613281,
        -1950.0,
        766.0
      ],
      [
        -417.9999694824219,
        -1950.0,
        766.0
      ],
      [
        -417.9999694824219,
        -1950.0,
        769.087890625
      ],
      [
        -422.5,
        -1950.0,
        772.7266845703125
      ],
      [
        -422.5,
        -1950.0,
        772.7266845703125
      ],
      [
        -395.6517639160156,
        -2040.9208984375,
        657.1885986328125
      ],
      [
        -422.5,
        -1950.0,
        773.7592163085938
      ],
      [
        -414.0,
        -1950.0,
        767.8125610351562
      ],
      [
        -422.5,
        -1944.5528564453125,
        779.617919921875
      ],
      [
        -422.5,
        -1950.0,
        773.7592163085938
      ],
      [
        -395.6517639160156,
        -2040.9208984375,
        657.1885986328125
      ],
      [
        -499.8879089355469,
        -2015.7177734375,
        798.3612670898438
      ],
      [
        -597.4422607421875,
        -2061.258056640625,
        817.3342895507812
      ],
      [
        -499.8879089355469,
        -2015.7177734375,
        798.3612670898438
      ],
      [
        -418.30963134765625,
        -1976.85595703125,
        782.4132080078125
      ],
      [
        -414.0,
        -1972.0,
        781.2753295898438
      ],
      [
        -414.0,
        -1950.0,
        778.9569702148438
      ],
      [
        -360.0,
        -1939.0,
        769.951904296875
      ],
      [
        -348.0,
        -1928.0,
        767.0492553710938
      ],
      [
        -360.0,
        -1939.0,
        769.951904296875
      ],
      [
        -369.0,
        -1939.0,
        771.2595825195312
      ],
      [
        -348.0,
        -1928.0,
        767.0492553710938
      ],
      [
        -348.0,
        -1918.043212890625,
        766.0
      ],
      [
        -369.0,
        -1947.25,
        772.1290283203125
      ],
      [
        -369.0,
        -1939.0,
        771.2595825195312
      ],
      [
        -369.0,
        -1947.25,
        766.0
      ],
      [
        -406.8780212402344,
        -1972.0,
        778.7999267578125
      ],
      [
        -414.0,
        -1972.0,
        781.2753295898438
      ],
      [
        -408.1163024902344,
        -1972.0,
        780.4204711914062
      ],
      [
        -406.6728515625,
        -1970.0,
        780.0
      ],
      [
        -412.0,
        -1962.6553955078125,
        780.0
      ],
      [
        -412.0,
        -1962.6553955078125,
        780.0
      ],
      [
        -412.0,
        -1970.0,
        780.7739868164062
      ],
      [
        -412.0,
        -1970.0,
        780.7739868164062
      ],
      [
        -406.67291259765625,
        -1970.0,
        780.0
      ],
      [
        -369.0,
        -1950.0,
        772.4188232421875
      ],
      [
        -422.5,
        -1950.0,
        780.1919555664062
      ],
      [
        -414.0,
        -1950.0,
        778.9569091796875
      ],
      [
        -422.5,
        -1950.0,
        780.1919555664062
      ],
      [
        -418.30963134765625,
        -1976.85595703125,
        782.4132080078125
      ],
      [
        -407.9463195800781,
        -1972.7974853515625,
        780.4797973632812
      ],
      [
        -405.1982727050781,
        -1972.0,
        778.7999267578125
      ],
      [
        -406.2379455566406,
        -1972.0,
        780.1475830078125
      ],
      [
        -427.18609619140625,
        -2372.12451171875,
        825.35693359375
      ],
      [
        -415.3110656738281,
        -2348.869140625,
        821.1808471679688
      ],
      [
        -343.83367919921875,
        -2211.443115234375,
        796.3135986328125
      ],
      [
        -346.0715026855469,
        -2213.27392578125,
        796.8316650390625
      ],
      [
        -214.34085083007812,
        -2179.7744140625,
        774.1619262695312
      ],
      [
        -256.07354736328125,
        -2167.5234375,
        778.934326171875
      ],
      [
        -343.83367919921875,
        -2211.443115234375,
        796.3135986328125
      ],
      [
        -322.5062255859375,
        -2198.047119140625,
        791.80322265625
      ],
      [
        -279.776123046875,
        -2177.188720703125,
        783.396728515625
      ],
      [
        -291.5123291015625,
        -2183.931884765625,
        785.8125
      ],
      [
        -278.7546691894531,
        -2146.58154296875,
        732.890380859375
      ],
      [
        -256.07354736328125,
        -2167.5234375,
        778.934326171875
      ],
      [
        -260.9525451660156,
        -2166.373291015625,
        779.5220336914062
      ],
      [
        -338.6816101074219,
        -2134.919677734375,
        667.9999389648438
      ],
      [
        -339.2903137207031,
        -2135.19482421875,
        667.9999389648438
      ],
      [
        -390.7621765136719,
        -2160.501220703125,
        667.9999389648438
      ],
      [
        -352.2367248535156,
        -2141.042724609375,
        667.9999389648438
      ],
      [
        -339.2903137207031,
        -2135.19482421875,
        667.9999389648438
      ],
      [
        -318.54534912109375,
        -2125.823974609375,
        667.9999389648438
      ],
      [
        -328.2811279296875,
        -2113.50927734375,
        639.9999389648438
      ],
      [
        -337.61968994140625,
        -2136.82763671875,
        671.9999389648438
      ],
      [
        -317.154541015625,
        -2127.583251953125,
        671.9999389648438
      ],
      [
        -337.61968994140625,
        -2136.82763671875,
        671.9999389648438
      ],
      [
        -338.6816101074219,
        -2134.919677734375,
        667.9999389648438
      ],
      [
        -318.54534912109375,
        -2125.823974609375,
        667.9999389648438
      ],
      [
        -317.154541015625,
        -2127.583251953125,
        671.9999389648438
      ],
      [
        -291.5123291015625,
        -2183.931884765625,
        785.8125
      ],
      [
        -302.4618225097656,
        -2188.997314453125,
        787.9371948242188
      ],
      [
        -322.5062255859375,
        -2198.047119140625,
        791.80322265625
      ],
      [
        -302.4618225097656,
        -2188.997314453125,
        787.9371948242188
      ],
      [
        -295.6280212402344,
        -2134.0361328125,
        705.10546875
      ],
      [
        -267.2416076660156,
        -2168.66357421875,
        780.6771850585938
      ],
      [
        -279.776123046875,
        -2177.188720703125,
        783.396728515625
      ],
      [
        -298.57379150390625,
        -2128.281982421875,
        692.6564331054688
      ],
      [
        -263.1219177246094,
        -2165.86181640625,
        779.7833251953125
      ],
      [
        -294.19268798828125,
        -2133.64990234375,
        705.6879272460938
      ],
      [
        -319.5613708496094,
        -2124.538818359375,
        667.9999389648438
      ],
      [
        -318.2466735839844,
        -2126.201904296875,
        671.9999389648438
      ],
      [
        -319.5613708496094,
        -2124.538818359375,
        667.9999389648438
      ],
      [
        -328.7640686035156,
        -2112.8984375,
        639.9999389648438
      ],
      [
        -337.9849548339844,
        -2136.17138671875,
        671.9999389648438
      ],
      [
        -318.2466735839844,
        -2126.201904296875,
        671.9999389648438
      ],
      [
        -338.9958801269531,
        -2134.35498046875,
        667.9999389648438
      ],
      [
        -339.6225280761719,
        -2134.671630859375,
        667.9999389648438
      ],
      [
        -339.6225280761719,
        -2134.671630859375,
        667.9999389648438
      ],
      [
        -337.9849548339844,
        -2136.17138671875,
        671.9999389648438
      ],
      [
        -338.9958801269531,
        -2134.35498046875,
        667.9999389648438
      ],
      [
        -294.1375732421875,
        -2133.717529296875,
        705.8518676757812
      ],
      [
        -263.1683654785156,
        -2165.850830078125,
        779.7890014648438
      ],
      [
        -267.2416076660156,
        -2168.66357421875,
        780.6771850585938
      ],
      [
        -295.6280212402344,
        -2134.0361328125,
        705.10546875
      ],
      [
        -263.1683654785156,
        -2165.850830078125,
        779.7889404296875
      ],
      [
        -294.1375732421875,
        -2133.717529296875,
        705.8518676757812
      ],
      [
        -370.0525817871094,
        -2143.47509765625,
        669.841796875
      ],
      [
        -361.6012878417969,
        -2140.760498046875,
        671.0531616210938
      ],
      [
        -342.2251281738281,
        -2128.552734375,
        667.9999389648438
      ],
      [
        -343.2315979003906,
        -2128.98828125,
        667.9999389648438
      ],
      [
        -392.8360595703125,
        -2157.313232421875,
        667.9999389648438
      ],
      [
        -365.69537353515625,
        -2139.34814453125,
        667.9999389648438
      ],
      [
        -352.1119689941406,
        -2132.832275390625,
        667.9999389648438
      ],
      [
        -343.23150634765625,
        -2128.98828125,
        667.9999389648438
      ],
      [
        -394.6381530761719,
        -2139.6162109375,
        639.9999389648438
      ],
      [
        -354.8740539550781,
        -2113.295166015625,
        639.9999389648438
      ],
      [
        -322.9754943847656,
        -2120.220458984375,
        667.9999389648438
      ],
      [
        -328.5604248046875,
        -2113.15625,
        660.4229125976562
      ],
      [
        -332.61920166015625,
        -2108.022216796875,
        654.0196533203125
      ],
      [
        -337.5279846191406,
        -2101.813232421875,
        639.9999389648438
      ],
      [
        -339.98016357421875,
        -2132.58642578125,
        671.9999389648438
      ],
      [
        -320.0272216796875,
        -2123.94970703125,
        671.9999389648438
      ],
      [
        -339.98016357421875,
        -2132.58642578125,
        671.9999389648438
      ],
      [
        -342.2251281738281,
        -2128.552734375,
        667.9999389648438
      ],
      [
        -322.9754943847656,
        -2120.220458984375,
        667.9999389648438
      ],
      [
        -320.0272216796875,
        -2123.94970703125,
        671.9999389648438
      ],
      [
        -348.87811279296875,
        -2148.298583984375,
        683.3890991210938
      ],
      [
        -349.0511474609375,
        -2140.843505859375,
        676.5722045898438
      ],
      [
        -340.4855041503906,
        -2131.678466796875,
        671.9999389648438
      ],
      [
        -321.2221984863281,
        -2122.438232421875,
        671.9999389648438
      ],
      [
        -323.75762939453125,
        -2119.231201171875,
        667.9999389648438
      ],
      [
        -321.2221984863281,
        -2122.438232421875,
        671.9999389648438
      ],
      [
        -323.75762939453125,
        -2119.231201171875,
        667.9999389648438
      ],
      [
        -342.4285888671875,
        -2128.187255859375,
        667.9999389648438
      ],
      [
        -343.4339904785156,
        -2128.669677734375,
        667.9999389648438
      ],
      [
        -343.4339904785156,
        -2128.66943359375,
        667.9999389648438
      ],
      [
        -340.4855041503906,
        -2131.678466796875,
        671.9999389648438
      ],
      [
        -342.4285888671875,
        -2128.187255859375,
        667.9999389648438
      ],
      [
        -361.024169921875,
        -2141.695556640625,
        671.9999389648438
      ],
      [
        -361.6012878417969,
        -2140.760498046875,
        671.0531616210938
      ],
      [
        -359.4483337402344,
        -2140.774658203125,
        671.9999389648438
      ],
      [
        -349.0511474609375,
        -2140.843505859375,
        676.5722045898438
      ],
      [
        -363.3562927246094,
        -2137.917236328125,
        668.1739501953125
      ],
      [
        -362.91766357421875,
        -2137.509521484375,
        667.9999389648438
      ],
      [
        -352.1119689941406,
        -2132.832275390625,
        667.9999389648438
      ],
      [
        -332.0211181640625,
        -2108.77880859375,
        655.727783203125
      ],
      [
        -328.5604248046875,
        -2113.15625,
        660.4229125976562
      ],
      [
        -294.19268798828125,
        -2133.64990234375,
        705.6879272460938
      ],
      [
        -329.02239990234375,
        -2112.57177734375,
        664.2922973632812
      ],
      [
        -326.6052551269531,
        -2110.63525390625,
        663.7935180664062
      ],
      [
        -341.3185119628906,
        -2130.181640625,
        671.9999389648438
      ],
      [
        -322.4370422363281,
        -2120.901611328125,
        671.9999389648438
      ],
      [
        -359.68548583984375,
        -2135.369873046875,
        668.0
      ],
      [
        -362.8344421386719,
        -2137.531005859375,
        668.1134033203125
      ],
      [
        -343.9417419433594,
        -2125.468505859375,
        667.9999389648438
      ],
      [
        -345.0316467285156,
        -2126.15380859375,
        667.9999389648438
      ],
      [
        -359.68182373046875,
        -2135.36767578125,
        667.9999389648438
      ],
      [
        -345.0316467285156,
        -2126.15380859375,
        667.9999389648438
      ],
      [
        -325.85455322265625,
        -2116.578857421875,
        667.9999389648438
      ],
      [
        -329.0224609375,
        -2112.57177734375,
        664.2921142578125
      ],
      [
        -325.85455322265625,
        -2116.578857421875,
        667.9999389648438
      ],
      [
        -322.4370422363281,
        -2120.901611328125,
        671.9999389648438
      ],
      [
        -341.3185119628906,
        -2130.181640625,
        671.9999389648438
      ],
      [
        -343.9417419433594,
        -2125.468505859375,
        667.9999389648438
      ],
      [
        -359.4483337402344,
        -2140.774658203125,
        671.9999389648438
      ],
      [
        -363.3562927246094,
        -2137.917236328125,
        668.1739501953125
      ],
      [
        -362.8344421386719,
        -2137.531005859375,
        668.1134033203125
      ],
      [
        -345.1039733886719,
        -2126.039794921875,
        667.9999389648438
      ],
      [
        -346.9913024902344,
        -2126.96728515625,
        667.9999389648438
      ],
      [
        -345.1039733886719,
        -2126.039794921875,
        667.9999389648438
      ],
      [
        -343.05560302734375,
        -2127.060546875,
        671.9999389648438
      ],
      [
        -326.32373046875,
        -2115.9853515625,
        671.9999389648438
      ],
      [
        -327.7242431640625,
        -2114.2138671875,
        667.9999389648438
      ],
      [
        -326.32373046875,
        -2115.9853515625,
        671.9999389648438
      ],
      [
        -327.7242431640625,
        -2114.2138671875,
        667.9999389648438
      ],
      [
        -343.05560302734375,
        -2127.060546875,
        671.9999389648438
      ],
      [
        -344.1531677246094,
        -2125.088623046875,
        667.9999389648438
      ],
      [
        -344.1531677246094,
        -2125.088623046875,
        667.9999389648438
      ],
      [
        -345.247802734375,
        -2125.813232421875,
        667.9999389648438
      ],
      [
        -345.247802734375,
        -2125.813232421875,
        667.9999389648438
      ],
      [
        -279.2770690917969,
        -2067.12646484375,
        645.7384643554688
      ],
      [
        -301.4779357910156,
        -2092.2255859375,
        661.1591796875
      ],
      [
        -320.1700744628906,
        -2105.479736328125,
        662.465576171875
      ],
      [
        -301.4779357910156,
        -2092.2255859375,
        661.1591796875
      ],
      [
        -320.1700744628906,
        -2105.479736328125,
        662.465576171875
      ],
      [
        -279.2770690917969,
        -2067.12646484375,
        645.7384643554688
      ],
      [
        -266.4682922363281,
        -2058.64794921875,
        645.7384643554688
      ],
      [
        -160.9969024658203,
        -2087.99462890625,
        633.150634765625
      ],
      [
        -220.62191772460938,
        -2028.4605712890625,
        645.9752807617188
      ],
      [
        -215.57534790039062,
        -2024.864990234375,
        645.5972290039062
      ],
      [
        -220.62191772460938,
        -2028.4605712890625,
        645.9752807617188
      ],
      [
        -262.76373291015625,
        -2056.19580078125,
        645.7384643554688
      ],
      [
        -262.76373291015625,
        -2056.19580078125,
        645.7384643554688
      ],
      [
        -215.57534790039062,
        -2024.864990234375,
        645.5972290039062
      ],
      [
        -213.13516235351562,
        -2024.114501953125,
        646.8789672851562
      ],
      [
        -101.408447265625,
        -1985.910400390625,
        699.871826171875
      ],
      [
        -114.53120422363281,
        -2019.0810546875,
        676.8016357421875
      ],
      [
        -127.384521484375,
        -1997.7406005859375,
        691.9205932617188
      ],
      [
        -101.408447265625,
        -1985.910400390625,
        699.871826171875
      ],
      [
        -87.03228759765625,
        -1978.8719482421875,
        703.544189453125
      ],
      [
        -100.10627746582031,
        -1993.89208984375,
        702.322021484375
      ],
      [
        -99.80781555175781,
        -2000.8687744140625,
        696.3668823242188
      ],
      [
        -156.2670440673828,
        -2010.8944091796875,
        683.0796508789062
      ],
      [
        -213.1351776123047,
        -2024.114501953125,
        646.8789672851562
      ],
      [
        -156.2670440673828,
        -2010.8944091796875,
        683.0796508789062
      ],
      [
        -101.0772476196289,
        -1991.3837890625,
        708.3096923828125
      ],
      [
        -103.98069763183594,
        -1998.7393798828125,
        716.3638916015625
      ],
      [
        -102.27159118652344,
        -2009.362060546875,
        701.7084350585938
      ],
      [
        -209.0651397705078,
        -2181.046875,
        773.529541015625
      ],
      [
        -214.34085083007812,
        -2179.7744140625,
        774.1619262695312
      ],
      [
        -186.70205688476562,
        -2182.421142578125,
        770.4251708984375
      ],
      [
        -186.70205688476562,
        -2182.421142578125,
        770.4251708984375
      ],
      [
        -209.0651397705078,
        -2181.046875,
        773.529541015625
      ],
      [
        -110.97541046142578,
        -2016.4595947265625,
        735.7672729492188
      ],
      [
        -110.97541046142578,
        -2016.4595947265625,
        735.7672729492188
      ],
      [
        -107.99134063720703,
        -2018.4967041015625,
        741.7144775390625
      ],
      [
        -195.0,
        -1979.0,
        750.1940307617188
      ],
      [
        -195.0,
        -1987.0,
        751.0370483398438
      ],
      [
        -195.0,
        -1987.0,
        751.0370483398438
      ],
      [
        -187.0,
        -1987.0,
        749.8746337890625
      ],
      [
        -195.0,
        -1955.948974609375,
        747.7648315429688
      ],
      [
        -126.01776123046875,
        -1956.1983642578125,
        737.7685546875
      ],
      [
        -195.0,
        -1980.298828125,
        705.0193481445312
      ],
      [
        -103.80093383789062,
        -1987.0,
        699.1394653320312
      ],
      [
        -195.0,
        -1987.0,
        700.32421875
      ],
      [
        -195.0,
        -1980.298828125,
        705.0193481445312
      ],
      [
        -83.5708999633789,
        -1974.339599609375,
        707.7470703125
      ],
      [
        -126.01776885986328,
        -1956.1983642578125,
        737.7685546875
      ],
      [
        -87.22331237792969,
        -1971.048828125,
        733.6969604492188
      ],
      [
        -87.22331237792969,
        -1971.048828125,
        733.6969604492188
      ],
      [
        -102.7741928100586,
        -1987.0,
        718.774169921875
      ],
      [
        -105.77139282226562,
        -1979.2572021484375,
        737.2568969726562
      ],
      [
        -107.15234375,
        -1987.0,
        738.2734985351562
      ],
      [
        -195.0,
        -1994.003662109375,
        695.4171142578125
      ],
      [
        -195.0,
        -1994.003662109375,
        695.4171142578125
      ],
      [
        -195.0,
        -2019.898681640625,
        658.42333984375
      ],
      [
        -111.8211441040039,
        -2013.17724609375,
        741.7103881835938
      ],
      [
        -111.8211441040039,
        -2013.17724609375,
        741.7103881835938
      ],
      [
        -283.0,
        -1979.0,
        700.029296875
      ],
      [
        -275.0,
        -1979.0,
        701.2011108398438
      ],
      [
        -283.0,
        -1979.0,
        700.029296875
      ],
      [
        -283.0,
        -1987.0,
        688.6607666015625
      ],
      [
        -283.0,
        -1987.0,
        688.6607666015625
      ],
      [
        -275.0,
        -1987.0,
        689.8326416015625
      ],
      [
        -214.7158203125,
        -1979.0,
        710.03125
      ],
      [
        -195.0,
        -1979.0,
        707.2994384765625
      ],
      [
        -195.0,
        -1987.0,
        700.32421875
      ],
      [
        -202.69137573242188,
        -1987.0,
        700.424072265625
      ],
      [
        -195.0,
        -1988.7025146484375,
        699.13134765625
      ],
      [
        -195.0,
        -1962.1953125,
        736.7996826171875
      ],
      [
        -323.1261901855469,
        -1991.678466796875,
        680.0523681640625
      ],
      [
        -280.9403076171875,
        -1977.038330078125,
        707.046142578125
      ],
      [
        -197.5624542236328,
        -1955.939697265625,
        748.1361694335938
      ],
      [
        -283.0,
        -1979.0,
        703.77734375
      ],
      [
        -283.0,
        -1987.0,
        691.2601318359375
      ],
      [
        -283.0,
        -1979.0,
        703.77734375
      ],
      [
        -275.0,
        -1979.0,
        704.55224609375
      ],
      [
        -283.0,
        -1987.0,
        691.2601318359375
      ],
      [
        -275.0,
        -1987.0,
        692.0352783203125
      ],
      [
        -527.6100463867188,
        -2209.01611328125,
        639.28125
      ],
      [
        -345.8387756347656,
        -2122.06005859375,
        667.9999389648438
      ],
      [
        -347.13427734375,
        -2122.842529296875,
        667.9999389648438
      ],
      [
        -396.0443115234375,
        -2152.381591796875,
        667.9999389648438
      ],
      [
        -347.13427734375,
        -2122.842529296875,
        667.9999389648438
      ],
      [
        -222.40594482421875,
        -2023.2745361328125,
        645.9884033203125
      ],
      [
        -268.69073486328125,
        -2050.952880859375,
        645.7384643554688
      ],
      [
        -392.0724792480469,
        -2119.150146484375,
        640.0
      ],
      [
        -375.8053283691406,
        -2109.32568359375,
        640.0
      ],
      [
        -342.7324523925781,
        -2095.22998046875,
        645.338623046875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        640.3275756835938
      ],
      [
        -335.66217041015625,
        -2104.17333984375,
        645.328857421875
      ],
      [
        -405.737060546875,
        -2137.482421875,
        644.981689453125
      ],
      [
        -406.736328125,
        -2129.89404296875,
        641.7142333984375
      ],
      [
        -406.29559326171875,
        -2133.240966796875,
        644.9953002929688
      ],
      [
        -366.48583984375,
        -2103.697021484375,
        639.9999389648438
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        642.8467407226562
      ],
      [
        -406.736328125,
        -2129.89404296875,
        641.7142333984375
      ],
      [
        -404.03619384765625,
        -2126.375732421875,
        639.9999389648438
      ],
      [
        -392.0724792480469,
        -2119.150146484375,
        640.0
      ],
      [
        -391.3579406738281,
        -2119.943115234375,
        641.11181640625
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        642.8467407226562
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        640.0137329101562
      ],
      [
        -345.9211730957031,
        -2091.277099609375,
        639.9999389648438
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        640.3275756835938
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        640.0137329101562
      ],
      [
        -358.6785583496094,
        -2098.98193359375,
        639.9999389648438
      ],
      [
        -214.79327392578125,
        -2024.62451171875,
        646.0079956054688
      ],
      [
        -329.4201354980469,
        -2095.0888671875,
        652.5116577148438
      ],
      [
        -299.10333251953125,
        -2076.334716796875,
        652.1083374023438
      ],
      [
        -292.9984130859375,
        -2065.633544921875,
        645.7384643554688
      ],
      [
        -299.10333251953125,
        -2076.334716796875,
        652.1083374023438
      ],
      [
        -338.4354248046875,
        -2100.665283203125,
        652.63134765625
      ],
      [
        -329.4352722167969,
        -2112.049560546875,
        663.1131591796875
      ],
      [
        -405.737060546875,
        -2137.482421875,
        649.1535034179688
      ],
      [
        -292.9984436035156,
        -2065.633544921875,
        645.7384643554688
      ],
      [
        -268.69073486328125,
        -2050.952880859375,
        645.7384643554688
      ],
      [
        -217.8099822998047,
        -2022.4813232421875,
        647.788818359375
      ],
      [
        -210.87344360351562,
        -2021.7569580078125,
        650.935546875
      ],
      [
        -201.66111755371094,
        -2021.4471435546875,
        654.1830444335938
      ],
      [
        -329.3799133300781,
        -2112.11962890625,
        667.9999389648438
      ],
      [
        -337.21307373046875,
        -2102.21142578125,
        654.7057495117188
      ],
      [
        -329.4201354980469,
        -2095.0888671875,
        652.5116577148438
      ],
      [
        -196.56874084472656,
        -2020.2633056640625,
        657.4247436523438
      ],
      [
        -392.9285583496094,
        -2150.499755859375,
        667.9998779296875
      ],
      [
        -344.00396728515625,
        -2125.356689453125,
        671.9999389648438
      ],
      [
        -327.02294921875,
        -2115.100830078125,
        671.9999389648438
      ],
      [
        -344.00396728515625,
        -2125.356689453125,
        671.9999389648438
      ],
      [
        -345.8387756347656,
        -2122.06005859375,
        667.9999389648438
      ],
      [
        -329.3799133300781,
        -2112.11962890625,
        667.9999389648438
      ],
      [
        -327.02294921875,
        -2115.100830078125,
        671.9999389648438
      ],
      [
        -527.6100463867188,
        -2209.01611328125,
        639.28125
      ],
      [
        -516.3707275390625,
        -2193.428466796875,
        639.28125
      ],
      [
        -323.1261901855469,
        -1991.678466796875,
        680.0523681640625
      ],
      [
        -393.3953552246094,
        -2044.01123046875,
        652.2862548828125
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        640.79150390625
      ],
      [
        -360.30859375,
        -2091.77294921875,
        640.9903564453125
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.6522216796875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.7276000976562
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        641.346923828125
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.6522216796875
      ],
      [
        -360.30859375,
        -2091.77294921875,
        640.9903564453125
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        641.346923828125
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.7276000976562
      ],
      [
        -344.8598327636719,
        -2092.5390625,
        641.7280883789062
      ],
      [
        -369.78338623046875,
        -2105.177734375,
        639.9999389648438
      ],
      [
        -367.435791015625,
        -2103.822265625,
        640.169189453125
      ],
      [
        -367.435791015625,
        -2103.822265625,
        640.169189453125
      ],
      [
        -365.894287109375,
        -2103.619140625,
        640.2536010742188
      ],
      [
        -358.9753723144531,
        -2099.974609375,
        640.7385864257812
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        640.79150390625
      ],
      [
        -386.3768615722656,
        -2112.560791015625,
        639.28125
      ],
      [
        -413.24639892578125,
        -2069.015625,
        639.28125
      ],
      [
        -380.7559814453125,
        -2109.727783203125,
        639.6287231445312
      ],
      [
        -377.9178466796875,
        -2108.01611328125,
        639.8123168945312
      ],
      [
        -359.1897277832031,
        -2096.721435546875,
        641.0240478515625
      ],
      [
        -360.02789306640625,
        -2097.226806640625,
        640.9697875976562
      ],
      [
        -347.6043395996094,
        -2089.734375,
        641.7735595703125
      ],
      [
        -360.02789306640625,
        -2097.226806640625,
        640.9697875976562
      ],
      [
        -369.4089050292969,
        -2102.884521484375,
        640.3628540039062
      ],
      [
        -369.4089050292969,
        -2102.884521484375,
        640.3628540039062
      ],
      [
        -377.9178466796875,
        -2108.01611328125,
        639.8123168945312
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        640.9821166992188
      ],
      [
        -359.23504638671875,
        -2096.520751953125,
        640.859619140625
      ],
      [
        -359.1897277832031,
        -2096.721435546875,
        641.0240478515625
      ],
      [
        -347.66058349609375,
        -2089.669677734375,
        641.7001953125
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.8128662109375
      ],
      [
        -347.5961608886719,
        -2089.729248046875,
        641.7741088867188
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.8128662109375
      ],
      [
        -344.80450439453125,
        -2092.609130859375,
        641.822021484375
      ],
      [
        -374.1383361816406,
        -2107.692138671875,
        640.0
      ],
      [
        -367.435791015625,
        -2103.822265625,
        640.4285888671875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        640.4285888671875
      ],
      [
        -365.2231140136719,
        -2103.53076171875,
        640.5414428710938
      ],
      [
        -359.0538635253906,
        -2100.23095703125,
        640.9283447265625
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        640.9821166992188
      ],
      [
        -376.5371398925781,
        -2107.5634765625,
        639.890625
      ],
      [
        -381.0154724121094,
        -2109.88427734375,
        639.6119384765625
      ],
      [
        -360.30859375,
        -2091.77294921875,
        641.115234375
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        641.4136962890625
      ],
      [
        -357.18017578125,
        -2086.585205078125,
        641.4136352539062
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.70263671875
      ],
      [
        -360.30859375,
        -2091.77294921875,
        641.115234375
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.70263671875
      ],
      [
        -383.7384033203125,
        -2111.20166015625,
        639.4452514648438
      ],
      [
        -386.3768615722656,
        -2112.560791015625,
        639.28125
      ],
      [
        -383.83221435546875,
        -2111.343994140625,
        639.4366455078125
      ],
      [
        -380.7559814453125,
        -2109.727783203125,
        639.6287231445312
      ],
      [
        -383.7384033203125,
        -2111.20166015625,
        639.4452514648438
      ],
      [
        -282.354736328125,
        -2059.205322265625,
        645.7384643554688
      ],
      [
        -217.88108825683594,
        -2020.9951171875,
        649.8903198242188
      ],
      [
        -212.70004272460938,
        -2021.94775390625,
        650.1068725585938
      ],
      [
        -348.19085693359375,
        -2117.833984375,
        667.9999389648438
      ],
      [
        -349.6827697753906,
        -2118.829345703125,
        667.9999389648438
      ],
      [
        -397.2310485839844,
        -2150.557373046875,
        667.9999389648438
      ],
      [
        -349.6827697753906,
        -2118.829345703125,
        667.9999389648438
      ],
      [
        -387.98919677734375,
        -2109.94775390625,
        639.28125
      ],
      [
        -299.1072082519531,
        -2058.383056640625,
        645.7384643554688
      ],
      [
        -336.96319580078125,
        -2079.83544921875,
        642.5633544921875
      ],
      [
        -299.1072082519531,
        -2058.383056640625,
        645.7384643554688
      ],
      [
        -287.5999755859375,
        -2050.704833984375,
        645.7384643554688
      ],
      [
        -217.96669006347656,
        -2019.2060546875,
        652.420166015625
      ],
      [
        -205.69081115722656,
        -2021.2158203125,
        653.2865600585938
      ],
      [
        -293.274658203125,
        -2066.11767578125,
        646.0267333984375
      ],
      [
        -398.08636474609375,
        -2152.732177734375,
        667.9999389648438
      ],
      [
        -418.117919921875,
        -2164.494384765625,
        667.9999389648438
      ],
      [
        -330.7850036621094,
        -2093.5556640625,
        651.04296875
      ],
      [
        -299.0163879394531,
        -2075.7529296875,
        651.7769775390625
      ],
      [
        -376.68212890625,
        -2107.806884765625,
        639.9999389648438
      ],
      [
        -380.38275146484375,
        -2110.05224609375,
        639.9999389648438
      ],
      [
        -392.9296875,
        -2117.66552734375,
        640.0
      ],
      [
        -380.38275146484375,
        -2110.05224609375,
        639.9999389648438
      ],
      [
        -376.24151611328125,
        -2108.90625,
        640.96044921875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.1423950195312
      ],
      [
        -402.07666015625,
        -2123.822265625,
        640.4264526367188
      ],
      [
        -392.44219970703125,
        -2118.259765625,
        640.6255493164062
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.1423950195312
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        643.6758422851562
      ],
      [
        -406.736328125,
        -2129.89404296875,
        642.7066650390625
      ],
      [
        -402.07666015625,
        -2123.822265625,
        640.4264526367188
      ],
      [
        -406.1461181640625,
        -2134.3759765625,
        646.1080932617188
      ],
      [
        -406.736328125,
        -2129.89404296875,
        642.7066650390625
      ],
      [
        -392.44219970703125,
        -2118.259765625,
        640.6255493164062
      ],
      [
        -391.15643310546875,
        -2119.826904296875,
        642.275146484375
      ],
      [
        -345.62652587890625,
        -2091.5693359375,
        641.8134765625
      ],
      [
        -341.94830322265625,
        -2096.221923828125,
        646.66943359375
      ],
      [
        -345.56378173828125,
        -2091.648681640625,
        641.9136962890625
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        643.6758422851562
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.4857177734375
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.4857177734375
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        640.9859008789062
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        641.3222045898438
      ],
      [
        -293.7386169433594,
        -2066.010009765625,
        645.9945678710938
      ],
      [
        -294.28948974609375,
        -2067.896484375,
        647.0856323242188
      ],
      [
        -392.9296875,
        -2117.66552734375,
        640.0
      ],
      [
        -392.44219970703125,
        -2118.259765625,
        640.6255493164062
      ],
      [
        -358.8147888183594,
        -2098.379638671875,
        640.9934692382812
      ],
      [
        -379.28436279296875,
        -2109.229736328125,
        639.9999389648438
      ],
      [
        -376.7274169921875,
        -2107.728515625,
        639.9999389648438
      ],
      [
        -379.28436279296875,
        -2109.229736328125,
        639.9999389648438
      ],
      [
        -380.0483703613281,
        -2109.301025390625,
        639.6744995117188
      ],
      [
        -338.4354553222656,
        -2100.665283203125,
        652.6312866210938
      ],
      [
        -339.9817199707031,
        -2098.70947265625,
        650.83056640625
      ],
      [
        -376.28717041015625,
        -2108.9326171875,
        641.2617797851562
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.3364868164062
      ],
      [
        -402.07666015625,
        -2123.822265625,
        641.0430297851562
      ],
      [
        -392.3555908203125,
        -2118.209716796875,
        641.1254272460938
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.3364868164062
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        644.3175659179688
      ],
      [
        -406.736328125,
        -2129.89404296875,
        643.9202270507812
      ],
      [
        -402.07666015625,
        -2123.822265625,
        641.0430297851562
      ],
      [
        -405.737060546875,
        -2137.482421875,
        650.5148315429688
      ],
      [
        -406.736328125,
        -2129.89404296875,
        643.9202270507812
      ],
      [
        -405.9731140136719,
        -2135.68994140625,
        649.3056640625
      ],
      [
        -392.3555908203125,
        -2118.209716796875,
        641.1254272460938
      ],
      [
        -391.0085754394531,
        -2119.741455078125,
        643.128662109375
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        644.3175659179688
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.6099853515625
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        641.6099853515625
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        641.3222045898438
      ],
      [
        -358.7217712402344,
        -2098.790771484375,
        641.41015625
      ],
      [
        -358.8181457519531,
        -2098.36474609375,
        640.9937133789062
      ],
      [
        -293.82012939453125,
        -2065.990966796875,
        645.9888916015625
      ],
      [
        -299.0163879394531,
        -2075.7529296875,
        651.7769775390625
      ],
      [
        -331.7253723144531,
        -2109.15283203125,
        664.0193481445312
      ],
      [
        -398.08636474609375,
        -2152.732177734375,
        667.9999389648438
      ],
      [
        -405.737060546875,
        -2137.482421875,
        650.9712524414062
      ],
      [
        -338.4950256347656,
        -2100.58984375,
        653.205322265625
      ],
      [
        -330.7850036621094,
        -2093.5556640625,
        651.04296875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        644.1882934570312
      ],
      [
        -339.9817199707031,
        -2098.70947265625,
        650.83056640625
      ],
      [
        -406.736328125,
        -2129.89404296875,
        645.3958740234375
      ],
      [
        -402.07666015625,
        -2123.822265625,
        643.0117797851562
      ],
      [
        -405.7652893066406,
        -2128.628662109375,
        644.96728515625
      ],
      [
        -405.9731140136719,
        -2135.68994140625,
        649.3056640625
      ],
      [
        -406.736328125,
        -2129.89404296875,
        645.3958740234375
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        645.9818725585938
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        644.0260620117188
      ],
      [
        -344.69561767578125,
        -2092.7470703125,
        645.3407592773438
      ],
      [
        -344.8223571777344,
        -2092.92724609375,
        645.4061279296875
      ],
      [
        -347.24755859375,
        -2089.519287109375,
        641.796630859375
      ],
      [
        -347.5960388183594,
        -2089.7294921875,
        641.7741088867188
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        643.9666137695312
      ],
      [
        -348.23577880859375,
        -2089.13818359375,
        641.7611694335938
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        644.1882934570312
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.9988403320312
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        645.0252685546875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        641.9988403320312
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        642.8890991210938
      ],
      [
        -359.18975830078125,
        -2096.72119140625,
        641.0239868164062
      ],
      [
        -367.435791015625,
        -2103.822265625,
        643.772216796875
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        645.9818725585938
      ],
      [
        -376.65020751953125,
        -2109.142333984375,
        643.6571044921875
      ],
      [
        -367.435791015625,
        -2103.822265625,
        643.772216796875
      ],
      [
        -402.07666015625,
        -2123.822265625,
        643.0117797851562
      ],
      [
        -391.9501953125,
        -2117.975830078125,
        643.4659423828125
      ],
      [
        -396.8337707519531,
        -2120.795166015625,
        643.4049072265625
      ],
      [
        -391.9501953125,
        -2117.975830078125,
        643.4659423828125
      ],
      [
        -390.697265625,
        -2119.561767578125,
        644.9258422851562
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        644.0260620117188
      ],
      [
        -359.62054443359375,
        -2094.81591796875,
        641.0591430664062
      ],
      [
        -332.91888427734375,
        -2107.643310546875,
        667.9999389648438
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        647.4327392578125
      ],
      [
        -405.737060546875,
        -2137.482421875,
        652.365234375
      ],
      [
        -406.736328125,
        -2129.89404296875,
        645.4821166992188
      ],
      [
        -367.435791015625,
        -2103.822265625,
        645.6092529296875
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        648.9978637695312
      ],
      [
        -376.8392028808594,
        -2109.25146484375,
        644.9042358398438
      ],
      [
        -367.435791015625,
        -2103.822265625,
        645.6092529296875
      ],
      [
        -391.8966369628906,
        -2117.94482421875,
        643.7750854492188
      ],
      [
        -391.8966369628906,
        -2117.94482421875,
        643.7750854492188
      ],
      [
        -390.5455017089844,
        -2119.47412109375,
        645.8020629882812
      ],
      [
        -406.736328125,
        -2129.89404296875,
        645.4821166992188
      ],
      [
        -349.9858703613281,
        -2087.520751953125,
        641.7257080078125
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        647.4327392578125
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        646.4585571289062
      ],
      [
        -359.94158935546875,
        -2093.39599609375,
        641.0853271484375
      ],
      [
        -344.69561767578125,
        -2092.7470703125,
        645.3407592773438
      ],
      [
        -359.847412109375,
        -2102.82275390625,
        648.9978637695312
      ],
      [
        -358.675537109375,
        -2098.995361328125,
        646.4585571289062
      ],
      [
        -218.08865356445312,
        -2016.6572265625,
        656.0243530273438
      ],
      [
        -195.0,
        -2014.0863037109375,
        666.7269287109375
      ],
      [
        -346.2439880371094,
        -2121.33203125,
        671.9999389648438
      ],
      [
        -330.4360046386719,
        -2110.78369140625,
        671.9999389648438
      ],
      [
        -332.91888427734375,
        -2107.643310546875,
        667.9999389648438
      ],
      [
        -330.4360046386719,
        -2110.78369140625,
        671.9999389648438
      ],
      [
        -346.2439880371094,
        -2121.33203125,
        671.9999389648438
      ],
      [
        -348.19085693359375,
        -2117.833984375,
        667.9999389648438
      ],
      [
        -475.03424072265625,
        -2136.10009765625,
        639.28125
      ],
      [
        -491.83642578125,
        -2159.402587890625,
        639.28125
      ],
      [
        -438.51513671875,
        -2085.452880859375,
        639.28125
      ],
      [
        -475.03424072265625,
        -2136.10009765625,
        639.28125
      ],
      [
        -491.83642578125,
        -2159.402587890625,
        639.28125
      ],
      [
        -234.3852081298828,
        -1963.6575927734375,
        738.5435791015625
      ],
      [
        -280.9403076171875,
        -1977.038330078125,
        707.046142578125
      ],
      [
        -222.8990478515625,
        -1959.335205078125,
        745.6863403320312
      ],
      [
        -214.63650512695312,
        -1955.8780517578125,
        750.6104125976562
      ],
      [
        -234.3852081298828,
        -1963.6575927734375,
        738.5435791015625
      ],
      [
        -222.8990478515625,
        -1959.335205078125,
        745.6863403320312
      ],
      [
        -283.0,
        -1987.0,
        711.4183349609375
      ],
      [
        -275.0,
        -1987.0,
        718.2457275390625
      ],
      [
        -283.0,
        -1979.0,
        706.495361328125
      ],
      [
        -283.0,
        -1987.0,
        711.4183349609375
      ],
      [
        -283.0,
        -1979.0,
        706.495361328125
      ],
      [
        -275.0,
        -1979.0,
        713.3228149414062
      ],
      [
        -599.257568359375,
        -2193.659912109375,
        641.6248779296875
      ],
      [
        -751.5808715820312,
        -2303.27001953125,
        641.6248779296875
      ],
      [
        -610.9917602539062,
        -2204.5048828125,
        639.2813110351562
      ],
      [
        -750.7027587890625,
        -2305.03955078125,
        639.28125
      ],
      [
        -598.208740234375,
        -2195.306396484375,
        639.2813110351562
      ],
      [
        -599.257568359375,
        -2193.659912109375,
        641.6248779296875
      ],
      [
        -415.3110656738281,
        -2348.869140625,
        821.1808471679688
      ],
      [
        -370.31365966796875,
        -2233.106689453125,
        802.4439086914062
      ],
      [
        -370.31365966796875,
        -2233.106689453125,
        802.4439086914062
      ],
      [
        -331.3708190917969,
        -1977.4061279296875,
        701.5846557617188
      ],
      [
        -364.7082214355469,
        -2005.7095947265625,
        684.19091796875
      ],
      [
        -261.0925598144531,
        -1952.1192626953125,
        756.9640502929688
      ],
      [
        -240.9657440185547,
        -1954.890869140625,
        754.3318481445312
      ],
      [
        -320.88385009765625,
        -1972.99560546875,
        709.5015869140625
      ],
      [
        -240.9657440185547,
        -1954.890869140625,
        754.3318481445312
      ],
      [
        -223.3677520751953,
        -1955.846435546875,
        751.8756713867188
      ],
      [
        -223.3677520751953,
        -1955.846435546875,
        751.8756713867188
      ],
      [
        -482.1658630371094,
        -2135.513671875,
        639.28125
      ],
      [
        -493.8836975097656,
        -2156.69482421875,
        639.28125
      ],
      [
        -463.44097900390625,
        -2101.666748046875,
        639.28125
      ],
      [
        -482.1658630371094,
        -2135.513671875,
        639.28125
      ],
      [
        -493.8836975097656,
        -2156.69482421875,
        639.28125
      ],
      [
        -507.0679931640625,
        -2180.52685546875,
        639.28125
      ],
      [
        -364.7082214355469,
        -2005.7095947265625,
        684.19091796875
      ],
      [
        -404.1024169921875,
        -2039.9964599609375,
        664.094970703125
      ],
      [
        -331.3708190917969,
        -1977.4061279296875,
        701.5846557617188
      ],
      [
        -320.88385009765625,
        -1972.99560546875,
        709.5015869140625
      ],
      [
        -283.0,
        -1979.0,
        750.0411987304688
      ],
      [
        -283.0,
        -1986.2734375,
        754.0
      ],
      [
        -278.9761962890625,
        -1979.0,
        754.0
      ],
      [
        -283.0,
        -1979.0,
        750.0411987304688
      ],
      [
        -258.4636535644531,
        -2032.0,
        765.0
      ],
      [
        -283.0,
        -2032.0,
        765.0
      ],
      [
        -283.0,
        -2032.0,
        768.56494140625
      ],
      [
        -286.0,
        -2011.906494140625,
        765.0
      ],
      [
        -286.0,
        -2000.74169921875,
        758.9232788085938
      ],
      [
        -286.0,
        -2032.0,
        765.0
      ],
      [
        -286.0,
        -2032.0,
        769.0007934570312
      ],
      [
        -291.5428161621094,
        -2030.4571533203125,
        769.6435546875
      ],
      [
        -290.0,
        -2032.0,
        769.5819702148438
      ],
      [
        -294.5815734863281,
        -2027.41845703125,
        765.0
      ],
      [
        -290.0,
        -2032.0,
        769.5819702148438
      ],
      [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      [
        -525.8124389648438,
        -2209.887939453125,
        641.3519287109375
      ],
      [
        -525.575439453125,
        -2210.0029296875,
        641.6248779296875
      ],
      [
        -561.891357421875,
        -2238.921875,
        641.6248779296875
      ],
      [
        -561.7347412109375,
        -2240.273681640625,
        641.6248779296875
      ],
      [
        -561.334716796875,
        -2239.679443359375,
        641.6248779296875
      ],
      [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      [
        -398.94171142578125,
        -1969.27099609375,
        778.7999267578125
      ],
      [
        -372.4520263671875,
        -1958.8970947265625,
        773.8579711914062
      ],
      [
        -405.90997314453125,
        -1972.0,
        780.0999145507812
      ],
      [
        -372.4520263671875,
        -1958.8970947265625,
        773.8579711914062
      ],
      [
        -365.873291015625,
        -1955.6063232421875,
        772.5553588867188
      ],
      [
        -365.873291015625,
        -1955.6063232421875,
        772.5553588867188
      ],
      [
        -362.6562194824219,
        -1953.9971923828125,
        771.9183349609375
      ],
      [
        -355.47674560546875,
        -1950.406005859375,
        770.4967041015625
      ],
      [
        -362.6562194824219,
        -1953.9971923828125,
        771.9183349609375
      ],
      [
        -404.598876953125,
        -1972.0,
        778.7999267578125
      ],
      [
        -405.9098205566406,
        -1972.0,
        780.0999145507812
      ],
      [
        -355.47674560546875,
        -1950.406005859375,
        770.4967041015625
      ],
      [
        -347.57135009765625,
        -1949.1533203125,
        769.2161254882812
      ],
      [
        -286.0,
        -1926.8548583984375,
        754.0
      ],
      [
        -286.0,
        -1920.0,
        757.1981201171875
      ],
      [
        -286.0,
        -1925.0406494140625,
        757.7293090820312
      ],
      [
        -317.3755187988281,
        -1944.3687744140625,
        764.32470703125
      ],
      [
        -286.0,
        -1951.9654541015625,
        754.0
      ],
      [
        -286.0,
        -1948.6893310546875,
        760.221435546875
      ],
      [
        -317.3755187988281,
        -1944.3687744140625,
        764.32470703125
      ],
      [
        -300.0,
        -1974.732177734375,
        765.0
      ],
      [
        -300.0,
        -2022.0,
        769.9811401367188
      ],
      [
        -286.0,
        -1994.0347900390625,
        765.0
      ],
      [
        -300.0,
        -2022.0,
        769.9811401367188
      ],
      [
        -325.0,
        -1977.0,
        768.8712158203125
      ],
      [
        -325.0,
        -1987.0,
        769.9249877929688
      ],
      [
        -311.5650939941406,
        -1992.0,
        768.5
      ],
      [
        -320.0,
        -1992.0,
        769.7254638671875
      ],
      [
        -320.0,
        -1992.0,
        769.7254638671875
      ],
      [
        -325.0,
        -1987.0,
        769.9249877929688
      ],
      [
        -325.0,
        -1977.0,
        768.8712158203125
      ],
      [
        -323.5190734863281,
        -1975.51904296875,
        768.5
      ],
      [
        -396.96240234375,
        -1972.0,
        778.7999267578125
      ],
      [
        328.0791320800781,
        -3776.214599609375,
        1518.7890625
      ],
      [
        335.708251953125,
        -3760.00537109375,
        1080.644775390625
      ],
      [
        330.92059326171875,
        -3796.41357421875,
        1757.6214599609375
      ],
      [
        328.59930419921875,
        -3784.984130859375,
        1640.2244873046875
      ],
      [
        328.0791320800781,
        -3776.214599609375,
        1518.7890625
      ],
      [
        328.59930419921875,
        -3784.984130859375,
        1640.2244873046875
      ],
      [
        -306.4415588378906,
        -2983.1630859375,
        1431.283447265625
      ],
      [
        -234.2976531982422,
        -3017.2685546875,
        865.3178100585938
      ],
      [
        -306.5951843261719,
        -2982.99560546875,
        1431.225341796875
      ],
      [
        -754.6883544921875,
        -2359.7060546875,
        1442.865478515625
      ],
      [
        -741.3680419921875,
        -2370.765380859375,
        1443.3846435546875
      ],
      [
        -955.45703125,
        -2167.037841796875,
        942.2494506835938
      ],
      [
        -960.8914794921875,
        -2159.280517578125,
        880.4703979492188
      ],
      [
        -698.2745361328125,
        -2408.3671875,
        1479.6412353515625
      ],
      [
        -502.1300354003906,
        -2816.757568359375,
        1479.110595703125
      ],
      [
        -495.6846008300781,
        -2819.032470703125,
        1478.0430908203125
      ],
      [
        -732.7146606445312,
        -2333.082275390625,
        1138.8837890625
      ],
      [
        -783.6495361328125,
        -2253.353515625,
        974.8693237304688
      ],
      [
        -781.6626586914062,
        -2256.458740234375,
        999.04052734375
      ],
      [
        -783.6495361328125,
        -2253.353515625,
        974.869384765625
      ],
      [
        -787.0260009765625,
        -2248.078125,
        929.305419921875
      ],
      [
        -752.145263671875,
        -2361.8173828125,
        1442.964599609375
      ],
      [
        -787.0260009765625,
        -2248.078125,
        929.305419921875
      ],
      [
        -792.2826538085938,
        -2239.86328125,
        864.4647827148438
      ],
      [
        -779.03271484375,
        -2261.742919921875,
        1062.635009765625
      ],
      [
        -779.9501342773438,
        -2259.135009765625,
        1019.874267578125
      ],
      [
        -733.7510375976562,
        -2332.29296875,
        1165.0404052734375
      ],
      [
        -733.7015380859375,
        -2332.1337890625,
        1156.9876708984375
      ],
      [
        -733.4498291015625,
        -2333.14013671875,
        1178.760986328125
      ],
      [
        -733.7510375976562,
        -2332.29296875,
        1165.040283203125
      ],
      [
        -732.7146606445312,
        -2333.082275390625,
        1138.8837890625
      ],
      [
        -733.7015380859375,
        -2332.1337890625,
        1156.9876708984375
      ],
      [
        -733.4498291015625,
        -2333.14013671875,
        1178.760986328125
      ],
      [
        -758.3310546875,
        -2310.554931640625,
        866.9813842773438
      ],
      [
        -779.03271484375,
        -2261.742919921875,
        1062.635009765625
      ],
      [
        -777.7199096679688,
        -2262.626220703125,
        1025.4935302734375
      ],
      [
        -774.6851196289062,
        -2267.39453125,
        972.22314453125
      ],
      [
        -774.6851196289062,
        -2267.39453125,
        972.22314453125
      ],
      [
        -771.3636474609375,
        -2272.616455078125,
        902.14453125
      ],
      [
        -770.5025634765625,
        -2273.9755859375,
        864.8950805664062
      ],
      [
        -773.9361572265625,
        -2268.5849609375,
        910.4217529296875
      ],
      [
        -771.3636474609375,
        -2272.616455078125,
        902.14453125
      ],
      [
        -773.9361572265625,
        -2268.5849609375,
        910.4217529296875
      ],
      [
        -781.3290405273438,
        -2254.945068359375,
        946.2813720703125
      ],
      [
        -783.2191162109375,
        -2249.745849609375,
        864.1893310546875
      ],
      [
        -772.17138671875,
        -2266.23876953125,
        864.3222045898438
      ],
      [
        -774.7032470703125,
        -2264.4326171875,
        932.4190063476562
      ],
      [
        -774.7032470703125,
        -2264.4326171875,
        932.4190063476562
      ],
      [
        -775.7066650390625,
        -2263.272216796875,
        944.0588989257812
      ],
      [
        -775.0943603515625,
        -2264.15380859375,
        942.9470825195312
      ],
      [
        -775.7066650390625,
        -2263.272216796875,
        944.0588989257812
      ],
      [
        -771.7664794921875,
        -2271.985107421875,
        903.4407348632812
      ],
      [
        -775.6288452148438,
        -2264.033447265625,
        966.3348388671875
      ],
      [
        -774.9893798828125,
        -2264.304931640625,
        942.7564086914062
      ],
      [
        -775.6288452148438,
        -2264.033447265625,
        966.3348388671875
      ],
      [
        -774.9893798828125,
        -2264.304931640625,
        942.7564086914062
      ],
      [
        -781.0300903320312,
        -2256.06494140625,
        969.5385131835938
      ],
      [
        -781.0300903320312,
        -2256.06494140625,
        969.53857421875
      ],
      [
        -781.3290405273438,
        -2254.945068359375,
        946.2813720703125
      ],
      [
        -718.0658569335938,
        -2356.0107421875,
        1190.5318603515625
      ],
      [
        -732.9428100585938,
        -2332.720458984375,
        1154.5731201171875
      ],
      [
        -733.1166381835938,
        -2332.73046875,
        1164.033935546875
      ],
      [
        -718.0658569335938,
        -2356.0107421875,
        1190.5318603515625
      ],
      [
        -778.4437866210938,
        -2261.489013671875,
        1038.20166015625
      ],
      [
        -779.9501342773438,
        -2259.135009765625,
        1019.874267578125
      ],
      [
        -778.4437866210938,
        -2261.489013671875,
        1038.20166015625
      ],
      [
        -777.7199096679688,
        -2262.626220703125,
        1025.4935302734375
      ],
      [
        -732.9428100585938,
        -2332.720458984375,
        1154.5731201171875
      ],
      [
        -733.1773681640625,
        -2332.494140625,
        1158.9423828125
      ],
      [
        -733.1166381835938,
        -2332.73046875,
        1164.033935546875
      ],
      [
        -733.188232421875,
        -2332.5322265625,
        1160.8394775390625
      ],
      [
        -733.188232421875,
        -2332.5322265625,
        1160.839599609375
      ],
      [
        -733.1773681640625,
        -2332.494140625,
        1158.9423828125
      ],
      [
        -779.7763061523438,
        -2256.816650390625,
        950.9082641601562
      ],
      [
        -781.840576171875,
        -2251.2490234375,
        864.1474609375
      ],
      [
        -772.4083862304688,
        -2265.36767578125,
        864.2648315429688
      ],
      [
        -775.2893676757812,
        -2263.2548828125,
        941.2236938476562
      ],
      [
        -775.2893676757812,
        -2263.2548828125,
        941.2236938476562
      ],
      [
        -775.980712890625,
        -2262.449951171875,
        949.26513671875
      ],
      [
        -775.5611572265625,
        -2263.055419921875,
        948.4863891601562
      ],
      [
        -775.980712890625,
        -2262.449951171875,
        949.26513671875
      ],
      [
        -775.0943603515625,
        -2264.15380859375,
        942.9470825195312
      ],
      [
        -778.0450439453125,
        -2261.486328125,
        1023.680419921875
      ],
      [
        -775.9306640625,
        -2262.95849609375,
        964.4517822265625
      ],
      [
        -778.34228515625,
        -2261.6484375,
        1036.4193115234375
      ],
      [
        -775.9306640625,
        -2262.95849609375,
        964.4517822265625
      ],
      [
        -775.4889526367188,
        -2263.15966796875,
        948.3524169921875
      ],
      [
        -775.4889526367188,
        -2263.15966796875,
        948.3524169921875
      ],
      [
        -778.195068359375,
        -2261.3818359375,
        1027.882080078125
      ],
      [
        -779.5615234375,
        -2257.5849609375,
        966.5499267578125
      ],
      [
        -779.5615234375,
        -2257.5849609375,
        966.5499267578125
      ],
      [
        -779.7763061523438,
        -2256.816650390625,
        950.9082641601562
      ],
      [
        -778.195068359375,
        -2261.3818359375,
        1027.882080078125
      ],
      [
        -775.5611572265625,
        -2263.055419921875,
        948.4863891601562
      ],
      [
        -778.0450439453125,
        -2261.486328125,
        1023.680419921875
      ],
      [
        -477.7598571777344,
        -2825.35888671875,
        1475.0743408203125
      ],
      [
        -467.463623046875,
        -2820.6962890625,
        1405.229248046875
      ],
      [
        -458.1455383300781,
        -2820.93603515625,
        1363.39306640625
      ],
      [
        -467.463623046875,
        -2820.6962890625,
        1405.229248046875
      ],
      [
        -351.9558410644531,
        -2913.74560546875,
        1384.2762451171875
      ],
      [
        -430.2678527832031,
        -2830.660888671875,
        1347.227294921875
      ],
      [
        -424.3450622558594,
        -2839.9580078125,
        1431.2955322265625
      ],
      [
        -420.02252197265625,
        -2845.73681640625,
        1465.511474609375
      ],
      [
        -424.3450622558594,
        -2839.9580078125,
        1431.2955322265625
      ],
      [
        -360.3669128417969,
        -2906.77197265625,
        1432.8883056640625
      ],
      [
        -351.9558410644531,
        -2913.74560546875,
        1384.2762451171875
      ],
      [
        -423.2952880859375,
        -2833.09326171875,
        1343.18408203125
      ],
      [
        -418.51580810546875,
        -2842.56201171875,
        1434.8194580078125
      ],
      [
        -352.0573425292969,
        -2913.139892578125,
        1383.491943359375
      ],
      [
        -415.3899230957031,
        -2847.371826171875,
        1464.744140625
      ],
      [
        -418.51580810546875,
        -2842.56201171875,
        1434.8194580078125
      ],
      [
        -360.6916809082031,
        -2905.960205078125,
        1433.3387451171875
      ],
      [
        -352.0573425292969,
        -2913.139892578125,
        1383.491943359375
      ],
      [
        -352.36334228515625,
        -2644.916748046875,
        885.4474487304688
      ],
      [
        -359.0617980957031,
        -2631.8935546875,
        842.8338012695312
      ],
      [
        -348.41632080078125,
        -2636.71923828125,
        885.4474487304688
      ],
      [
        -355.1763916015625,
        -2622.86572265625,
        841.3179321289062
      ],
      [
        435.65338134765625,
        -3795.162109375,
        1520.5963134765625
      ],
      [
        6.261878967285156,
        -2217.946533203125,
        965.2910766601562
      ],
      [
        88.00088500976562,
        -2182.5361328125,
        854.3977661132812
      ],
      [
        10.76284408569336,
        -2205.647705078125,
        926.5805053710938
      ],
      [
        -65.38192749023438,
        -2204.348876953125,
        855.09765625
      ],
      [
        -82.27347564697266,
        -2206.352783203125,
        847.1929321289062
      ],
      [
        -65.38194274902344,
        -2204.348876953125,
        855.09765625
      ],
      [
        -178.07568359375,
        -2239.39990234375,
        861.0
      ],
      [
        -125.63127136230469,
        -2221.324462890625,
        861.0
      ],
      [
        -174.511474609375,
        -2233.716796875,
        861.0
      ],
      [
        -212.53125,
        -2294.34033203125,
        861.0
      ],
      [
        -178.07568359375,
        -2239.39990234375,
        861.0
      ],
      [
        -352.1613464355469,
        -2629.04443359375,
        861.0
      ],
      [
        -347.6778869628906,
        -2619.732666015625,
        861.0
      ],
      [
        -227.06105041503906,
        -2297.300048828125,
        836.5
      ],
      [
        -227.94046020507812,
        -2297.300048828125,
        834.7999877929688
      ],
      [
        -217.74984741210938,
        -2297.300048828125,
        854.5
      ],
      [
        -227.06105041503906,
        -2297.300048828125,
        836.5
      ],
      [
        -217.74984741210938,
        -2297.300048828125,
        854.5
      ],
      [
        -216.45657348632812,
        -2297.300048828125,
        857.0
      ],
      [
        -95.5,
        -2297.300048828125,
        825.0
      ],
      [
        -85.5,
        -2297.300048828125,
        825.0
      ],
      [
        -115.5,
        -2297.300048828125,
        825.0
      ],
      [
        -95.5,
        -2297.300048828125,
        825.0
      ],
      [
        -95.5,
        -2297.300048828125,
        836.5
      ],
      [
        -115.5,
        -2297.300048828125,
        836.5
      ],
      [
        -85.5,
        -2297.300048828125,
        833.5
      ],
      [
        -95.5,
        -2297.300048828125,
        836.5
      ],
      [
        -85.5,
        -2297.300048828125,
        825.0
      ],
      [
        -85.5,
        -2297.300048828125,
        833.5
      ],
      [
        -227.94046020507812,
        -2297.300048828125,
        834.7999877929688
      ],
      [
        -230.800048828125,
        -2301.85986328125,
        834.7999877929688
      ],
      [
        -216.45657348632812,
        -2297.300048828125,
        857.0
      ],
      [
        -214.60037231445312,
        -2294.34033203125,
        857.0
      ],
      [
        -214.60037231445312,
        -2294.34033203125,
        857.0
      ],
      [
        -212.53126525878906,
        -2294.34033203125,
        861.0
      ],
      [
        -145.5,
        -2240.5,
        857.0
      ],
      [
        -145.5,
        -2291.0,
        857.0
      ],
      [
        -125.63127136230469,
        -2221.324462890625,
        861.0
      ],
      [
        -125.82259368896484,
        -2220.219970703125,
        857.0
      ],
      [
        -132.5,
        -2240.5,
        857.0
      ],
      [
        -145.5,
        -2240.5,
        857.0
      ],
      [
        -184.0,
        -2245.546875,
        857.0
      ],
      [
        -184.0,
        -2246.371826171875,
        858.0
      ],
      [
        -184.0,
        -2291.0,
        857.0
      ],
      [
        -171.0,
        -2240.5,
        857.0
      ],
      [
        -180.3175506591797,
        -2240.5,
        858.0
      ],
      [
        -180.8348388671875,
        -2240.5,
        857.0
      ],
      [
        -233.00991821289062,
        -2297.300048828125,
        825.0
      ],
      [
        -231.15370178222656,
        -2294.34033203125,
        825.0
      ],
      [
        -160.0,
        -2219.661376953125,
        825.0
      ],
      [
        -129.6967010498047,
        -2211.97900390625,
        825.0
      ],
      [
        -127.32233428955078,
        -2211.562744140625,
        825.0
      ],
      [
        -160.0,
        -2219.661376953125,
        825.0
      ],
      [
        -196.69815063476562,
        -2239.39990234375,
        825.0
      ],
      [
        -188.91696166992188,
        -2226.99267578125,
        825.0
      ],
      [
        -196.69815063476562,
        -2239.39990234375,
        825.0
      ],
      [
        -197.5,
        -2240.678466796875,
        825.0
      ],
      [
        -197.5,
        -2240.678466796875,
        825.0
      ],
      [
        -231.15370178222656,
        -2294.34033203125,
        825.0
      ],
      [
        -121.76889038085938,
        -2209.8974609375,
        819.28125
      ],
      [
        -124.5,
        -2210.372802734375,
        819.2525024414062
      ],
      [
        -124.5,
        -2219.5,
        818.7000122070312
      ],
      [
        -142.3841094970703,
        -2213.484619140625,
        819.0640869140625
      ],
      [
        -166.52584838867188,
        -2219.5,
        818.7000122070312
      ],
      [
        -128.0,
        -2292.5,
        814.2816162109375
      ],
      [
        -155.0,
        -2292.5,
        814.2816162109375
      ],
      [
        -124.5,
        -2289.84033203125,
        814.4425659179688
      ],
      [
        -128.0,
        -2292.5,
        814.2816162109375
      ],
      [
        -120.56061553955078,
        -2264.300048828125,
        855.0
      ],
      [
        -119.3484878540039,
        -2264.300048828125,
        845.0
      ],
      [
        -120.56061553955078,
        -2287.300048828125,
        855.0
      ],
      [
        -119.3484878540039,
        -2287.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2287.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2292.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2264.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2269.300048828125,
        845.0
      ],
      [
        -120.56061553955078,
        -2239.300048828125,
        855.0
      ],
      [
        -119.3484878540039,
        -2239.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2239.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2244.300048828125,
        845.0
      ],
      [
        -120.9000015258789,
        -2264.300048828125,
        855.0
      ],
      [
        -120.50000762939453,
        -2264.300048828125,
        854.5
      ],
      [
        -120.9000015258789,
        -2287.300048828125,
        855.0
      ],
      [
        -120.50000762939453,
        -2287.300048828125,
        854.5
      ],
      [
        -120.9000015258789,
        -2239.300048828125,
        855.0
      ],
      [
        -120.50000762939453,
        -2239.300048828125,
        854.5
      ],
      [
        -123.9921646118164,
        -2218.89111328125,
        854.0
      ],
      [
        -124.02630615234375,
        -2219.0439453125,
        854.5
      ],
      [
        -120.43939208984375,
        -2239.39990234375,
        854.0
      ],
      [
        -120.45671081542969,
        -2239.300048828125,
        854.0
      ],
      [
        -120.43939971923828,
        -2239.300048828125,
        854.0
      ],
      [
        -120.5204086303711,
        -2239.300048828125,
        854.5255126953125
      ],
      [
        -124.02630615234375,
        -2219.0439453125,
        854.5
      ],
      [
        -125.82259368896484,
        -2220.219970703125,
        857.0
      ],
      [
        -120.91727447509766,
        -2239.300048828125,
        855.0
      ],
      [
        -120.517333984375,
        -2239.300048828125,
        854.5001220703125
      ],
      [
        -123.0,
        -2264.300048828125,
        854.0
      ],
      [
        -123.0,
        -2269.300048828125,
        854.0
      ],
      [
        -123.0,
        -2287.300048828125,
        854.0
      ],
      [
        -123.0,
        -2292.300048828125,
        854.0
      ],
      [
        -123.0,
        -2240.5,
        855.0
      ],
      [
        -123.0,
        -2244.300048828125,
        854.0
      ],
      [
        -123.0,
        -2240.5,
        854.0
      ],
      [
        -123.0,
        -2264.300048828125,
        854.0
      ],
      [
        -120.43939971923828,
        -2264.300048828125,
        854.0
      ],
      [
        -123.0,
        -2287.300048828125,
        854.0
      ],
      [
        -120.43939971923828,
        -2287.300048828125,
        854.0
      ],
      [
        -123.0,
        -2239.300048828125,
        854.0
      ],
      [
        -123.0,
        -2239.300048828125,
        854.0
      ],
      [
        -122.89964294433594,
        -2214.002685546875,
        838.0
      ],
      [
        -119.36579895019531,
        -2239.300048828125,
        845.0
      ],
      [
        -120.45671081542969,
        -2239.300048828125,
        854.0
      ],
      [
        -119.36579895019531,
        -2239.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2239.39990234375,
        845.0
      ],
      [
        -122.97138977050781,
        -2213.58837890625,
        836.5
      ],
      [
        -122.89964294433594,
        -2214.002685546875,
        838.0
      ],
      [
        -182.38668823242188,
        -2240.5,
        854.0
      ],
      [
        -184.0,
        -2243.072509765625,
        854.0
      ],
      [
        -214.0574188232422,
        -2291.0,
        854.0
      ],
      [
        -209.0,
        -2282.935791015625,
        854.0
      ],
      [
        -184.0,
        -2243.072509765625,
        854.0
      ],
      [
        -182.38668823242188,
        -2240.5,
        854.0
      ],
      [
        -127.32233428955078,
        -2211.562744140625,
        825.0
      ],
      [
        -126.844482421875,
        -2211.640625,
        826.3350219726562
      ],
      [
        -122.97138977050781,
        -2213.58837890625,
        836.5
      ],
      [
        -118.0,
        -2252.099853515625,
        831.6123657226562
      ],
      [
        -118.0,
        -2250.71923828125,
        832.2999877929688
      ],
      [
        -118.0,
        -2250.71923828125,
        832.2999877929688
      ],
      [
        -118.0,
        -2242.2861328125,
        836.5
      ],
      [
        -118.0,
        -2294.34033203125,
        836.5
      ],
      [
        -118.0,
        -2294.34033203125,
        825.0
      ],
      [
        -75.20256805419922,
        -2188.82080078125,
        754.8995361328125
      ],
      [
        -82.27347564697266,
        -2206.352783203125,
        847.1929321289062
      ],
      [
        -85.23542785644531,
        -2204.010009765625,
        836.4595336914062
      ],
      [
        -122.04180908203125,
        -2208.415771484375,
        819.3709106445312
      ],
      [
        -127.35315704345703,
        -2211.384765625,
        825.0
      ],
      [
        -127.35315704345703,
        -2211.384765625,
        825.0
      ],
      [
        109.38591766357422,
        -2157.62939453125,
        724.793212890625
      ],
      [
        88.00088500976562,
        -2182.5361328125,
        854.3977661132812
      ],
      [
        115.94408416748047,
        -2143.981201171875,
        733.1575927734375
      ],
      [
        120.03185272216797,
        -2140.243408203125,
        721.414306640625
      ],
      [
        115.94408416748047,
        -2143.981201171875,
        733.1575927734375
      ],
      [
        114.55083465576172,
        -2156.28759765625,
        723.9014282226562
      ],
      [
        -93.01200103759766,
        -2197.859130859375,
        808.2791137695312
      ],
      [
        -87.60077667236328,
        -2202.13916015625,
        827.8881225585938
      ],
      [
        -106.53463745117188,
        -2187.16357421875,
        759.2772216796875
      ],
      [
        -93.01200103759766,
        -2197.859130859375,
        808.2791137695312
      ],
      [
        -87.60077667236328,
        -2202.13916015625,
        827.8881225585938
      ],
      [
        2.2432632446289062,
        -2208.197021484375,
        934.54248046875
      ],
      [
        6.261871337890625,
        -2217.946533203125,
        965.2910766601562
      ],
      [
        -137.57774353027344,
        -2185.76123046875,
        765.2666625976562
      ],
      [
        -138.2781219482422,
        -2185.397216796875,
        763.703125
      ],
      [
        -137.57774353027344,
        -2185.76123046875,
        765.2666625976562
      ],
      [
        -123.37515258789062,
        -2201.177490234375,
        819.8090209960938
      ],
      [
        -186.154296875,
        -2217.491455078125,
        818.8215942382812
      ],
      [
        -187.47689819335938,
        -2219.5,
        818.7000122070312
      ],
      [
        -126.46916198730469,
        -2216.487548828125,
        861.0
      ],
      [
        -171.14169311523438,
        -2228.343505859375,
        861.0
      ],
      [
        -129.73455810546875,
        -2219.5,
        867.0999755859375
      ],
      [
        -119.42144775390625,
        -2216.708740234375,
        866.9457397460938
      ],
      [
        -160.0,
        -2212.723388671875,
        825.0
      ],
      [
        -128.56640625,
        -2204.381103515625,
        825.0
      ],
      [
        -160.0,
        -2212.723388671875,
        825.0
      ],
      [
        -183.9552459716797,
        -2219.0810546875,
        825.0
      ],
      [
        -123.98490905761719,
        -2207.738037109375,
        838.0
      ],
      [
        -124.93572235107422,
        -2213.794189453125,
        854.5
      ],
      [
        -128.56640625,
        -2204.381103515625,
        825.0
      ],
      [
        -124.07225799560547,
        -2207.233642578125,
        836.5
      ],
      [
        -124.07225799560547,
        -2207.233642578125,
        836.5
      ],
      [
        -123.98490905761719,
        -2207.738037109375,
        838.0
      ],
      [
        -126.46916198730469,
        -2216.487548828125,
        861.0
      ],
      [
        -126.70217895507812,
        -2215.142578125,
        857.0
      ],
      [
        -124.93572235107422,
        -2213.794189453125,
        854.5
      ],
      [
        -126.70217895507812,
        -2215.142578125,
        857.0
      ],
      [
        2.2432632446289062,
        -2208.197021484375,
        934.54248046875
      ],
      [
        -85.23542785644531,
        -2204.010009765625,
        836.4595336914062
      ],
      [
        -170.35752868652344,
        -2193.500732421875,
        820.2736206054688
      ],
      [
        -187.56568908691406,
        -2183.116943359375,
        774.4188842773438
      ],
      [
        -187.56568908691406,
        -2183.116943359375,
        774.4188842773438
      ],
      [
        -188.94747924804688,
        -2182.283203125,
        770.7368774414062
      ],
      [
        -154.5896759033203,
        -2206.3720703125,
        866.360107421875
      ],
      [
        -124.04472351074219,
        -2197.542724609375,
        820.029052734375
      ],
      [
        -170.35745239257812,
        -2193.50048828125,
        820.273681640625
      ],
      [
        -128.4463348388672,
        -2205.07421875,
        861.0
      ],
      [
        -148.3314971923828,
        -2203.318359375,
        861.0
      ],
      [
        -155.38954162597656,
        -2203.226318359375,
        861.0
      ],
      [
        -162.4400634765625,
        -2219.5,
        867.0999755859375
      ],
      [
        -154.58753967285156,
        -2206.380859375,
        866.375
      ],
      [
        -121.2672119140625,
        -2206.830078125,
        866.3998413085938
      ],
      [
        -160.0,
        -2195.32861328125,
        825.0
      ],
      [
        -129.67066955566406,
        -2198.0068359375,
        825.0
      ],
      [
        -160.0,
        -2195.32861328125,
        825.0
      ],
      [
        -168.5838623046875,
        -2194.57080078125,
        825.0
      ],
      [
        -125.16641998291016,
        -2200.917724609375,
        838.0
      ],
      [
        -126.63630676269531,
        -2203.9775390625,
        854.5
      ],
      [
        -129.67066955566406,
        -2198.0068359375,
        825.0
      ],
      [
        -125.21743774414062,
        -2200.623046875,
        836.5
      ],
      [
        -128.4463348388672,
        -2205.07421875,
        861.0
      ],
      [
        -128.5823974609375,
        -2204.288818359375,
        857.0
      ],
      [
        -126.63630676269531,
        -2203.9775390625,
        854.5
      ],
      [
        -128.5823974609375,
        -2204.288818359375,
        857.0
      ],
      [
        -125.21743774414062,
        -2200.623046875,
        836.5
      ],
      [
        -125.16641998291016,
        -2200.917724609375,
        838.0
      ],
      [
        -153.1080780029297,
        -2203.9091796875,
        866.2384033203125
      ],
      [
        -121.28227233886719,
        -2206.74951171875,
        866.3953857421875
      ],
      [
        -155.07388305664062,
        -2202.722900390625,
        861.0
      ],
      [
        -162.45565795898438,
        -2181.5,
        821.0
      ],
      [
        -166.02816772460938,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -166.02816772460938,
        -2186.925537109375,
        820.671630859375
      ],
      [
        -128.8770751953125,
        -2181.5,
        849.3609008789062
      ],
      [
        -122.45878601074219,
        -2181.5,
        849.4133911132812
      ],
      [
        -160.38650512695312,
        -2181.5,
        825.0
      ],
      [
        -162.45565795898438,
        -2181.5,
        821.0
      ],
      [
        -142.94244384765625,
        -2186.925537109375,
        865.2998046875
      ],
      [
        -142.74118041992188,
        -2186.58935546875,
        865.28125
      ],
      [
        -125.05792236328125,
        -2186.542236328125,
        865.2786254882812
      ],
      [
        -142.9424285888672,
        -2186.925537109375,
        865.2998046875
      ],
      [
        -160.38653564453125,
        -2181.5,
        825.0
      ],
      [
        -164.1160888671875,
        -2187.44677734375,
        825.0
      ],
      [
        -164.11610412597656,
        -2187.44677734375,
        825.0
      ],
      [
        -145.49356079101562,
        -2187.44677734375,
        861.0
      ],
      [
        -128.8770751953125,
        -2181.5,
        849.3609008789062
      ],
      [
        -129.5,
        -2183.1328125,
        854.5
      ],
      [
        -127.5,
        -2186.3974609375,
        836.5
      ],
      [
        -128.129150390625,
        -2181.5,
        834.6912231445312
      ],
      [
        -127.5,
        -2186.3974609375,
        836.5
      ],
      [
        -129.5,
        -2183.1328125,
        854.5
      ],
      [
        -130.31439208984375,
        -2183.4580078125,
        855.5180053710938
      ],
      [
        -131.5,
        -2183.931396484375,
        857.0
      ],
      [
        -131.5,
        -2183.931396484375,
        857.0
      ],
      [
        -132.10870361328125,
        -2183.932861328125,
        857.0
      ],
      [
        -127.5,
        -2186.668701171875,
        836.8875732421875
      ],
      [
        -147.56275939941406,
        -2187.44677734375,
        857.0
      ],
      [
        -145.38064575195312,
        -2183.96728515625,
        857.0
      ],
      [
        -154.65696716308594,
        -2187.44677734375,
        861.0
      ],
      [
        -268.35565185546875,
        -2215.476318359375,
        861.0
      ],
      [
        -264.1788024902344,
        -2219.5,
        867.0999755859375
      ],
      [
        -143.82920837402344,
        -2188.406982421875,
        865.3816528320312
      ],
      [
        -285.90447998046875,
        -2225.2060546875,
        867.4153442382812
      ],
      [
        -277.4501953125,
        -2218.526123046875,
        861.0
      ],
      [
        -285.90447998046875,
        -2225.2060546875,
        867.4153442382812
      ],
      [
        -294.67291259765625,
        -2228.899658203125,
        867.6195068359375
      ],
      [
        -291.0722351074219,
        -2224.105224609375,
        861.0
      ],
      [
        -303.925537109375,
        -2233.296630859375,
        867.8624267578125
      ],
      [
        -310.88970947265625,
        -2233.276611328125,
        861.0
      ],
      [
        -306.70843505859375,
        -2230.509033203125,
        861.0
      ],
      [
        -302.0498352050781,
        -2232.0068359375,
        867.7911987304688
      ],
      [
        -154.5874481201172,
        -2206.380859375,
        866.375
      ],
      [
        -277.4001159667969,
        -2219.5,
        862.9827880859375
      ],
      [
        -277.6429138183594,
        -2219.5,
        861.0
      ],
      [
        -277.4501647949219,
        -2218.526123046875,
        861.0
      ],
      [
        -299.7816162109375,
        -2230.7333984375,
        867.7208251953125
      ],
      [
        -301.7933654785156,
        -2227.839599609375,
        861.0
      ],
      [
        -291.0722351074219,
        -2224.105224609375,
        861.0
      ],
      [
        -294.67291259765625,
        -2228.899658203125,
        867.6195068359375
      ],
      [
        -301.5079040527344,
        -2231.63427734375,
        867.7706298828125
      ],
      [
        -305.518310546875,
        -2229.72119140625,
        861.0
      ],
      [
        -301.7933654785156,
        -2227.839599609375,
        861.0
      ],
      [
        -299.7816162109375,
        -2230.7333984375,
        867.7208251953125
      ],
      [
        -305.518310546875,
        -2229.72119140625,
        861.0
      ],
      [
        -301.5079040527344,
        -2231.63427734375,
        867.7706298828125
      ],
      [
        -277.3228454589844,
        -2217.8828125,
        861.0
      ],
      [
        -277.37689208984375,
        -2219.5,
        863.17236328125
      ],
      [
        -277.2821350097656,
        -2217.677001953125,
        861.0
      ],
      [
        -210.4822540283203,
        -2205.627197265625,
        866.3333129882812
      ],
      [
        -302.0498352050781,
        -2232.0068359375,
        867.7911987304688
      ],
      [
        -264.94683837890625,
        -2181.5,
        821.0
      ],
      [
        -268.1400451660156,
        -2182.24951171875,
        820.9546508789062
      ],
      [
        -251.5053253173828,
        -2181.5,
        825.0
      ],
      [
        -264.94683837890625,
        -2181.5,
        821.0
      ],
      [
        -251.50534057617188,
        -2181.5,
        825.0
      ],
      [
        -263.5,
        -2184.45703125,
        825.0
      ],
      [
        -270.3253479003906,
        -2186.925537109375,
        825.0
      ],
      [
        -268.1400451660156,
        -2182.24951171875,
        820.9546508789062
      ],
      [
        -270.1554870605469,
        -2186.09765625,
        825.0
      ],
      [
        -270.3253479003906,
        -2186.925537109375,
        825.0
      ],
      [
        -277.0091857910156,
        -2219.5,
        825.0
      ],
      [
        -312.5693359375,
        -2212.33984375,
        825.0
      ],
      [
        -314.28076171875,
        -2209.878173828125,
        819.2825317382812
      ],
      [
        -286.6089782714844,
        -2200.54150390625,
        819.84765625
      ],
      [
        -284.0493469238281,
        -2202.405517578125,
        825.0
      ],
      [
        -347.42327880859375,
        -2233.172119140625,
        825.0
      ],
      [
        -354.6549377441406,
        -2233.1513671875,
        817.8739624023438
      ],
      [
        -330.51251220703125,
        -2217.7978515625,
        818.80322265625
      ],
      [
        -326.8420104980469,
        -2219.548828125,
        825.0
      ],
      [
        -326.8420104980469,
        -2219.548828125,
        825.0
      ],
      [
        -330.51251220703125,
        -2217.7978515625,
        818.80322265625
      ],
      [
        -314.28076171875,
        -2209.878173828125,
        819.2825317382812
      ],
      [
        -312.5693359375,
        -2212.33984375,
        825.0
      ],
      [
        -272.6656188964844,
        -2198.3310546875,
        825.0
      ],
      [
        -284.0493469238281,
        -2202.405517578125,
        825.0
      ],
      [
        -286.6089782714844,
        -2200.54150390625,
        819.84765625
      ],
      [
        -168.098388671875,
        -2187.44677734375,
        857.0
      ],
      [
        -154.07594299316406,
        -2183.98974609375,
        857.0
      ],
      [
        -209.0,
        -2240.5,
        857.0
      ],
      [
        -222.0,
        -2240.5,
        857.0
      ],
      [
        -184.0,
        -2240.5,
        857.0
      ],
      [
        -180.8348388671875,
        -2240.5,
        857.0
      ],
      [
        -184.0,
        -2240.5,
        857.0
      ],
      [
        -184.0,
        -2245.546875,
        857.0
      ],
      [
        -278.0542907714844,
        -2206.77099609375,
        837.0676879882812
      ],
      [
        -277.62744140625,
        -2219.421875,
        861.0
      ],
      [
        -278.0542907714844,
        -2206.77099609375,
        837.0676879882812
      ],
      [
        -272.6896667480469,
        -2198.4482421875,
        825.0
      ],
      [
        -277.4501647949219,
        -2218.526123046875,
        861.0
      ],
      [
        -276.244873046875,
        -2197.723876953125,
        837.2224731445312
      ],
      [
        -270.589111328125,
        -2186.925537109375,
        825.870361328125
      ],
      [
        -270.589111328125,
        -2186.925537109375,
        825.870361328125
      ],
      [
        -276.244873046875,
        -2197.723876953125,
        837.2224731445312
      ],
      [
        -278.2578125,
        -2200.33251953125,
        825.0
      ],
      [
        -255.55990600585938,
        -2179.60009765625,
        821.5
      ],
      [
        -261.0,
        -2180.941162109375,
        821.5
      ],
      [
        -253.87985229492188,
        -2179.60009765625,
        822.0
      ],
      [
        -255.55990600585938,
        -2179.60009765625,
        821.5
      ],
      [
        -252.8496856689453,
        -2181.5,
        824.5999755859375
      ],
      [
        -253.87985229492188,
        -2179.60009765625,
        822.0
      ],
      [
        -261.0,
        -2181.5,
        822.1744995117188
      ],
      [
        -261.0,
        -2180.941162109375,
        821.5
      ],
      [
        -354.308349609375,
        -2220.012451171875,
        798.7385864257812
      ],
      [
        -347.122802734375,
        -2228.361328125,
        818.1638793945312
      ],
      [
        -149.79421997070312,
        -2186.925537109375,
        865.2998046875
      ],
      [
        -148.6685333251953,
        -2186.605224609375,
        865.2821044921875
      ],
      [
        -149.79420471191406,
        -2186.925537109375,
        865.2998046875
      ],
      [
        -165.52450561523438,
        -2187.44677734375,
        861.0
      ],
      [
        -268.3276672363281,
        -2215.314697265625,
        861.0
      ],
      [
        -277.2162780761719,
        -2216.41015625,
        859.4903564453125
      ],
      [
        -276.0447998046875,
        -2196.723388671875,
        837.2395629882812
      ],
      [
        -178.36936950683594,
        -2187.44677734375,
        857.0
      ],
      [
        -165.72781372070312,
        -2184.02001953125,
        857.0
      ],
      [
        -271.09100341796875,
        -2186.925537109375,
        827.5264892578125
      ],
      [
        -268.3478698730469,
        -2181.5,
        822.14794921875
      ],
      [
        -271.09100341796875,
        -2186.925537109375,
        827.5264892578125
      ],
      [
        -276.0447998046875,
        -2196.723388671875,
        837.2395629882812
      ],
      [
        -268.3478698730469,
        -2181.5,
        822.14794921875
      ],
      [
        -265.8244323730469,
        -2181.5,
        822.933837890625
      ],
      [
        -259.18975830078125,
        -2181.5,
        825.0
      ],
      [
        -265.8244323730469,
        -2181.5,
        822.933837890625
      ],
      [
        -259.18975830078125,
        -2181.5,
        825.0
      ],
      [
        -263.5,
        -2182.66845703125,
        825.0
      ],
      [
        -260.47467041015625,
        -2181.5,
        824.5999755859375
      ],
      [
        -261.0,
        -2180.755615234375,
        823.5812377929688
      ],
      [
        -261.0,
        -2181.5,
        824.4364013671875
      ],
      [
        -261.0,
        -2180.755615234375,
        823.5812377929688
      ],
      [
        -258.2527160644531,
        -2186.925537109375,
        865.2998046875
      ],
      [
        -258.21820068359375,
        -2186.896728515625,
        865.2982177734375
      ],
      [
        -270.9947814941406,
        -2197.5283203125,
        865.8857421875
      ],
      [
        -258.25274658203125,
        -2186.925537109375,
        865.2998046875
      ],
      [
        -277.2821350097656,
        -2217.677001953125,
        861.0
      ],
      [
        -271.3973693847656,
        -2187.942138671875,
        861.0
      ],
      [
        -271.8732604980469,
        -2191.251220703125,
        862.4619140625
      ],
      [
        -271.8732604980469,
        -2191.251220703125,
        862.4619140625
      ],
      [
        -270.9947814941406,
        -2197.5283203125,
        865.8857421875
      ],
      [
        -263.5,
        -2184.273681640625,
        857.0
      ],
      [
        -271.25115966796875,
        -2186.925537109375,
        860.5508422851562
      ],
      [
        -271.68597412109375,
        -2186.925537109375,
        857.0
      ],
      [
        -271.16510009765625,
        -2184.293701171875,
        857.0
      ],
      [
        -270.9993896484375,
        -2185.1748046875,
        859.7774047851562
      ],
      [
        -277.0851745605469,
        -2214.206787109375,
        857.0
      ],
      [
        -271.68597412109375,
        -2186.925537109375,
        857.0
      ],
      [
        -271.25115966796875,
        -2186.925537109375,
        860.5508422851562
      ],
      [
        -271.6905212402344,
        -2181.5,
        848.1939697265625
      ],
      [
        -266.25897216796875,
        -2181.5,
        848.2384033203125
      ],
      [
        -271.6905212402344,
        -2181.5,
        848.1939697265625
      ],
      [
        -270.8542175292969,
        -2185.94677734375,
        862.2106323242188
      ],
      [
        -270.8542175292969,
        -2185.94677734375,
        862.2106323242188
      ],
      [
        -131.19256591796875,
        -1937.994140625,
        877.8367919921875
      ],
      [
        -119.52893829345703,
        -1943.7169189453125,
        822.0950927734375
      ],
      [
        -131.19256591796875,
        -1937.994140625,
        877.8367919921875
      ],
      [
        -17.906570434570312,
        -1993.5772705078125,
        725.9998168945312
      ],
      [
        131.89161682128906,
        -2067.07470703125,
        711.9805908203125
      ],
      [
        -480.0,
        -1766.85400390625,
        895.0
      ],
      [
        -317.0,
        -1846.8289794921875,
        895.0
      ],
      [
        -361.5999755859375,
        -1777.00439453125,
        927.0407104492188
      ],
      [
        -465.3614196777344,
        -1774.036376953125,
        975.0
      ],
      [
        -456.2104797363281,
        -1778.5262451171875,
        895.0
      ],
      [
        -325.229248046875,
        -1842.7913818359375,
        895.0
      ],
      [
        -317.5520935058594,
        -1846.55810546875,
        965.7921142578125
      ],
      [
        -316.4599914550781,
        -1847.093994140625,
        975.0
      ],
      [
        -317.5520935058594,
        -1846.55810546875,
        965.7921752929688
      ],
      [
        -364.911376953125,
        -1823.3216552734375,
        932.9944458007812
      ],
      [
        -366.427001953125,
        -1822.5780029296875,
        933.9417724609375
      ],
      [
        -364.40289306640625,
        -1823.5711669921875,
        933.7893676757812
      ],
      [
        -364.911376953125,
        -1823.3216552734375,
        932.9944458007812
      ],
      [
        -129.078369140625,
        -1946.1995849609375,
        862.97998046875
      ],
      [
        -116.65182495117188,
        -1951.1494140625,
        804.3529052734375
      ],
      [
        -129.078369140625,
        -1946.1995849609375,
        862.97998046875
      ],
      [
        -170.0,
        -1922.31591796875,
        770.0
      ],
      [
        -171.66697692871094,
        -1920.0,
        770.0
      ],
      [
        -480.0,
        -1806.415771484375,
        895.0
      ],
      [
        -317.0,
        -1871.3441162109375,
        895.0
      ],
      [
        -170.0,
        -1929.899169921875,
        770.0
      ],
      [
        -180.0,
        -1925.915771484375,
        770.0
      ],
      [
        -478.33013916015625,
        -1807.0809326171875,
        975.0
      ],
      [
        -468.4256591796875,
        -1811.026123046875,
        895.0
      ],
      [
        -334.6983947753906,
        -1864.294189453125,
        895.0
      ],
      [
        -330.0039367675781,
        -1866.1641845703125,
        936.8412475585938
      ],
      [
        -325.3266906738281,
        -1868.02734375,
        975.0
      ],
      [
        -330.0039367675781,
        -1866.1641845703125,
        936.84130859375
      ],
      [
        -364.4867248535156,
        -1832.5,
        932.9812622070312
      ],
      [
        -364.4773864746094,
        -1823.53466796875,
        933.6729125976562
      ],
      [
        -364.60009765625,
        -1834.4891357421875,
        932.7999267578125
      ],
      [
        -364.8807678222656,
        -1834.48681640625,
        932.975341796875
      ],
      [
        -364.8807678222656,
        -1834.48681640625,
        932.975341796875
      ],
      [
        -373.0906066894531,
        -1834.4173583984375,
        938.106689453125
      ],
      [
        -382.0517578125,
        -1834.845458984375,
        906.4307861328125
      ],
      [
        -393.1310729980469,
        -1834.861572265625,
        905.2467651367188
      ],
      [
        -364.60009765625,
        -1834.4891357421875,
        932.7999267578125
      ],
      [
        -386.6792907714844,
        -1843.5885009765625,
        906.42333984375
      ],
      [
        -398.227294921875,
        -1838.9884033203125,
        904.9318237304688
      ],
      [
        -363.32025146484375,
        -1834.5,
        932.0
      ],
      [
        -377.7359619140625,
        -1847.1510009765625,
        909.0686645507812
      ],
      [
        -386.6792907714844,
        -1843.5885009765625,
        906.42333984375
      ],
      [
        135.55726623535156,
        -2073.446044921875,
        712.1194458007812
      ],
      [
        72.51788330078125,
        -2187.1689453125,
        868.8673706054688
      ],
      [
        -118.56556701660156,
        -1950.38720703125,
        813.3817138671875
      ],
      [
        -103.21552276611328,
        -1964.927001953125,
        735.3753662109375
      ],
      [
        54.186500549316406,
        -2192.654296875,
        885.9989624023438
      ],
      [
        67.68318176269531,
        -2197.409423828125,
        925.469970703125
      ],
      [
        -156.7864990234375,
        -1941.345947265625,
        768.1051025390625
      ],
      [
        -144.57403564453125,
        -1940.0272216796875,
        819.6739501953125
      ],
      [
        -156.7864990234375,
        -1941.345947265625,
        768.1051025390625
      ],
      [
        -152.91403198242188,
        -1956.10107421875,
        741.6661376953125
      ],
      [
        10.762889862060547,
        -2205.647705078125,
        926.5804443359375
      ],
      [
        -325.4910888671875,
        -1887.239013671875,
        895.0
      ],
      [
        -339.44354248046875,
        -1884.5,
        895.0
      ],
      [
        -480.0,
        -1856.906494140625,
        895.0
      ],
      [
        -339.4434814453125,
        -1884.5,
        895.0
      ],
      [
        -479.5778503417969,
        -1856.989501953125,
        975.0
      ],
      [
        -469.62359619140625,
        -1858.943603515625,
        895.0
      ],
      [
        -332.85211181640625,
        -1885.7939453125,
        975.0
      ],
      [
        -341.4044494628906,
        -1884.114990234375,
        910.3347778320312
      ],
      [
        -343.265869140625,
        -1883.7496337890625,
        895.0
      ],
      [
        -341.4044494628906,
        -1884.114990234375,
        910.3347778320312
      ],
      [
        -364.4867248535156,
        -1873.0,
        932.9812622070312
      ],
      [
        -364.476318359375,
        -1863.0078125,
        933.7521362304688
      ],
      [
        -364.4867248535156,
        -1875.0,
        932.9812622070312
      ],
      [
        -364.48193359375,
        -1879.58447265625,
        933.3348999023438
      ],
      [
        -364.2569274902344,
        -1879.628662109375,
        933.6981811523438
      ],
      [
        -364.4867248535156,
        -1875.0,
        932.9812622070312
      ],
      [
        -386.8975524902344,
        -1875.18408203125,
        923.8720703125
      ],
      [
        -386.78643798828125,
        -1875.205810546875,
        923.9033203125
      ],
      [
        -433.007080078125,
        -1866.1319580078125,
        942.0552368164062
      ],
      [
        -431.9927062988281,
        -1866.3310546875,
        940.444091796875
      ],
      [
        -404.89727783203125,
        -1871.650390625,
        921.3309936523438
      ],
      [
        -386.8975524902344,
        -1875.18408203125,
        923.8720703125
      ],
      [
        -431.9927062988281,
        -1866.3310546875,
        940.444091796875
      ],
      [
        -420.9374084472656,
        -1868.50146484375,
        927.3629150390625
      ],
      [
        -386.78643798828125,
        -1875.205810546875,
        923.9033203125
      ],
      [
        -386.8122863769531,
        -1875.2008056640625,
        923.96484375
      ],
      [
        -413.6098937988281,
        -1869.93994140625,
        922.7227783203125
      ],
      [
        -404.89727783203125,
        -1871.650390625,
        921.3309936523438
      ],
      [
        -420.9374084472656,
        -1868.50146484375,
        927.3629150390625
      ],
      [
        -413.6098937988281,
        -1869.93994140625,
        922.7227783203125
      ],
      [
        -415.90264892578125,
        -1858.717529296875,
        915.8359375
      ],
      [
        -414.19915771484375,
        -1860.672119140625,
        915.9921264648438
      ],
      [
        -414.5202941894531,
        -1860.3492431640625,
        915.9148559570312
      ],
      [
        -414.19915771484375,
        -1860.672119140625,
        915.9921264648438
      ],
      [
        -414.5202941894531,
        -1860.3492431640625,
        915.9148559570312
      ],
      [
        -414.5531311035156,
        -1860.3162841796875,
        915.906982421875
      ],
      [
        -416.77490234375,
        -1857.8739013671875,
        915.59130859375
      ],
      [
        -416.0355224609375,
        -1858.8260498046875,
        915.5504150390625
      ],
      [
        -416.77490234375,
        -1857.8739013671875,
        915.59130859375
      ],
      [
        -409.2228698730469,
        -1856.6424560546875,
        911.7913208007812
      ],
      [
        -414.4464111328125,
        -1860.8724365234375,
        915.4625854492188
      ],
      [
        -412.94708251953125,
        -1859.6583251953125,
        913.9824829101562
      ],
      [
        -413.41632080078125,
        -1860.0382080078125,
        914.2586059570312
      ],
      [
        -409.8982238769531,
        -1857.1893310546875,
        912.1886596679688
      ],
      [
        -412.94708251953125,
        -1859.6583251953125,
        913.9824829101562
      ],
      [
        -410.746337890625,
        -1857.8760986328125,
        912.6876831054688
      ],
      [
        -410.746337890625,
        -1857.8760986328125,
        912.6876831054688
      ],
      [
        -409.8982238769531,
        -1857.1893310546875,
        912.1886596679688
      ],
      [
        -414.6675109863281,
        -1860.587646484375,
        915.4747924804688
      ],
      [
        -414.4464111328125,
        -1860.8724365234375,
        915.4625854492188
      ],
      [
        -414.6675109863281,
        -1860.587646484375,
        915.4747924804688
      ],
      [
        -409.8028259277344,
        -1849.87255859375,
        909.3016357421875
      ],
      [
        -408.82843017578125,
        -1851.0782470703125,
        909.2991333007812
      ],
      [
        -408.82843017578125,
        -1851.0782470703125,
        909.2991333007812
      ],
      [
        -409.0236511230469,
        -1850.8758544921875,
        909.2586059570312
      ],
      [
        -412.9498596191406,
        -1845.818603515625,
        909.4773559570312
      ],
      [
        -414.3072814941406,
        -1844.0318603515625,
        909.5927734375
      ],
      [
        -414.1578369140625,
        -1844.2608642578125,
        909.54638671875
      ],
      [
        -414.1578369140625,
        -1844.2608642578125,
        909.54638671875
      ],
      [
        -412.6193542480469,
        -1846.6163330078125,
        909.0692138671875
      ],
      [
        -412.6193542480469,
        -1846.6163330078125,
        909.0692138671875
      ],
      [
        -411.8395080566406,
        -1847.8101806640625,
        908.827392578125
      ],
      [
        -410.00067138671875,
        -1849.86279296875,
        909.0559692382812
      ],
      [
        -410.00067138671875,
        -1849.86279296875,
        909.0559692382812
      ],
      [
        -411.8395080566406,
        -1847.8101806640625,
        908.827392578125
      ],
      [
        -411.54412841796875,
        -1848.262451171875,
        908.7357788085938
      ],
      [
        -407.48968505859375,
        -1854.4698486328125,
        907.478271484375
      ],
      [
        -413.1623840332031,
        -1859.8326416015625,
        913.9617919921875
      ],
      [
        -413.1623840332031,
        -1859.8326416015625,
        913.9617919921875
      ],
      [
        -412.4131164550781,
        -1859.225830078125,
        913.0860595703125
      ],
      [
        -412.4131164550781,
        -1859.225830078125,
        913.0860595703125
      ],
      [
        -408.5957336425781,
        -1856.1346435546875,
        908.624267578125
      ],
      [
        -422.4215393066406,
        -1850.6026611328125,
        915.9035034179688
      ],
      [
        -422.4280090332031,
        -1850.60791015625,
        915.8896484375
      ],
      [
        -420.8323974609375,
        -1853.0509033203125,
        915.3948364257812
      ],
      [
        -420.8323974609375,
        -1853.0509033203125,
        915.3948364257812
      ],
      [
        -420.001220703125,
        -1854.323486328125,
        915.1370239257812
      ],
      [
        -415.5675048828125,
        -1861.11181640625,
        913.7618408203125
      ],
      [
        -420.001220703125,
        -1854.323486328125,
        915.1370239257812
      ],
      [
        -422.6275634765625,
        -1850.76953125,
        915.4623413085938
      ],
      [
        -421.35247802734375,
        -1852.7218017578125,
        915.0668334960938
      ],
      [
        -421.35247802734375,
        -1852.7218017578125,
        915.0668334960938
      ],
      [
        -420.68817138671875,
        -1853.7388916015625,
        914.86083984375
      ],
      [
        -417.14483642578125,
        -1859.1639404296875,
        913.7618408203125
      ],
      [
        -420.68817138671875,
        -1853.7388916015625,
        914.86083984375
      ],
      [
        -373.19097900390625,
        -1877.8748779296875,
        938.1693725585938
      ],
      [
        -364.7537536621094,
        -1879.5311279296875,
        932.89599609375
      ],
      [
        -364.7537536621094,
        -1879.5311279296875,
        932.89599609375
      ],
      [
        -364.4888000488281,
        -1875.0,
        932.826904296875
      ],
      [
        -364.5322265625,
        -1875.0,
        932.7575073242188
      ],
      [
        -364.4901123046875,
        -1875.0,
        932.7311401367188
      ],
      [
        -359.621337890625,
        -1884.8155517578125,
        895.0
      ],
      [
        -359.164306640625,
        -1884.5,
        895.0
      ],
      [
        -354.7975158691406,
        -1881.4857177734375,
        895.0
      ],
      [
        -359.1643981933594,
        -1884.5,
        895.0
      ],
      [
        -433.4872741699219,
        -1935.8033447265625,
        892.0023193359375
      ],
      [
        -442.0,
        -1928.0,
        895.0
      ],
      [
        -433.4872741699219,
        -1935.8033447265625,
        895.0
      ],
      [
        -433.4872741699219,
        -1935.8033447265625,
        892.0023193359375
      ],
      [
        -433.4872741699219,
        -1935.8033447265625,
        872.4360961914062
      ],
      [
        -433.6276550292969,
        -1935.6746826171875,
        780.299072265625
      ],
      [
        -365.0,
        -1888.5283203125,
        893.5
      ],
      [
        -396.106201171875,
        -1910.0,
        893.5
      ],
      [
        -427.11065673828125,
        -1884.5,
        893.5
      ],
      [
        -427.9731750488281,
        -1884.5,
        893.5
      ],
      [
        -430.0,
        -1884.5,
        893.5
      ],
      [
        -427.9731750488281,
        -1884.5,
        893.5
      ],
      [
        -360.0,
        -1884.5,
        893.5
      ],
      [
        -364.9961242675781,
        -1884.5,
        893.5
      ],
      [
        -405.01934814453125,
        -1884.5,
        893.5
      ],
      [
        -427.11065673828125,
        -1884.5,
        893.5
      ],
      [
        -412.5,
        -1921.3162841796875,
        892.0
      ],
      [
        -399.0033874511719,
        -1912.0,
        892.0
      ],
      [
        -399.0033874511719,
        -1912.0,
        892.0
      ],
      [
        -412.5,
        -1912.0,
        893.5
      ],
      [
        -399.00341796875,
        -1912.0,
        893.5
      ],
      [
        -360.0,
        -1884.5,
        893.5
      ],
      [
        -359.621337890625,
        -1884.8155517578125,
        892.0023193359375
      ],
      [
        -359.621337890625,
        -1884.8155517578125,
        893.5
      ],
      [
        -412.5,
        -1912.0,
        893.5
      ],
      [
        -412.5,
        -1921.3162841796875,
        892.0
      ],
      [
        -412.5,
        -1921.3162841796875,
        893.5
      ],
      [
        -440.5,
        -1910.0,
        895.0
      ],
      [
        -396.106201171875,
        -1910.0,
        893.5
      ],
      [
        -396.1061706542969,
        -1910.0,
        895.0
      ],
      [
        -412.5,
        -1912.0,
        895.0
      ],
      [
        -399.00341796875,
        -1912.0,
        895.0
      ],
      [
        -412.5,
        -1912.0,
        895.0
      ],
      [
        -412.5,
        -1921.3162841796875,
        895.0
      ],
      [
        -386.5,
        -1886.0,
        895.0
      ],
      [
        -385.75,
        -1886.0,
        895.0
      ],
      [
        -385.75,
        -1886.0,
        895.0
      ],
      [
        -385.0,
        -1886.0,
        895.0
      ],
      [
        -381.5,
        -1886.0,
        895.0
      ],
      [
        -385.0,
        -1886.0,
        895.0
      ],
      [
        -381.5,
        -1886.0,
        895.0
      ],
      [
        -365.0,
        -1886.0,
        895.0
      ],
      [
        -427.53570556640625,
        -1886.0,
        895.0
      ],
      [
        -426.31817626953125,
        -1886.0,
        895.0
      ],
      [
        -430.0,
        -1886.0,
        895.0
      ],
      [
        -427.53570556640625,
        -1886.0,
        895.0
      ],
      [
        -426.31817626953125,
        -1886.0,
        895.0
      ],
      [
        -386.5,
        -1886.0,
        895.0
      ],
      [
        -424.21685791015625,
        -1884.5,
        895.0
      ],
      [
        -425.9432067871094,
        -1884.5,
        895.0
      ],
      [
        -430.0,
        -1884.5,
        895.0
      ],
      [
        -425.9432067871094,
        -1884.5,
        895.0
      ],
      [
        -360.0,
        -1884.5,
        895.0
      ],
      [
        -424.21685791015625,
        -1884.5,
        895.0
      ],
      [
        -360.0,
        -1884.5,
        895.0
      ],
      [
        -359.621337890625,
        -1884.8155517578125,
        895.0
      ],
      [
        -430.0,
        -1886.0,
        894.5
      ],
      [
        -438.1666564941406,
        -1893.0,
        893.5
      ],
      [
        -438.1666564941406,
        -1893.0,
        894.5
      ],
      [
        -420.5,
        -1886.0,
        894.5
      ],
      [
        -420.5,
        -1893.0,
        893.5
      ],
      [
        -420.5,
        -1893.0,
        894.5
      ],
      [
        -427.5,
        -1886.0,
        894.5
      ],
      [
        -427.5,
        -1893.0,
        893.5
      ],
      [
        -427.5,
        -1893.0,
        894.5
      ],
      [
        -430.0,
        -1893.0,
        893.5
      ],
      [
        -430.0,
        -1886.0,
        894.5
      ],
      [
        -430.0,
        -1893.0,
        894.5
      ],
      [
        -423.0,
        -1893.0,
        893.5
      ],
      [
        -423.0,
        -1886.0,
        894.5
      ],
      [
        -423.0,
        -1893.0,
        894.5
      ],
      [
        -386.5,
        -1890.0,
        894.5
      ],
      [
        -386.5,
        -1890.0,
        893.5
      ],
      [
        -365.0,
        -1888.5283203125,
        893.5
      ],
      [
        -365.0,
        -1886.0,
        894.0
      ],
      [
        -365.0,
        -1888.5283203125,
        894.0
      ],
      [
        -365.0,
        -1886.0,
        894.5
      ],
      [
        -365.0,
        -1888.5283203125,
        894.5
      ],
      [
        -416.5,
        -1887.0,
        895.0
      ],
      [
        -390.5,
        -1887.0,
        895.0
      ],
      [
        -420.5,
        -1887.0,
        895.0
      ],
      [
        -420.5,
        -1886.0,
        895.0
      ],
      [
        -420.5,
        -1887.0,
        894.5
      ],
      [
        -431.1666564941406,
        -1887.0,
        895.0
      ],
      [
        -430.0,
        -1886.0,
        895.0
      ],
      [
        -431.1666564941406,
        -1887.0,
        894.5
      ],
      [
        -427.5,
        -1887.0,
        895.0
      ],
      [
        -427.5,
        -1886.0,
        895.0
      ],
      [
        -427.5,
        -1887.0,
        894.5
      ],
      [
        -430.0,
        -1886.0,
        895.0
      ],
      [
        -430.0,
        -1887.0,
        895.0
      ],
      [
        -430.0,
        -1887.0,
        894.5
      ],
      [
        -423.0,
        -1886.0,
        895.0
      ],
      [
        -423.0,
        -1887.0,
        895.0
      ],
      [
        -423.0,
        -1887.0,
        894.5
      ],
      [
        -380.0,
        -1887.0,
        894.5
      ],
      [
        -380.0,
        -1887.0,
        895.0
      ],
      [
        -365.0,
        -1886.0,
        895.0
      ],
      [
        -365.0,
        -1887.0,
        895.0
      ],
      [
        -365.0,
        -1887.0,
        894.5
      ],
      [
        -370.0,
        -1887.0,
        895.0
      ],
      [
        -370.0,
        -1887.0,
        894.5
      ],
      [
        -390.5,
        -1887.0,
        895.0
      ],
      [
        -390.5,
        -1886.0,
        895.0
      ],
      [
        -416.5,
        -1886.0,
        895.0
      ],
      [
        -416.5,
        -1887.0,
        895.0
      ],
      [
        -438.1666564941406,
        -1893.0,
        895.0
      ],
      [
        -420.5,
        -1893.0,
        895.0
      ],
      [
        -427.5,
        -1893.0,
        895.0
      ],
      [
        -430.0,
        -1893.0,
        895.0
      ],
      [
        -423.0,
        -1893.0,
        895.0
      ],
      [
        -365.0,
        -1888.0,
        895.0
      ],
      [
        -365.0,
        -1888.0,
        894.5
      ],
      [
        -365.0,
        -1888.5283203125,
        895.0
      ],
      [
        -440.5,
        -1910.0,
        895.0
      ],
      [
        -440.5,
        -1895.0,
        895.0
      ],
      [
        -440.5,
        -1895.0,
        895.0
      ],
      [
        -427.5,
        -1893.5,
        895.0
      ],
      [
        -428.0,
        -1894.5,
        895.0
      ],
      [
        -429.5,
        -1894.5,
        895.0
      ],
      [
        -428.0,
        -1894.5,
        895.0
      ],
      [
        -430.0,
        -1893.5,
        895.0
      ],
      [
        -429.5,
        -1894.5,
        895.0
      ],
      [
        -427.5,
        -1893.5,
        895.0
      ],
      [
        -430.0,
        -1893.5,
        895.0
      ],
      [
        -422.5,
        -1894.5,
        895.0
      ],
      [
        -421.0,
        -1894.5,
        895.0
      ],
      [
        -420.5,
        -1893.5,
        895.0
      ],
      [
        -421.0,
        -1894.5,
        895.0
      ],
      [
        -423.0,
        -1893.5,
        895.0
      ],
      [
        -422.5,
        -1894.5,
        895.0
      ],
      [
        -420.5,
        -1893.5,
        895.0
      ],
      [
        -423.0,
        -1893.5,
        895.0
      ],
      [
        -360.0,
        -1885.076904296875,
        913.038330078125
      ],
      [
        -373.6513977050781,
        -1894.5,
        930.0
      ],
      [
        -422.18267822265625,
        -1928.0,
        930.0
      ],
      [
        -373.6513977050781,
        -1894.5,
        930.0
      ],
      [
        -374.3757629394531,
        -1895.0,
        921.0
      ],
      [
        -365.0,
        -1888.5284423828125,
        914.0969848632812
      ],
      [
        -360.0,
        -1884.5,
        909.8001098632812
      ],
      [
        -359.6213684082031,
        -1884.8155517578125,
        910.1367797851562
      ],
      [
        -359.6213684082031,
        -1884.8155517578125,
        912.0
      ],
      [
        -359.6213684082031,
        -1884.8155517578125,
        912.0
      ],
      [
        -360.0,
        -1885.076904296875,
        913.038330078125
      ],
      [
        -396.1060485839844,
        -1910.0,
        921.0
      ],
      [
        -374.3757629394531,
        -1895.0,
        921.0
      ],
      [
        -441.1549072265625,
        -1904.8299560546875,
        930.0
      ],
      [
        -441.3722229003906,
        -1903.716552734375,
        921.0
      ],
      [
        -436.0,
        -1903.3736572265625,
        921.0
      ],
      [
        -430.0,
        -1933.3961181640625,
        921.1698608398438
      ],
      [
        -422.18267822265625,
        -1928.0,
        930.0
      ],
      [
        -436.0,
        -1928.0,
        921.0
      ],
      [
        -430.0,
        -1933.3961181640625,
        921.1698608398438
      ],
      [
        -430.0646057128906,
        -1933.440673828125,
        921.0
      ],
      [
        -396.1060485839844,
        -1910.0,
        921.0
      ],
      [
        -396.1061096191406,
        -1910.0,
        911.4000244140625
      ],
      [
        -396.1061096191406,
        -1910.0,
        911.4000244140625
      ],
      [
        -396.1060485839844,
        -1910.0,
        906.0
      ],
      [
        -396.1060485839844,
        -1910.0,
        906.0
      ],
      [
        -433.48736572265625,
        -1935.8033447265625,
        912.0
      ],
      [
        -399.00347900390625,
        -1912.0,
        904.0
      ],
      [
        -412.5,
        -1921.3162841796875,
        904.0
      ],
      [
        -433.48736572265625,
        -1935.8033447265625,
        912.0
      ],
      [
        -399.00347900390625,
        -1912.0,
        904.0
      ],
      [
        -412.5,
        -1921.3162841796875,
        904.0
      ],
      [
        -371.5,
        -1885.0,
        906.0
      ],
      [
        -378.5,
        -1885.0,
        906.0
      ],
      [
        -390.5,
        -1885.0,
        906.0
      ],
      [
        -416.5,
        -1885.0,
        906.0
      ],
      [
        -360.0,
        -1884.5,
        906.0
      ],
      [
        -359.6213684082031,
        -1884.8155517578125,
        906.0
      ],
      [
        -390.5,
        -1885.0,
        899.0
      ],
      [
        -416.5,
        -1885.0,
        899.0
      ],
      [
        -370.5454406738281,
        -1884.5,
        899.0
      ],
      [
        -370.5454406738281,
        -1885.0,
        899.0
      ],
      [
        -370.0,
        -1885.0,
        895.0
      ],
      [
        -360.0,
        -1884.5,
        899.0
      ],
      [
        -359.621337890625,
        -1884.8155517578125,
        899.0
      ],
      [
        -380.0,
        -1885.0,
        895.0
      ],
      [
        -379.4545593261719,
        -1885.0,
        899.0
      ],
      [
        -379.4545593261719,
        -1884.5,
        899.0
      ],
      [
        -378.5,
        -1885.0,
        906.0
      ],
      [
        -418.5,
        -1885.0,
        904.5
      ],
      [
        -418.5,
        -1885.0,
        900.5
      ],
      [
        -388.5,
        -1885.0,
        900.5
      ],
      [
        -388.5,
        -1885.0,
        904.5
      ],
      [
        -418.5,
        -1885.0,
        900.5
      ],
      [
        -416.5,
        -1885.0,
        899.0
      ],
      [
        -418.5,
        -1885.0,
        904.5
      ],
      [
        -416.5,
        -1885.0,
        906.0
      ],
      [
        -388.5,
        -1885.0,
        900.5
      ],
      [
        -390.5,
        -1885.0,
        899.0
      ],
      [
        -388.5,
        -1885.0,
        904.5
      ],
      [
        -390.5,
        -1885.0,
        906.0
      ],
      [
        -371.5,
        -1885.0,
        906.0
      ],
      [
        -370.5454406738281,
        -1886.0,
        899.0
      ],
      [
        -370.5454406738281,
        -1885.0,
        899.0
      ],
      [
        -379.4545593261719,
        -1886.0,
        899.0
      ],
      [
        -379.4545593261719,
        -1885.0,
        899.0
      ],
      [
        -432.1875,
        -1896.0,
        919.0
      ],
      [
        -432.734375,
        -1896.0,
        918.5
      ],
      [
        -432.734375,
        -1898.5,
        918.5
      ],
      [
        -432.1875,
        -1898.5,
        919.0
      ],
      [
        -430.0,
        -1898.5,
        921.0
      ],
      [
        -430.0,
        -1896.0,
        921.0
      ],
      [
        -432.734375,
        -1895.0,
        918.5
      ],
      [
        -430.0,
        -1892.65625,
        918.5
      ],
      [
        -432.734375,
        -1895.0,
        918.5
      ],
      [
        -432.1875,
        -1909.0,
        919.0
      ],
      [
        -432.1875,
        -1906.5,
        919.0
      ],
      [
        -432.734375,
        -1906.5,
        918.5
      ],
      [
        -432.734375,
        -1909.0,
        918.5
      ],
      [
        -432.734375,
        -1910.0,
        918.5
      ],
      [
        -432.1875,
        -1910.0,
        919.0
      ],
      [
        -430.0,
        -1906.5,
        921.0
      ],
      [
        -441.4325866699219,
        -1903.4072265625,
        918.5
      ],
      [
        -437.6666564941406,
        -1903.1668701171875,
        918.5
      ],
      [
        -365.0,
        -1886.0,
        898.5
      ],
      [
        -365.0,
        -1887.0,
        898.4998779296875
      ],
      [
        -365.0,
        -1887.0,
        895.0
      ],
      [
        -365.0,
        -1886.0,
        898.8331909179688
      ],
      [
        -365.0,
        -1888.5,
        897.9998779296875
      ],
      [
        -365.0,
        -1888.5,
        897.5
      ],
      [
        -365.0,
        -1887.0,
        897.5
      ],
      [
        -365.0,
        -1888.5283203125,
        897.9904174804688
      ],
      [
        -365.0,
        -1888.5283203125,
        897.5
      ],
      [
        -365.0,
        -1888.5283203125,
        911.4000244140625
      ],
      [
        -365.0,
        -1888.5283203125,
        906.0
      ],
      [
        -365.0,
        -1888.5284423828125,
        914.0969848632812
      ],
      [
        -365.0,
        -1888.5283203125,
        911.4000244140625
      ],
      [
        -365.0,
        -1888.5283203125,
        906.0
      ],
      [
        -415.5,
        -1887.314208984375,
        908.4000244140625
      ],
      [
        -415.5,
        -1888.0947265625,
        907.5999755859375
      ],
      [
        -412.5999755859375,
        -1888.0947265625,
        907.5999755859375
      ],
      [
        -412.5999755859375,
        -1887.314208984375,
        908.4000244140625
      ],
      [
        -413.4000244140625,
        -1888.0946044921875,
        907.5999755859375
      ],
      [
        -413.4000244140625,
        -1887.3140869140625,
        908.4000244140625
      ],
      [
        -411.0,
        -1888.0947265625,
        907.5999755859375
      ],
      [
        -411.0,
        -1887.314208984375,
        908.4000244140625
      ],
      [
        -405.5,
        -1887.314208984375,
        908.4000244140625
      ],
      [
        -405.5,
        -1888.0947265625,
        907.5999755859375
      ],
      [
        -402.5999755859375,
        -1888.0947265625,
        907.5999755859375
      ],
      [
        -402.5999755859375,
        -1887.314208984375,
        908.4000244140625
      ],
      [
        -403.4000244140625,
        -1888.0946044921875,
        907.5999755859375
      ],
      [
        -403.4000244140625,
        -1887.3140869140625,
        908.4000244140625
      ],
      [
        -401.0,
        -1888.0947265625,
        907.5999755859375
      ],
      [
        -401.0,
        -1887.314208984375,
        908.4000244140625
      ],
      [
        -390.5,
        -1888.0947265625,
        907.5999755859375
      ],
      [
        -390.5,
        -1887.314208984375,
        908.4000244140625
      ],
      [
        -392.800048828125,
        -1887.314208984375,
        908.4000244140625
      ],
      [
        -392.800048828125,
        -1888.0947265625,
        907.5999755859375
      ],
      [
        -392.0,
        -1887.3140869140625,
        908.4000244140625
      ],
      [
        -392.0,
        -1888.0946044921875,
        907.5999755859375
      ],
      [
        -392.800048828125,
        -1889.916015625,
        905.73291015625
      ],
      [
        -395.0,
        -1887.314208984375,
        908.4000244140625
      ],
      [
        -440.5773620605469,
        -1907.789306640625,
        953.920654296875
      ],
      [
        -435.1726379394531,
        -1907.3438720703125,
        953.1187744140625
      ],
      [
        -435.1726379394531,
        -1907.3438720703125,
        953.1187744140625
      ],
      [
        -383.2629699707031,
        -1901.134765625,
        930.0
      ],
      [
        -386.4400329589844,
        -1903.327880859375,
        945.8899536132812
      ],
      [
        -392.2603759765625,
        -1907.345458984375,
        975.0
      ],
      [
        -365.50933837890625,
        -1884.96533203125,
        933.3682250976562
      ],
      [
        -364.9289245605469,
        -1884.6959228515625,
        933.0054321289062
      ],
      [
        -364.9289245605469,
        -1884.6959228515625,
        933.0054321289062
      ],
      [
        -364.7384338378906,
        -1884.9921875,
        933.3326416015625
      ],
      [
        -431.22930908203125,
        -1934.768798828125,
        1080.0
      ],
      [
        -434.07379150390625,
        -1936.41796875,
        960.5042114257812
      ],
      [
        -434.07379150390625,
        -1936.41796875,
        960.5042114257812
      ],
      [
        -421.8410339355469,
        -1928.0,
        930.0
      ],
      [
        -372.7261047363281,
        -1894.5,
        930.0
      ],
      [
        -365.0,
        -1889.1412353515625,
        893.5
      ],
      [
        -395.58123779296875,
        -1910.0,
        893.5
      ],
      [
        -433.45745849609375,
        -1935.8306884765625,
        892.0023193359375
      ],
      [
        -433.4872741699219,
        -1935.8033447265625,
        893.5
      ],
      [
        -433.4551696777344,
        -1935.832763671875,
        893.5
      ],
      [
        -433.45745849609375,
        -1935.8306884765625,
        892.0023193359375
      ],
      [
        -412.5,
        -1921.5361328125,
        892.0
      ],
      [
        -398.51904296875,
        -1912.0,
        892.0
      ],
      [
        -398.51904296875,
        -1912.0,
        892.0
      ],
      [
        -399.0033874511719,
        -1912.0,
        893.5
      ],
      [
        -398.513671875,
        -1912.0,
        893.5
      ],
      [
        -359.1902160644531,
        -1885.1748046875,
        892.0023193359375
      ],
      [
        -359.18780517578125,
        -1885.1767578125,
        893.5
      ],
      [
        -359.621337890625,
        -1884.8155517578125,
        893.5
      ],
      [
        -412.5,
        -1921.3162841796875,
        893.5
      ],
      [
        -412.5,
        -1921.5361328125,
        892.0
      ],
      [
        -412.5,
        -1921.539794921875,
        893.5
      ],
      [
        -395.48309326171875,
        -1910.0,
        921.0
      ],
      [
        -373.4913024902344,
        -1895.0,
        921.0
      ],
      [
        -430.0,
        -1933.5,
        921.0
      ],
      [
        -421.8410339355469,
        -1928.0,
        930.0
      ],
      [
        -429.9368591308594,
        -1933.5,
        921.0
      ],
      [
        -365.4277038574219,
        -1889.5,
        921.0
      ],
      [
        -372.7261047363281,
        -1894.5,
        930.0
      ],
      [
        -366.4078674316406,
        -1889.5,
        921.0
      ],
      [
        -430.0646057128906,
        -1933.440673828125,
        921.0
      ],
      [
        -430.0,
        -1933.5,
        921.0
      ],
      [
        -359.15802001953125,
        -1885.20166015625,
        912.0
      ],
      [
        -433.427001953125,
        -1935.858642578125,
        912.0
      ],
      [
        -398.4761657714844,
        -1912.0,
        904.0
      ],
      [
        -412.5,
        -1921.5653076171875,
        904.0
      ],
      [
        -373.4913024902344,
        -1895.0,
        921.0
      ],
      [
        -365.0,
        -1889.1932373046875,
        914.8060913085938
      ],
      [
        -360.0,
        -1885.7816162109375,
        914.3068237304688
      ],
      [
        -359.15802001953125,
        -1885.20166015625,
        912.0
      ],
      [
        -360.0,
        -1885.7816162109375,
        914.3068237304688
      ],
      [
        -433.427001953125,
        -1935.858642578125,
        912.0
      ],
      [
        -430.0,
        -1933.5428466796875,
        920.9298095703125
      ],
      [
        -395.48309326171875,
        -1910.0,
        921.0
      ],
      [
        -395.517333984375,
        -1910.0,
        911.4000244140625
      ],
      [
        -395.517333984375,
        -1910.0,
        911.4000244140625
      ],
      [
        -395.53662109375,
        -1910.0,
        906.0
      ],
      [
        -395.53662109375,
        -1910.0,
        906.0
      ],
      [
        -396.1060791015625,
        -1910.0,
        904.0
      ],
      [
        -395.54376220703125,
        -1910.0,
        904.0
      ],
      [
        -430.0,
        -1933.5428466796875,
        920.9298095703125
      ],
      [
        -365.0,
        -1889.184814453125,
        911.4000244140625
      ],
      [
        -365.0,
        -1889.1717529296875,
        906.0
      ],
      [
        -365.0,
        -1889.1932373046875,
        914.8060913085938
      ],
      [
        -365.0,
        -1889.184814453125,
        911.4000244140625
      ],
      [
        -365.0,
        -1888.5283203125,
        904.0
      ],
      [
        -365.0,
        -1889.1717529296875,
        906.0
      ],
      [
        -365.0,
        -1889.1668701171875,
        904.0
      ],
      [
        -395.58123779296875,
        -1910.0,
        893.5
      ],
      [
        -398.4761657714844,
        -1912.0,
        904.0
      ],
      [
        -412.5,
        -1921.5653076171875,
        904.0
      ],
      [
        -365.0,
        -1889.1412353515625,
        893.5
      ],
      [
        -359.1853332519531,
        -1885.1788330078125,
        895.0
      ],
      [
        -358.19000244140625,
        -1884.5,
        895.0
      ],
      [
        -354.0003356933594,
        -1881.6422119140625,
        895.0
      ],
      [
        -358.19012451171875,
        -1884.5,
        895.0
      ],
      [
        -391.3096923828125,
        -1907.2847900390625,
        975.0
      ],
      [
        -382.3698425292969,
        -1901.0777587890625,
        930.0
      ],
      [
        -348.0,
        -1905.1326904296875,
        892.0023193359375
      ],
      [
        -348.0,
        -1905.1326904296875,
        912.0
      ],
      [
        -348.0,
        -1905.1326904296875,
        892.0023193359375
      ],
      [
        -348.0,
        -1905.1326904296875,
        766.0
      ],
      [
        -348.0,
        -1902.367431640625,
        957.8114624023438
      ],
      [
        -348.0,
        -1904.5203857421875,
        975.0
      ],
      [
        -348.0,
        -1902.367431640625,
        957.8114624023438
      ],
      [
        -400.9820251464844,
        -1913.7725830078125,
        930.0
      ],
      [
        -382.3697814941406,
        -1901.07763671875,
        930.0
      ],
      [
        -360.0,
        -1899.6497802734375,
        930.0
      ],
      [
        -360.0,
        -1907.0894775390625,
        930.0
      ],
      [
        -348.0,
        -1896.6292724609375,
        912.0
      ],
      [
        -348.0,
        -1905.1326904296875,
        912.0
      ],
      [
        -360.0,
        -1907.0894775390625,
        930.0
      ],
      [
        -360.0,
        -1899.6497802734375,
        930.0
      ],
      [
        -377.8475036621094,
        -1910.0,
        921.0
      ],
      [
        -395.0,
        -1912.797119140625,
        921.0
      ],
      [
        -377.8475036621094,
        -1910.0,
        921.0
      ],
      [
        -365.0,
        -1907.9049072265625,
        921.0
      ],
      [
        -365.0,
        -1898.8416748046875,
        921.0
      ],
      [
        -380.58184814453125,
        -1899.8363037109375,
        921.0
      ],
      [
        -395.0,
        -1912.797119140625,
        893.5
      ],
      [
        -377.8475036621094,
        -1910.0,
        893.5
      ],
      [
        -365.0,
        -1895.397216796875,
        893.5
      ],
      [
        -365.0,
        -1907.9049072265625,
        893.5
      ],
      [
        -377.8475036621094,
        -1910.0,
        893.5
      ],
      [
        -375.118896484375,
        -1896.0430908203125,
        893.5
      ],
      [
        -396.5,
        -1913.0416259765625,
        892.0
      ],
      [
        -401.16046142578125,
        -1913.8016357421875,
        892.0
      ],
      [
        -396.5,
        -1912.0,
        893.5
      ],
      [
        -398.513671875,
        -1912.0,
        893.5
      ],
      [
        -348.4186706542969,
        -1894.151123046875,
        892.0023193359375
      ],
      [
        -348.0,
        -1894.5,
        893.5
      ],
      [
        -348.2095642089844,
        -1894.3253173828125,
        893.5
      ],
      [
        -396.5,
        -1913.0416259765625,
        892.0
      ],
      [
        -397.2125244140625,
        -1912.0,
        893.5
      ],
      [
        -397.2125244140625,
        -1913.1578369140625,
        893.5
      ],
      [
        -396.5,
        -1913.0416259765625,
        893.0416259765625
      ],
      [
        -396.5,
        -1913.0416259765625,
        892.0
      ],
      [
        -377.84771728515625,
        -1910.0,
        896.375
      ],
      [
        -377.84771728515625,
        -1910.0,
        900.75
      ],
      [
        -377.8475341796875,
        -1910.0,
        893.5
      ],
      [
        -377.84771728515625,
        -1910.0,
        896.375
      ],
      [
        -377.84771728515625,
        -1910.0,
        900.75
      ],
      [
        -377.8475646972656,
        -1910.0,
        921.0
      ],
      [
        -395.0,
        -1911.0,
        893.5
      ],
      [
        -395.0,
        -1911.0,
        904.8571166992188
      ],
      [
        -395.0,
        -1911.0,
        906.0
      ],
      [
        -395.0,
        -1911.0,
        904.8571166992188
      ],
      [
        -395.0,
        -1911.0,
        906.0
      ],
      [
        -395.0,
        -1911.0,
        911.4000244140625
      ],
      [
        -395.0,
        -1911.0,
        911.4000244140625
      ],
      [
        -395.0,
        -1911.0,
        921.0
      ],
      [
        -395.0,
        -1912.7969970703125,
        893.5
      ],
      [
        -395.0,
        -1912.7969970703125,
        902.8034057617188
      ],
      [
        -395.0,
        -1912.797119140625,
        906.0
      ],
      [
        -395.0,
        -1912.7969970703125,
        902.8034057617188
      ],
      [
        -395.0,
        -1912.797119140625,
        906.0
      ],
      [
        -395.0,
        -1912.797119140625,
        911.4000244140625
      ],
      [
        -395.0,
        -1912.797119140625,
        911.4000244140625
      ],
      [
        -395.0,
        -1912.797119140625,
        921.0
      ],
      [
        -398.4000244140625,
        -1913.3514404296875,
        900.0
      ],
      [
        -396.5,
        -1913.0416259765625,
        904.0
      ],
      [
        -398.4000244140625,
        -1913.3514404296875,
        896.0
      ],
      [
        -398.4000244140625,
        -1913.3514404296875,
        900.0
      ],
      [
        -398.4000244140625,
        -1913.3514404296875,
        896.0
      ],
      [
        -396.5,
        -1913.0416259765625,
        902.6111450195312
      ],
      [
        -396.5,
        -1913.0416259765625,
        904.0
      ],
      [
        -401.104248046875,
        -1913.7926025390625,
        904.0
      ],
      [
        -396.5,
        -1913.0416259765625,
        904.0
      ],
      [
        -383.98046875,
        -1911.0,
        893.5
      ],
      [
        -383.98052978515625,
        -1911.0,
        894.4956665039062
      ],
      [
        -383.98052978515625,
        -1911.0,
        902.6293334960938
      ],
      [
        -383.98046875,
        -1911.0,
        921.0
      ],
      [
        -383.0,
        -1910.840087890625,
        896.375
      ],
      [
        -383.0,
        -1910.840087890625,
        900.75
      ],
      [
        -383.98052978515625,
        -1911.0,
        902.6293334960938
      ],
      [
        -383.0,
        -1910.840087890625,
        900.75
      ],
      [
        -383.98052978515625,
        -1911.0,
        894.4956665039062
      ],
      [
        -383.0,
        -1910.840087890625,
        896.375
      ],
      [
        -371.7152099609375,
        -1909.0,
        903.5
      ],
      [
        -370.50762939453125,
        -1908.8031005859375,
        906.9466552734375
      ],
      [
        -368.5,
        -1908.4755859375,
        921.0
      ],
      [
        -370.50762939453125,
        -1908.8031005859375,
        906.9466552734375
      ],
      [
        -371.7152099609375,
        -1909.0,
        903.5
      ],
      [
        -377.84716796875,
        -1910.0,
        903.5
      ],
      [
        -365.0,
        -1897.6392822265625,
        911.4000244140625
      ],
      [
        -365.0,
        -1907.9049072265625,
        911.4000244140625
      ],
      [
        -365.0,
        -1907.9049072265625,
        906.0
      ],
      [
        -365.0,
        -1896.962890625,
        906.0
      ],
      [
        -365.0,
        -1898.8416748046875,
        921.0
      ],
      [
        -365.0,
        -1907.9049072265625,
        921.0
      ],
      [
        -365.0,
        -1907.9049072265625,
        911.4000244140625
      ],
      [
        -365.0,
        -1897.6392822265625,
        911.4000244140625
      ],
      [
        -365.0,
        -1896.962890625,
        906.0
      ],
      [
        -365.0,
        -1907.9049072265625,
        906.0
      ],
      [
        -365.0,
        -1907.9049072265625,
        893.5
      ],
      [
        -365.0,
        -1895.397216796875,
        893.5
      ],
      [
        -348.0,
        -1894.5,
        895.0009765625
      ],
      [
        -348.0,
        -1884.5,
        895.0
      ],
      [
        -348.0,
        -1882.8201904296875,
        895.0
      ],
      [
        -348.0,
        -1884.5,
        895.0
      ],
      [
        -340.5271911621094,
        -1903.9140625,
        975.0
      ],
      [
        -340.66888427734375,
        -1903.9371337890625,
        974.0792236328125
      ],
      [
        -343.7642822265625,
        -1884.5,
        895.0
      ],
      [
        -343.4325866699219,
        -1883.7169189453125,
        895.0
      ],
      [
        -343.7642822265625,
        -1884.5,
        895.0
      ],
      [
        -340.9013671875,
        -1903.9749755859375,
        974.2633666992188
      ],
      [
        -340.6899719238281,
        -1903.9405517578125,
        974.0958862304688
      ],
      [
        -340.6899719238281,
        -1903.9405517578125,
        974.0958862304688
      ],
      [
        -340.66888427734375,
        -1903.9371337890625,
        974.0792236328125
      ],
      [
        -341.83099365234375,
        -1904.1265869140625,
        975.0
      ],
      [
        -340.9013671875,
        -1903.9749755859375,
        974.2633666992188
      ],
      [
        -433.3038635253906,
        -1935.971435546875,
        892.0023193359375
      ],
      [
        -433.3038635253906,
        -1935.9715576171875,
        912.0
      ],
      [
        -433.3038635253906,
        -1935.971435546875,
        892.0023193359375
      ],
      [
        -433.30377197265625,
        -1935.9715576171875,
        780.2833251953125
      ],
      [
        -419.5531921386719,
        -1928.0,
        930.0
      ],
      [
        -392.67535400390625,
        -1912.41796875,
        930.0
      ],
      [
        -396.5,
        -1914.63525390625,
        892.0
      ],
      [
        -412.5,
        -1923.910888671875,
        892.0
      ],
      [
        -412.5,
        -1923.910888671875,
        904.0
      ],
      [
        -396.5,
        -1914.63525390625,
        904.0
      ],
      [
        -430.0,
        -1934.0562744140625,
        920.089599609375
      ],
      [
        -419.5531921386719,
        -1928.0,
        930.0
      ],
      [
        -395.0,
        -1913.765625,
        906.0
      ],
      [
        -395.0,
        -1912.7969970703125,
        904.0
      ],
      [
        -395.0,
        -1913.765625,
        904.0
      ],
      [
        -395.0,
        -1913.765625,
        906.0
      ],
      [
        -395.0,
        -1913.765625,
        911.4000244140625
      ],
      [
        -395.0,
        -1913.765625,
        911.4000244140625
      ],
      [
        -395.0,
        -1913.765625,
        921.0
      ],
      [
        -433.3038635253906,
        -1935.9715576171875,
        912.0
      ],
      [
        -430.0,
        -1934.0562744140625,
        920.089599609375
      ],
      [
        -392.6755676269531,
        -1912.4180908203125,
        921.0
      ],
      [
        -395.0,
        -1913.765625,
        921.0
      ],
      [
        -412.5,
        -1923.910888671875,
        904.0
      ],
      [
        -412.5,
        -1923.910888671875,
        892.0
      ],
      [
        -395.0,
        -1913.7655029296875,
        902.0
      ],
      [
        -396.5,
        -1914.6351318359375,
        893.5
      ],
      [
        -396.5,
        -1914.63525390625,
        892.0
      ],
      [
        -396.5,
        -1914.6351318359375,
        902.0
      ],
      [
        -396.5,
        -1914.63525390625,
        904.0
      ],
      [
        -395.0,
        -1913.7655029296875,
        893.5
      ],
      [
        -396.5,
        -1914.6351318359375,
        893.5
      ],
      [
        -395.0,
        -1913.7655029296875,
        902.0
      ],
      [
        -396.5,
        -1914.6351318359375,
        902.0
      ],
      [
        -395.0,
        -1913.765625,
        893.5
      ],
      [
        -392.6755676269531,
        -1912.4180908203125,
        893.5
      ],
      [
        -270.61224365234375,
        -2181.5,
        857.0
      ],
      [
        -271.16510009765625,
        -2184.293701171875,
        857.0
      ],
      [
        -289.98388671875,
        -1901.391845703125,
        849.5217895507812
      ],
      [
        -280.6551818847656,
        -1902.015869140625,
        849.5562744140625
      ],
      [
        -280.6551818847656,
        -1902.015869140625,
        849.5562744140625
      ],
      [
        -253.52130126953125,
        -1901.3677978515625,
        849.5204467773438
      ],
      [
        -348.0,
        -1928.0,
        791.4063720703125
      ],
      [
        -348.0,
        -1905.1326904296875,
        834.8331909179688
      ],
      [
        -348.0,
        -1928.0,
        791.4063720703125
      ],
      [
        -359.5250549316406,
        -1938.564697265625,
        769.8370361328125
      ],
      [
        -180.0,
        -1942.0989990234375,
        770.0
      ],
      [
        -200.0,
        -1943.677490234375,
        770.0
      ],
      [
        -290.0,
        -1943.264892578125,
        770.0
      ],
      [
        -270.0,
        -1944.6416015625,
        770.0
      ],
      [
        -270.0,
        -1944.6416015625,
        770.0
      ],
      [
        -200.0,
        -1943.677490234375,
        770.0
      ],
      [
        -224.73558044433594,
        -1945.6300048828125,
        770.0
      ],
      [
        -247.49774169921875,
        -1946.190673828125,
        770.0
      ],
      [
        -300.0,
        -1942.576416015625,
        770.0
      ],
      [
        -290.0,
        -1943.2650146484375,
        770.0
      ],
      [
        -170.0,
        -1941.3095703125,
        770.0
      ],
      [
        -180.0,
        -1942.098876953125,
        770.0
      ],
      [
        -286.0,
        -1946.173095703125,
        765.0
      ],
      [
        -286.0,
        -1948.689453125,
        760.221435546875
      ],
      [
        -300.0,
        -1945.2093505859375,
        765.0
      ],
      [
        -300.0,
        -1942.576416015625,
        770.0
      ],
      [
        -239.13368225097656,
        -1946.7664794921875,
        770.0
      ],
      [
        -208.44378662109375,
        -1914.585693359375,
        835.1259765625
      ],
      [
        -150.88082885742188,
        -1940.708251953125,
        793.0426025390625
      ],
      [
        -180.0,
        -1950.8372802734375,
        770.0
      ],
      [
        -200.0,
        -1949.4605712890625,
        770.0
      ],
      [
        -200.0,
        -1949.4605712890625,
        770.0
      ],
      [
        -170.0,
        -1951.5257568359375,
        770.0
      ],
      [
        -180.0,
        -1950.83740234375,
        770.0
      ],
      [
        -383.135009765625,
        -1922.1614990234375,
        850.66943359375
      ],
      [
        -289.98388671875,
        -1901.391845703125,
        849.5217895507812
      ],
      [
        -430.0,
        -1939.0,
        836.4241943359375
      ],
      [
        -433.3038330078125,
        -1935.971435546875,
        845.1998901367188
      ],
      [
        -430.0,
        -1939.0,
        836.4241943359375
      ],
      [
        -422.5,
        -1939.0,
        832.4522094726562
      ],
      [
        -360.0,
        -1939.0,
        799.3531494140625
      ],
      [
        -369.0,
        -1939.0,
        804.1194458007812
      ],
      [
        -348.0,
        -1928.0,
        818.5172119140625
      ],
      [
        -348.0,
        -1914.3275146484375,
        850.236572265625
      ],
      [
        -348.0,
        -1905.1326904296875,
        849.728515625
      ],
      [
        -360.0,
        -1939.0,
        799.3531494140625
      ],
      [
        -348.0,
        -1928.0,
        818.5172119140625
      ],
      [
        -422.5,
        -1939.0,
        832.4522705078125
      ],
      [
        -422.5,
        -1945.875,
        816.502685546875
      ],
      [
        -422.5,
        -1945.875,
        779.7572631835938
      ],
      [
        -371.6431579589844,
        -1950.0,
        780.0
      ],
      [
        -412.0,
        -1950.0,
        801.3724365234375
      ],
      [
        -417.9999694824219,
        -1950.0,
        804.5499267578125
      ],
      [
        -414.0,
        -1950.0,
        802.4315795898438
      ],
      [
        -417.9999694824219,
        -1950.0,
        779.5380859375
      ],
      [
        -369.0,
        -1950.0,
        778.6002197265625
      ],
      [
        -369.0,
        -1939.0,
        804.1194458007812
      ],
      [
        -412.0,
        -1955.5,
        780.0
      ],
      [
        -404.0,
        -1957.38623046875,
        780.0
      ],
      [
        -408.7575378417969,
        -1958.4722900390625,
        780.0
      ],
      [
        -404.0,
        -1957.38623046875,
        780.0
      ],
      [
        -371.6431579589844,
        -1950.0,
        780.0
      ],
      [
        -414.0,
        -1953.6666259765625,
        779.3433837890625
      ],
      [
        -414.0,
        -1950.0,
        780.0
      ],
      [
        -414.0,
        -1953.6666259765625,
        780.0
      ],
      [
        -414.0,
        -1950.0,
        802.4315795898438
      ],
      [
        -414.0,
        -1953.6666259765625,
        793.9251708984375
      ],
      [
        -412.0,
        -1950.0,
        801.372314453125
      ],
      [
        -412.0,
        -1955.5,
        780.0
      ],
      [
        -412.0,
        -1955.5,
        788.612548828125
      ],
      [
        -388.1759033203125,
        -1950.0,
        788.7554931640625
      ],
      [
        -404.0,
        -1957.127685546875,
        780.5999755859375
      ],
      [
        -422.5,
        -1950.0,
        806.9330444335938
      ],
      [
        -422.5,
        -1950.0,
        806.9330444335938
      ],
      [
        -414.0,
        -1959.678955078125,
        779.9769287109375
      ],
      [
        -412.0,
        -1959.21240234375,
        780.0
      ],
      [
        -412.0,
        -1959.21240234375,
        780.0
      ],
      [
        -521.9082641601562,
        -2003.739501953125,
        855.1773071289062
      ],
      [
        -505.3973388671875,
        -1994.70654296875,
        854.6781616210938
      ],
      [
        -521.9082641601562,
        -2003.739501953125,
        855.1773071289062
      ],
      [
        -547.7910766601562,
        -2017.629638671875,
        855.94482421875
      ],
      [
        -475.3267822265625,
        -1977.0572509765625,
        853.7029418945312
      ],
      [
        -505.3973388671875,
        -1994.70654296875,
        854.6781616210938
      ],
      [
        -422.6108093261719,
        -1945.10791015625,
        851.9375
      ],
      [
        -475.3267822265625,
        -1977.0572509765625,
        853.7029418945312
      ],
      [
        -414.0,
        -1972.0,
        788.1215209960938
      ],
      [
        -414.0,
        -1950.0,
        833.3431396484375
      ],
      [
        -371.0,
        -1950.0,
        780.0711059570312
      ],
      [
        -393.54351806640625,
        -1950.0,
        808.0
      ],
      [
        -393.54351806640625,
        -1950.0,
        808.0
      ],
      [
        -412.0,
        -1950.0,
        830.8653564453125
      ],
      [
        -412.0,
        -1950.0,
        830.8653564453125
      ],
      [
        -412.0,
        -1970.0,
        789.7544555664062
      ],
      [
        -412.0,
        -1972.0,
        780.9847412109375
      ],
      [
        -414.0,
        -1972.0,
        788.1215209960938
      ],
      [
        -412.0,
        -1972.0,
        785.5038452148438
      ],
      [
        -404.2237243652344,
        -1970.0,
        780.0
      ],
      [
        -404.0,
        -1969.874755859375,
        780.0
      ],
      [
        -404.0,
        -1969.874755859375,
        780.0
      ],
      [
        -371.0,
        -1950.0345458984375,
        780.0
      ],
      [
        -402.849609375,
        -1969.23046875,
        780.0
      ],
      [
        -380.99652099609375,
        -1950.0,
        792.4556274414062
      ],
      [
        -392.7138366699219,
        -1960.0,
        786.4166870117188
      ],
      [
        -392.7138366699219,
        -1960.0,
        786.4166870117188
      ],
      [
        -392.37188720703125,
        -1960.0,
        785.992919921875
      ],
      [
        -371.0,
        -1950.0,
        780.0711059570312
      ],
      [
        -371.0,
        -1950.0345458984375,
        780.0
      ],
      [
        -405.16424560546875,
        -1970.0,
        780.0
      ],
      [
        -404.22381591796875,
        -1970.0,
        780.0
      ],
      [
        -404.489501953125,
        -1970.0,
        780.3477783203125
      ],
      [
        -412.0,
        -1961.415771484375,
        807.4000244140625
      ],
      [
        -404.0,
        -1956.593994140625,
        807.4000244140625
      ],
      [
        -404.0,
        -1956.593994140625,
        807.4000244140625
      ],
      [
        -396.3739318847656,
        -1950.0,
        811.50634765625
      ],
      [
        -412.0,
        -1961.123779296875,
        808.0
      ],
      [
        -404.0,
        -1956.30224609375,
        808.0
      ],
      [
        -396.7113952636719,
        -1950.0,
        811.9246215820312
      ],
      [
        -404.0,
        -1956.30224609375,
        808.0
      ],
      [
        -412.0,
        -1970.0,
        789.7544555664062
      ],
      [
        -405.95135498046875,
        -1970.0,
        782.2611083984375
      ],
      [
        -408.1161193847656,
        -1972.0,
        780.4204711914062
      ],
      [
        -422.5,
        -1939.0,
        851.5999755859375
      ],
      [
        -422.5,
        -1945.0406494140625,
        851.933837890625
      ],
      [
        -422.5,
        -1950.0,
        842.955078125
      ],
      [
        -422.5,
        -1950.0,
        842.955078125
      ],
      [
        -414.0,
        -1950.0,
        833.3430786132812
      ],
      [
        -430.0,
        -1939.0,
        851.5999755859375
      ],
      [
        -422.5,
        -1939.0,
        851.5999755859375
      ],
      [
        -430.0,
        -1939.0,
        851.5999755859375
      ],
      [
        -433.3038330078125,
        -1935.971435546875,
        851.4326171875
      ],
      [
        -395.4977111816406,
        -1929.4959716796875,
        851.0747680664062
      ],
      [
        -396.46453857421875,
        -1935.3475341796875,
        841.7374267578125
      ],
      [
        -414.000732421875,
        -1944.912353515625,
        843.8018188476562
      ],
      [
        -418.7743835449219,
        -1943.3056640625,
        851.837890625
      ],
      [
        -383.135009765625,
        -1922.1614990234375,
        850.66943359375
      ],
      [
        -379.3594055175781,
        -1926.01708984375,
        839.72509765625
      ],
      [
        -382.8944396972656,
        -1927.9449462890625,
        840.1419067382812
      ],
      [
        -385.6120910644531,
        -1923.631103515625,
        850.7506713867188
      ],
      [
        -418.7743835449219,
        -1943.3056640625,
        851.837890625
      ],
      [
        -414.000732421875,
        -1944.912353515625,
        843.8018188476562
      ],
      [
        -422.6108093261719,
        -1945.10791015625,
        851.9375
      ],
      [
        -422.5,
        -1945.0556640625,
        851.9346923828125
      ],
      [
        -422.5,
        -1945.1697998046875,
        851.7000122070312
      ],
      [
        -422.5,
        -1950.0,
        843.8735961914062
      ],
      [
        -422.5,
        -1945.515869140625,
        851.9600830078125
      ],
      [
        -422.5,
        -1949.548828125,
        844.8010864257812
      ],
      [
        -422.5,
        -1950.0,
        843.8735961914062
      ],
      [
        -422.5,
        -1946.0516357421875,
        851.9896850585938
      ],
      [
        -414.0,
        -1950.0,
        839.5381469726562
      ],
      [
        -412.0,
        -1950.0,
        836.92041015625
      ],
      [
        -412.0,
        -1970.0,
        790.1778564453125
      ],
      [
        -412.0,
        -1945.5858154296875,
        840.4337158203125
      ],
      [
        -412.0,
        -1950.0,
        831.3602905273438
      ],
      [
        -412.0,
        -1945.5858154296875,
        840.4337158203125
      ],
      [
        -412.0,
        -1943.821044921875,
        843.5662841796875
      ],
      [
        -366.15057373046875,
        -1939.5059814453125,
        801.436767578125
      ],
      [
        -373.7199401855469,
        -1942.5079345703125,
        804.3277587890625
      ],
      [
        -371.0,
        -1951.3939208984375,
        780.0
      ],
      [
        -369.0,
        -1950.0,
        780.0
      ],
      [
        -369.0,
        -1950.7550048828125,
        778.8754272460938
      ],
      [
        -369.0,
        -1950.2738037109375,
        780.0
      ],
      [
        -369.0,
        -1950.7550048828125,
        778.8754272460938
      ],
      [
        -369.0,
        -1950.787353515625,
        778.7999267578125
      ],
      [
        -369.0,
        -1950.0,
        780.0
      ],
      [
        -369.0,
        -1949.3966064453125,
        780.0
      ],
      [
        -371.0,
        -1950.0,
        783.2578735351562
      ],
      [
        -389.90386962890625,
        -1950.0,
        808.0
      ],
      [
        -389.90386962890625,
        -1950.0,
        808.0
      ],
      [
        -412.0,
        -1950.0,
        832.5980224609375
      ],
      [
        -392.6095886230469,
        -1950.0,
        811.5413818359375
      ],
      [
        -369.0,
        -1950.0,
        780.6402587890625
      ],
      [
        -369.0,
        -1940.6358642578125,
        802.5252075195312
      ],
      [
        -369.0,
        -1939.0,
        805.4290161132812
      ],
      [
        -366.6461181640625,
        -1939.0,
        802.8728637695312
      ],
      [
        -369.0,
        -1939.0,
        805.4290161132812
      ],
      [
        -378.8663330078125,
        -1950.0,
        793.5535278320312
      ],
      [
        -391.6778869628906,
        -1960.0,
        786.9506225585938
      ],
      [
        -371.0,
        -1950.0,
        783.2578125
      ],
      [
        -371.0,
        -1951.3939208984375,
        780.0
      ],
      [
        -369.0,
        -1950.0,
        780.6400146484375
      ],
      [
        -391.6778869628906,
        -1960.0,
        786.9506225585938
      ],
      [
        -391.3489685058594,
        -1960.0,
        786.5201416015625
      ],
      [
        -404.0,
        -1958.15087890625,
        807.4000244140625
      ],
      [
        -394.7740783691406,
        -1950.8585205078125,
        812.3677978515625
      ],
      [
        -393.8358459472656,
        -1950.0,
        812.8729858398438
      ],
      [
        -412.0,
        -1962.3743896484375,
        808.0
      ],
      [
        -404.0,
        -1957.8941650390625,
        808.0
      ],
      [
        -412.0,
        -1962.631103515625,
        807.4000244140625
      ],
      [
        -404.0,
        -1958.15087890625,
        807.4000244140625
      ],
      [
        -394.2052307128906,
        -1950.0,
        813.2741088867188
      ],
      [
        -395.4261169433594,
        -1951.1171875,
        812.61669921875
      ],
      [
        -404.0,
        -1957.8941650390625,
        808.0
      ],
      [
        -412.0,
        -1970.0,
        790.1778564453125
      ],
      [
        -411.2967834472656,
        -1950.0,
        836.0
      ],
      [
        -411.2967834472656,
        -1950.0,
        836.0
      ],
      [
        -412.0,
        -1950.0,
        836.92041015625
      ],
      [
        -366.13958740234375,
        -1939.0,
        802.6046142578125
      ],
      [
        -369.0,
        -1939.0,
        806.3483276367188
      ],
      [
        -369.0,
        -1939.0,
        806.3483276367188
      ],
      [
        -394.01263427734375,
        -1950.0,
        813.3778076171875
      ],
      [
        -393.6878662109375,
        -1950.0,
        812.9526977539062
      ],
      [
        -410.8384094238281,
        -1950.0,
        835.4000244140625
      ],
      [
        -412.0,
        -1950.6505126953125,
        835.4000244140625
      ],
      [
        -412.0,
        -1950.393798828125,
        836.0
      ],
      [
        -411.29681396484375,
        -1950.0,
        836.0
      ],
      [
        -422.5,
        -1950.0,
        850.6633911132812
      ],
      [
        -414.0,
        -1950.0,
        839.5380859375
      ],
      [
        -422.5,
        -1949.3543701171875,
        852.1721801757812
      ],
      [
        -422.5,
        -1950.0,
        850.6633911132812
      ],
      [
        -369.0,
        -1972.0,
        853.4234619140625
      ],
      [
        -414.0,
        -1972.0,
        853.4234619140625
      ],
      [
        -414.0,
        -1972.0,
        853.4234619140625
      ],
      [
        -414.0,
        -1950.0,
        852.2078247070312
      ],
      [
        -369.0,
        -1950.0,
        852.2078247070312
      ],
      [
        -369.0,
        -1972.0,
        853.4234619140625
      ],
      [
        -369.0,
        -1950.0,
        852.2078247070312
      ],
      [
        -369.0,
        -1939.0,
        851.5999755859375
      ],
      [
        -412.0,
        -1950.0,
        852.2078247070312
      ],
      [
        -412.0,
        -1970.0,
        853.3129272460938
      ],
      [
        -371.0,
        -1970.0,
        853.3129272460938
      ],
      [
        -412.0,
        -1970.0,
        853.3129272460938
      ],
      [
        -371.0,
        -1950.0,
        852.207763671875
      ],
      [
        -412.0,
        -1950.0,
        852.2078247070312
      ],
      [
        -369.0,
        -1940.635986328125,
        802.5250854492188
      ],
      [
        -369.0,
        -1957.1702880859375,
        773.1744384765625
      ],
      [
        -371.0,
        -1950.0,
        852.2078247070312
      ],
      [
        -371.0,
        -1970.0,
        853.3129272460938
      ],
      [
        -378.55706787109375,
        -1960.0,
        821.7000732421875
      ],
      [
        -403.44293212890625,
        -1960.0,
        835.699951171875
      ],
      [
        -378.0,
        -1960.0,
        821.4000244140625
      ],
      [
        -376.8858947753906,
        -1970.0,
        821.4000244140625
      ],
      [
        -376.8858947753906,
        -1960.0,
        821.4000244140625
      ],
      [
        -378.55706787109375,
        -1950.0,
        821.7000732421875
      ],
      [
        -378.55706787109375,
        -1960.0,
        821.7000732421875
      ],
      [
        -376.8858947753906,
        -1950.0,
        821.4000244140625
      ],
      [
        -403.44293212890625,
        -1960.0,
        835.699951171875
      ],
      [
        -403.44293212890625,
        -1950.0,
        835.699951171875
      ],
      [
        -378.55712890625,
        -1960.0,
        849.7000122070312
      ],
      [
        -378.0,
        -1960.0,
        850.0
      ],
      [
        -376.8856506347656,
        -1950.0,
        850.0
      ],
      [
        -376.8856506347656,
        -1960.0,
        850.0
      ],
      [
        -376.8856506347656,
        -1970.0,
        850.0
      ],
      [
        -378.55712890625,
        -1970.0,
        849.7000122070312
      ],
      [
        -378.55712890625,
        -1960.0,
        849.7000122070312
      ],
      [
        -405.1142272949219,
        -1970.0,
        836.0
      ],
      [
        -405.1142272949219,
        -1950.0,
        836.0
      ],
      [
        -385.2668762207031,
        -1970.0,
        853.31298828125
      ],
      [
        -384.2406311035156,
        -1960.0,
        852.7603759765625
      ],
      [
        -383.1263122558594,
        -1960.0,
        852.7603149414062
      ],
      [
        -384.1525573730469,
        -1970.0,
        853.3129272460938
      ],
      [
        -384.2406311035156,
        -1960.0,
        852.7603759765625
      ],
      [
        -383.1263122558594,
        -1960.0,
        852.7603149414062
      ],
      [
        -403.44293212890625,
        -1960.0,
        807.699951171875
      ],
      [
        -405.1142272949219,
        -1970.0,
        808.0
      ],
      [
        -405.11419677734375,
        -1960.0,
        808.0
      ],
      [
        -404.0,
        -1960.0,
        808.0
      ],
      [
        -371.4643859863281,
        -1968.0,
        789.880859375
      ],
      [
        -371.14385986328125,
        -1968.0,
        790.3082275390625
      ],
      [
        -371.14385986328125,
        -1969.5,
        790.3082275390625
      ],
      [
        -371.4643859863281,
        -1969.5,
        789.880859375
      ],
      [
        -371.4643859863281,
        -1960.5,
        789.880859375
      ],
      [
        -371.14385986328125,
        -1960.5,
        790.3082275390625
      ],
      [
        -371.14385986328125,
        -1962.0,
        790.3082275390625
      ],
      [
        -371.4643859863281,
        -1962.0,
        789.880859375
      ],
      [
        -371.0,
        -1968.0,
        789.6307983398438
      ],
      [
        -371.0,
        -1968.0,
        790.2307739257812
      ],
      [
        -371.14385986328125,
        -1968.0,
        790.3082275390625
      ],
      [
        -371.4643859863281,
        -1968.0,
        789.880859375
      ],
      [
        -371.0,
        -1960.5,
        789.6307983398438
      ],
      [
        -371.0,
        -1960.5,
        790.2307739257812
      ],
      [
        -371.14385986328125,
        -1960.5,
        790.3082275390625
      ],
      [
        -371.4643859863281,
        -1960.5,
        789.880859375
      ],
      [
        -404.0,
        -1960.0,
        807.4000244140625
      ],
      [
        -407.3018493652344,
        -1960.0,
        807.4000244140625
      ],
      [
        -407.7602233886719,
        -1960.0,
        808.0
      ],
      [
        -403.44293212890625,
        -1960.0,
        807.699951171875
      ],
      [
        -403.44293212890625,
        -1957.7105712890625,
        807.699951171875
      ],
      [
        -412.0,
        -1960.0,
        835.4000244140625
      ],
      [
        -404.0,
        -1960.0,
        835.4000244140625
      ],
      [
        -412.0,
        -1960.0,
        836.0
      ],
      [
        -405.1142272949219,
        -1960.0,
        836.0
      ],
      [
        -360.0,
        -1939.0,
        851.5999755859375
      ],
      [
        -369.0,
        -1939.0,
        851.5999755859375
      ],
      [
        -360.0,
        -1939.0,
        851.5999755859375
      ],
      [
        -348.0,
        -1928.0,
        850.9920654296875
      ],
      [
        -348.0,
        -1928.0,
        850.9920654296875
      ],
      [
        -349.0,
        -1972.0,
        780.0
      ],
      [
        -349.0,
        -1972.0,
        780.0
      ],
      [
        -349.0,
        -1972.0,
        778.7999267578125
      ],
      [
        -422.5,
        -1950.0,
        852.2078247070312
      ],
      [
        -414.0,
        -1950.0,
        852.2078247070312
      ],
      [
        -422.5,
        -1950.0,
        852.2078247070312
      ],
      [
        -362.6666564941406,
        -1977.0,
        778.7999877929688
      ],
      [
        -362.6666564941406,
        -1977.0,
        780.0
      ],
      [
        -348.0,
        -1905.1326904296875,
        871.5677490234375
      ],
      [
        -348.0,
        -1914.3275146484375,
        850.236572265625
      ],
      [
        -430.0,
        -1939.0,
        871.3511352539062
      ],
      [
        -433.3038635253906,
        -1935.971435546875,
        880.5703735351562
      ],
      [
        -430.0,
        -1939.0,
        871.3511352539062
      ],
      [
        -422.5,
        -1939.0,
        862.8701782226562
      ],
      [
        -422.5,
        -1939.0,
        862.8701782226562
      ],
      [
        -422.5,
        -1945.0406494140625,
        851.9337768554688
      ],
      [
        -411.5170593261719,
        -1939.0,
        851.5999755859375
      ],
      [
        -431.5664367675781,
        -1939.0,
        873.3723754882812
      ],
      [
        -430.0,
        -1939.0,
        871.6710205078125
      ],
      [
        -433.3038635253906,
        -1935.971435546875,
        880.6351928710938
      ],
      [
        -431.5664367675781,
        -1939.0,
        873.3723754882812
      ],
      [
        -433.3614501953125,
        -1939.0,
        875.1522827148438
      ],
      [
        -360.0,
        -1933.5,
        921.0
      ],
      [
        -354.0,
        -1928.0,
        921.0
      ],
      [
        -396.5,
        -1928.0,
        892.0
      ],
      [
        -412.5,
        -1928.0,
        892.0
      ],
      [
        -412.5,
        -1928.0,
        904.0
      ],
      [
        -396.5,
        -1928.0,
        904.0
      ],
      [
        -412.5,
        -1928.0,
        904.0
      ],
      [
        -412.5,
        -1928.0,
        892.0
      ],
      [
        -396.5,
        -1928.0,
        903.4400024414062
      ],
      [
        -396.5,
        -1928.0,
        892.4199829101562
      ],
      [
        -396.5,
        -1928.0,
        892.4199829101562
      ],
      [
        -396.5,
        -1928.0,
        892.0
      ],
      [
        -396.5,
        -1928.0,
        904.0
      ],
      [
        -396.5,
        -1928.0,
        903.4400024414062
      ],
      [
        -396.5,
        -1928.0,
        893.5
      ],
      [
        -412.5,
        -1923.910888671875,
        893.5
      ],
      [
        -412.5,
        -1928.0,
        893.5
      ],
      [
        -397.2125244140625,
        -1920.5,
        893.5
      ],
      [
        -397.2125244140625,
        -1919.0,
        893.5
      ],
      [
        -396.5,
        -1920.5,
        893.5
      ],
      [
        -397.2125244140625,
        -1920.5,
        893.5
      ],
      [
        -397.2125244140625,
        -1919.0,
        893.5
      ],
      [
        -396.5,
        -1919.0,
        893.5
      ],
      [
        -365.0,
        -1911.0,
        911.4000244140625
      ],
      [
        -365.0,
        -1911.0,
        906.0
      ],
      [
        -365.0,
        -1911.0,
        921.0
      ],
      [
        -365.0,
        -1911.0,
        911.4000244140625
      ],
      [
        -365.0,
        -1911.0,
        906.0
      ],
      [
        -365.0,
        -1911.0,
        893.5
      ],
      [
        -395.0,
        -1923.5,
        904.0
      ],
      [
        -395.0,
        -1928.0,
        904.0
      ],
      [
        -395.0,
        -1913.765625,
        904.0
      ],
      [
        -395.0,
        -1923.5,
        904.0
      ],
      [
        -422.5,
        -1942.0516357421875,
        858.1096801757812
      ],
      [
        -422.5,
        -1939.0,
        863.5267944335938
      ],
      [
        -422.5,
        -1942.0516357421875,
        858.1096801757812
      ],
      [
        -422.5,
        -1945.055908203125,
        851.9346313476562
      ],
      [
        -414.0,
        -1970.0,
        853.3129272460938
      ],
      [
        -414.0,
        -1970.0,
        892.0
      ],
      [
        -369.0,
        -1970.0,
        892.0
      ],
      [
        -369.0,
        -1970.0,
        853.3129272460938
      ],
      [
        -402.8857727050781,
        -1960.0,
        891.4000244140625
      ],
      [
        -402.8857727050781,
        -1970.0,
        891.4000244140625
      ],
      [
        -402.8857727050781,
        -1960.0,
        891.4000244140625
      ],
      [
        -378.55706787109375,
        -1960.0,
        877.7000732421875
      ],
      [
        -378.0,
        -1960.0,
        877.4000244140625
      ],
      [
        -376.8858947753906,
        -1970.0,
        877.4000244140625
      ],
      [
        -376.8858947753906,
        -1960.0,
        877.4000244140625
      ],
      [
        -376.8858947753906,
        -1950.0,
        877.4000244140625
      ],
      [
        -378.55706787109375,
        -1960.0,
        877.7000732421875
      ],
      [
        -378.55706787109375,
        -1950.0,
        877.7000732421875
      ],
      [
        -403.44287109375,
        -1960.0,
        863.7000122070312
      ],
      [
        -405.1143493652344,
        -1950.0,
        863.4000244140625
      ],
      [
        -405.1143493652344,
        -1960.0,
        863.4000244140625
      ],
      [
        -404.0,
        -1960.0,
        863.4000244140625
      ],
      [
        -405.1143493652344,
        -1970.0,
        863.4000244140625
      ],
      [
        -403.44287109375,
        -1960.0,
        863.7000122070312
      ],
      [
        -403.44287109375,
        -1970.0,
        863.7000122070312
      ],
      [
        -414.0,
        -1971.0,
        892.0
      ],
      [
        -414.0,
        -1971.0,
        896.0
      ],
      [
        -369.0,
        -1971.0,
        896.0
      ],
      [
        -369.0,
        -1971.0,
        892.0
      ],
      [
        -414.0,
        -1949.0,
        896.0
      ],
      [
        -414.0,
        -1949.0,
        892.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        -4840.0,
        0.0
      ],
      "bbox_max": [
        2500.0,
        2921.382080078125,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600968956947327,
        0.260924369096756,
        0.10065929591655731
      ],
      "plane_d": 4053.40478515625,
      "bbox_min": [
        -4912.15185546875,
        -3588.4169921875,
        0.0
      ],
      "bbox_max": [
        -508.5000305175781,
        2154.178466796875,
        1401.26220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9293507933616638,
        0.34574177861213684,
        0.1294977068901062
      ],
      "plane_d": 4632.30078125,
      "bbox_min": [
        -4205.1796875,
        -3588.4169921875,
        1220.0
      ],
      "bbox_max": [
        -3605.179443359375,
        -2416.412353515625,
        1401.26220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6941572427749634,
        0.6507723927497864,
        0.3076378405094147
      ],
      "plane_d": 4443.431640625,
      "bbox_min": [
        -4205.1796875,
        -3588.4169921875,
        1220.0
      ],
      "bbox_max": [
        -3605.179443359375,
        -2416.412353515625,
        1400.2685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4914821684360504,
        -0.7588846683502197,
        0.4272461533546448
      ],
      "plane_d": -492.10723876953125,
      "bbox_min": [
        -4205.1796875,
        -3588.4169921875,
        1220.0
      ],
      "bbox_max": [
        -3605.179443359375,
        -2416.412353515625,
        1400.2685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5384979844093323,
        -0.7894291877746582,
        0.29465532302856445
      ],
      "plane_d": -215.73916625976562,
      "bbox_min": [
        -4205.1796875,
        -3588.4169921875,
        1220.0
      ],
      "bbox_max": [
        -3605.179443359375,
        -2462.454833984375,
        1400.2685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6886258125305176,
        0.6727038025856018,
        0.2706737220287323
      ],
      "plane_d": 4546.642578125,
      "bbox_min": [
        -3861.128173828125,
        -3588.4169921875,
        1220.0
      ],
      "bbox_max": [
        -3605.179443359375,
        -3360.06591796875,
        1376.4132080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8203666806221008,
        0.5627213716506958,
        0.1017010360956192
      ],
      "plane_d": 4234.45703125,
      "bbox_min": [
        -3714.02392578125,
        -3126.308349609375,
        0.0
      ],
      "bbox_max": [
        -508.5000305175781,
        -1920.0,
        1181.5367431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6826116442680359,
        -0.6173016428947449,
        0.39112648367881775
      ],
      "plane_d": 596.6063232421875,
      "bbox_min": [
        -3699.87890625,
        -2864.23095703125,
        450.0
      ],
      "bbox_max": [
        -3288.09619140625,
        -2364.646728515625,
        1181.5367431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321149587631226,
        0.2707196772098541,
        0.2405669242143631
      ],
      "plane_d": 3807.88525390625,
      "bbox_min": [
        -3699.87890625,
        -2864.23095703125,
        450.0
      ],
      "bbox_max": [
        -3288.09619140625,
        -2376.406982421875,
        1181.5367431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499688863754272,
        0.6611048579216003,
        -0.022072864696383476
      ],
      "plane_d": 4375.75048828125,
      "bbox_min": [
        -3697.488525390625,
        -2864.23095703125,
        450.0
      ],
      "bbox_max": [
        -3288.09619140625,
        -2384.901123046875,
        1181.5367431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3662.39306640625,
        -2668.90283203125,
        984.034423828125
      ],
      "bbox_max": [
        -3452.950927734375,
        -2424.958984375,
        1174.1900634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7079524397850037,
        0.6621437072753906,
        0.2457011193037033
      ],
      "plane_d": 4043.7548828125,
      "bbox_min": [
        -3505.179443359375,
        -2864.23095703125,
        450.0
      ],
      "bbox_max": [
        -3288.09619140625,
        -2569.13720703125,
        735.013427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.71111661195755,
        0.6483710408210754,
        0.2718975245952606
      ],
      "plane_d": 4000.435791015625,
      "bbox_min": [
        -3505.179443359375,
        -2753.041015625,
        450.0
      ],
      "bbox_max": [
        -3348.958251953125,
        -2569.13720703125,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3605.199951171875,
        -3126.308349609375,
        0.0
      ],
      "bbox_max": [
        -508.5000305175781,
        -1920.0,
        1150.8623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7079524397850037,
        0.6621437072753906,
        0.2457011193037033
      ],
      "plane_d": 4043.7548828125,
      "bbox_min": [
        -3299.01806640625,
        -2969.13720703125,
        712.7105102539062
      ],
      "bbox_max": [
        -3195.179443359375,
        -2844.277587890625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7517760992050171,
        0.6551191806793213,
        0.07517760246992111
      ],
      "plane_d": 4246.7822265625,
      "bbox_min": [
        -3605.199951171875,
        -2969.13720703125,
        0.0
      ],
      "bbox_max": [
        -508.5000305175781,
        -1920.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.71111661195755,
        0.6483710408210754,
        0.2718975245952606
      ],
      "plane_d": 4000.435791015625,
      "bbox_min": [
        -3455.179443359375,
        -2969.13720703125,
        450.0
      ],
      "bbox_max": [
        -3155.179443359375,
        -2569.13720703125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7079524397850037,
        0.6621437072753906,
        0.2457011193037033
      ],
      "plane_d": 4043.7548828125,
      "bbox_min": [
        -3348.958251953125,
        -2969.13720703125,
        500.0
      ],
      "bbox_max": [
        -3155.179443359375,
        -2753.041015625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7904930710792542,
        0.5928698182106018,
        0.15370698273181915
      ],
      "plane_d": 4185.29150390625,
      "bbox_min": [
        -3605.199951171875,
        -2919.13720703125,
        0.0
      ],
      "bbox_max": [
        -508.5000305175781,
        -1920.0,
        450.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7715306282043457,
        0.6171962022781372,
        0.15430296957492828
      ],
      "plane_d": 4182.001953125,
      "bbox_min": [
        -3605.199951171875,
        -2569.13720703125,
        0.0
      ],
      "bbox_max": [
        -3405.179443359375,
        -2269.10009765625,
        450.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -739.388427734375,
        -2424.544921875,
        0.0
      ],
      "bbox_max": [
        -508.5000305175781,
        -1920.0,
        82.3607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8710070252418518,
        0.4906066656112671,
        0.025533335283398628
      ],
      "plane_d": 1752.1368408203125,
      "bbox_min": [
        -739.388427734375,
        -2424.544921875,
        0.0
      ],
      "bbox_max": [
        -508.5000305175781,
        -2289.004638671875,
        82.3607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7153007388114929,
        0.6982023119926453,
        0.029299555346369743
      ],
      "plane_d": 2127.64697265625,
      "bbox_min": [
        -739.388427734375,
        -2333.46923828125,
        0.0
      ],
      "bbox_max": [
        -697.9111328125,
        -2289.004638671875,
        82.3607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9409332871437073,
        0.3373378813266754,
        0.0291153434664011
      ],
      "plane_d": 1465.486572265625,
      "bbox_min": [
        -739.388427734375,
        -2333.46923828125,
        0.0
      ],
      "bbox_max": [
        -697.9111328125,
        -2289.004638671875,
        82.3607177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -704.1276245117188,
        -2333.46923828125,
        0.0
      ],
      "bbox_max": [
        -697.9111328125,
        -2329.093994140625,
        74.91236877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8764687180519104,
        0.48085832595825195,
        0.02404039539396763
      ],
      "plane_d": 1733.21240234375,
      "bbox_min": [
        -699.4265747070312,
        -2424.544921875,
        0.0
      ],
      "bbox_max": [
        -508.5000305175781,
        -2332.319091796875,
        73.79135131835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -699.4265747070312,
        -2333.705078125,
        0.0
      ],
      "bbox_max": [
        -697.9111328125,
        -2332.319091796875,
        73.79135131835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.834480881690979,
        0.550487756729126,
        0.024593127891421318
      ],
      "plane_d": 1872.022705078125,
      "bbox_min": [
        -659.8515014648438,
        -2424.544921875,
        0.0
      ],
      "bbox_max": [
        -508.5000305175781,
        -2403.364990234375,
        68.94023895263672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8689243793487549,
        0.41837501525878906,
        0.2644478976726532
      ],
      "plane_d": 566.2352905273438,
      "bbox_min": [
        -511.46240234375,
        -2419.84619140625,
        0.0
      ],
      "bbox_max": [
        -508.5000305175781,
        -2415.673583984375,
        15.709417343139648
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14300712943077087,
        0.10372389853000641,
        0.9842714667320251
      ],
      "plane_d": -505.2385559082031,
      "bbox_min": [
        -4912.15185546875,
        -4840.0,
        0.0
      ],
      "bbox_max": [
        2500.0,
        2154.178466796875,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600968956947327,
        0.260924369096756,
        0.10065929591655731
      ],
      "plane_d": 4053.40478515625,
      "bbox_min": [
        -4912.15185546875,
        -4840.0,
        0.0
      ],
      "bbox_max": [
        2500.0,
        2154.178466796875,
        1434.669189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5384979844093323,
        -0.7894291877746582,
        0.29465532302856445
      ],
      "plane_d": -215.73916625976562,
      "bbox_min": [
        -4205.05908203125,
        -3619.13720703125,
        1181.2401123046875
      ],
      "bbox_max": [
        -3614.939453125,
        -2329.13720703125,
        1434.669189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6886258125305176,
        0.6727038025856018,
        0.2706737220287323
      ],
      "plane_d": 4546.642578125,
      "bbox_min": [
        -4000.395751953125,
        -3619.13720703125,
        1181.2401123046875
      ],
      "bbox_max": [
        -3614.939453125,
        -2329.13720703125,
        1434.669189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4914821684360504,
        -0.7588846683502197,
        0.4272461533546448
      ],
      "plane_d": -492.10723876953125,
      "bbox_min": [
        -4000.395751953125,
        -3360.06591796875,
        1181.2401123046875
      ],
      "bbox_max": [
        -3697.77392578125,
        -2329.13720703125,
        1434.669189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6826116442680359,
        -0.6173016428947449,
        0.39112648367881775
      ],
      "plane_d": 596.6063232421875,
      "bbox_min": [
        -3725.179443359375,
        -2378.998046875,
        1181.2401123046875
      ],
      "bbox_max": [
        -3699.20947265625,
        -2329.13720703125,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321149587631226,
        0.2707196772098541,
        0.2405669242143631
      ],
      "plane_d": 3807.88525390625,
      "bbox_min": [
        -3712.849365234375,
        -2378.998046875,
        1181.2401123046875
      ],
      "bbox_max": [
        -3699.20947265625,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6941572427749634,
        0.6507723927497864,
        0.3076378405094147
      ],
      "plane_d": 4443.431640625,
      "bbox_min": [
        -4000.395751953125,
        -3360.06591796875,
        1181.5616455078125
      ],
      "bbox_max": [
        -3697.77392578125,
        -2366.191162109375,
        1434.669189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8682754039764404,
        0.3892272710800171,
        0.3075709939002991
      ],
      "plane_d": 4276.294921875,
      "bbox_min": [
        -4000.395751953125,
        -3278.16796875,
        1181.5616455078125
      ],
      "bbox_max": [
        -3697.77392578125,
        -2366.191162109375,
        1434.669189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321149587631226,
        0.2707196772098541,
        0.2405669242143631
      ],
      "plane_d": 3807.88525390625,
      "bbox_min": [
        -3712.849365234375,
        -2384.5537109375,
        1181.5616455078125
      ],
      "bbox_max": [
        -3697.77392578125,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499688863754272,
        0.6611048579216003,
        -0.022072864696383476
      ],
      "plane_d": 4375.75048828125,
      "bbox_min": [
        -3712.849365234375,
        -2384.5537109375,
        1182.2510986328125
      ],
      "bbox_max": [
        -3697.77392578125,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3712.849365234375,
        -2378.32275390625,
        1210.5433349609375
      ],
      "bbox_max": [
        -3702.43359375,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -3725.179443359375,
        -4840.0,
        0.0
      ],
      "bbox_max": [
        2500.0,
        -1918.043212890625,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3725.179443359375,
        -3742.4970703125,
        15.57293701171875
      ],
      "bbox_max": [
        284.8452453613281,
        -1918.043212890625,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499688863754272,
        0.6611048579216003,
        -0.022072864696383476
      ],
      "plane_d": 4375.75048828125,
      "bbox_min": [
        -3702.43359375,
        -2424.958984375,
        1174.1900634765625
      ],
      "bbox_max": [
        -3662.39306640625,
        -2378.32275390625,
        1210.5433349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321149587631226,
        0.2707196772098541,
        0.2405669242143631
      ],
      "plane_d": 3807.88525390625,
      "bbox_min": [
        -3698.34423828125,
        -2384.901123046875,
        1181.455322265625
      ],
      "bbox_max": [
        -3697.488525390625,
        -2382.34619140625,
        1182.2510986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8689243793487549,
        0.41837501525878906,
        0.2644478976726532
      ],
      "plane_d": 566.2352905273438,
      "bbox_min": [
        -3725.179443359375,
        -3742.4970703125,
        15.57293701171875
      ],
      "bbox_max": [
        284.8452453613281,
        -1918.043212890625,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8467844724655151,
        0.531133234500885,
        0.029217718169093132
      ],
      "plane_d": 1677.308349609375,
      "bbox_min": [
        -508.76104736328125,
        -3742.4970703125,
        506.04541015625
      ],
      "bbox_max": [
        284.8452453613281,
        -1974.324462890625,
        874.2164306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5775443315505981,
        0.816006064414978,
        0.024013593792915344
      ],
      "plane_d": 2576.892578125,
      "bbox_min": [
        -508.76104736328125,
        -3742.4970703125,
        506.04541015625
      ],
      "bbox_max": [
        284.8452453613281,
        -2729.926025390625,
        874.2164306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8509166240692139,
        0.5241855978965759,
        0.03420881927013397
      ],
      "plane_d": 1648.3133544921875,
      "bbox_min": [
        -55.04105758666992,
        -3742.4970703125,
        748.3753662109375
      ],
      "bbox_max": [
        284.8452453613281,
        -3144.068603515625,
        869.05712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5784721970558167,
        0.8153333067893982,
        0.024523697793483734
      ],
      "plane_d": 2574.3935546875,
      "bbox_min": [
        -55.04105758666992,
        -3742.4970703125,
        765.4616088867188
      ],
      "bbox_max": [
        284.8452453613281,
        -3144.068603515625,
        869.05712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17268596589565277,
        0.98418790102005,
        0.03941702842712402
      ],
      "plane_d": 3599.98388671875,
      "bbox_min": [
        263.3183288574219,
        -3742.4970703125,
        789.3822631835938
      ],
      "bbox_max": [
        284.8452453613281,
        -3736.21240234375,
        869.05712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -508.76104736328125,
        -3018.20361328125,
        506.04541015625
      ],
      "bbox_max": [
        -229.613525390625,
        -2729.926025390625,
        874.2164306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910527229309082,
        0.41264408826828003,
        0.025789525359869003
      ],
      "plane_d": 1473.680908203125,
      "bbox_min": [
        -352.2469787597656,
        -3018.20361328125,
        651.6136474609375
      ],
      "bbox_max": [
        -229.613525390625,
        -2845.004150390625,
        867.947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9309833645820618,
        0.3635721206665039,
        0.032943326979875565
      ],
      "plane_d": 1331.6527099609375,
      "bbox_min": [
        -326.8922119140625,
        -2929.62353515625,
        688.5384521484375
      ],
      "bbox_max": [
        -312.7353515625,
        -2904.17919921875,
        867.947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388458251953125,
        0.6731601357460022,
        0.031021643429994583
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -318.19537353515625,
        -2929.62353515625,
        688.5384521484375
      ],
      "bbox_max": [
        -312.7353515625,
        -2924.27294921875,
        867.947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388458251953125,
        0.6731601357460022,
        0.031021643429994583
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -315.3895263671875,
        -3018.20361328125,
        688.5384521484375
      ],
      "bbox_max": [
        -229.613525390625,
        -2924.27294921875,
        867.8637084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -257.3710632324219,
        -3018.20361328125,
        699.149169921875
      ],
      "bbox_max": [
        -229.613525390625,
        -2993.223876953125,
        866.1363525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9373313784599304,
        0.34786927700042725,
        0.019921978935599327
      ],
      "plane_d": 1415.8299560546875,
      "bbox_min": [
        -508.76104736328125,
        -2801.845947265625,
        506.04541015625
      ],
      "bbox_max": [
        -482.3701171875,
        -2729.926025390625,
        696.4218139648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -508.76104736328125,
        -2800.61376953125,
        506.04541015625
      ],
      "bbox_max": [
        -482.3701171875,
        -2729.926025390625,
        619.49169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.137159526348114,
        -0.01990017108619213,
        0.9903489947319031
      ],
      "plane_d": -646.2860107421875,
      "bbox_min": [
        -184.84814453125,
        -2189.92578125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -1974.324462890625,
        767.5735473632812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1436760127544403,
        0.03255536034703255,
        0.9890891313552856
      ],
      "plane_d": -535.7574462890625,
      "bbox_min": [
        -119.778564453125,
        -2181.199951171875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2048.967529296875,
        626.3668212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13787776231765747,
        -0.03273407742381096,
        0.9899080991744995
      ],
      "plane_d": -673.2636108398438,
      "bbox_min": [
        -119.778564453125,
        -2181.199951171875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2048.967529296875,
        626.3668212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -109.34033203125,
        -2181.199951171875,
        618.4127807617188
      ],
      "bbox_max": [
        -66.12939453125,
        -2048.967529296875,
        625.504150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        0.9927930235862732,
        0.0
      ],
      "plane_d": 2114.69677734375,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.412841796875
      ],
      "bbox_max": [
        -66.12939453125,
        -2048.967529296875,
        625.0650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.412841796875
      ],
      "bbox_max": [
        -79.672119140625,
        -2048.967529296875,
        625.0650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.5,
        -2073.7763671875,
        618.5244140625
      ],
      "bbox_max": [
        -92.20442962646484,
        -2071.60009765625,
        623.3185424804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.5,
        -2138.245849609375,
        618.5244140625
      ],
      "bbox_max": [
        -92.20442199707031,
        -2136.069580078125,
        622.3348388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.412841796875
      ],
      "bbox_max": [
        -89.30126953125,
        -2069.38525390625,
        625.0650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.412841796875
      ],
      "bbox_max": [
        -89.30126953125,
        -2069.38525390625,
        625.0650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2127.946044921875,
      "bbox_min": [
        -91.10107421875,
        -2127.946044921875,
        618.5244140625
      ],
      "bbox_max": [
        -89.30126953125,
        -2127.946044921875,
        622.4420776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.412841796875
      ],
      "bbox_max": [
        -100.88525390625,
        -2069.38525390625,
        625.0650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.412841796875
      ],
      "bbox_max": [
        -100.88525390625,
        -2139.665283203125,
        624.0093994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -109.34033203125,
        -2150.27197265625,
        618.412841796875
      ],
      "bbox_max": [
        -105.2154541015625,
        -2059.421630859375,
        625.504150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2150.27197265625,
        618.412841796875
      ],
      "bbox_max": [
        -105.22237396240234,
        -2064.5546875,
        625.504150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -107.177978515625,
        -2069.38525390625,
        618.412841796875
      ],
      "bbox_max": [
        -105.22237396240234,
        -2069.026611328125,
        625.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -107.177978515625,
        -2140.8193359375,
        618.412841796875
      ],
      "bbox_max": [
        -105.2717514038086,
        -2140.4697265625,
        624.2633666992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -105.278564453125,
        -2059.573974609375,
        618.412841796875
      ],
      "bbox_max": [
        -105.2154541015625,
        -2059.421630859375,
        624.7501831054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -119.778564453125,
        -2181.199951171875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2113.157470703125,
        626.3668212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        0.9927930235862732,
        0.0
      ],
      "plane_d": 2114.69677734375,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.63818359375
      ],
      "bbox_max": [
        -66.12939453125,
        -2130.7216796875,
        624.153076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        620.4703369140625
      ],
      "bbox_max": [
        -79.672119140625,
        -2130.7216796875,
        624.153076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        0.9238802790641785,
        -0.0
      ],
      "plane_d": 2007.28369140625,
      "bbox_min": [
        -92.5,
        -2139.665283203125,
        620.4703369140625
      ],
      "bbox_max": [
        -79.672119140625,
        -2135.27197265625,
        622.4317016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.5,
        -2138.245849609375,
        622.3040161132812
      ],
      "bbox_max": [
        -92.20442962646484,
        -2136.069580078125,
        622.4317016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        622.3347778320312
      ],
      "bbox_max": [
        -91.47808074951172,
        -2130.7216796875,
        624.153076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        623.4249877929688
      ],
      "bbox_max": [
        -100.88525390625,
        -2139.665283203125,
        624.153076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2150.27197265625,
        623.6862182617188
      ],
      "bbox_max": [
        -105.2717514038086,
        -2140.4697265625,
        624.61962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        624.0093994140625
      ],
      "bbox_max": [
        -105.2717514038086,
        -2140.4697265625,
        624.61962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -107.177978515625,
        -2140.8193359375,
        624.0093994140625
      ],
      "bbox_max": [
        -105.2717514038086,
        -2140.4697265625,
        624.4100341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10146033763885498,
        0.9581761956214905,
        0.2675895094871521
      ],
      "plane_d": 1884.0174560546875,
      "bbox_min": [
        -91.48384094238281,
        -2132.77880859375,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2113.157470703125,
        622.4413452148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36875930428504944,
        0.824822723865509,
        0.4285838007926941
      ],
      "plane_d": 1509.3642578125,
      "bbox_min": [
        26.906936645507812,
        -2132.77880859375,
        605.8223876953125
      ],
      "bbox_max": [
        27.273826599121094,
        -2132.563232421875,
        606.0013427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -91.48384094238281,
        -2130.76416015625,
        622.4104614257812
      ],
      "bbox_max": [
        -91.18179321289062,
        -2128.540283203125,
        622.4413452148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10736268758773804,
        -0.8992251753807068,
        0.42410773038864136
      ],
      "plane_d": -2122.285888671875,
      "bbox_min": [
        -112.20849609375,
        -2113.157470703125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2048.967529296875,
        626.3668212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -108.26380157470703,
        -2077.08203125,
        623.0650024414062
      ],
      "bbox_max": [
        -90.278564453125,
        -2066.781005859375,
        626.048095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -108.26380157470703,
        -2073.7763671875,
        623.2898559570312
      ],
      "bbox_max": [
        -92.20442962646484,
        -2066.781005859375,
        626.048095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.26380157470703,
        -2067.21044921875,
        625.405029296875
      ],
      "bbox_max": [
        -108.0561752319336,
        -2066.781005859375,
        626.048095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -108.0561752319336,
        -2077.08203125,
        623.3185424804688
      ],
      "bbox_max": [
        -91.75545501708984,
        -2067.21044921875,
        626.0107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.0561752319336,
        -2069.026611328125,
        625.3372802734375
      ],
      "bbox_max": [
        -107.177978515625,
        -2067.21044921875,
        626.0107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.20443725585938,
        -2077.08203125,
        623.3185424804688
      ],
      "bbox_max": [
        -91.75545501708984,
        -2073.7763671875,
        623.683349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -109.34033203125,
        -2066.781005859375,
        624.7501831054688
      ],
      "bbox_max": [
        -105.278564453125,
        -2059.573974609375,
        626.241943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2066.781005859375,
        625.4210815429688
      ],
      "bbox_max": [
        -108.26380157470703,
        -2064.5546875,
        626.241943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8734391927719116,
        -0.19791147112846375,
        -0.44489893317222595
      ],
      "plane_d": -14.895965576171875,
      "bbox_min": [
        -91.76782989501953,
        -2113.157470703125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2063.799072265625,
        623.5582885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -91.76782989501953,
        -2080.781494140625,
        623.362060546875
      ],
      "bbox_max": [
        -91.25299072265625,
        -2076.990966796875,
        623.5582885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10736268758773804,
        -0.8992251753807068,
        0.42410773038864136
      ],
      "plane_d": -2122.285888671875,
      "bbox_min": [
        -184.84814453125,
        -2189.92578125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -1974.324462890625,
        767.5735473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0745648443698883,
        -0.5767466425895691,
        0.8135129809379578
      ],
      "plane_d": -1707.160400390625,
      "bbox_min": [
        -154.93328857421875,
        -2078.106689453125,
        623.4006958007812
      ],
      "bbox_max": [
        121.512451171875,
        -1974.324462890625,
        717.9649047851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -154.93328857421875,
        -2078.106689453125,
        623.4006958007812
      ],
      "bbox_max": [
        -85.1344985961914,
        -1998.9012451171875,
        690.3648681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -114.53120422363281,
        -2076.99072265625,
        623.4006958007812
      ],
      "bbox_max": [
        -85.1344985961914,
        -1998.9012451171875,
        690.3648681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -95.60404205322266,
        -2076.99072265625,
        623.4006958007812
      ],
      "bbox_max": [
        -90.278564453125,
        -2071.60009765625,
        630.682861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -92.20443725585938,
        -2074.573974609375,
        623.4006958007812
      ],
      "bbox_max": [
        -90.278564453125,
        -2073.7763671875,
        628.6817016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -95.60404205322266,
        -2073.7763671875,
        623.6834716796875
      ],
      "bbox_max": [
        -92.20442199707031,
        -2072.3681640625,
        630.2362670898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -114.53120422363281,
        -2072.91552734375,
        623.9885864257812
      ],
      "bbox_max": [
        -94.2827377319336,
        -2002.6787109375,
        688.1463012695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -109.34033203125,
        -2072.91552734375,
        623.9885864257812
      ],
      "bbox_max": [
        -94.2827377319336,
        -2047.3251953125,
        652.889892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -108.26380157470703,
        -2072.91552734375,
        623.9885864257812
      ],
      "bbox_max": [
        -94.2827377319336,
        -2047.3251953125,
        652.889892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.26380157470703,
        -2069.026611328125,
        625.8526000976562
      ],
      "bbox_max": [
        -96.92050170898438,
        -2047.3251953125,
        652.889892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -98.24224853515625,
        -2047.8726806640625,
        652.7044067382812
      ],
      "bbox_max": [
        -96.92050170898438,
        -2047.3251953125,
        652.889892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -100.88525390625,
        -2072.91552734375,
        623.9885864257812
      ],
      "bbox_max": [
        -94.2827377319336,
        -2070.1806640625,
        632.6511840820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -109.34033203125,
        -2066.781005859375,
        625.7794799804688
      ],
      "bbox_max": [
        -105.278564453125,
        -2059.573974609375,
        642.64306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2066.781005859375,
        626.048095703125
      ],
      "bbox_max": [
        -108.26380157470703,
        -2064.5546875,
        638.4468383789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13752444088459015,
        -0.08930294960737228,
        0.9864643812179565
      ],
      "plane_d": -788.0382080078125,
      "bbox_min": [
        -154.93328857421875,
        -2078.106689453125,
        626.3668212890625
      ],
      "bbox_max": [
        -106.350830078125,
        -2019.0810546875,
        676.8016357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -124.34606170654297,
        -2032.661865234375,
        663.7589111328125
      ],
      "bbox_max": [
        -106.350830078125,
        -2019.0810546875,
        676.8016357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -124.34606170654297,
        -2032.661865234375,
        663.7589111328125
      ],
      "bbox_max": [
        -106.350830078125,
        -2026.7733154296875,
        671.481201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -99.6484375,
        -2044.892578125,
        637.62353515625
      ],
      "bbox_max": [
        121.512451171875,
        -1974.324462890625,
        717.9649047851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -99.6484375,
        -2033.1209716796875,
        666.0712890625
      ],
      "bbox_max": [
        -97.80713653564453,
        -1997.3214111328125,
        696.0213623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -157.4827117919922,
        -2080.4765625,
        626.3668212890625
      ],
      "bbox_max": [
        121.512451171875,
        -1974.461669921875,
        732.4716186523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -157.4827117919922,
        -2080.4765625,
        626.3668212890625
      ],
      "bbox_max": [
        -79.672119140625,
        -2000.3193359375,
        727.9965209960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2706061899662018,
        0.6532682776451111,
        0.7071157693862915
      ],
      "plane_d": 898.547607421875,
      "bbox_min": [
        -99.86669921875,
        -2075.235595703125,
        627.3399658203125
      ],
      "bbox_max": [
        -79.672119140625,
        -2045.857666015625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.653276264667511,
        0.27059444785118103,
        0.7071129083633423
      ],
      "plane_d": 26.99755859375,
      "bbox_min": [
        -99.86669921875,
        -2075.235595703125,
        627.3399658203125
      ],
      "bbox_max": [
        -90.278564453125,
        -2051.547119140625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -96.68566131591797,
        -2075.235595703125,
        627.3399658203125
      ],
      "bbox_max": [
        -90.278564453125,
        -2071.60009765625,
        635.4951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.5,
        -2073.7763671875,
        628.6817626953125
      ],
      "bbox_max": [
        -92.20441436767578,
        -2071.60009765625,
        635.1734008789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.20441436767578,
        -2075.235595703125,
        627.3399658203125
      ],
      "bbox_max": [
        -92.00621032714844,
        -2073.7763671875,
        630.4842529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532886624336243,
        -0.2705933749675751,
        0.7071020007133484
      ],
      "plane_d": -1087.6129150390625,
      "bbox_min": [
        -100.01698303222656,
        -2071.94189453125,
        635.3507080078125
      ],
      "bbox_max": [
        -96.63316345214844,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -657.704345703125,
      "bbox_min": [
        -99.86669921875,
        -2071.94189453125,
        635.3507080078125
      ],
      "bbox_max": [
        -96.63316345214844,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -96.74231719970703,
        -2071.94189453125,
        635.3507080078125
      ],
      "bbox_max": [
        -96.63316345214844,
        -2071.896728515625,
        635.6185913085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -157.4827117919922,
        -2080.4765625,
        626.3668212890625
      ],
      "bbox_max": [
        -95.60404205322266,
        -2047.5574951171875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13752444088459015,
        -0.08930294960737228,
        0.9864643812179565
      ],
      "plane_d": -788.0382080078125,
      "bbox_min": [
        -155.26504516601562,
        -2078.106689453125,
        626.3668212890625
      ],
      "bbox_max": [
        -95.60404205322266,
        -2047.5574951171875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.653276264667511,
        0.27059444785118103,
        0.7071129083633423
      ],
      "plane_d": 26.99755859375,
      "bbox_min": [
        -109.34033203125,
        -2072.3681640625,
        630.2362670898438
      ],
      "bbox_max": [
        -95.60404205322266,
        -2047.5574951171875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7667246460914612,
        -0.3175787925720215,
        0.5579220652580261
      ],
      "plane_d": -1098.954833984375,
      "bbox_min": [
        -109.34033203125,
        -2069.031982421875,
        634.2090454101562
      ],
      "bbox_max": [
        -96.99674224853516,
        -2047.5574951171875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -109.34033203125,
        -2069.031982421875,
        634.2090454101562
      ],
      "bbox_max": [
        -96.99674224853516,
        -2047.5574951171875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.26380157470703,
        -2069.031982421875,
        634.2090454101562
      ],
      "bbox_max": [
        -96.99674224853516,
        -2047.5574951171875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -108.26380157470703,
        -2069.031982421875,
        644.2874145507812
      ],
      "bbox_max": [
        -96.99674224853516,
        -2047.5574951171875,
        656.0746459960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        -0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": -1186.8843994140625,
      "bbox_min": [
        -108.26380157470703,
        -2069.031982421875,
        644.2874145507812
      ],
      "bbox_max": [
        -105.54733276367188,
        -2065.597412109375,
        648.0633544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -109.34033203125,
        -2066.781005859375,
        636.3370361328125
      ],
      "bbox_max": [
        -105.278564453125,
        -2059.573974609375,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2066.781005859375,
        636.3370361328125
      ],
      "bbox_max": [
        -107.77347564697266,
        -2064.5546875,
        645.8472290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        -0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": -1186.8843994140625,
      "bbox_min": [
        -109.34033203125,
        -2066.781005859375,
        644.2874145507812
      ],
      "bbox_max": [
        -107.77347564697266,
        -2064.5546875,
        645.8472290039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -100.88525390625,
        -2072.3681640625,
        630.2362670898438
      ],
      "bbox_max": [
        -95.60404205322266,
        -2070.1806640625,
        640.3057250976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17143665254116058,
        0.9780559539794922,
        0.11838870495557785
      ],
      "plane_d": 2043.5338134765625,
      "bbox_min": [
        -184.84814453125,
        -2189.92578125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        767.5735473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10146033763885498,
        0.9581761956214905,
        0.2675895094871521
      ],
      "plane_d": 1884.0174560546875,
      "bbox_min": [
        -184.84814453125,
        -2189.92578125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        767.5735473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -139.03756713867188,
        -2189.92578125,
        606.0013427734375
      ],
      "bbox_max": [
        26.906936645507812,
        -2132.764404296875,
        757.572021484375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.300048828125,
        -2181.199951171875,
        623.3385620117188
      ],
      "bbox_max": [
        -80.69756317138672,
        -2160.9189453125,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -677.7044067382812,
      "bbox_min": [
        -99.89990234375,
        -2181.199951171875,
        656.5999755859375
      ],
      "bbox_max": [
        -80.69756317138672,
        -2167.647705078125,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -98.89990234375,
        -2171.5,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2167.647705078125,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6793980598449707,
        0.0004719383723568171,
        0.7337697148323059
      ],
      "plane_d": -549.4459838867188,
      "bbox_min": [
        -105.300048828125,
        -2181.199951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -99.88549041748047,
        -2166.400146484375,
        657.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.08373019099235535,
        0.9710349440574646,
        0.22378645837306976
      ],
      "plane_d": 1966.399658203125,
      "bbox_min": [
        -139.03753662109375,
        -2169.029541015625,
        623.7440795898438
      ],
      "bbox_max": [
        -81.60009765625,
        -2160.685546875,
        657.9076538085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.28976440429688,
        -2166.400146484375,
        623.7440795898438
      ],
      "bbox_max": [
        -105.28579711914062,
        -2160.685546875,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -105.28976440429688,
        -2169.029541015625,
        651.650146484375
      ],
      "bbox_max": [
        -81.60009765625,
        -2166.156982421875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6793980598449707,
        0.0004719383723568171,
        0.7337697148323059
      ],
      "plane_d": -549.4459838867188,
      "bbox_min": [
        -105.28976440429688,
        -2167.4736328125,
        651.650146484375
      ],
      "bbox_max": [
        -101.08056640625,
        -2166.156982421875,
        656.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.28976440429688,
        -2166.400146484375,
        651.650146484375
      ],
      "bbox_max": [
        -105.28959655761719,
        -2166.156982421875,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786047220230103,
        0.0007285246392711997,
        0.7345033884048462
      ],
      "plane_d": -549.2896118164062,
      "bbox_min": [
        -101.08056640625,
        -2167.778076171875,
        656.5999755859375
      ],
      "bbox_max": [
        -99.88549041748047,
        -2167.465576171875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16232021152973175,
        0.6113415360450745,
        0.7745409607887268
      ],
      "plane_d": 836.6258544921875,
      "bbox_min": [
        -139.03756713867188,
        -2173.240966796875,
        606.0013427734375
      ],
      "bbox_max": [
        26.906936645507812,
        -2132.764404296875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.28959655761719,
        -2166.156005859375,
        623.748779296875
      ],
      "bbox_max": [
        -105.2795181274414,
        -2151.646240234375,
        651.6453247070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -105.28974151611328,
        -2173.240966796875,
        606.0013427734375
      ],
      "bbox_max": [
        26.906936645507812,
        -2132.764404296875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -677.7044067382812,
      "bbox_min": [
        -99.88970184326172,
        -2173.240966796875,
        656.5999755859375
      ],
      "bbox_max": [
        -80.69480895996094,
        -2158.262451171875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -98.89990234375,
        -2169.029541015625,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2158.262451171875,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.28974151611328,
        -2167.778076171875,
        644.7898559570312
      ],
      "bbox_max": [
        -99.877685546875,
        -2157.47216796875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786047220230103,
        0.0007285246392711997,
        0.7345033884048462
      ],
      "plane_d": -549.2896118164062,
      "bbox_min": [
        -105.28974151611328,
        -2167.778076171875,
        652.7044067382812
      ],
      "bbox_max": [
        -99.877685546875,
        -2159.6826171875,
        657.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9362152218818665,
        0.2509586215019226,
        -0.2460101991891861
      ],
      "plane_d": 826.9634399414062,
      "bbox_min": [
        -184.84814453125,
        -2187.80908203125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        767.5735473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -184.84814453125,
        -2187.80908203125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        767.5735473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -109.34033203125,
        -2156.387451171875,
        618.7809448242188
      ],
      "bbox_max": [
        -66.12939453125,
        -2130.763916015625,
        640.90576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        0.9927930235862732,
        0.0
      ],
      "plane_d": 2114.69677734375,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        618.7809448242188
      ],
      "bbox_max": [
        -66.12939453125,
        -2130.763916015625,
        630.7153930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        620.623779296875
      ],
      "bbox_max": [
        -79.672119140625,
        -2130.763916015625,
        630.7153930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        0.9238802790641785,
        -0.0
      ],
      "plane_d": 2007.28369140625,
      "bbox_min": [
        -92.5,
        -2139.665283203125,
        620.623779296875
      ],
      "bbox_max": [
        -79.672119140625,
        -2135.27197265625,
        627.3795776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.5,
        -2138.245849609375,
        622.4288940429688
      ],
      "bbox_max": [
        -92.20442962646484,
        -2136.069580078125,
        627.3795776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -105.2717514038086,
        -2140.4697265625,
        622.4317016601562
      ],
      "bbox_max": [
        -91.48381042480469,
        -2130.763916015625,
        630.7153930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.20442962646484,
        -2136.069580078125,
        622.4317016601562
      ],
      "bbox_max": [
        -91.48381042480469,
        -2130.763916015625,
        625.9423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2150.27197265625,
        623.95703125
      ],
      "bbox_max": [
        -105.2717514038086,
        -2140.4697265625,
        636.99072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        624.153076171875
      ],
      "bbox_max": [
        -105.2717514038086,
        -2140.4697265625,
        634.4107666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -107.177978515625,
        -2140.8193359375,
        624.153076171875
      ],
      "bbox_max": [
        -105.2717514038086,
        -2140.4697265625,
        631.224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661781549453735,
        -0.4989537298679352,
        -0.027941754087805748
      ],
      "plane_d": -897.239013671875,
      "bbox_min": [
        -184.84814453125,
        -2187.80908203125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        767.5735473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8734391927719116,
        -0.19791147112846375,
        -0.44489893317222595
      ],
      "plane_d": -14.895965576171875,
      "bbox_min": [
        121.512451171875,
        -2113.157470703125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2044.892578125,
        637.62353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45699819922447205,
        -0.8811807036399841,
        -0.1211327537894249
      ],
      "plane_d": -1669.15185546875,
      "bbox_min": [
        -184.84814453125,
        -2187.80908203125,
        622.1928100585938
      ],
      "bbox_max": [
        126.47466278076172,
        -2015.640380859375,
        767.5735473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08636579662561417,
        0.9781541228294373,
        0.18909122049808502
      ],
      "plane_d": 2005.1881103515625,
      "bbox_min": [
        -184.84814453125,
        -2187.80908203125,
        622.1928100585938
      ],
      "bbox_max": [
        -64.5244140625,
        -2029.1715087890625,
        767.5735473632812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.07853952795267105,
        0.978276252746582,
        0.19185161590576172
      ],
      "plane_d": 2002.348876953125,
      "bbox_min": [
        -184.84814453125,
        -2187.80908203125,
        622.1928100585938
      ],
      "bbox_max": [
        -64.5244140625,
        -2029.1715087890625,
        762.282958984375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.08373019099235535,
        0.9710349440574646,
        0.22378645837306976
      ],
      "plane_d": 1966.399658203125,
      "bbox_min": [
        -163.181640625,
        -2164.698486328125,
        657.4825439453125
      ],
      "bbox_max": [
        -138.92935180664062,
        -2163.4716796875,
        661.6588745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16232021152973175,
        0.6113415360450745,
        0.7745409607887268
      ],
      "plane_d": 836.6258544921875,
      "bbox_min": [
        -184.84814453125,
        -2169.73779296875,
        622.1928100585938
      ],
      "bbox_max": [
        -64.5244140625,
        -2029.1715087890625,
        741.733642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2157.47216796875,
        628.624267578125
      ],
      "bbox_max": [
        -98.66907501220703,
        -2138.747314453125,
        644.7898559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        628.624267578125
      ],
      "bbox_max": [
        -98.66907501220703,
        -2138.747314453125,
        636.0255737304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        631.224609375
      ],
      "bbox_max": [
        -107.177978515625,
        -2140.8193359375,
        636.0255737304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -100.88525390625,
        -2139.665283203125,
        628.624267578125
      ],
      "bbox_max": [
        -98.66907501220703,
        -2138.747314453125,
        629.813232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.2835693359375,
        -2157.47216796875,
        636.99072265625
      ],
      "bbox_max": [
        -105.278564453125,
        -2150.27197265625,
        644.7898559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -184.84814453125,
        -2169.73779296875,
        622.1928100585938
      ],
      "bbox_max": [
        -64.5244140625,
        -2029.1715087890625,
        741.733642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -98.35603332519531,
        -2081.89990234375,
        623.3673095703125
      ],
      "bbox_max": [
        -79.672119140625,
        -2059.564208984375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2705896496772766,
        -0.6532796025276184,
        0.7071117758750916
      ],
      "plane_d": -1841.240234375,
      "bbox_min": [
        -94.10701751708984,
        -2075.322998046875,
        630.484375
      ],
      "bbox_max": [
        -88.0,
        -2067.576171875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.5,
        -2075.322998046875,
        630.484375
      ],
      "bbox_max": [
        -88.0,
        -2071.60009765625,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.5,
        -2075.322998046875,
        651.2399291992188
      ],
      "bbox_max": [
        -88.0,
        -2071.60009765625,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.20442962646484,
        -2081.89990234375,
        623.3673095703125
      ],
      "bbox_max": [
        -88.47032928466797,
        -2073.7763671875,
        651.2399291992188
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -90.90784454345703,
        -2081.537353515625,
        637.3416748046875
      ],
      "bbox_max": [
        -88.47032928466797,
        -2074.313232421875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9126664400100708,
        0.4087052345275879
      ],
      "plane_d": -2160.234130859375,
      "bbox_min": [
        -89.51535034179688,
        -2081.537353515625,
        637.3416748046875
      ],
      "bbox_max": [
        -89.0361328125,
        -2079.802001953125,
        641.2166748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33603790402412415,
        0.4438745677471161,
        0.8306947946548462
      ],
      "plane_d": 465.50872802734375,
      "bbox_min": [
        -184.84814453125,
        -2169.73779296875,
        622.1928100585938
      ],
      "bbox_max": [
        -64.5244140625,
        -2061.6728515625,
        701.5438232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20432525873184204,
        0.34070679545402527,
        0.9176982641220093
      ],
      "plane_d": 163.24847412109375,
      "bbox_min": [
        -184.84814453125,
        -2163.4716796875,
        658.3607177734375
      ],
      "bbox_max": [
        -163.181640625,
        -2144.25439453125,
        667.4351806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -184.84814453125,
        -2163.4716796875,
        661.6588745117188
      ],
      "bbox_max": [
        -163.181640625,
        -2157.106201171875,
        667.4351806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -184.38143920898438,
        -2169.73779296875,
        622.1928100585938
      ],
      "bbox_max": [
        -64.5244140625,
        -2061.6728515625,
        701.5438232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25527524948120117,
        0.9336197376251221,
        0.25137388706207275
      ],
      "plane_d": 1895.1923828125,
      "bbox_min": [
        -184.38143920898438,
        -2169.73779296875,
        622.1928100585938
      ],
      "bbox_max": [
        -64.5244140625,
        -2061.6728515625,
        701.5438232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -184.38143920898438,
        -2168.828369140625,
        622.1928100585938
      ],
      "bbox_max": [
        -64.5244140625,
        -2061.6728515625,
        698.6240844726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -677.7044067382812,
      "bbox_min": [
        -109.34033203125,
        -2166.092529296875,
        622.1928100585938
      ],
      "bbox_max": [
        -64.5244140625,
        -2061.6728515625,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        0.9238802790641785,
        -0.0
      ],
      "plane_d": 2007.28369140625,
      "bbox_min": [
        -109.34033203125,
        -2166.092529296875,
        622.1928100585938
      ],
      "bbox_max": [
        -64.5244140625,
        -2061.6728515625,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.999999463558197,
        0.0010735620744526386,
        0.0
      ],
      "plane_d": -97.55819702148438,
      "bbox_min": [
        -109.34033203125,
        -2166.092529296875,
        624.9449462890625
      ],
      "bbox_max": [
        -68.04356384277344,
        -2134.559326171875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -99.86669921875,
        -2160.094482421875,
        624.9449462890625
      ],
      "bbox_max": [
        -68.04356384277344,
        -2134.559326171875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -99.86669921875,
        -2160.094482421875,
        625.9423828125
      ],
      "bbox_max": [
        -68.04356384277344,
        -2135.27197265625,
        677.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6532713174819946,
        0.27060064673423767,
        0.7071151733398438
      ],
      "plane_d": 169.50509643554688,
      "bbox_min": [
        -99.86359405517578,
        -2150.27197265625,
        625.9423828125
      ],
      "bbox_max": [
        -68.04356384277344,
        -2135.27197265625,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -99.86359405517578,
        -2147.37841796875,
        625.9423828125
      ],
      "bbox_max": [
        -79.672119140625,
        -2135.27197265625,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060675621032715,
        0.6532860994338989,
        0.707099199295044
      ],
      "plane_d": 908.98681640625,
      "bbox_min": [
        -99.86359405517578,
        -2147.37841796875,
        625.9423828125
      ],
      "bbox_max": [
        -88.0,
        -2135.27197265625,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -99.86359405517578,
        -2147.37841796875,
        625.9423828125
      ],
      "bbox_max": [
        -88.0,
        -2135.27197265625,
        656.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.5,
        -2138.245849609375,
        651.2399291992188
      ],
      "bbox_max": [
        -88.0,
        -2135.27197265625,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532719135284424,
        0.2706008851528168,
        0.7071145176887512
      ],
      "plane_d": 51.553009033203125,
      "bbox_min": [
        -99.86359405517578,
        -2147.37841796875,
        654.0486450195312
      ],
      "bbox_max": [
        -97.9036636352539,
        -2140.694091796875,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4983988106250763,
        0.20644919574260712,
        0.8420079350471497
      ],
      "plane_d": -68.14163208007812,
      "bbox_min": [
        -79.672119140625,
        -2150.27197265625,
        647.041748046875
      ],
      "bbox_max": [
        -68.04356384277344,
        -2139.665283203125,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48884037137031555,
        0.2158251702785492,
        0.8452541828155518
      ],
      "plane_d": -50.819091796875,
      "bbox_min": [
        -75.278564453125,
        -2150.27197265625,
        647.041748046875
      ],
      "bbox_max": [
        -68.04356384277344,
        -2143.5625,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238762259483337,
        0.3826916813850403,
        0.0
      ],
      "plane_d": 730.626708984375,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -79.4952163696289,
        -2139.488525390625,
        677.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3826916813850403,
        0.9238762259483337,
        0.0
      ],
      "plane_d": 1943.1781005859375,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -79.4952163696289,
        -2139.488525390625,
        677.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3827034533023834,
        0.9238713383674622,
        -0.0
      ],
      "plane_d": 2012.266357421875,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -79.4952163696289,
        -2140.086181640625,
        677.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9272966980934143,
        -0.3743273913860321,
        0.0
      ],
      "plane_d": -880.7164916992188,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -79.4952163696289,
        -2140.683837890625,
        664.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -84.69074249267578,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -79.4952163696289,
        -2142.99853515625,
        659.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6532713174819946,
        0.27060064673423767,
        0.7071151733398438
      ],
      "plane_d": 169.50509643554688,
      "bbox_min": [
        -83.4990234375,
        -2150.27197265625,
        656.5999755859375
      ],
      "bbox_max": [
        -79.4952163696289,
        -2143.4921875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3681499660015106,
        0.9297664761543274,
        0.0
      ],
      "plane_d": 2036.0167236328125,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -84.2060546875,
        -2140.683837890625,
        664.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826918601989746,
        -0.9238760471343994,
        -0.0
      ],
      "plane_d": -2013.19921875,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -84.2060546875,
        -2140.683837890625,
        664.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -91.48558807373047,
        -2144.19921875,
        659.7044067382812
      ],
      "bbox_max": [
        -84.2060546875,
        -2140.683837890625,
        659.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2010255753993988,
        -0.4735967814922333,
        0.8574933409690857
      ],
      "plane_d": -1600.109375,
      "bbox_min": [
        -88.23503875732422,
        -2148.014892578125,
        659.5287475585938
      ],
      "bbox_max": [
        -84.95695495605469,
        -2144.73681640625,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3907240033149719,
        0.9205079078674316,
        0.0
      ],
      "plane_d": 1937.51904296875,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -90.278564453125,
        -2141.183837890625,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9205050468444824,
        -0.3907306492328644,
        -0.0
      ],
      "plane_d": -926.4359741210938,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -92.36495971679688,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2010255753993988,
        -0.4735967814922333,
        0.8574933409690857
      ],
      "plane_d": -1563.80419921875,
      "bbox_min": [
        -95.74359130859375,
        -2148.014892578125,
        659.5287475585938
      ],
      "bbox_max": [
        -92.36495971679688,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33503803610801697,
        0.7893171906471252,
        0.5145173072814941
      ],
      "plane_d": 1321.4937744140625,
      "bbox_min": [
        -95.74359130859375,
        -2145.713623046875,
        660.5999755859375
      ],
      "bbox_max": [
        -93.34178161621094,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        659.7044067382812
      ],
      "bbox_max": [
        -97.0795669555664,
        -2146.0439453125,
        659.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -98.33621978759766,
        -2146.5771484375,
        659.7044067382812
      ],
      "bbox_max": [
        -90.278564453125,
        -2141.183837890625,
        659.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -90.278564453125,
        -2144.08984375,
        656.5999755859375
      ],
      "bbox_max": [
        -82.05598449707031,
        -2140.086181640625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532713174819946,
        0.27060064673423767,
        0.7071151733398438
      ],
      "plane_d": 169.50509643554688,
      "bbox_min": [
        -83.4990234375,
        -2144.08984375,
        656.5999755859375
      ],
      "bbox_max": [
        -82.05598449707031,
        -2142.64697265625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060675621032715,
        0.6532860994338989,
        0.707099199295044
      ],
      "plane_d": 908.98681640625,
      "bbox_min": [
        -97.058349609375,
        -2143.4921875,
        656.5999755859375
      ],
      "bbox_max": [
        -88.835693359375,
        -2139.488525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -90.278564453125,
        -2140.683837890625,
        656.5999755859375
      ],
      "bbox_max": [
        -88.835693359375,
        -2139.488525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532719135284424,
        0.2706008851528168,
        0.7071145176887512
      ],
      "plane_d": 51.553009033203125,
      "bbox_min": [
        -99.86669921875,
        -2150.27197265625,
        656.5999755859375
      ],
      "bbox_max": [
        -96.46065521240234,
        -2142.04931640625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060675621032715,
        0.6532860994338989,
        0.707099199295044
      ],
      "plane_d": 908.98681640625,
      "bbox_min": [
        -97.9036636352539,
        -2143.4921875,
        656.5999755859375
      ],
      "bbox_max": [
        -96.46065521240234,
        -2142.04931640625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.20442962646484,
        -2136.069580078125,
        624.9449462890625
      ],
      "bbox_max": [
        -90.2786636352539,
        -2134.559326171875,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.20442962646484,
        -2136.069580078125,
        651.2399291992188
      ],
      "bbox_max": [
        -90.2786636352539,
        -2134.559326171875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -109.34033203125,
        -2160.506591796875,
        629.2604370117188
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -109.34033203125,
        -2160.506591796875,
        633.6602172851562
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532719135284424,
        0.2706008851528168,
        0.7071145176887512
      ],
      "plane_d": 51.553009033203125,
      "bbox_min": [
        -105.28510284423828,
        -2160.506591796875,
        647.5548095703125
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786047220230103,
        0.0007285246392711997,
        0.7345033884048462
      ],
      "plane_d": -549.2896118164062,
      "bbox_min": [
        -105.28510284423828,
        -2160.506591796875,
        647.5548095703125
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        657.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": 375.2848815917969,
      "bbox_min": [
        -105.27322387695312,
        -2142.5849609375,
        647.5548095703125
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        654.0486450195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060675621032715,
        0.6532860994338989,
        0.707099199295044
      ],
      "plane_d": 908.98681640625,
      "bbox_min": [
        -100.88525390625,
        -2140.694091796875,
        652.7044067382812
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        654.0486450195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2150.27197265625,
        633.6602172851562
      ],
      "bbox_max": [
        -105.27245330810547,
        -2141.482421875,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        633.6602172851562
      ],
      "bbox_max": [
        -105.27245330810547,
        -2141.482421875,
        648.336181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": 375.2848815917969,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        644.2874145507812
      ],
      "bbox_max": [
        -105.27245330810547,
        -2141.482421875,
        648.336181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038634955883026,
        0.9835958480834961,
        0.0
      ],
      "plane_d": 2086.36767578125,
      "bbox_min": [
        -108.05611419677734,
        -2142.635498046875,
        629.813232421875
      ],
      "bbox_max": [
        -100.88525390625,
        -2139.665283203125,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -108.05611419677734,
        -2142.635498046875,
        632.0427856445312
      ],
      "bbox_max": [
        -100.88525390625,
        -2139.665283203125,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": 375.2848815917969,
      "bbox_min": [
        -108.05611419677734,
        -2142.635498046875,
        644.2874145507812
      ],
      "bbox_max": [
        -100.88525390625,
        -2139.665283203125,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        0.9927930235862732,
        0.0
      ],
      "plane_d": 2114.69677734375,
      "bbox_min": [
        -107.14860534667969,
        -2144.48193359375,
        622.1928100585938
      ],
      "bbox_max": [
        -64.5244140625,
        -2061.6728515625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4983988106250763,
        0.20644919574260712,
        0.8420079350471497
      ],
      "plane_d": -68.14163208007812,
      "bbox_min": [
        -79.672119140625,
        -2144.48193359375,
        644.2874145507812
      ],
      "bbox_max": [
        -64.5244140625,
        -2138.030517578125,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48884037137031555,
        0.2158251702785492,
        0.8452541828155518
      ],
      "plane_d": -50.819091796875,
      "bbox_min": [
        -70.26387023925781,
        -2144.48193359375,
        644.2874145507812
      ],
      "bbox_max": [
        -64.5244140625,
        -2138.030517578125,
        648.0910034179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2127.946044921875,
      "bbox_min": [
        -107.14860534667969,
        -2136.103759765625,
        622.1928100585938
      ],
      "bbox_max": [
        -88.2706298828125,
        -2061.6728515625,
        657.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -91.99929809570312,
        -2136.103759765625,
        622.4384765625
      ],
      "bbox_max": [
        -88.2706298828125,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -91.9992904663086,
        -2136.103759765625,
        636.5319213867188
      ],
      "bbox_max": [
        -88.2706298828125,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.912666380405426,
        0.4087052345275879
      ],
      "plane_d": 1681.950927734375,
      "bbox_min": [
        -91.385986328125,
        -2130.0439453125,
        636.5319213867188
      ],
      "bbox_max": [
        -89.0361328125,
        -2127.946044921875,
        645.4983520507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2130.0439453125,
      "bbox_min": [
        -91.385986328125,
        -2130.0439453125,
        641.2166748046875
      ],
      "bbox_max": [
        -89.0361328125,
        -2130.0439453125,
        645.4983520507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -107.14860534667969,
        -2081.89990234375,
        629.0875244140625
      ],
      "bbox_max": [
        -88.72579193115234,
        -2061.6728515625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532886624336243,
        -0.2705933749675751,
        0.7071020007133484
      ],
      "plane_d": -1087.6129150390625,
      "bbox_min": [
        -106.26387786865234,
        -2074.313232421875,
        646.3912353515625
      ],
      "bbox_max": [
        -90.90784454345703,
        -2061.6728515625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        -0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": -1186.8843994140625,
      "bbox_min": [
        -106.26387786865234,
        -2074.313232421875,
        646.3912353515625
      ],
      "bbox_max": [
        -90.90784454345703,
        -2061.6728515625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7667246460914612,
        -0.3175787925720215,
        0.5579220652580261
      ],
      "plane_d": -1098.954833984375,
      "bbox_min": [
        -105.54733276367188,
        -2074.313232421875,
        647.6743774414062
      ],
      "bbox_max": [
        -90.90784454345703,
        -2061.6728515625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -657.704345703125,
      "bbox_min": [
        -98.96705627441406,
        -2074.313232421875,
        647.6743774414062
      ],
      "bbox_max": [
        -90.90784454345703,
        -2061.6728515625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.4161148071289,
        -2074.313232421875,
        651.2399291992188
      ],
      "bbox_max": [
        -90.90784454345703,
        -2072.2177734375,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -107.14860534667969,
        -2081.89990234375,
        629.0875244140625
      ],
      "bbox_max": [
        -88.72579193115234,
        -2067.95263671875,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        -0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": -1186.8843994140625,
      "bbox_min": [
        -107.14860534667969,
        -2070.1806640625,
        644.3267211914062
      ],
      "bbox_max": [
        -100.88525390625,
        -2067.95263671875,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.20443725585938,
        -2081.89990234375,
        629.0875244140625
      ],
      "bbox_max": [
        -88.72579193115234,
        -2073.7763671875,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.20443725585938,
        -2081.89990234375,
        636.5319213867188
      ],
      "bbox_max": [
        -88.72579193115234,
        -2073.7763671875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9126664400100708,
        0.4087052345275879
      ],
      "plane_d": -2160.234130859375,
      "bbox_min": [
        -91.385986328125,
        -2081.89990234375,
        636.5319213867188
      ],
      "bbox_max": [
        -89.25543975830078,
        -2079.802001953125,
        641.2166748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -3725.179443359375,
        -2818.79248046875,
        66.72640991210938
      ],
      "bbox_max": [
        -76.1886215209961,
        -1918.043212890625,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8764687180519104,
        0.48085832595825195,
        0.02404039539396763
      ],
      "plane_d": 1733.21240234375,
      "bbox_min": [
        -3725.179443359375,
        -2818.79248046875,
        66.72640991210938
      ],
      "bbox_max": [
        -439.5000305175781,
        -2073.451171875,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.034249160438776016,
        0.9861814379692078,
        0.16208960115909576
      ],
      "plane_d": 2026.164306640625,
      "bbox_min": [
        -3725.179443359375,
        -2812.848388671875,
        348.18731689453125
      ],
      "bbox_max": [
        -456.6446533203125,
        -2073.451171875,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -3725.179443359375,
        -2812.848388671875,
        467.370361328125
      ],
      "bbox_max": [
        -456.6446533203125,
        -2121.847900390625,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9373313784599304,
        0.34786927700042725,
        0.019921978935599327
      ],
      "plane_d": 1415.8299560546875,
      "bbox_min": [
        -3725.179443359375,
        -2803.547607421875,
        467.370361328125
      ],
      "bbox_max": [
        -484.9613342285156,
        -2121.847900390625,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.637331485748291,
        0.7695214152336121,
        0.04056220501661301
      ],
      "plane_d": 2238.30517578125,
      "bbox_min": [
        -3725.179443359375,
        -2519.998046875,
        467.370361328125
      ],
      "bbox_max": [
        -703.939208984375,
        -2121.847900390625,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6826116442680359,
        -0.6173016428947449,
        0.39112648367881775
      ],
      "plane_d": 596.6063232421875,
      "bbox_min": [
        -3725.179443359375,
        -2519.998046875,
        639.3530883789062
      ],
      "bbox_max": [
        -711.3695678710938,
        -2310.43701171875,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8203666806221008,
        0.5627213716506958,
        0.1017010360956192
      ],
      "plane_d": 4234.45703125,
      "bbox_min": [
        -3725.179443359375,
        -2364.646728515625,
        1174.237060546875
      ],
      "bbox_max": [
        -3685.231201171875,
        -2323.554931640625,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004718358162790537,
        0.006487742997705936,
        0.9999678134918213
      ],
      "plane_d": -620.764404296875,
      "bbox_min": [
        -3699.87890625,
        -2519.998046875,
        639.3530883789062
      ],
      "bbox_max": [
        -711.3695678710938,
        -2310.43701171875,
        1181.9771728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -789.134033203125,
        -2435.9833984375,
        639.3530883789062
      ],
      "bbox_max": [
        -714.4843139648438,
        -2317.40283203125,
        640.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6539711952209473,
        0.5783635973930359,
        0.4876650273799896
      ],
      "plane_d": 580.55517578125,
      "bbox_min": [
        -789.134033203125,
        -2435.9833984375,
        639.3538208007812
      ],
      "bbox_max": [
        -714.4843139648438,
        -2350.78662109375,
        640.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -3699.87890625,
        -2519.998046875,
        639.3778686523438
      ],
      "bbox_max": [
        -711.3695678710938,
        -2310.43701171875,
        1181.9771728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321149587631226,
        0.2707196772098541,
        0.2405669242143631
      ],
      "plane_d": 3807.88525390625,
      "bbox_min": [
        -3699.87890625,
        -2382.568603515625,
        1181.2401123046875
      ],
      "bbox_max": [
        -3698.14501953125,
        -2376.406982421875,
        1181.9771728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7721387147903442,
        -0.5362740755081177,
        0.34089893102645874
      ],
      "plane_d": -867.376708984375,
      "bbox_min": [
        -898.0948486328125,
        -2488.22265625,
        660.5962524414062
      ],
      "bbox_max": [
        -837.259033203125,
        -2400.9833984375,
        665.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7694186568260193,
        -0.5282776355743408,
        0.35905107855796814
      ],
      "plane_d": -862.0191650390625,
      "bbox_min": [
        -898.0948486328125,
        -2488.22265625,
        660.5962524414062
      ],
      "bbox_max": [
        -885.3728637695312,
        -2471.9287109375,
        665.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -896.314453125,
        -2519.998046875,
        639.3778686523438
      ],
      "bbox_max": [
        -711.3695678710938,
        -2311.39697265625,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7135183811187744,
        0.6962600350379944,
        -0.0781886950135231
      ],
      "plane_d": 1183.0814208984375,
      "bbox_min": [
        -896.314453125,
        -2519.998046875,
        639.4075927734375
      ],
      "bbox_max": [
        -711.3695678710938,
        -2350.81201171875,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.794124960899353,
        0.5035092234611511,
        0.3403586447238922
      ],
      "plane_d": 381.9332275390625,
      "bbox_min": [
        -847.2936401367188,
        -2519.998046875,
        640.3125
      ],
      "bbox_max": [
        -782.259033203125,
        -2435.9833984375,
        663.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -847.2936401367188,
        -2519.998046875,
        640.3125
      ],
      "bbox_max": [
        -789.134033203125,
        -2435.9833984375,
        641.796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -860.583251953125,
        -2516.7783203125,
        640.3125
      ],
      "bbox_max": [
        -789.134033203125,
        -2435.9833984375,
        641.796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00834949966520071,
        0.011480561457574368,
        0.9998992085456848
      ],
      "plane_d": -605.692626953125,
      "bbox_min": [
        -896.314453125,
        -2509.036865234375,
        639.4075927734375
      ],
      "bbox_max": [
        -711.3695678710938,
        -2350.81201171875,
        663.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6539711952209473,
        0.5783635973930359,
        0.4876650273799896
      ],
      "plane_d": 580.55517578125,
      "bbox_min": [
        -896.314453125,
        -2509.036865234375,
        639.4075927734375
      ],
      "bbox_max": [
        -711.3695678710938,
        -2350.81201171875,
        663.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -896.314453125,
        -2509.036865234375,
        640.3125
      ],
      "bbox_max": [
        -789.134033203125,
        -2400.9833984375,
        663.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7721387147903442,
        -0.5362740755081177,
        0.34089893102645874
      ],
      "plane_d": -867.376708984375,
      "bbox_min": [
        -885.3728637695312,
        -2471.9287109375,
        640.3125
      ],
      "bbox_max": [
        -830.384033203125,
        -2400.9833984375,
        663.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7176309823989868,
        0.6963256597518921,
        0.011679554358124733
      ],
      "plane_d": 2144.92041015625,
      "bbox_min": [
        -969.41943359375,
        -2363.59228515625,
        467.370361328125
      ],
      "bbox_max": [
        -713.2835083007812,
        -2121.847900390625,
        867.2271728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -969.41943359375,
        -2363.59228515625,
        467.370361328125
      ],
      "bbox_max": [
        -713.2835083007812,
        -2121.847900390625,
        866.0255126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3005043566226959,
        0.9524807333946228,
        0.04977479577064514
      ],
      "plane_d": 2285.599609375,
      "bbox_min": [
        -969.41943359375,
        -2333.9970703125,
        467.370361328125
      ],
      "bbox_max": [
        -734.5917358398438,
        -2121.847900390625,
        741.552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34745892882347107,
        0.9374035000801086,
        0.023386523127555847
      ],
      "plane_d": 2312.29541015625,
      "bbox_min": [
        -964.5498046875,
        -2333.9970703125,
        467.370361328125
      ],
      "bbox_max": [
        -734.5917358398438,
        -2121.847900390625,
        686.6377563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -765.279052734375,
        -2333.9970703125,
        639.3507080078125
      ],
      "bbox_max": [
        -734.5917358398438,
        -2306.33251953125,
        686.6377563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -758.4041137695312,
        -2314.277587890625,
        639.3507080078125
      ],
      "bbox_max": [
        -756.310791015625,
        -2311.613525390625,
        639.3829345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -765.279052734375,
        -2319.55615234375,
        639.3507080078125
      ],
      "bbox_max": [
        -752.123779296875,
        -2306.33251953125,
        686.6377563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -765.279052734375,
        -2319.55615234375,
        639.3507080078125
      ],
      "bbox_max": [
        -752.123779296875,
        -2306.33251953125,
        686.6377563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -763.1380615234375,
        -2311.39697265625,
        649.1970825195312
      ],
      "bbox_max": [
        -760.0313110351562,
        -2307.621826171875,
        651.2776489257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -969.41943359375,
        -2144.2890625,
        650.2186279296875
      ],
      "bbox_max": [
        -924.068359375,
        -2127.7587890625,
        741.552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -765.0918579101562,
        -2352.376220703125,
        639.28125
      ],
      "bbox_max": [
        -714.7833862304688,
        -2295.123779296875,
        867.2271728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -728.7424926757812,
        -2352.376220703125,
        686.9425659179688
      ],
      "bbox_max": [
        -720.4447631835938,
        -2339.38037109375,
        865.884033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -765.0918579101562,
        -2350.402099609375,
        639.28125
      ],
      "bbox_max": [
        -714.7833862304688,
        -2295.123779296875,
        867.2271728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -762.0160522460938,
        -2308.695556640625,
        647.44970703125
      ],
      "bbox_max": [
        -755.9295654296875,
        -2302.23095703125,
        675.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -762.0160522460938,
        -2306.4140625,
        675.0604858398438
      ],
      "bbox_max": [
        -761.55126953125,
        -2305.747802734375,
        675.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -765.0918579101562,
        -2317.2421875,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2295.123779296875,
        759.6312255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -761.9382934570312,
        -2316.721435546875,
        675.13037109375
      ],
      "bbox_max": [
        -752.123779296875,
        -2305.747802734375,
        686.6377563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -759.2736206054688,
        -2317.2421875,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2302.23388671875,
        650.0578002929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -756.310791015625,
        -2317.2421875,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2308.314453125,
        639.3574829101562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -757.0103149414062,
        -2350.402099609375,
        639.28125
      ],
      "bbox_max": [
        -714.7833862304688,
        -2299.9072265625,
        666.3358764648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -757.0103149414062,
        -2303.119873046875,
        648.4926147460938
      ],
      "bbox_max": [
        -755.6077270507812,
        -2300.06005859375,
        666.3358764648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -755.9369506835938,
        -2302.23388671875,
        650.0578002929688
      ],
      "bbox_max": [
        -755.906494140625,
        -2302.20166015625,
        650.1961669921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -755.9295654296875,
        -2303.119873046875,
        648.4926147460938
      ],
      "bbox_max": [
        -755.6077270507812,
        -2302.20166015625,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -756.3975830078125,
        -2308.314453125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2299.9072265625,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -756.3975830078125,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2299.9072265625,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -488.8430480957031,
        -2803.547607421875,
        696.4218139648438
      ],
      "bbox_max": [
        -484.9613342285156,
        -2801.845947265625,
        879.7427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9562264084815979,
        0.139556884765625,
        0.257205992937088
      ],
      "plane_d": 836.2110595703125,
      "bbox_min": [
        -742.0281372070312,
        -2404.270751953125,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2313.18505859375,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8815664052963257,
        0.47085967659950256,
        0.03364010900259018
      ],
      "plane_d": 1707.248779296875,
      "bbox_min": [
        -742.0281372070312,
        -2404.270751953125,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2313.18505859375,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -742.0281372070312,
        -2355.322998046875,
        639.28125
      ],
      "bbox_max": [
        -706.224853515625,
        -2313.18505859375,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7135183811187744,
        0.6962600350379944,
        -0.0781886950135231
      ],
      "plane_d": 1183.0814208984375,
      "bbox_min": [
        -714.5018920898438,
        -2355.322998046875,
        639.28125
      ],
      "bbox_max": [
        -706.224853515625,
        -2344.337158203125,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6539711952209473,
        0.5783635973930359,
        0.4876650273799896
      ],
      "plane_d": 580.55517578125,
      "bbox_min": [
        -714.5018920898438,
        -2355.322998046875,
        639.28125
      ],
      "bbox_max": [
        -706.224853515625,
        -2344.337158203125,
        649.505126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -487.7523193359375,
        -2812.848388671875,
        698.314208984375
      ],
      "bbox_max": [
        -456.6446533203125,
        -2802.0263671875,
        879.6206665039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21514897048473358,
        0.9664539694786072,
        0.14027751982212067
      ],
      "plane_d": 1756.6002197265625,
      "bbox_min": [
        -986.5693359375,
        -2165.07177734375,
        650.2186279296875
      ],
      "bbox_max": [
        -924.2988891601562,
        -2127.7587890625,
        884.4805297851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -969.41943359375,
        -2145.107666015625,
        650.2186279296875
      ],
      "bbox_max": [
        -925.69384765625,
        -2127.7587890625,
        832.941162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8710070252418518,
        0.4906066656112671,
        0.025533335283398628
      ],
      "plane_d": 1752.1368408203125,
      "bbox_min": [
        -708.7366943359375,
        -2818.79248046875,
        66.72640991210938
      ],
      "bbox_max": [
        -439.5000305175781,
        -2341.75634765625,
        876.3236083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -550.1890869140625,
        -2814.923828125,
        468.4746398925781
      ],
      "bbox_max": [
        -450.5697021484375,
        -2618.96142578125,
        876.3236083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -458.3141784667969,
        -2814.923828125,
        807.879150390625
      ],
      "bbox_max": [
        -450.5697021484375,
        -2812.469482421875,
        876.3236083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.834480881690979,
        0.550487756729126,
        0.024593127891421318
      ],
      "plane_d": 1872.022705078125,
      "bbox_min": [
        -708.7366943359375,
        -2818.79248046875,
        66.72640991210938
      ],
      "bbox_max": [
        -439.5000305175781,
        -2344.52734375,
        875.587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -579.789306640625,
        -2818.79248046875,
        443.0972900390625
      ],
      "bbox_max": [
        -439.5000305175781,
        -2544.010009765625,
        875.587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -451.7451171875,
        -2818.79248046875,
        831.3848266601562
      ],
      "bbox_max": [
        -439.5000305175781,
        -2814.7099609375,
        875.587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -708.7366943359375,
        -2560.513427734375,
        443.0972900390625
      ],
      "bbox_max": [
        -578.171875,
        -2344.52734375,
        867.3816528320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8313450217247009,
        0.5555300712585449,
        0.01586890034377575
      ],
      "plane_d": 1886.90283203125,
      "bbox_min": [
        -708.7366943359375,
        -2544.7578125,
        443.0972900390625
      ],
      "bbox_max": [
        -578.171875,
        -2344.52734375,
        866.5881958007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8306585550308228,
        0.5565486550331116,
        0.01612250879406929
      ],
      "plane_d": 1888.747802734375,
      "bbox_min": [
        -689.266845703125,
        -2459.815673828125,
        558.2156982421875
      ],
      "bbox_max": [
        -642.5032958984375,
        -2391.343994140625,
        865.8818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -689.266845703125,
        -2405.76025390625,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2391.343994140625,
        865.4605712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -708.7366943359375,
        -2349.337158203125,
        641.6248779296875
      ],
      "bbox_max": [
        -704.5856323242188,
        -2344.52734375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7153007388114929,
        0.6982023119926453,
        0.029299555346369743
      ],
      "plane_d": 2127.64697265625,
      "bbox_min": [
        -928.2157592773438,
        -2372.12451171875,
        74.912353515625
      ],
      "bbox_max": [
        -76.1886215209961,
        -1918.043212890625,
        874.1994018554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -928.2157592773438,
        -2304.79736328125,
        441.74444580078125
      ],
      "bbox_max": [
        -750.960693359375,
        -2135.580078125,
        874.1994018554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21514897048473358,
        0.9664539694786072,
        0.14027751982212067
      ],
      "plane_d": 1756.6002197265625,
      "bbox_min": [
        -928.2157592773438,
        -2301.549560546875,
        642.3101806640625
      ],
      "bbox_max": [
        -754.3570556640625,
        -2145.107666015625,
        874.1994018554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -756.52685546875,
        -2301.549560546875,
        642.3101806640625
      ],
      "bbox_max": [
        -754.3570556640625,
        -2299.30322265625,
        645.4570922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -765.2636108398438,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2294.6083984375,
        754.5840454101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -754.571533203125,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2301.44482421875,
        643.3828735351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34745892882347107,
        0.9374035000801086,
        0.023386523127555847
      ],
      "plane_d": 2312.29541015625,
      "bbox_min": [
        -926.8214111328125,
        -2151.04931640625,
        441.74444580078125
      ],
      "bbox_max": [
        -899.52685546875,
        -2135.580078125,
        697.4168701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3005043566226959,
        0.9524807333946228,
        0.04977479577064514
      ],
      "plane_d": 2285.599609375,
      "bbox_min": [
        -926.8214111328125,
        -2151.04931640625,
        583.9189453125
      ],
      "bbox_max": [
        -903.4149169921875,
        -2137.733642578125,
        697.4168701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9409332871437073,
        0.3373378813266754,
        0.0291153434664011
      ],
      "plane_d": 1465.486572265625,
      "bbox_min": [
        -909.4484252929688,
        -2372.12451171875,
        82.31546020507812
      ],
      "bbox_max": [
        -76.1886215209961,
        -1918.043212890625,
        872.2504272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7385133504867554,
        0.6736845970153809,
        0.027333253994584084
      ],
      "plane_d": 2070.8447265625,
      "bbox_min": [
        -909.4484252929688,
        -2304.79736328125,
        386.6241149902344
      ],
      "bbox_max": [
        -750.960693359375,
        -2144.3037109375,
        872.2504272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34745892882347107,
        0.9374035000801086,
        0.023386523127555847
      ],
      "plane_d": 2312.29541015625,
      "bbox_min": [
        -909.4484252929688,
        -2304.79736328125,
        386.6241149902344
      ],
      "bbox_max": [
        -750.960693359375,
        -2144.3037109375,
        872.2504272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -909.4484252929688,
        -2304.79736328125,
        560.3877563476562
      ],
      "bbox_max": [
        -750.960693359375,
        -2147.172119140625,
        872.2504272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -909.4484252929688,
        -2300.9306640625,
        629.1983032226562
      ],
      "bbox_max": [
        -757.1561889648438,
        -2147.172119140625,
        872.2504272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -909.4484252929688,
        -2168.956298828125,
        629.1983032226562
      ],
      "bbox_max": [
        -852.66796875,
        -2147.172119140625,
        872.2504272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3005043566226959,
        0.9524807333946228,
        0.04977479577064514
      ],
      "plane_d": 2285.599609375,
      "bbox_min": [
        -904.4052734375,
        -2168.956298828125,
        629.1983032226562
      ],
      "bbox_max": [
        -852.66796875,
        -2147.172119140625,
        733.704833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -771.5575561523438,
        -2300.9306640625,
        745.6580810546875
      ],
      "bbox_max": [
        -759.466064453125,
        -2275.722412109375,
        865.232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -768.5449829101562,
        -2304.79736328125,
        560.3877563476562
      ],
      "bbox_max": [
        -750.960693359375,
        -2257.5107421875,
        866.58154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -768.0648193359375,
        -2303.75732421875,
        759.6312255859375
      ],
      "bbox_max": [
        -758.6404418945312,
        -2280.178466796875,
        866.58154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -753.873046875,
        -2300.73291015625,
        630.2252807617188
      ],
      "bbox_max": [
        -752.4913940429688,
        -2299.746337890625,
        638.5557861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -753.871337890625,
        -2304.58740234375,
        641.6248779296875
      ],
      "bbox_max": [
        -751.1085205078125,
        -2299.947021484375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -881.6675415039062,
        -2170.06396484375,
        733.704833984375
      ],
      "bbox_max": [
        -852.66796875,
        -2161.587646484375,
        869.2028198242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -856.5706787109375,
        -2259.71875,
        560.3877563476562
      ],
      "bbox_max": [
        -765.472412109375,
        -2168.956298828125,
        866.44970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -856.5706787109375,
        -2170.197509765625,
        733.704833984375
      ],
      "bbox_max": [
        -852.66796875,
        -2168.956298828125,
        866.44970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -856.1751708984375,
        -2222.050537109375,
        733.704833984375
      ],
      "bbox_max": [
        -808.619384765625,
        -2168.956298828125,
        866.4063110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -856.1751708984375,
        -2170.466796875,
        733.704833984375
      ],
      "bbox_max": [
        -852.66796875,
        -2168.956298828125,
        866.4063110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -774.0728149414062,
        -2372.12451171875,
        560.3877563476562
      ],
      "bbox_max": [
        -76.1886215209961,
        -1918.043212890625,
        863.9918212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -774.0728149414062,
        -2259.916259765625,
        560.3877563476562
      ],
      "bbox_max": [
        -765.472412109375,
        -2257.5107421875,
        863.911376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -752.7722778320312,
        -2372.12451171875,
        630.2252807617188
      ],
      "bbox_max": [
        -76.1886215209961,
        -1918.043212890625,
        825.35693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.581074595451355,
        0.8138503432273865,
        -3.70419037665215e-08
      ],
      "plane_d": 1434.395751953125,
      "bbox_min": [
        -726.714599609375,
        -2281.34228515625,
        630.2252807617188
      ],
      "bbox_max": [
        -275.0,
        -1928.0,
        780.706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -511.7373046875,
        -2133.08251953125,
        635.0
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        652.9671630859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -281.0429382324219,
        -1979.0,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -281.0429382324219,
        -1987.0,
        636.369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -511.7373046875,
        -2133.08251953125,
        639.28125
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        652.9671630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -419.70733642578125,
        -2068.681396484375,
        639.28125
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        652.9671630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1984.2923583984375,
        639.28125
      ],
      "bbox_max": [
        -283.0,
        -1979.0,
        644.9732055664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -419.70733642578125,
        -2068.681396484375,
        639.28125
      ],
      "bbox_max": [
        -388.1926574707031,
        -2051.13671875,
        648.85546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -416.1728515625,
        -2068.681396484375,
        639.28125
      ],
      "bbox_max": [
        -409.1650085449219,
        -2064.272216796875,
        639.5584106445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -419.70733642578125,
        -2064.272216796875,
        639.28125
      ],
      "bbox_max": [
        -405.201171875,
        -2051.787353515625,
        648.85546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -508.4297790527344,
        -2125.49072265625,
        644.52880859375
      ],
      "bbox_max": [
        -393.708740234375,
        -1928.0,
        780.706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -442.0,
        -1950.0,
        766.0
      ],
      "bbox_max": [
        -414.1811828613281,
        -1928.0,
        780.706787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -430.0,
        -1950.0,
        766.0
      ],
      "bbox_max": [
        -414.1811828613281,
        -1939.0,
        780.1223754882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1950.0,
        766.0
      ],
      "bbox_max": [
        -414.1811828613281,
        -1939.0,
        779.551513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -417.9999694824219,
        -1950.0,
        766.0
      ],
      "bbox_max": [
        -414.1811828613281,
        -1950.0,
        769.087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1950.0,
        766.0
      ],
      "bbox_max": [
        -417.9999694824219,
        -1945.875,
        777.359130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -468.130615234375,
        -2062.144287109375,
        644.52880859375
      ],
      "bbox_max": [
        -393.708740234375,
        -1943.9227294921875,
        779.617919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1950.0,
        772.7266845703125
      ],
      "bbox_max": [
        -422.5,
        -1943.9227294921875,
        779.617919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -405.201171875,
        -2051.787353515625,
        648.85546875
      ],
      "bbox_max": [
        -393.708740234375,
        -2040.9208984375,
        657.1885986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -752.7722778320312,
        -2372.12451171875,
        630.2252807617188
      ],
      "bbox_max": [
        -76.1886215209961,
        -1918.043212890625,
        825.35693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4577594995498657,
        -0.8173955082893372,
        0.3497438430786133
      ],
      "plane_d": -1698.0321044921875,
      "bbox_min": [
        -499.8879089355469,
        -2032.99267578125,
        716.4224243164062
      ],
      "bbox_max": [
        -348.0,
        -1918.043212890625,
        798.3612670898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -422.5,
        -1972.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1918.043212890625,
        781.2753295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -414.0,
        -1972.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1918.043212890625,
        781.2753295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1918.043212890625,
        781.2753295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -348.0,
        -1928.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1918.043212890625,
        767.0492553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        766.0
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        781.2753295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 412.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -406.67291259765625,
        -1962.6553955078125,
        780.7739868164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1970.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -406.67291259765625,
        -1970.0,
        780.7739868164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1950.0,
        766.0
      ],
      "bbox_max": [
        -369.0,
        -1947.25,
        772.4188232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1950.0,
        767.8125610351562
      ],
      "bbox_max": [
        -414.0,
        -1944.5528564453125,
        780.1919555664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1950.0,
        773.7592163085938
      ],
      "bbox_max": [
        -422.5,
        -1944.5528564453125,
        780.1919555664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794647693634033,
        -0.8249639868736267,
        0.40133899450302124
      ],
      "plane_d": -1778.383056640625,
      "bbox_min": [
        -468.130615234375,
        -2032.99267578125,
        716.4224243164062
      ],
      "bbox_max": [
        -405.1982727050781,
        -1972.0,
        782.4132080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -408.1163024902344,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -405.1982727050781,
        -1972.0,
        780.4204711914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5879413485527039,
        0.423933207988739,
        0.6889162063598633
      ],
      "plane_d": 185.86029052734375,
      "bbox_min": [
        -752.7722778320312,
        -2372.12451171875,
        630.2252807617188
      ],
      "bbox_max": [
        -76.1886215209961,
        -1920.0,
        825.35693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -527.6100463867188,
        -2232.79736328125,
        632.5843505859375
      ],
      "bbox_max": [
        -76.1886215209961,
        -1955.8780517578125,
        796.8316650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -408.99609375,
        -2211.443115234375,
        632.5843505859375
      ],
      "bbox_max": [
        -87.03228759765625,
        -1978.8719482421875,
        796.3135986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -408.99609375,
        -2211.443115234375,
        639.9999389648438
      ],
      "bbox_max": [
        -256.07354736328125,
        -2101.813232421875,
        796.3135986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36162224411964417,
        0.8005647659301758,
        0.4778340458869934
      ],
      "plane_d": 1267.4736328125,
      "bbox_min": [
        -390.7621765136719,
        -2198.047119140625,
        639.9999389648438
      ],
      "bbox_max": [
        -256.07354736328125,
        -2112.8984375,
        791.80322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -390.7621765136719,
        -2170.64208984375,
        639.9999389648438
      ],
      "bbox_max": [
        -256.07354736328125,
        -2113.50927734375,
        779.5220336914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -390.7621765136719,
        -2170.64208984375,
        639.9999389648438
      ],
      "bbox_max": [
        -314.135009765625,
        -2113.50927734375,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -328.2811279296875,
        -2131.402587890625,
        639.9999389648438
      ],
      "bbox_max": [
        -314.135009765625,
        -2113.50927734375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -338.6816101074219,
        -2144.902587890625,
        667.9999389648438
      ],
      "bbox_max": [
        -314.135009765625,
        -2125.823974609375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -338.6816101074219,
        -2144.902587890625,
        667.9999389648438
      ],
      "bbox_max": [
        -314.135009765625,
        -2125.823974609375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -318.54534912109375,
        -2131.402587890625,
        667.9999389648438
      ],
      "bbox_max": [
        -314.135009765625,
        -2125.823974609375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -355.803466796875,
        -2198.047119140625,
        639.9999389648438
      ],
      "bbox_max": [
        -260.9525451660156,
        -2112.8984375,
        791.80322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -355.803466796875,
        -2198.047119140625,
        639.9999389648438
      ],
      "bbox_max": [
        -260.9525451660156,
        -2112.8984375,
        791.80322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -355.803466796875,
        -2177.188720703125,
        639.9999389648438
      ],
      "bbox_max": [
        -260.9525451660156,
        -2112.8984375,
        783.396728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -352.2367248535156,
        -2166.373291015625,
        639.9999389648438
      ],
      "bbox_max": [
        -260.9525451660156,
        -2112.8984375,
        779.7833251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -352.2367248535156,
        -2141.042724609375,
        639.9999389648438
      ],
      "bbox_max": [
        -317.154541015625,
        -2112.8984375,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -352.2367248535156,
        -2141.042724609375,
        667.9999389648438
      ],
      "bbox_max": [
        -317.154541015625,
        -2126.201904296875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -352.2367248535156,
        -2141.042724609375,
        667.9999389648438
      ],
      "bbox_max": [
        -337.61968994140625,
        -2134.35498046875,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -338.9958801269531,
        -2136.82763671875,
        667.9999389648438
      ],
      "bbox_max": [
        -337.61968994140625,
        -2134.35498046875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4140956699848175,
        0.7585507035255432,
        0.5031157732009888
      ],
      "plane_d": 1141.6068115234375,
      "bbox_min": [
        -295.6280212402344,
        -2168.66357421875,
        705.10546875
      ],
      "bbox_max": [
        -263.1219177246094,
        -2133.64990234375,
        780.6771850585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -294.19268798828125,
        -2165.86181640625,
        705.6879272460938
      ],
      "bbox_max": [
        -263.1219177246094,
        -2133.64990234375,
        779.7889404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3062765598297119,
        0.638495922088623,
        0.7060579061508179
      ],
      "plane_d": 782.314453125,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        639.9999389648438
      ],
      "bbox_max": [
        -294.1375732421875,
        -2101.813232421875,
        705.8518676757812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2608638405799866,
        0.6026611328125,
        0.7541548013687134
      ],
      "plane_d": 689.7464599609375,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        639.9999389648438
      ],
      "bbox_max": [
        -305.860595703125,
        -2101.813232421875,
        686.3023681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -394.6381530761719,
        -2160.501220703125,
        639.9999389648438
      ],
      "bbox_max": [
        -318.2466735839844,
        -2101.813232421875,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -639.9998779296875,
      "bbox_min": [
        -394.6381530761719,
        -2139.6162109375,
        639.9999389648438
      ],
      "bbox_max": [
        -319.5613708496094,
        -2101.813232421875,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -337.5279846191406,
        -2124.538818359375,
        639.9999389648438
      ],
      "bbox_max": [
        -319.5613708496094,
        -2101.813232421875,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -342.2251281738281,
        -2136.17138671875,
        667.9999389648438
      ],
      "bbox_max": [
        -318.2466735839844,
        -2120.220458984375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -342.2251281738281,
        -2136.17138671875,
        667.9999389648438
      ],
      "bbox_max": [
        -318.2466735839844,
        -2120.220458984375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -322.9754943847656,
        -2126.201904296875,
        667.9999389648438
      ],
      "bbox_max": [
        -318.2466735839844,
        -2120.220458984375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -361.6012878417969,
        -2150.153564453125,
        660.4229125976562
      ],
      "bbox_max": [
        -305.860595703125,
        -2113.15625,
        683.3890991210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -361.6012878417969,
        -2141.695556640625,
        660.4229125976562
      ],
      "bbox_max": [
        -320.0272216796875,
        -2113.15625,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -361.6012878417969,
        -2141.695556640625,
        667.9999389648438
      ],
      "bbox_max": [
        -339.98016357421875,
        -2128.187255859375,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.329372763633728,
        0.5637140274047852,
        0.757456362247467
      ],
      "plane_d": 579.381591796875,
      "bbox_min": [
        -361.6012878417969,
        -2141.695556640625,
        671.0531616210938
      ],
      "bbox_max": [
        -359.4483337402344,
        -2140.760498046875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.329372763633728,
        0.5637140274047852,
        0.757456362247467
      ],
      "plane_d": 579.381591796875,
      "bbox_min": [
        -361.024169921875,
        -2150.153564453125,
        671.9999389648438
      ],
      "bbox_max": [
        -349.0511474609375,
        -2140.774658203125,
        680.5648193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2608638405799866,
        0.6026611328125,
        0.7541548013687134
      ],
      "plane_d": 689.7464599609375,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        654.0196533203125
      ],
      "bbox_max": [
        -294.1375732421875,
        -2108.022216796875,
        705.8518676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -365.69537353515625,
        -2139.34814453125,
        654.0196533203125
      ],
      "bbox_max": [
        -328.5604248046875,
        -2108.022216796875,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -332.61920166015625,
        -2113.15625,
        654.0196533203125
      ],
      "bbox_max": [
        -328.5604248046875,
        -2108.022216796875,
        660.4229125976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -363.3562927246094,
        -2148.298583984375,
        655.727783203125
      ],
      "bbox_max": [
        -294.1375732421875,
        -2108.77880859375,
        705.8518676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -305.860595703125,
        -2133.64990234375,
        677.8638305664062
      ],
      "bbox_max": [
        -294.19268798828125,
        -2121.553955078125,
        705.6879272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2629581093788147,
        0.5350224375724792,
        0.8028724193572998
      ],
      "plane_d": 510.412353515625,
      "bbox_min": [
        -363.3562927246094,
        -2140.843505859375,
        655.727783203125
      ],
      "bbox_max": [
        -294.1375732421875,
        -2108.77880859375,
        705.8518676757812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.31740716099739075,
        0.5046849250793457,
        0.8028361797332764
      ],
      "plane_d": 427.22772216796875,
      "bbox_min": [
        -363.3562927246094,
        -2140.774658203125,
        655.727783203125
      ],
      "bbox_max": [
        -321.2221984863281,
        -2108.77880859375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -362.91766357421875,
        -2137.509521484375,
        655.727783203125
      ],
      "bbox_max": [
        -321.2221984863281,
        -2108.77880859375,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -332.0211181640625,
        -2119.231201171875,
        655.727783203125
      ],
      "bbox_max": [
        -323.75762939453125,
        -2108.77880859375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -343.9417419433594,
        -2131.678466796875,
        667.9999389648438
      ],
      "bbox_max": [
        -321.2221984863281,
        -2116.578857421875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -343.9417419433594,
        -2131.678466796875,
        667.9999389648438
      ],
      "bbox_max": [
        -340.4855041503906,
        -2125.468505859375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.329372763633728,
        0.5637140274047852,
        0.757456362247467
      ],
      "plane_d": 579.381591796875,
      "bbox_min": [
        -363.3562927246094,
        -2140.774658203125,
        667.9999389648438
      ],
      "bbox_max": [
        -341.3185729980469,
        -2125.468505859375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -359.68182373046875,
        -2135.36767578125,
        667.9999389648438
      ],
      "bbox_max": [
        -343.9417419433594,
        -2125.468505859375,
        667.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.329372763633728,
        0.5637140274047852,
        0.757456362247467
      ],
      "plane_d": 579.381591796875,
      "bbox_min": [
        -359.4483337402344,
        -2140.843505859375,
        671.9999389648438
      ],
      "bbox_max": [
        -341.3185729980469,
        -2130.181640625,
        676.5722045898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -346.9913024902344,
        -2134.0361328125,
        664.2921142578125
      ],
      "bbox_max": [
        -294.1375732421875,
        -2112.57177734375,
        705.8518676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4140956699848175,
        0.7585507035255432,
        0.5031157732009888
      ],
      "plane_d": 1141.6068115234375,
      "bbox_min": [
        -346.9913024902344,
        -2134.0361328125,
        664.2921142578125
      ],
      "bbox_max": [
        -294.1375732421875,
        -2112.57177734375,
        705.8518676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -346.9913024902344,
        -2130.181640625,
        664.2921142578125
      ],
      "bbox_max": [
        -322.4370422363281,
        -2112.57177734375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -346.9913024902344,
        -2130.181640625,
        664.2921142578125
      ],
      "bbox_max": [
        -322.4370422363281,
        -2112.57177734375,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -346.9913024902344,
        -2126.96728515625,
        667.9999389648438
      ],
      "bbox_max": [
        -343.9417419433594,
        -2125.088623046875,
        667.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.20432525873184204,
        0.34070679545402527,
        0.9176982641220093
      ],
      "plane_d": 163.24847412109375,
      "bbox_min": [
        -326.6052551269531,
        -2183.68359375,
        632.5843505859375
      ],
      "bbox_max": [
        -87.03228759765625,
        -1978.8719482421875,
        774.1619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33603790402412415,
        0.4438745677471161,
        0.8306947946548462
      ],
      "plane_d": 465.50872802734375,
      "bbox_min": [
        -326.6052551269531,
        -2144.25439453125,
        633.150634765625
      ],
      "bbox_max": [
        -160.9969024658203,
        -2058.64794921875,
        677.8638305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -326.6052551269531,
        -2121.553955078125,
        645.7384643554688
      ],
      "bbox_max": [
        -246.357421875,
        -2058.64794921875,
        677.8638305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -326.6052551269531,
        -2121.553955078125,
        661.1591796875
      ],
      "bbox_max": [
        -301.4779357910156,
        -2092.2255859375,
        677.8638305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26295778155326843,
        0.5350207686424255,
        0.8028736114501953
      ],
      "plane_d": 510.40802001953125,
      "bbox_min": [
        -326.6052551269531,
        -2121.553955078125,
        662.465576171875
      ],
      "bbox_max": [
        -305.860595703125,
        -2105.479736328125,
        677.8638305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -279.2770690917969,
        -2070.70849609375,
        645.7384643554688
      ],
      "bbox_max": [
        -246.357421875,
        -2058.64794921875,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -246.357421875,
        -2106.755859375,
        633.150634765625
      ],
      "bbox_max": [
        -160.9969024658203,
        -2070.70849609375,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13752444088459015,
        -0.08930294960737228,
        0.9864643812179565
      ],
      "plane_d": -788.0382080078125,
      "bbox_min": [
        -266.4682922363281,
        -2183.68359375,
        632.5843505859375
      ],
      "bbox_max": [
        -87.03228759765625,
        -1978.8719482421875,
        774.1619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -266.4682922363281,
        -2070.70849609375,
        645.7384643554688
      ],
      "bbox_max": [
        -220.62191772460938,
        -2028.4605712890625,
        645.9752807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -266.4682922363281,
        -2070.70849609375,
        645.7384643554688
      ],
      "bbox_max": [
        -246.357421875,
        -2056.19580078125,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -246.357421875,
        -2183.68359375,
        632.5843505859375
      ],
      "bbox_max": [
        -87.03228759765625,
        -1978.8719482421875,
        774.1619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -215.57534790039062,
        -2183.68359375,
        632.9395751953125
      ],
      "bbox_max": [
        -87.03228759765625,
        -1978.8719482421875,
        774.1619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -127.384521484375,
        -2019.0810546875,
        676.8016357421875
      ],
      "bbox_max": [
        -87.03228759765625,
        -1978.8719482421875,
        703.544189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0745648443698883,
        -0.5767466425895691,
        0.8135129809379578
      ],
      "plane_d": -1707.160400390625,
      "bbox_min": [
        -103.1811294555664,
        -2002.6787109375,
        688.1463012695312
      ],
      "bbox_max": [
        -87.03228759765625,
        -1978.8719482421875,
        703.544189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -100.10627746582031,
        -2000.8687744140625,
        694.1359252929688
      ],
      "bbox_max": [
        -98.77880096435547,
        -1993.89208984375,
        702.322021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -214.34085083007812,
        -2183.68359375,
        646.8789672851562
      ],
      "bbox_max": [
        -99.80781555175781,
        -1991.3837890625,
        774.1619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -156.2670440673828,
        -2026.7733154296875,
        671.481201171875
      ],
      "bbox_max": [
        -99.80781555175781,
        -1991.3837890625,
        716.3638916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -103.98069763183594,
        -2009.362060546875,
        696.3668823242188
      ],
      "bbox_max": [
        -99.80781555175781,
        -1991.3837890625,
        716.3638916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25527524948120117,
        0.9336197376251221,
        0.25137388706207275
      ],
      "plane_d": 1895.1923828125,
      "bbox_min": [
        -214.34085083007812,
        -2183.68359375,
        698.6240844726562
      ],
      "bbox_max": [
        -99.90170288085938,
        -1998.7393798828125,
        774.1619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0863649919629097,
        0.9781539440155029,
        0.18909214437007904
      ],
      "plane_d": 2005.18701171875,
      "bbox_min": [
        -209.0651397705078,
        -2183.68359375,
        701.5438232421875
      ],
      "bbox_max": [
        -99.90170288085938,
        -1998.7393798828125,
        773.529541015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -110.97541046142578,
        -2029.7327880859375,
        713.8018798828125
      ],
      "bbox_max": [
        -99.90170288085938,
        -2016.4595947265625,
        741.7232055664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -527.6100463867188,
        -2232.79736328125,
        635.0
      ],
      "bbox_max": [
        -76.1886215209961,
        -1955.8780517578125,
        751.0370483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -195.0,
        -2019.898681640625,
        635.0
      ],
      "bbox_max": [
        -76.1886215209961,
        -1955.948974609375,
        751.0370483398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -195.0,
        -1987.0,
        699.1394653320312
      ],
      "bbox_max": [
        -76.1886215209961,
        -1955.948974609375,
        747.7648315429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0745648443698883,
        -0.5767466425895691,
        0.8135129809379578
      ],
      "plane_d": -1707.160400390625,
      "bbox_min": [
        -101.408447265625,
        -1985.910400390625,
        699.871826171875
      ],
      "bbox_max": [
        -83.5708999633789,
        -1968.943359375,
        711.7363891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -99.61474609375,
        -1974.339599609375,
        706.4854125976562
      ],
      "bbox_max": [
        -83.5708999633789,
        -1968.943359375,
        711.7363891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -126.01776885986328,
        -1987.0,
        707.7470703125
      ],
      "bbox_max": [
        -76.1886215209961,
        -1956.1983642578125,
        738.2734985351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -99.61474609375,
        -1974.6351318359375,
        707.7470703125
      ],
      "bbox_max": [
        -76.1886215209961,
        -1968.943359375,
        733.6969604492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -107.15234375,
        -1987.0,
        718.774169921875
      ],
      "bbox_max": [
        -102.7741928100586,
        -1979.2572021484375,
        738.2734985351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -195.0,
        -2019.898681640625,
        658.42333984375
      ],
      "bbox_max": [
        -101.0772476196289,
        -1987.0,
        741.7144775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -195.0,
        -2019.898681640625,
        658.42333984375
      ],
      "bbox_max": [
        -156.2670440673828,
        -1994.003662109375,
        695.4171142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -111.8211441040039,
        -2018.4967041015625,
        735.7672729492188
      ],
      "bbox_max": [
        -107.99134063720703,
        -2013.17724609375,
        741.7144775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -527.6100463867188,
        -2232.79736328125,
        635.0
      ],
      "bbox_max": [
        -195.0,
        -1955.8780517578125,
        750.6104125976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -283.0,
        -1988.7025146484375,
        635.0
      ],
      "bbox_max": [
        -195.0,
        -1962.1953125,
        736.7996826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1988.7025146484375,
        635.0
      ],
      "bbox_max": [
        -195.0,
        -1979.0,
        710.03125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1988.7025146484375,
        635.0
      ],
      "bbox_max": [
        -195.0,
        -1979.0,
        710.03125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -219.687744140625,
        -1987.0,
        700.32421875
      ],
      "bbox_max": [
        -195.0,
        -1979.0,
        710.03125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -219.687744140625,
        -1987.0,
        700.32421875
      ],
      "bbox_max": [
        -195.0,
        -1980.298828125,
        705.0193481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -202.69137573242188,
        -1988.7025146484375,
        699.13134765625
      ],
      "bbox_max": [
        -195.0,
        -1987.0,
        700.424072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -214.7158203125,
        -1979.0,
        707.2994384765625
      ],
      "bbox_max": [
        -195.0,
        -1962.1953125,
        736.7996826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -527.6100463867188,
        -2232.79736328125,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -1955.8780517578125,
        750.6104125976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -283.0,
        -1987.0,
        688.6607666015625
      ],
      "bbox_max": [
        -195.0,
        -1955.939697265625,
        748.1361694335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        688.6607666015625
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        704.55224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        688.6607666015625
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        692.0352783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619760632514954,
        0.6228957772254944,
        0.6859126091003418
      ],
      "plane_d": 733.5289306640625,
      "bbox_min": [
        -527.6100463867188,
        -2232.79736328125,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -1955.8780517578125,
        750.6104125976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -527.6100463867188,
        -2232.79736328125,
        639.28125
      ],
      "bbox_max": [
        -196.56874084472656,
        -2020.2633056640625,
        695.7612915039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        639.9999389648438
      ],
      "bbox_max": [
        -196.56874084472656,
        -2020.2633056640625,
        686.3023681640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.9999389648438
      ],
      "bbox_max": [
        -196.56874084472656,
        -2020.2633056640625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -639.9998779296875,
      "bbox_min": [
        -406.736328125,
        -2140.209716796875,
        639.9999389648438
      ],
      "bbox_max": [
        -214.79327392578125,
        -2023.7451171875,
        646.0079956054688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        639.9999389648438
      ],
      "bbox_max": [
        -214.79327392578125,
        -2023.7451171875,
        646.0079956054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        639.9999389648438
      ],
      "bbox_max": [
        -345.68505859375,
        -2091.277099609375,
        644.9953002929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        639.9999389648438
      ],
      "bbox_max": [
        -391.3579406738281,
        -2119.150146484375,
        641.7142333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -392.0724792480469,
        -2120.05419921875,
        640.0
      ],
      "bbox_max": [
        -391.3579406738281,
        -2119.150146484375,
        641.11181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        639.9999389648438
      ],
      "bbox_max": [
        -345.68505859375,
        -2091.277099609375,
        642.8467407226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -345.9211730957031,
        -2091.495361328125,
        639.9999389648438
      ],
      "bbox_max": [
        -345.68505859375,
        -2091.277099609375,
        640.3275756835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.6785583496094,
        -2098.995361328125,
        639.9999389648438
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.98193359375,
        640.0137329101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13752444088459015,
        -0.08930294960737228,
        0.9864643812179565
      ],
      "plane_d": -788.0382080078125,
      "bbox_min": [
        -220.62191772460938,
        -2028.4605712890625,
        645.5972290039062
      ],
      "bbox_max": [
        -214.79327392578125,
        -2023.7451171875,
        646.0079956054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -217.74951171875,
        -2024.864990234375,
        645.5972290039062
      ],
      "bbox_max": [
        -214.79327392578125,
        -2023.7451171875,
        646.0079956054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -406.29559326171875,
        -2137.482421875,
        644.981689453125
      ],
      "bbox_max": [
        -196.56874084472656,
        -2020.2633056640625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -406.29559326171875,
        -2137.482421875,
        644.981689453125
      ],
      "bbox_max": [
        -201.66111755371094,
        -2021.4471435546875,
        663.1131591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -406.29559326171875,
        -2137.482421875,
        644.981689453125
      ],
      "bbox_max": [
        -329.4352722167969,
        -2095.22998046875,
        663.1131591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -406.29559326171875,
        -2137.482421875,
        644.981689453125
      ],
      "bbox_max": [
        -405.737060546875,
        -2133.240966796875,
        649.1535034179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -292.9984436035156,
        -2067.12646484375,
        645.7384643554688
      ],
      "bbox_max": [
        -201.66111755371094,
        -2021.4471435546875,
        654.1830444335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -217.8099822998047,
        -2024.62451171875,
        646.001708984375
      ],
      "bbox_max": [
        -201.66111755371094,
        -2021.4471435546875,
        654.1830444335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -217.74951171875,
        -2024.62451171875,
        646.001708984375
      ],
      "bbox_max": [
        -213.13516235351562,
        -2023.7451171875,
        646.8789672851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -338.4354248046875,
        -2114.2138671875,
        650.935546875
      ],
      "bbox_max": [
        -196.56874084472656,
        -2020.2633056640625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26295778155326843,
        0.5350207686424255,
        0.8028736114501953
      ],
      "plane_d": 510.40802001953125,
      "bbox_min": [
        -337.21307373046875,
        -2112.57177734375,
        650.935546875
      ],
      "bbox_max": [
        -196.56874084472656,
        -2020.2633056640625,
        664.2922973632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -210.87344360351562,
        -2021.7569580078125,
        650.935546875
      ],
      "bbox_max": [
        -196.56874084472656,
        -2020.2633056640625,
        657.4247436523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2608638405799866,
        0.6026611328125,
        0.7541548013687134
      ],
      "plane_d": 689.7464599609375,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        667.9998168945312
      ],
      "bbox_max": [
        -326.32373046875,
        -2112.11962890625,
        686.3023681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3062775135040283,
        0.6384968161582947,
        0.7060566544532776
      ],
      "plane_d": 782.3170166015625,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        667.9998168945312
      ],
      "bbox_max": [
        -370.0525817871094,
        -2143.47509765625,
        686.3023681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -329.3799133300781,
        -2115.9853515625,
        667.9999389648438
      ],
      "bbox_max": [
        -326.32373046875,
        -2112.11962890625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31740716099739075,
        0.5046849250793457,
        0.8028361797332764
      ],
      "plane_d": 427.22772216796875,
      "bbox_min": [
        -363.46234130859375,
        -2137.917236328125,
        668.0
      ],
      "bbox_max": [
        -359.68548583984375,
        -2135.369873046875,
        668.1739501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.329372763633728,
        0.5637140274047852,
        0.757456362247467
      ],
      "plane_d": 579.381591796875,
      "bbox_min": [
        -363.46234130859375,
        -2137.917236328125,
        668.0
      ],
      "bbox_max": [
        -362.8344421386719,
        -2137.531005859375,
        668.1739501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -527.6100463867188,
        -2209.01611328125,
        639.28125
      ],
      "bbox_max": [
        -481.86572265625,
        -2172.58935546875,
        639.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -516.3707275390625,
        -2193.428466796875,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -1955.8780517578125,
        750.6104125976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -413.24639892578125,
        -2112.560791015625,
        639.28125
      ],
      "bbox_max": [
        -212.70004272460938,
        -2014.4228515625,
        650.1068725585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -413.24639892578125,
        -2112.560791015625,
        639.28125
      ],
      "bbox_max": [
        -338.8740234375,
        -2066.103271484375,
        642.3384399414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -369.78338623046875,
        -2105.177734375,
        639.9999389648438
      ],
      "bbox_max": [
        -344.8598327636719,
        -2086.4697265625,
        641.7280883789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -360.30859375,
        -2092.5390625,
        639.9999389648438
      ],
      "bbox_max": [
        -344.8598327636719,
        -2086.4697265625,
        641.7280883789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -360.30859375,
        -2092.5390625,
        639.9999389648438
      ],
      "bbox_max": [
        -344.8598327636719,
        -2086.4697265625,
        641.7280883789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8563423156738281,
        0.5164088010787964,
        0.0
      ],
      "plane_d": 771.6624755859375,
      "bbox_min": [
        -360.30859375,
        -2092.5390625,
        639.9999389648438
      ],
      "bbox_max": [
        -344.8598327636719,
        -2086.585205078125,
        641.7280883789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -345.68505859375,
        -2092.5390625,
        640.3275756835938
      ],
      "bbox_max": [
        -344.8598327636719,
        -2091.495361328125,
        641.7280883789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        0.8660230040550232,
        5.416695330495713e-06
      ],
      "plane_d": 1638.2353515625,
      "bbox_min": [
        -369.78338623046875,
        -2105.177734375,
        639.9999389648438
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        640.79150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058818876743317,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -367.435791015625,
        -2103.822265625,
        639.9999389648438
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        640.79150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -358.9753723144531,
        -2099.974609375,
        640.0137329101562
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        640.79150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -413.24639892578125,
        -2112.560791015625,
        639.28125
      ],
      "bbox_max": [
        -338.8740234375,
        -2068.68115234375,
        642.3384399414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3726341724395752,
        0.5366532206535339,
        0.7570648193359375
      ],
      "plane_d": 506.0691223144531,
      "bbox_min": [
        -386.3768615722656,
        -2112.560791015625,
        639.28125
      ],
      "bbox_max": [
        -338.8740234375,
        -2084.468994140625,
        642.3384399414062
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -347.66058349609375,
        -2092.609130859375,
        641.7001953125
      ],
      "bbox_max": [
        -344.80450439453125,
        -2089.669677734375,
        641.822021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -345.68505859375,
        -2092.609130859375,
        641.7276000976562
      ],
      "bbox_max": [
        -344.80450439453125,
        -2091.495361328125,
        641.822021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        0.8660230040550232,
        5.416695330495713e-06
      ],
      "plane_d": 1638.2353515625,
      "bbox_min": [
        -381.0154724121094,
        -2109.88427734375,
        639.28125
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        640.9821166992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058818876743317,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -367.435791015625,
        -2103.822265625,
        640.169189453125
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        640.9821166992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.0538635253906,
        -2100.23095703125,
        640.7385864257812
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        640.9821166992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3294079899787903,
        0.5428956151008606,
        0.7724989652633667
      ],
      "plane_d": 525.8377685546875,
      "bbox_min": [
        -381.0154724121094,
        -2109.88427734375,
        639.28125
      ],
      "bbox_max": [
        -376.5371398925781,
        -2107.5634765625,
        639.890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8563423156738281,
        0.5164088010787964,
        0.0
      ],
      "plane_d": 771.6624755859375,
      "bbox_min": [
        -386.3768615722656,
        -2112.560791015625,
        639.28125
      ],
      "bbox_max": [
        -347.5961608886719,
        -2086.4697265625,
        641.7741088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -360.30859375,
        -2096.721435546875,
        640.859619140625
      ],
      "bbox_max": [
        -347.5961608886719,
        -2086.4697265625,
        641.7741088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -360.30859375,
        -2096.721435546875,
        640.859619140625
      ],
      "bbox_max": [
        -347.5961608886719,
        -2086.4697265625,
        641.7741088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -351.123291015625,
        -2089.729248046875,
        641.6522216796875
      ],
      "bbox_max": [
        -347.5961608886719,
        -2086.4697265625,
        641.7741088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3580712676048279,
        0.6098201870918274,
        0.7070391774177551
      ],
      "plane_d": 697.9349975585938,
      "bbox_min": [
        -386.3768615722656,
        -2112.560791015625,
        639.28125
      ],
      "bbox_max": [
        -380.7559814453125,
        -2109.384765625,
        639.6287231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3294079899787903,
        0.5428956151008606,
        0.7724989652633667
      ],
      "plane_d": 525.8377685546875,
      "bbox_min": [
        -383.83221435546875,
        -2111.343994140625,
        639.28125
      ],
      "bbox_max": [
        -380.7559814453125,
        -2109.384765625,
        639.6287231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3261350691318512,
        0.5656665563583374,
        0.757401704788208
      ],
      "plane_d": 584.7686767578125,
      "bbox_min": [
        -383.7384033203125,
        -2111.20166015625,
        639.28125
      ],
      "bbox_max": [
        -380.7559814453125,
        -2109.384765625,
        639.6287231445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -309.987548828125,
        -2059.205322265625,
        645.7384643554688
      ],
      "bbox_max": [
        -212.70004272460938,
        -2014.4228515625,
        650.1068725585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -217.88108825683594,
        -2022.4813232421875,
        647.788818359375
      ],
      "bbox_max": [
        -212.70004272460938,
        -2020.9951171875,
        650.1068725585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39295151829719543,
        0.5888877511024475,
        0.7062578797340393
      ],
      "plane_d": 638.5640869140625,
      "bbox_min": [
        -516.3707275390625,
        -2193.428466796875,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -1955.8780517578125,
        750.6104125976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -432.43115234375,
        -2180.35791015625,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -2014.0863037109375,
        686.3023681640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -432.43115234375,
        -2164.494384765625,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -2014.0863037109375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -432.43115234375,
        -2164.494384765625,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -2014.0863037109375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -299.1072082519531,
        -2066.11767578125,
        645.7384643554688
      ],
      "bbox_max": [
        -205.69081115722656,
        -2019.2060546875,
        653.2865600585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -297.43212890625,
        -2066.11767578125,
        645.7384643554688
      ],
      "bbox_max": [
        -205.69081115722656,
        -2019.2060546875,
        653.2865600585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -297.43212890625,
        -2066.11767578125,
        645.7384643554688
      ],
      "bbox_max": [
        -292.9984130859375,
        -2065.151123046875,
        646.0267333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3580712676048279,
        0.6098201870918274,
        0.7070391774177551
      ],
      "plane_d": 697.9349975585938,
      "bbox_min": [
        -432.43115234375,
        -2164.494384765625,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -2014.0863037109375,
        667.9999389648438
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -406.736328125,
        -2152.732177734375,
        639.4366455078125
      ],
      "bbox_max": [
        -293.274658203125,
        -2065.990966796875,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3294079899787903,
        0.5428956151008606,
        0.7724989652633667
      ],
      "plane_d": 525.8377685546875,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        639.4366455078125
      ],
      "bbox_max": [
        -293.274658203125,
        -2065.990966796875,
        652.6312866210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        -406.736328125,
        -2134.3759765625,
        639.9999389648438
      ],
      "bbox_max": [
        -293.274658203125,
        -2066.010009765625,
        647.0856323242188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        0.8660218715667725,
        0.0
      ],
      "plane_d": 1638.2357177734375,
      "bbox_min": [
        -406.736328125,
        -2134.3759765625,
        639.9999389648438
      ],
      "bbox_max": [
        -293.274658203125,
        -2066.010009765625,
        647.0856323242188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.13058818876743317,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -406.736328125,
        -2134.3759765625,
        639.9999389648438
      ],
      "bbox_max": [
        -293.274658203125,
        -2066.010009765625,
        647.0856323242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -406.736328125,
        -2134.3759765625,
        640.0
      ],
      "bbox_max": [
        -391.15643310546875,
        -2118.259765625,
        646.1080932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -392.550537109375,
        -2119.943115234375,
        640.0
      ],
      "bbox_max": [
        -391.15643310546875,
        -2118.259765625,
        642.275146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        640.9283447265625
      ],
      "bbox_max": [
        -293.274658203125,
        -2066.010009765625,
        647.0856323242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        640.9283447265625
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        643.6758422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.7217712402344,
        -2098.995361328125,
        640.9821166992188
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        641.4857177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -294.28948974609375,
        -2067.896484375,
        645.9945678710938
      ],
      "bbox_max": [
        -293.274658203125,
        -2066.010009765625,
        647.0856323242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8492053747177124,
        0.4903010427951813,
        -0.19610005617141724
      ],
      "plane_d": 1497.4755859375,
      "bbox_min": [
        -392.9296875,
        -2118.322265625,
        640.0
      ],
      "bbox_max": [
        -358.7217712402344,
        -2098.379638671875,
        641.3222045898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.8147888183594,
        -2098.790771484375,
        640.9859008789062
      ],
      "bbox_max": [
        -358.7217712402344,
        -2098.379638671875,
        641.3222045898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.639268015831476e-06,
        2.1011842363805044e-06,
        1.0
      ],
      "plane_d": -639.994140625,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        639.4452514648438
      ],
      "bbox_max": [
        -293.7386169433594,
        -2065.990966796875,
        652.6312866210938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3261350691318512,
        0.5656665563583374,
        0.757401704788208
      ],
      "plane_d": 584.7686767578125,
      "bbox_min": [
        -393.1123962402344,
        -2117.34912109375,
        639.4452514648438
      ],
      "bbox_max": [
        -379.28436279296875,
        -2109.229736328125,
        640.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3726298213005066,
        0.536638617515564,
        0.7570772171020508
      ],
      "plane_d": 506.03204345703125,
      "bbox_min": [
        -380.7559814453125,
        -2110.094482421875,
        639.6287231445312
      ],
      "bbox_max": [
        -379.28436279296875,
        -2109.229736328125,
        639.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        640.0
      ],
      "bbox_max": [
        -293.7386169433594,
        -2065.990966796875,
        652.6312866210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        0.8660218715667725,
        0.0
      ],
      "plane_d": 1638.2357177734375,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        640.0
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.36474609375,
        650.5148315429688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.13058818876743317,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        640.4264526367188
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        650.5148315429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        640.4264526367188
      ],
      "bbox_max": [
        -391.0085754394531,
        -2118.209716796875,
        650.5148315429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        640.6255493164062
      ],
      "bbox_max": [
        -391.0085754394531,
        -2118.209716796875,
        650.5148315429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -392.44219970703125,
        -2119.826904296875,
        640.6255493164062
      ],
      "bbox_max": [
        -391.0085754394531,
        -2118.209716796875,
        643.128662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        641.3222045898438
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        644.3175659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.7217712402344,
        -2098.995361328125,
        641.3222045898438
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.790771484375,
        641.6099853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8492053747177124,
        0.4903010427951813,
        -0.19610005617141724
      ],
      "plane_d": 1497.4755859375,
      "bbox_min": [
        -393.1123962402344,
        -2118.259765625,
        640.0
      ],
      "bbox_max": [
        -358.7217712402344,
        -2098.36474609375,
        641.41015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -358.8181457519531,
        -2098.790771484375,
        640.9934692382812
      ],
      "bbox_max": [
        -358.7217712402344,
        -2098.36474609375,
        641.41015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -299.10333251953125,
        -2076.334716796875,
        645.9888916015625
      ],
      "bbox_max": [
        -293.7386169433594,
        -2065.990966796875,
        652.1083374023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -405.9731140136719,
        -2152.732177734375,
        649.3056640625
      ],
      "bbox_max": [
        -329.4201354980469,
        -2093.5556640625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26082277297973633,
        0.6026551723480225,
        0.7541738748550415
      ],
      "plane_d": 689.7371826171875,
      "bbox_min": [
        -405.9731140136719,
        -2152.732177734375,
        649.3056640625
      ],
      "bbox_max": [
        -396.3149719238281,
        -2135.68994140625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -405.9731140136719,
        -2137.482421875,
        649.3056640625
      ],
      "bbox_max": [
        -405.737060546875,
        -2135.68994140625,
        650.9712524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26295778155326843,
        0.5350207686424255,
        0.8028736114501953
      ],
      "plane_d": 510.40802001953125,
      "bbox_min": [
        -338.4950256347656,
        -2102.21142578125,
        651.04296875
      ],
      "bbox_max": [
        -329.4201354980469,
        -2093.5556640625,
        654.7057495117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        639.6744995117188
      ],
      "bbox_max": [
        -195.0,
        -2014.0863037109375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -406.736328125,
        -2135.68994140625,
        639.6744995117188
      ],
      "bbox_max": [
        -293.82012939453125,
        -2065.151123046875,
        651.7769775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -406.736328125,
        -2135.68994140625,
        639.6744995117188
      ],
      "bbox_max": [
        -338.8740234375,
        -2084.468994140625,
        650.83056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2135.68994140625,
        639.6744995117188
      ],
      "bbox_max": [
        -344.69561767578125,
        -2089.13818359375,
        649.3056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37263402342796326,
        0.536638617515564,
        0.7570752501487732
      ],
      "plane_d": 506.03204345703125,
      "bbox_min": [
        -348.23577880859375,
        -2092.92724609375,
        641.7611694335938
      ],
      "bbox_max": [
        -344.69561767578125,
        -2089.13818359375,
        645.4061279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -347.5960388183594,
        -2091.495361328125,
        641.7741088867188
      ],
      "bbox_max": [
        -345.68505859375,
        -2089.7294921875,
        643.9666137695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -348.23577880859375,
        -2091.495361328125,
        641.7611694335938
      ],
      "bbox_max": [
        -345.68505859375,
        -2089.13818359375,
        644.1882934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37262701988220215,
        0.5366407632827759,
        0.7570772171020508
      ],
      "plane_d": 506.0376281738281,
      "bbox_min": [
        -402.07666015625,
        -2123.822265625,
        639.6744995117188
      ],
      "bbox_max": [
        -358.675537109375,
        -2094.81591796875,
        645.9818725585938
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.500004231929779,
        0.8660230040550232,
        5.416695330495713e-06
      ],
      "plane_d": 1638.2353515625,
      "bbox_min": [
        -379.28436279296875,
        -2109.229736328125,
        639.9999389648438
      ],
      "bbox_max": [
        -367.435791015625,
        -2103.822265625,
        641.9988403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.3460825104848482e-05,
        3.3786840504035354e-05,
        1.0
      ],
      "plane_d": -639.9375610351562,
      "bbox_min": [
        -379.28436279296875,
        -2109.229736328125,
        639.9999389648438
      ],
      "bbox_max": [
        -376.7274169921875,
        -2107.53271484375,
        639.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -359.18975830078125,
        -2098.995361328125,
        640.9937133789062
      ],
      "bbox_max": [
        -358.675537109375,
        -2096.72119140625,
        642.8890991210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13058818876743317,
        0.9914367198944092,
        0.0
      ],
      "plane_d": 2037.8238525390625,
      "bbox_min": [
        -402.07666015625,
        -2123.822265625,
        641.0239868164062
      ],
      "bbox_max": [
        -358.675537109375,
        -2094.81591796875,
        645.9818725585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        0.8660230040550232,
        5.416695330495713e-06
      ],
      "plane_d": 1638.2353515625,
      "bbox_min": [
        -402.07666015625,
        -2123.822265625,
        641.0430297851562
      ],
      "bbox_max": [
        -367.435791015625,
        -2103.822265625,
        644.9258422851562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -392.3555908203125,
        -2119.741455078125,
        641.1254272460938
      ],
      "bbox_max": [
        -390.697265625,
        -2117.975830078125,
        644.9258422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -359.62054443359375,
        -2098.995361328125,
        641.0239868164062
      ],
      "bbox_max": [
        -358.675537109375,
        -2094.81591796875,
        644.0260620117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37263402342796326,
        0.536638617515564,
        0.7570752501487732
      ],
      "plane_d": 506.03204345703125,
      "bbox_min": [
        -347.24755859375,
        -2092.7470703125,
        641.796630859375
      ],
      "bbox_max": [
        -338.8740234375,
        -2084.468994140625,
        645.3407592773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        641.0591430664062
      ],
      "bbox_max": [
        -195.0,
        -2014.0863037109375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        641.0591430664062
      ],
      "bbox_max": [
        -341.914306640625,
        -2087.520751953125,
        652.365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        0.8660230040550232,
        5.416695330495713e-06
      ],
      "plane_d": 1638.2353515625,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        643.4049072265625
      ],
      "bbox_max": [
        -367.435791015625,
        -2103.822265625,
        645.8020629882812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2129.89404296875,
        644.96728515625
      ],
      "bbox_max": [
        -405.7652893066406,
        -2128.628662109375,
        645.4821166992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -359.94158935546875,
        -2102.82275390625,
        641.0591430664062
      ],
      "bbox_max": [
        -341.914306640625,
        -2087.520751953125,
        649.2033081054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -359.94158935546875,
        -2102.82275390625,
        641.0591430664062
      ],
      "bbox_max": [
        -341.914306640625,
        -2092.7470703125,
        649.2033081054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37263402342796326,
        0.536638617515564,
        0.7570752501487732
      ],
      "plane_d": 506.03204345703125,
      "bbox_min": [
        -344.8223571777344,
        -2096.264892578125,
        645.3407592773438
      ],
      "bbox_max": [
        -341.914306640625,
        -2092.7470703125,
        649.2033081054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        644.0260620117188
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        648.9978637695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -344.69561767578125,
        -2100.58984375,
        642.3384399414062
      ],
      "bbox_max": [
        -195.0,
        -2014.0863037109375,
        666.7269287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26295778155326843,
        0.5350207686424255,
        0.8028736114501953
      ],
      "plane_d": 510.40802001953125,
      "bbox_min": [
        -344.69561767578125,
        -2100.58984375,
        642.3384399414062
      ],
      "bbox_max": [
        -330.7850036621094,
        -2084.468994140625,
        653.205322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37263402342796326,
        0.536638617515564,
        0.7570752501487732
      ],
      "plane_d": 506.03204345703125,
      "bbox_min": [
        -344.69561767578125,
        -2096.264892578125,
        642.3384399414062
      ],
      "bbox_max": [
        -338.8740234375,
        -2084.468994140625,
        649.2033081054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2608638405799866,
        0.6026611328125,
        0.7541548013687134
      ],
      "plane_d": 689.7464599609375,
      "bbox_min": [
        -418.117919921875,
        -2180.35791015625,
        667.9998779296875
      ],
      "bbox_max": [
        -327.02294921875,
        -2107.643310546875,
        686.3023681640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -348.19085693359375,
        -2125.356689453125,
        667.9999389648438
      ],
      "bbox_max": [
        -344.00396728515625,
        -2117.833984375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -516.3707275390625,
        -2193.428466796875,
        639.28125
      ],
      "bbox_max": [
        -195.0,
        -1955.8780517578125,
        750.6104125976562
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.06079954281449318,
        -0.8831871151924133,
        0.4650632441043854
      ],
      "plane_d": -2091.9970703125,
      "bbox_min": [
        -406.736328125,
        -2150.557373046875,
        641.0853271484375
      ],
      "bbox_max": [
        -195.0,
        -1955.8780517578125,
        750.6104125976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -234.3852081298828,
        -1983.23779296875,
        703.2808227539062
      ],
      "bbox_max": [
        -197.5624542236328,
        -1955.8780517578125,
        750.6104125976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02143726870417595,
        -0.8702447414398193,
        0.49215301871299744
      ],
      "plane_d": -2067.314453125,
      "bbox_min": [
        -234.3852081298828,
        -1983.23779296875,
        703.2808227539062
      ],
      "bbox_max": [
        -219.687744140625,
        -1959.335205078125,
        745.6863403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -406.736328125,
        -2150.557373046875,
        641.0853271484375
      ],
      "bbox_max": [
        -195.0,
        -1979.0,
        718.2457275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -309.987548828125,
        -2058.383056640625,
        645.7384643554688
      ],
      "bbox_max": [
        -287.5999755859375,
        -2014.4228515625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -406.736328125,
        -2150.557373046875,
        641.0853271484375
      ],
      "bbox_max": [
        -195.0,
        -1979.0,
        718.2457275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -219.687744140625,
        -1994.003662109375,
        695.4171142578125
      ],
      "bbox_max": [
        -195.0,
        -1983.23779296875,
        703.2808227539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -406.736328125,
        -2150.557373046875,
        641.0853271484375
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        718.2457275390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        641.0853271484375
      ],
      "bbox_max": [
        -332.91888427734375,
        -2086.4697265625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        641.0853271484375
      ],
      "bbox_max": [
        -345.68505859375,
        -2086.4697265625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7933136224746704,
        0.6088131666183472,
        0.0
      ],
      "plane_d": 974.0380859375,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        641.0853271484375
      ],
      "bbox_max": [
        -345.68505859375,
        -2086.4697265625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        641.0853271484375
      ],
      "bbox_max": [
        -345.68505859375,
        -2086.4697265625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000061392784119,
        0.8660218715667725,
        0.0
      ],
      "plane_d": 1638.2357177734375,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        643.0117797851562
      ],
      "bbox_max": [
        -367.435791015625,
        -2103.822265625,
        667.9999389648438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9914408326148987,
        -0.13055682182312012,
        -0.0
      ],
      "plane_d": -681.3272094726562,
      "bbox_min": [
        -406.736328125,
        -2137.482421875,
        643.7750854492188
      ],
      "bbox_max": [
        -388.779052734375,
        -2116.72216796875,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8491910099983215,
        0.4903138279914856,
        -0.19613009691238403
      ],
      "plane_d": 1497.516357421875,
      "bbox_min": [
        -391.8966369628906,
        -2119.47412109375,
        643.7750854492188
      ],
      "bbox_max": [
        -388.779052734375,
        -2116.72216796875,
        655.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8563423156738281,
        0.5164088010787964,
        0.0
      ],
      "plane_d": 771.6624755859375,
      "bbox_min": [
        -360.30859375,
        -2102.82275390625,
        641.0853271484375
      ],
      "bbox_max": [
        -346.551025390625,
        -2086.585205078125,
        667.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        -0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -360.30859375,
        -2102.82275390625,
        641.0853271484375
      ],
      "bbox_max": [
        -346.551025390625,
        -2086.585205078125,
        667.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -654.9999389648438,
      "bbox_min": [
        -360.30859375,
        -2098.995361328125,
        650.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2086.585205078125,
        659.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.97299724817276,
        0.23081716895103455,
        -0.0
      ],
      "plane_d": 832.5162353515625,
      "bbox_min": [
        -359.342529296875,
        -2098.495361328125,
        650.9999389648438
      ],
      "bbox_max": [
        -357.809326171875,
        -2092.0322265625,
        654.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.97299724817276,
        -0.23081716895103455,
        0.0
      ],
      "plane_d": -832.5162353515625,
      "bbox_min": [
        -359.342529296875,
        -2098.995361328125,
        654.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2086.585205078125,
        659.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8645933270454407,
        0.5024722814559937,
        0.0
      ],
      "plane_d": 740.5030517578125,
      "bbox_min": [
        -359.342529296875,
        -2092.0322265625,
        654.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2086.585205078125,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107851028442,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": -1352.66748046875,
      "bbox_min": [
        -357.18017578125,
        -2087.451171875,
        654.9999389648438
      ],
      "bbox_max": [
        -356.68017578125,
        -2086.585205078125,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49991971254348755,
        0.866071879863739,
        0.0
      ],
      "plane_d": 1638.5718994140625,
      "bbox_min": [
        -358.675537109375,
        -2098.995361328125,
        654.9999389648438
      ],
      "bbox_max": [
        -357.809326171875,
        -2098.495361328125,
        659.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9561842679977417,
        0.2927654981613159,
        0.0
      ],
      "plane_d": 271.55352783203125,
      "bbox_min": [
        -359.847412109375,
        -2102.82275390625,
        646.4585571289062
      ],
      "bbox_max": [
        -358.675537109375,
        -2098.995361328125,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -360.30859375,
        -2121.33203125,
        667.9999389648438
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        718.2457275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8737850785255432,
        -0.4863123595714569,
        -0.0
      ],
      "plane_d": -1334.1727294921875,
      "bbox_min": [
        -360.30859375,
        -2121.33203125,
        667.9999389648438
      ],
      "bbox_max": [
        -330.4360046386719,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -360.30859375,
        -2110.78369140625,
        667.9999389648438
      ],
      "bbox_max": [
        -330.4360046386719,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        -0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -360.30859375,
        -2098.995361328125,
        667.9999389648438
      ],
      "bbox_max": [
        -345.68505859375,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753775000572205,
        -0.22054220736026764,
        0.0
      ],
      "plane_d": -812.7611083984375,
      "bbox_min": [
        -360.30859375,
        -2098.995361328125,
        667.9999389648438
      ],
      "bbox_max": [
        -351.123291015625,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8563423156738281,
        0.5164088010787964,
        0.0
      ],
      "plane_d": 771.6624755859375,
      "bbox_min": [
        -360.30859375,
        -2091.77294921875,
        667.9999389648438
      ],
      "bbox_max": [
        -351.123291015625,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01906219869852066,
        0.9998183250427246,
        0.0
      ],
      "plane_d": 2079.3974609375,
      "bbox_min": [
        -357.18017578125,
        -2086.585205078125,
        667.9999389648438
      ],
      "bbox_max": [
        -351.123291015625,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        691.2601318359375
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        718.2457275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        691.2601318359375
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        713.3228149414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -283.0,
        -1979.0,
        703.77734375
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        713.3228149414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -752.7722778320312,
        -2348.869140625,
        630.2252807617188
      ],
      "bbox_max": [
        -214.63650512695312,
        -1920.0,
        821.1808471679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -752.7722778320312,
        -2305.03955078125,
        630.2252807617188
      ],
      "bbox_max": [
        -598.208740234375,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -750.960693359375,
        -2305.03955078125,
        639.28125
      ],
      "bbox_max": [
        -598.208740234375,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428605794906616,
        0.5381312370300293,
        -0.0008949324255809188
      ],
      "plane_d": 1686.1417236328125,
      "bbox_min": [
        -600.715087890625,
        -2195.306396484375,
        639.2813110351562
      ],
      "bbox_max": [
        -598.208740234375,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6538359522819519,
        0.3617154061794281,
        0.6645753979682922
      ],
      "plane_d": 32.34027099609375,
      "bbox_min": [
        -751.5808715820312,
        -2348.869140625,
        639.28125
      ],
      "bbox_max": [
        -214.63650512695312,
        -1920.0,
        821.1808471679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -507.0679931640625,
        -2233.106689453125,
        639.28125
      ],
      "bbox_max": [
        -214.63650512695312,
        -1952.1192626953125,
        802.4439086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -507.0679931640625,
        -2180.52685546875,
        639.28125
      ],
      "bbox_max": [
        -214.63650512695312,
        -1952.1192626953125,
        769.6435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -223.3677520751953,
        -1959.335205078125,
        745.6863403320312
      ],
      "bbox_max": [
        -214.63650512695312,
        -1955.846435546875,
        751.8756713867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.28125,
      "bbox_min": [
        -507.0679931640625,
        -2180.52685546875,
        639.28125
      ],
      "bbox_max": [
        -258.4636535644531,
        -1972.99560546875,
        769.6435546875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -283.0,
      "bbox_min": [
        -294.5815734863281,
        -2032.0,
        706.495361328125
      ],
      "bbox_max": [
        -258.4636535644531,
        -1979.0,
        769.6435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -283.0,
        -2032.0,
        706.495361328125
      ],
      "bbox_max": [
        -258.4636535644531,
        -1979.0,
        768.56494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -2032.0,
        711.4183349609375
      ],
      "bbox_max": [
        -258.4636535644531,
        -1987.0,
        768.56494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2032.0,
      "bbox_min": [
        -283.0,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -258.4636535644531,
        -2032.0,
        768.56494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -294.5815734863281,
        -2032.0,
        758.9232788085938
      ],
      "bbox_max": [
        -283.0,
        -2000.74169921875,
        769.6435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2032.0,
      "bbox_min": [
        -286.0,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -283.0,
        -2032.0,
        769.0007934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1641.902099609375,
      "bbox_min": [
        -294.5815734863281,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -286.0,
        -2027.41845703125,
        769.6435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2032.0,
      "bbox_min": [
        -290.0,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -286.0,
        -2032.0,
        769.5819702148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -751.5808715820312,
        -2348.42529296875,
        639.28125
      ],
      "bbox_max": [
        -261.0925598144531,
        -1920.0,
        780.4797973632812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -750.7027587890625,
        -2344.337158203125,
        639.28125
      ],
      "bbox_max": [
        -463.44097900390625,
        -2101.666748046875,
        641.6248779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.5919927358627319,
        0.8059433102607727,
        0.0
      ],
      "plane_d": 1469.767333984375,
      "bbox_min": [
        -708.852294921875,
        -2344.337158203125,
        639.28125
      ],
      "bbox_max": [
        -525.575439453125,
        -2193.659912109375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -563.099609375,
        -2241.306640625,
        639.28125
      ],
      "bbox_max": [
        -525.575439453125,
        -2209.887939453125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8059484362602234,
        0.5919858813285828,
        -0.0
      ],
      "plane_d": 1778.2655029296875,
      "bbox_min": [
        -563.099609375,
        -2241.306640625,
        639.28125
      ],
      "bbox_max": [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5318214893341064,
        0.35797059535980225,
        0.7674782276153564
      ],
      "plane_d": 10.77642822265625,
      "bbox_min": [
        -563.099609375,
        -2240.273681640625,
        639.28125
      ],
      "bbox_max": [
        -561.334716796875,
        -2237.27685546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5318214893341064,
        0.35797059535980225,
        0.7674782276153564
      ],
      "plane_d": 10.77642822265625,
      "bbox_min": [
        -563.099609375,
        -2239.679443359375,
        639.28125
      ],
      "bbox_max": [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8059484362602234,
        0.5919858813285828,
        -0.0
      ],
      "plane_d": 1778.2655029296875,
      "bbox_min": [
        -563.099609375,
        -2238.921875,
        639.28125
      ],
      "bbox_max": [
        -561.891357421875,
        -2237.27685546875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -599.257568359375,
        -2237.27685546875,
        639.28125
      ],
      "bbox_max": [
        -525.8124389648438,
        -2193.659912109375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428605794906616,
        0.5381312370300293,
        -0.0008949324255809188
      ],
      "plane_d": 1686.1417236328125,
      "bbox_min": [
        -599.257568359375,
        -2195.333251953125,
        639.2813110351562
      ],
      "bbox_max": [
        -598.18994140625,
        -2193.659912109375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794841408729553,
        -0.8249640464782715,
        0.4013371765613556
      ],
      "plane_d": -1778.3809814453125,
      "bbox_min": [
        -561.7347412109375,
        -2295.365234375,
        641.6248779296875
      ],
      "bbox_max": [
        -261.0925598144531,
        -1920.0,
        780.4797973632812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.47035908699035645,
        -0.7688663601875305,
        0.4331360161304474
      ],
      "plane_d": -1666.129638671875,
      "bbox_min": [
        -406.2379455566406,
        -1972.0,
        710.3526000976562
      ],
      "bbox_max": [
        -286.0,
        -1920.0,
        780.1475830078125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -406.2379455566406,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -404.598876953125,
        -1972.0,
        780.1475830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -355.47674560546875,
        -1971.594482421875,
        710.3526000976562
      ],
      "bbox_max": [
        -286.0,
        -1920.0,
        770.4967041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -286.0,
        -1926.8548583984375,
        754.0
      ],
      "bbox_max": [
        -286.0,
        -1920.0,
        757.7293090820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -561.7347412109375,
        -2295.365234375,
        641.6248779296875
      ],
      "bbox_max": [
        -261.0925598144531,
        -1925.0406494140625,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5318214893341064,
        0.35797059535980225,
        0.7674782276153564
      ],
      "plane_d": 10.77642822265625,
      "bbox_min": [
        -561.7347412109375,
        -2295.365234375,
        641.6248779296875
      ],
      "bbox_max": [
        -261.0925598144531,
        -1925.0406494140625,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -559.5924072265625,
        -2237.091064453125,
        641.6248779296875
      ],
      "bbox_max": [
        -478.577392578125,
        -2210.0029296875,
        695.7612915039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06079954281449318,
        -0.8831871151924133,
        0.4650632441043854
      ],
      "plane_d": -2091.9970703125,
      "bbox_min": [
        -405.9098205566406,
        -2030.4571533203125,
        684.19091796875
      ],
      "bbox_max": [
        -261.0925598144531,
        -1925.0406494140625,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -286.0,
        -1951.9654541015625,
        754.0
      ],
      "bbox_max": [
        -286.0,
        -1925.0406494140625,
        760.221435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -405.9098205566406,
        -2030.4571533203125,
        684.19091796875
      ],
      "bbox_max": [
        -278.9761962890625,
        -1944.3687744140625,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -405.9098205566406,
        -2030.4571533203125,
        684.19091796875
      ],
      "bbox_max": [
        -278.9761962890625,
        -1948.6893310546875,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -405.9098205566406,
        -2030.4571533203125,
        701.5846557617188
      ],
      "bbox_max": [
        -278.9761962890625,
        -1948.6893310546875,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -300.0,
        -2030.4571533203125,
        750.0411987304688
      ],
      "bbox_max": [
        -278.9761962890625,
        -1948.6893310546875,
        769.9811401367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1979.0,
      "bbox_min": [
        -283.0,
        -1979.0,
        750.0411987304688
      ],
      "bbox_max": [
        -278.9761962890625,
        -1979.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1641.902099609375,
      "bbox_min": [
        -300.0,
        -2030.4571533203125,
        765.0
      ],
      "bbox_max": [
        -291.5428161621094,
        -2022.0,
        769.9811401367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -405.9098205566406,
        -1992.0,
        701.5846557617188
      ],
      "bbox_max": [
        -311.5650939941406,
        -1971.594482421875,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -325.0,
      "bbox_min": [
        -405.9098205566406,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -311.5650939941406,
        -1972.0,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1992.0,
      "bbox_min": [
        -325.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -311.5650939941406,
        -1975.51904296875,
        769.9249877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1634.8309326171875,
      "bbox_min": [
        -325.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -320.0,
        -1975.51904296875,
        769.9249877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1168.1405029296875,
      "bbox_min": [
        -325.0,
        -1977.0,
        768.5
      ],
      "bbox_max": [
        -323.5190734863281,
        -1975.51904296875,
        768.8712158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -405.9098205566406,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -396.96240234375,
        -1972.0,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8509166240692139,
        0.5241855978965759,
        0.03420881927013397
      ],
      "plane_d": 1648.3133544921875,
      "bbox_min": [
        -4203.63427734375,
        -3919.642822265625,
        711.775390625
      ],
      "bbox_max": [
        569.706298828125,
        -1739.924072265625,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9293507933616638,
        0.34574177861213684,
        0.1294977068901062
      ],
      "plane_d": 4632.30078125,
      "bbox_min": [
        -4203.63427734375,
        -3796.41357421875,
        841.3179321289062
      ],
      "bbox_max": [
        335.708251953125,
        -2148.940673828125,
        1757.6214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8467844724655151,
        0.531133234500885,
        0.029217718169093132
      ],
      "plane_d": 1677.308349609375,
      "bbox_min": [
        -3970.641357421875,
        -3796.41357421875,
        841.3179321289062
      ],
      "bbox_max": [
        335.708251953125,
        -2148.940673828125,
        1757.6214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5784721970558167,
        0.8153333067893982,
        0.024523697793483734
      ],
      "plane_d": 2574.3935546875,
      "bbox_min": [
        -3970.641357421875,
        -3796.41357421875,
        842.8338012695312
      ],
      "bbox_max": [
        335.708251953125,
        -2148.940673828125,
        1757.6214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17268596589565277,
        0.98418790102005,
        0.03941702842712402
      ],
      "plane_d": 3599.98388671875,
      "bbox_min": [
        -3970.641357421875,
        -3796.41357421875,
        852.6356201171875
      ],
      "bbox_max": [
        335.708251953125,
        -2982.99560546875,
        1757.6214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6886258125305176,
        0.6727038025856018,
        0.2706737220287323
      ],
      "plane_d": 4546.642578125,
      "bbox_min": [
        -3970.641357421875,
        -3796.41357421875,
        1424.3941650390625
      ],
      "bbox_max": [
        330.92059326171875,
        -3262.205078125,
        1757.6214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14199809730052948,
        0.9854755401611328,
        0.09313669055700302
      ],
      "plane_d": 3530.583740234375,
      "bbox_min": [
        -3970.641357421875,
        -3796.41357421875,
        1433.9918212890625
      ],
      "bbox_max": [
        330.92059326171875,
        -3262.205078125,
        1757.6214599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.171890527009964,
        0.9826100468635559,
        0.0702224150300026
      ],
      "plane_d": 3547.499755859375,
      "bbox_min": [
        -3970.641357421875,
        -3784.984130859375,
        1433.9918212890625
      ],
      "bbox_max": [
        328.59930419921875,
        -3262.205078125,
        1640.2244873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8682754039764404,
        0.3892272710800171,
        0.3075709939002991
      ],
      "plane_d": 4276.294921875,
      "bbox_min": [
        -3970.641357421875,
        -3286.26123046875,
        1433.9918212890625
      ],
      "bbox_max": [
        -3956.019775390625,
        -3262.205078125,
        1440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6941572427749634,
        0.6507723927497864,
        0.3076378405094147
      ],
      "plane_d": 4443.431640625,
      "bbox_min": [
        -3965.179443359375,
        -3286.26123046875,
        1434.4024658203125
      ],
      "bbox_max": [
        -3956.019775390625,
        -3278.16796875,
        1440.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5775443315505981,
        0.816006064414978,
        0.024013593792915344
      ],
      "plane_d": 2576.892578125,
      "bbox_min": [
        -306.5951843261719,
        -3536.330078125,
        852.6356201171875
      ],
      "bbox_max": [
        176.252197265625,
        -2982.99560546875,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8440337181091309,
        0.5237486362457275,
        0.11530200392007828
      ],
      "plane_d": 1527.4400634765625,
      "bbox_min": [
        -306.4415588378906,
        -3536.330078125,
        1354.7957763671875
      ],
      "bbox_max": [
        176.252197265625,
        -2983.1630859375,
        1693.583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8434123396873474,
        0.5291796922683716,
        0.09286854416131973
      ],
      "plane_d": 1580.055908203125,
      "bbox_min": [
        -306.4415588378906,
        -3527.64501953125,
        1354.7957763671875
      ],
      "bbox_max": [
        176.252197265625,
        -2983.1630859375,
        1577.280517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5382782816886902,
        0.8385637402534485,
        0.08406741917133331
      ],
      "plane_d": 2561.375,
      "bbox_min": [
        -306.4415588378906,
        -3178.84619140625,
        1354.7957763671875
      ],
      "bbox_max": [
        -40.82177734375,
        -2983.1630859375,
        1577.280517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5380130410194397,
        0.8274743556976318,
        0.16071178019046783
      ],
      "plane_d": 2416.71533203125,
      "bbox_min": [
        -306.4415588378906,
        -3171.47509765625,
        1354.7957763671875
      ],
      "bbox_max": [
        -40.82177734375,
        -2983.1630859375,
        1447.936279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -306.4415588378906,
        -3031.18994140625,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -2983.1630859375,
        1447.936279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -306.5951843261719,
        -3024.712158203125,
        865.2859497070312
      ],
      "bbox_max": [
        -233.4002685546875,
        -2982.99560546875,
        1431.283447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -306.5951843261719,
        -3024.712158203125,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -2982.99560546875,
        1431.283447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9373313784599304,
        0.34786927700042725,
        0.019921978935599327
      ],
      "plane_d": 1415.8299560546875,
      "bbox_min": [
        -984.291259765625,
        -3024.712158203125,
        842.8338012695312
      ],
      "bbox_max": [
        -234.2976531982422,
        -2148.940673828125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -984.291259765625,
        -2819.032470703125,
        863.9058837890625
      ],
      "bbox_max": [
        -495.6846008300781,
        -2148.940673828125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8313450217247009,
        0.5555300712585449,
        0.01586890034377575
      ],
      "plane_d": 1886.90283203125,
      "bbox_min": [
        -984.291259765625,
        -2819.032470703125,
        863.9058837890625
      ],
      "bbox_max": [
        -495.6846008300781,
        -2148.940673828125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8306585550308228,
        0.5565486550331116,
        0.01612250879406929
      ],
      "plane_d": 1888.747802734375,
      "bbox_min": [
        -984.291259765625,
        -2819.032470703125,
        864.1474609375
      ],
      "bbox_max": [
        -495.6846008300781,
        -2148.940673828125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.637331485748291,
        0.7695214152336121,
        0.04056220501661301
      ],
      "plane_d": 2238.30517578125,
      "bbox_min": [
        -984.291259765625,
        -2819.032470703125,
        864.1893310546875
      ],
      "bbox_max": [
        -495.6846008300781,
        -2148.940673828125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -984.291259765625,
        -2819.032470703125,
        865.4462890625
      ],
      "bbox_max": [
        -495.6846008300781,
        -2159.280517578125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9314306974411011,
        0.3556700348854065,
        0.0770426094532013
      ],
      "plane_d": 1355.5810546875,
      "bbox_min": [
        -984.291259765625,
        -2819.032470703125,
        880.4703979492188
      ],
      "bbox_max": [
        -495.6846008300781,
        -2159.280517578125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321791529655457,
        0.32900404930114746,
        0.1509908139705658
      ],
      "plane_d": 1178.5645751953125,
      "bbox_min": [
        -984.291259765625,
        -2816.757568359375,
        880.4703979492188
      ],
      "bbox_max": [
        -498.223876953125,
        -2159.280517578125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8198854923248291,
        0.5702467560768127,
        0.05105101317167282
      ],
      "plane_d": 1870.3758544921875,
      "bbox_min": [
        -984.291259765625,
        -2549.36376953125,
        880.4703979492188
      ],
      "bbox_max": [
        -594.252197265625,
        -2159.280517578125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8297061324119568,
        0.5531379580497742,
        0.07500854879617691
      ],
      "plane_d": 1800.5321044921875,
      "bbox_min": [
        -984.291259765625,
        -2549.36376953125,
        880.4703979492188
      ],
      "bbox_max": [
        -594.252197265625,
        -2159.280517578125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4074098467826843,
        0.5257436037063599,
        0.7467334270477295
      ],
      "plane_d": 470.6318359375,
      "bbox_min": [
        -984.291259765625,
        -2430.738037109375,
        880.4703979492188
      ],
      "bbox_max": [
        -732.18115234375,
        -2159.280517578125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21514897048473358,
        0.9664539694786072,
        0.14027751982212067
      ],
      "plane_d": 1756.6002197265625,
      "bbox_min": [
        -984.291259765625,
        -2167.037841796875,
        880.4703979492188
      ],
      "bbox_max": [
        -955.45703125,
        -2159.280517578125,
        942.2494506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.838594913482666,
        0.5422794818878174,
        0.05188118666410446
      ],
      "plane_d": 1814.8121337890625,
      "bbox_min": [
        -698.2745361328125,
        -2409.47900390625,
        1258.9176025390625
      ],
      "bbox_max": [
        -685.0712890625,
        -2407.66796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -511.1015625,
        -2816.757568359375,
        1386.6339111328125
      ],
      "bbox_max": [
        -498.223876953125,
        -2806.955322265625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -502.1300354003906,
        -2819.032470703125,
        1386.6339111328125
      ],
      "bbox_max": [
        -495.6846008300781,
        -2806.955322265625,
        1479.110595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -960.8914794921875,
        -2408.3671875,
        864.1893310546875
      ],
      "bbox_max": [
        -685.0712890625,
        -2148.940673828125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -960.8914794921875,
        -2361.8173828125,
        864.4647827148438
      ],
      "bbox_max": [
        -752.145263671875,
        -2148.940673828125,
        1442.964599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -960.8914794921875,
        -2361.8173828125,
        864.4647827148438
      ],
      "bbox_max": [
        -752.145263671875,
        -2148.940673828125,
        1442.964599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21514897048473358,
        0.9664539694786072,
        0.14027751982212067
      ],
      "plane_d": 1756.6002197265625,
      "bbox_min": [
        -960.8914794921875,
        -2361.8173828125,
        864.4647827148438
      ],
      "bbox_max": [
        -752.145263671875,
        -2148.940673828125,
        1442.964599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4074098467826843,
        0.5257436037063599,
        0.7467334270477295
      ],
      "plane_d": 470.6318359375,
      "bbox_min": [
        -767.986572265625,
        -2361.8173828125,
        1420.5723876953125
      ],
      "bbox_max": [
        -752.145263671875,
        -2317.737060546875,
        1442.964599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -808.619384765625,
        -2248.078125,
        864.4647827148438
      ],
      "bbox_max": [
        -787.0260009765625,
        -2222.050537109375,
        929.305419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -786.48876953125,
        -2408.3671875,
        864.8950805664062
      ],
      "bbox_max": [
        -685.0712890625,
        -2256.458740234375,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -767.986572265625,
        -2408.3671875,
        865.7201538085938
      ],
      "bbox_max": [
        -685.0712890625,
        -2310.554931640625,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -767.986572265625,
        -2408.3671875,
        865.7201538085938
      ],
      "bbox_max": [
        -685.0712890625,
        -2310.554931640625,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -767.986572265625,
        -2408.3671875,
        1178.760986328125
      ],
      "bbox_max": [
        -685.0712890625,
        -2317.737060546875,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.838594913482666,
        0.5422794818878174,
        0.05188118666410446
      ],
      "plane_d": 1814.8121337890625,
      "bbox_min": [
        -767.986572265625,
        -2408.3671875,
        1258.9176025390625
      ],
      "bbox_max": [
        -685.0712890625,
        -2317.737060546875,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4074098467826843,
        0.5257436037063599,
        0.7467334270477295
      ],
      "plane_d": 470.6318359375,
      "bbox_min": [
        -767.986572265625,
        -2370.765380859375,
        1420.5723876953125
      ],
      "bbox_max": [
        -741.3680419921875,
        -2317.737060546875,
        1443.3846435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7176309823989868,
        0.6963256597518921,
        0.011679554358124733
      ],
      "plane_d": 2144.92041015625,
      "bbox_min": [
        -761.962646484375,
        -2328.31640625,
        866.7424926757812
      ],
      "bbox_max": [
        -743.80419921875,
        -2310.554931640625,
        1051.602294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -761.962646484375,
        -2314.733154296875,
        866.9813842773438
      ],
      "bbox_max": [
        -756.9921875,
        -2310.554931640625,
        1051.602294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -786.48876953125,
        -2312.703125,
        864.8950805664062
      ],
      "bbox_max": [
        -758.3310546875,
        -2261.742919921875,
        1371.9813232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -773.9361572265625,
        -2280.178466796875,
        864.8950805664062
      ],
      "bbox_max": [
        -768.0648193359375,
        -2268.5849609375,
        910.4217529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -773.9361572265625,
        -2280.178466796875,
        865.194580078125
      ],
      "bbox_max": [
        -768.0648193359375,
        -2268.5849609375,
        910.4217529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -792.2826538085938,
        -2273.9755859375,
        864.1893310546875
      ],
      "bbox_max": [
        -770.2017211914062,
        -2239.86328125,
        1025.4935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -777.7199096679688,
        -2273.9755859375,
        864.3222045898438
      ],
      "bbox_max": [
        -770.2017211914062,
        -2262.626220703125,
        1025.4935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -775.7066650390625,
        -2273.9755859375,
        864.7988891601562
      ],
      "bbox_max": [
        -770.2017211914062,
        -2263.272216796875,
        944.0588989257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.7066650390625,
        -2271.985107421875,
        903.4407348632812
      ],
      "bbox_max": [
        -771.7664794921875,
        -2263.272216796875,
        944.0588989257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -777.7199096679688,
        -2272.616455078125,
        902.14453125
      ],
      "bbox_max": [
        -771.3636474609375,
        -2262.626220703125,
        1025.4935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -777.7199096679688,
        -2272.616455078125,
        902.14453125
      ],
      "bbox_max": [
        -771.3636474609375,
        -2262.626220703125,
        1025.4935302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.0943603515625,
        -2272.616455078125,
        902.14453125
      ],
      "bbox_max": [
        -771.3636474609375,
        -2264.15380859375,
        942.9470825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -787.0260009765625,
        -2259.135009765625,
        929.305419921875
      ],
      "bbox_max": [
        -779.9501342773438,
        -2248.078125,
        1019.874267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -787.0260009765625,
        -2256.06494140625,
        929.305419921875
      ],
      "bbox_max": [
        -781.0300903320312,
        -2248.078125,
        974.869384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -779.9501342773438,
        -2407.66796875,
        1019.874267578125
      ],
      "bbox_max": [
        -685.0712890625,
        -2259.135009765625,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -733.7510375976562,
        -2333.14013671875,
        1156.9876708984375
      ],
      "bbox_max": [
        -733.1166381835938,
        -2332.1337890625,
        1178.760986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -733.7510375976562,
        -2332.5322265625,
        1156.9876708984375
      ],
      "bbox_max": [
        -733.1773681640625,
        -2332.1337890625,
        1165.0404052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -783.2191162109375,
        -2266.23876953125,
        864.1474609375
      ],
      "bbox_max": [
        -772.17138671875,
        -2249.745849609375,
        1038.20166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -778.34228515625,
        -2266.23876953125,
        864.2648315429688
      ],
      "bbox_max": [
        -772.17138671875,
        -2261.486328125,
        1036.4193115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -775.980712890625,
        -2264.4326171875,
        932.4190063476562
      ],
      "bbox_max": [
        -774.7032470703125,
        -2262.449951171875,
        949.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.980712890625,
        -2264.15380859375,
        942.9470825195312
      ],
      "bbox_max": [
        -775.0943603515625,
        -2262.449951171875,
        949.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -778.34228515625,
        -2264.304931640625,
        942.7564086914062
      ],
      "bbox_max": [
        -774.9893798828125,
        -2261.486328125,
        1036.4193115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.5611572265625,
        -2264.304931640625,
        942.7564086914062
      ],
      "bbox_max": [
        -774.9893798828125,
        -2263.055419921875,
        948.4863891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -781.3290405273438,
        -2261.6484375,
        946.2813720703125
      ],
      "bbox_max": [
        -778.0450439453125,
        -2254.945068359375,
        1038.20166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -778.4437866210938,
        -2261.6484375,
        1023.680419921875
      ],
      "bbox_max": [
        -778.0450439453125,
        -2261.3818359375,
        1038.20166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -781.840576171875,
        -2356.0107421875,
        863.9058837890625
      ],
      "bbox_max": [
        -718.0658569335938,
        -2251.2490234375,
        1190.5318603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -776.570068359375,
        -2263.055419921875,
        948.4863891601562
      ],
      "bbox_max": [
        -775.5611572265625,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -778.0450439453125,
        -2356.0107421875,
        948.3524169921875
      ],
      "bbox_max": [
        -718.0658569335938,
        -2260.681396484375,
        1190.5318603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -776.570068359375,
        -2263.15966796875,
        948.3524169921875
      ],
      "bbox_max": [
        -775.4889526367188,
        -2260.681396484375,
        964.4517822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -776.570068359375,
        -2263.15966796875,
        948.3524169921875
      ],
      "bbox_max": [
        -775.4889526367188,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -733.188232421875,
        -2356.0107421875,
        1154.5731201171875
      ],
      "bbox_max": [
        -718.0658569335938,
        -2332.494140625,
        1190.5318603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -733.188232421875,
        -2356.0107421875,
        1154.5731201171875
      ],
      "bbox_max": [
        -718.0658569335938,
        -2332.494140625,
        1190.5318603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -733.188232421875,
        -2332.73046875,
        1154.5731201171875
      ],
      "bbox_max": [
        -732.9428100585938,
        -2332.494140625,
        1164.033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -733.188232421875,
        -2332.73046875,
        1158.9423828125
      ],
      "bbox_max": [
        -733.01513671875,
        -2332.494140625,
        1164.033935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -733.188232421875,
        -2332.605712890625,
        1158.9423828125
      ],
      "bbox_max": [
        -733.01513671875,
        -2332.494140625,
        1160.839599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -779.7763061523438,
        -2261.486328125,
        950.9082641601562
      ],
      "bbox_max": [
        -776.570068359375,
        -2256.816650390625,
        1027.882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -779.7763061523438,
        -2261.3818359375,
        950.9082641601562
      ],
      "bbox_max": [
        -776.570068359375,
        -2256.816650390625,
        1027.882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -779.7763061523438,
        -2260.681396484375,
        950.9082641601562
      ],
      "bbox_max": [
        -776.570068359375,
        -2256.816650390625,
        966.5499267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3025262951850891,
        0.9530571103096008,
        0.01265391893684864
      ],
      "plane_d": 2808.368408203125,
      "bbox_min": [
        -498.223876953125,
        -3024.712158203125,
        842.8338012695312
      ],
      "bbox_max": [
        -234.2976531982422,
        -2631.8935546875,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3401496112346649,
        0.9401360750198364,
        0.02103203907608986
      ],
      "plane_d": 2779.226806640625,
      "bbox_min": [
        -498.223876953125,
        -3024.712158203125,
        864.626953125
      ],
      "bbox_max": [
        -234.2976531982422,
        -2806.955322265625,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217257618904114,
        0.6917038559913635,
        0.025647178292274475
      ],
      "plane_d": 2233.9619140625,
      "bbox_min": [
        -498.223876953125,
        -3024.712158203125,
        864.626953125
      ],
      "bbox_max": [
        -234.2976531982422,
        -2806.955322265625,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6857489347457886,
        0.7124961614608765,
        0.1486533135175705
      ],
      "plane_d": 2121.406005859375,
      "bbox_min": [
        -498.223876953125,
        -3024.712158203125,
        1313.6531982421875
      ],
      "bbox_max": [
        -244.5576171875,
        -2806.955322265625,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6927933096885681,
        0.6979525685310364,
        0.18138234317302704
      ],
      "plane_d": 2034.797607421875,
      "bbox_min": [
        -498.223876953125,
        -3024.712158203125,
        1354.7957763671875
      ],
      "bbox_max": [
        -244.5576171875,
        -2806.955322265625,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -498.223876953125,
        -2825.35888671875,
        1363.39306640625
      ],
      "bbox_max": [
        -458.1455383300781,
        -2806.955322265625,
        1478.0430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3677068054676056,
        0.9267826676368713,
        0.07658688724040985
      ],
      "plane_d": 2678.439697265625,
      "bbox_min": [
        -498.223876953125,
        -2820.93603515625,
        1363.39306640625
      ],
      "bbox_max": [
        -458.1455383300781,
        -2806.955322265625,
        1405.229248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9150537252426147,
        0.36777904629707336,
        0.16557550430297852
      ],
      "plane_d": 1164.4708251953125,
      "bbox_min": [
        -477.7598571777344,
        -2937.93310546875,
        1313.6531982421875
      ],
      "bbox_max": [
        -331.759765625,
        -2820.6962890625,
        1475.0743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -477.7598571777344,
        -2845.73681640625,
        1405.229248046875
      ],
      "bbox_max": [
        -420.02252197265625,
        -2820.6962890625,
        1475.0743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -360.3669128417969,
        -2937.93310546875,
        1384.2762451171875
      ],
      "bbox_max": [
        -347.90234375,
        -2906.77197265625,
        1432.8883056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7388458251953125,
        0.6731601357460022,
        0.031021643429994583
      ],
      "plane_d": 2178.20751953125,
      "bbox_min": [
        -430.2678527832031,
        -2993.223876953125,
        864.626953125
      ],
      "bbox_max": [
        -257.3710632324219,
        -2830.660888671875,
        1465.511474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3677068054676056,
        0.9267826676368713,
        0.07658688724040985
      ],
      "plane_d": 2678.439697265625,
      "bbox_min": [
        -430.2678527832031,
        -2932.19970703125,
        1313.6531982421875
      ],
      "bbox_max": [
        -331.759765625,
        -2830.660888671875,
        1465.511474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9150537252426147,
        0.36777904629707336,
        0.16557550430297852
      ],
      "plane_d": 1164.4708251953125,
      "bbox_min": [
        -424.3450622558594,
        -2932.19970703125,
        1313.6531982421875
      ],
      "bbox_max": [
        -331.759765625,
        -2839.9580078125,
        1465.511474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -424.3450622558594,
        -2847.371826171875,
        1431.2955322265625
      ],
      "bbox_max": [
        -415.3899230957031,
        -2839.9580078125,
        1465.511474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -360.6916809082031,
        -2913.74560546875,
        1383.491943359375
      ],
      "bbox_max": [
        -351.9558410644531,
        -2905.960205078125,
        1433.3387451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9309833645820618,
        0.3635721206665039,
        0.032943326979875565
      ],
      "plane_d": 1331.6527099609375,
      "bbox_min": [
        -423.2952880859375,
        -2932.19970703125,
        864.626953125
      ],
      "bbox_max": [
        -318.19537353515625,
        -2833.09326171875,
        1464.744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910527229309082,
        0.41264408826828003,
        0.025789525359869003
      ],
      "plane_d": 1473.680908203125,
      "bbox_min": [
        -423.2952880859375,
        -2932.19970703125,
        864.626953125
      ],
      "bbox_max": [
        -326.8922119140625,
        -2833.09326171875,
        1464.744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3677068054676056,
        0.9267826676368713,
        0.07658688724040985
      ],
      "plane_d": 2678.439697265625,
      "bbox_min": [
        -423.2952880859375,
        -2932.19970703125,
        1307.5714111328125
      ],
      "bbox_max": [
        -331.759765625,
        -2833.09326171875,
        1464.744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428581595420837,
        0.3114245533943176,
        0.1184622123837471
      ],
      "plane_d": 1075.2718505859375,
      "bbox_min": [
        -418.51580810546875,
        -2932.19970703125,
        1307.5714111328125
      ],
      "bbox_max": [
        -331.759765625,
        -2842.56201171875,
        1464.744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3473163843154907,
        0.9308735132217407,
        0.1133393794298172
      ],
      "plane_d": 2628.80126953125,
      "bbox_min": [
        -418.51580810546875,
        -2860.219482421875,
        1434.8194580078125
      ],
      "bbox_max": [
        -378.988037109375,
        -2842.56201171875,
        1464.744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9150537252426147,
        0.36777904629707336,
        0.16557550430297852
      ],
      "plane_d": 1164.4708251953125,
      "bbox_min": [
        -361.8818359375,
        -2932.19970703125,
        1307.5714111328125
      ],
      "bbox_max": [
        -331.759765625,
        -2854.516357421875,
        1383.491943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8689243793487549,
        0.41837501525878906,
        0.2644478976726532
      ],
      "plane_d": 566.2352905273438,
      "bbox_min": [
        -362.50360107421875,
        -2650.852294921875,
        842.8338012695312
      ],
      "bbox_max": [
        -352.36334228515625,
        -2631.8935546875,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8689243793487549,
        0.41837501525878906,
        0.2644478976726532
      ],
      "plane_d": 566.2352905273438,
      "bbox_min": [
        -359.0617980957031,
        -2644.916748046875,
        841.3179321289062
      ],
      "bbox_max": [
        -348.41632080078125,
        -2622.86572265625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17268596589565277,
        0.98418790102005,
        0.03941702842712402
      ],
      "plane_d": 3599.98388671875,
      "bbox_min": [
        -597.4422607421875,
        -3919.642822265625,
        711.775390625
      ],
      "bbox_max": [
        569.706298828125,
        -1739.924072265625,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6327277421951294,
        0.771410346031189,
        0.06768848747015
      ],
      "plane_d": 2549.050537109375,
      "bbox_min": [
        328.0791320800781,
        -3919.642822265625,
        1518.7890625
      ],
      "bbox_max": [
        569.706298828125,
        -3776.214599609375,
        1817.9713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.171890527009964,
        0.9826100468635559,
        0.0702224150300026
      ],
      "plane_d": 3547.499755859375,
      "bbox_min": [
        328.0791320800781,
        -3812.21435546875,
        1518.7890625
      ],
      "bbox_max": [
        435.65338134765625,
        -3776.214599609375,
        1774.9140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14199809730052948,
        0.9854755401611328,
        0.09313669055700302
      ],
      "plane_d": 3530.583740234375,
      "bbox_min": [
        328.59930419921875,
        -3812.21435546875,
        1640.2244873046875
      ],
      "bbox_max": [
        429.236328125,
        -3784.984130859375,
        1774.9140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6415850520133972,
        0.763245701789856,
        0.0763196349143982
      ],
      "plane_d": 2498.803955078125,
      "bbox_min": [
        429.236328125,
        -3906.921142578125,
        1520.5963134765625
      ],
      "bbox_max": [
        569.706298828125,
        -3795.162109375,
        1774.9140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.171890527009964,
        0.9826100468635559,
        0.0702224150300026
      ],
      "plane_d": 3547.499755859375,
      "bbox_min": [
        429.236328125,
        -3812.21435546875,
        1520.5963134765625
      ],
      "bbox_max": [
        440.13232421875,
        -3795.162109375,
        1774.9140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0024721375666558743,
        0.9531360864639282,
        0.3025318682193756
      ],
      "plane_d": 1821.989013671875,
      "bbox_min": [
        -597.4422607421875,
        -2636.71923828125,
        711.775390625
      ],
      "bbox_max": [
        315.632568359375,
        -1739.924072265625,
        1471.47119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42004507780075073,
        0.4338691234588623,
        0.7970694899559021
      ],
      "plane_d": 4.887939453125,
      "bbox_min": [
        -427.18609619140625,
        -2636.71923828125,
        721.414306640625
      ],
      "bbox_max": [
        279.593505859375,
        -2140.243408203125,
        1471.47119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32017049193382263,
        0.5482189655303955,
        0.7726233601570129
      ],
      "plane_d": 300.9718017578125,
      "bbox_min": [
        -427.18609619140625,
        -2636.71923828125,
        721.414306640625
      ],
      "bbox_max": [
        279.593505859375,
        -2140.243408203125,
        1471.47119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7759400010108948,
        0.4866269528865814,
        0.4013866186141968
      ],
      "plane_d": 605.982421875,
      "bbox_min": [
        -427.18609619140625,
        -2636.71923828125,
        721.414306640625
      ],
      "bbox_max": [
        120.03185272216797,
        -2140.243408203125,
        1275.6396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7798405289649963,
        0.46382713317871094,
        0.42037254571914673
      ],
      "plane_d": 529.9271850585938,
      "bbox_min": [
        -355.1763916015625,
        -2636.71923828125,
        721.414306640625
      ],
      "bbox_max": [
        120.03185272216797,
        -2140.243408203125,
        1275.6396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2366829514503479,
        0.9335814118385315,
        0.2690852880477905
      ],
      "plane_d": 1812.3699951171875,
      "bbox_min": [
        -355.1763916015625,
        -2636.71923828125,
        721.414306640625
      ],
      "bbox_max": [
        120.03185272216797,
        -2140.243408203125,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -355.1763916015625,
        -2636.71923828125,
        800.5
      ],
      "bbox_max": [
        -85.5,
        -2209.8974609375,
        885.4474487304688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8689243793487549,
        0.41837501525878906,
        0.2644478976726532
      ],
      "plane_d": 566.2352905273438,
      "bbox_min": [
        -352.1613464355469,
        -2636.71923828125,
        861.0
      ],
      "bbox_max": [
        -343.02734375,
        -2619.732666015625,
        885.4474487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2297.300048828125,
      "bbox_min": [
        -355.1763916015625,
        -2629.04443359375,
        800.5
      ],
      "bbox_max": [
        -85.5,
        -2209.8974609375,
        861.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -198.0,
      "bbox_min": [
        -355.1763916015625,
        -2629.04443359375,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2299.34033203125,
      "bbox_min": [
        -115.5,
        -2299.34033203125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -115.5,
        -2299.34033203125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 836.5,
      "bbox_min": [
        -115.5,
        -2299.34033203125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873478829860687,
        0.0,
        -0.9578263163566589
      ],
      "plane_d": 773.780029296875,
      "bbox_min": [
        -95.5,
        -2299.34033203125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -85.5,
      "bbox_min": [
        -85.5,
        -2299.34033203125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        833.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -355.1763916015625,
        -2629.04443359375,
        825.0
      ],
      "bbox_max": [
        -199.39990234375,
        -2297.300048828125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 834.7999877929688,
      "bbox_min": [
        -355.1763916015625,
        -2629.04443359375,
        825.0
      ],
      "bbox_max": [
        -199.39990234375,
        -2297.300048828125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8689243793487549,
        0.41837501525878906,
        0.2644478976726532
      ],
      "plane_d": 566.2352905273438,
      "bbox_min": [
        -355.1763916015625,
        -2629.04443359375,
        839.954345703125
      ],
      "bbox_max": [
        -347.6778869628906,
        -2614.744873046875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -199.39990234375,
      "bbox_min": [
        -208.60009765625,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -199.39990234375,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5469529032707214,
        0.0,
        0.8371633887290955
      ],
      "plane_d": -801.363037109375,
      "bbox_min": [
        -208.60009765625,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -199.39990234375,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5469409227371216,
        -0.0,
        -0.837171196937561
      ],
      "plane_d": 588.169677734375,
      "bbox_min": [
        -208.60009765625,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -199.39990234375,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2311.300048828125,
      "bbox_min": [
        -208.60009765625,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -199.39990234375,
        -2311.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -208.60009765625,
      "bbox_min": [
        -208.60009765625,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -208.60009765625,
        -2311.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -233.00991821289062,
        -2297.300048828125,
        800.5
      ],
      "bbox_max": [
        -85.5,
        -2209.8974609375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2294.34033203125,
      "bbox_min": [
        -214.60037231445312,
        -2294.34033203125,
        857.0
      ],
      "bbox_max": [
        -122.5,
        -2220.219970703125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -122.5,
      "bbox_min": [
        -184.0,
        -2294.34033203125,
        857.0
      ],
      "bbox_max": [
        -122.5,
        -2220.219970703125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -145.5,
      "bbox_min": [
        -184.0,
        -2291.0,
        857.0
      ],
      "bbox_max": [
        -122.5,
        -2220.219970703125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -145.5,
        -2240.5,
        857.0
      ],
      "bbox_max": [
        -122.5,
        -2220.219970703125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -145.5,
        -2240.5,
        857.0
      ],
      "bbox_max": [
        -132.5,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -184.0,
      "bbox_min": [
        -184.0,
        -2291.0,
        857.0
      ],
      "bbox_max": [
        -171.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -180.8348388671875,
        -2240.5,
        857.0
      ],
      "bbox_max": [
        -171.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -124.5,
      "bbox_min": [
        -166.52584838867188,
        -2292.5,
        800.5
      ],
      "bbox_max": [
        -87.0,
        -2209.8974609375,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2283.0,
      "bbox_min": [
        -124.5,
        -2283.0,
        800.5
      ],
      "bbox_max": [
        -87.0,
        -2209.8974609375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -124.5,
        -2281.0,
        818.7000122070312
      ],
      "bbox_max": [
        -87.0,
        -2209.8974609375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2281.0,
      "bbox_min": [
        -94.0,
        -2281.0,
        822.0
      ],
      "bbox_max": [
        -87.0,
        -2281.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -166.52584838867188,
        -2292.5,
        805.0
      ],
      "bbox_max": [
        -124.5,
        -2210.372802734375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2292.5,
      "bbox_min": [
        -158.0,
        -2292.5,
        814.2816162109375
      ],
      "bbox_max": [
        -124.5,
        -2289.84033203125,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6050354242324829,
        0.7961986660957336,
        0.0
      ],
      "plane_d": 1747.8408203125,
      "bbox_min": [
        -158.0,
        -2292.5,
        814.2816162109375
      ],
      "bbox_max": [
        -124.5,
        -2289.84033203125,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6633881330490112,
        0.7482755184173584,
        0.0
      ],
      "plane_d": 1818.246826171875,
      "bbox_min": [
        -158.0,
        -2292.5,
        820.0
      ],
      "bbox_max": [
        -155.0,
        -2289.84033203125,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2292.5,
      "bbox_min": [
        -155.0,
        -2292.5,
        805.0
      ],
      "bbox_max": [
        -124.5,
        -2289.84033203125,
        814.4425659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6050354242324829,
        0.7961986660957336,
        0.0
      ],
      "plane_d": 1747.8408203125,
      "bbox_min": [
        -128.0,
        -2292.5,
        805.0
      ],
      "bbox_max": [
        -124.5,
        -2289.84033203125,
        814.4425659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 836.5,
      "bbox_min": [
        -214.0574188232422,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2211.562744140625,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -95.5,
      "bbox_min": [
        -214.0574188232422,
        -2297.300048828125,
        836.5
      ],
      "bbox_max": [
        -95.5,
        -2213.58837890625,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9927337765693665,
        -0.0,
        -0.12033136934041977
      ],
      "plane_d": -16.80126953125,
      "bbox_min": [
        -214.0574188232422,
        -2297.300048828125,
        836.5
      ],
      "bbox_max": [
        -95.5,
        -2213.58837890625,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2294.34033203125,
      "bbox_min": [
        -120.56061553955078,
        -2294.34033203125,
        836.5
      ],
      "bbox_max": [
        -95.5,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2264.300048828125,
      "bbox_min": [
        -120.56061553955078,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2287.300048828125,
      "bbox_min": [
        -120.56061553955078,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2264.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -119.3484878540039,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2287.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -119.3484878540039,
        -2269.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2264.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.300048828125,
      "bbox_min": [
        -120.56061553955078,
        -2244.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -119.3484878540039,
        -2244.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2239.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -118.5,
      "bbox_min": [
        -214.0574188232422,
        -2297.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2213.58837890625,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 439.70721435546875,
      "bbox_min": [
        -214.0574188232422,
        -2297.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2213.58837890625,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2264.300048828125,
      "bbox_min": [
        -120.9000015258789,
        -2287.300048828125,
        854.5
      ],
      "bbox_max": [
        -120.50000762939453,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2287.300048828125,
      "bbox_min": [
        -120.9000015258789,
        -2287.300048828125,
        854.5
      ],
      "bbox_max": [
        -120.50000762939453,
        -2287.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.300048828125,
      "bbox_min": [
        -120.9000015258789,
        -2239.300048828125,
        854.5
      ],
      "bbox_max": [
        -120.50000762939453,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -145.5,
      "bbox_min": [
        -214.0574188232422,
        -2292.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2213.58837890625,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 854.0,
      "bbox_min": [
        -145.5,
        -2292.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2213.58837890625,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -145.5,
        -2292.300048828125,
        854.0
      ],
      "bbox_max": [
        -120.43939208984375,
        -2218.89111328125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.300048828125,
      "bbox_min": [
        -120.5204086303711,
        -2239.300048828125,
        854.0
      ],
      "bbox_max": [
        -120.43939971923828,
        -2239.300048828125,
        854.5255126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 135.5439453125,
      "bbox_min": [
        -145.5,
        -2292.300048828125,
        854.0
      ],
      "bbox_max": [
        -120.43939971923828,
        -2219.0439453125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.300048828125,
      "bbox_min": [
        -120.91727447509766,
        -2239.300048828125,
        854.5001220703125
      ],
      "bbox_max": [
        -120.517333984375,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -145.5,
        -2292.300048828125,
        854.0
      ],
      "bbox_max": [
        -120.43939971923828,
        -2239.300048828125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        -123.0,
        -2292.300048828125,
        854.0
      ],
      "bbox_max": [
        -120.43939971923828,
        -2240.5,
        855.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2287.300048828125,
      "bbox_min": [
        -123.0,
        -2287.300048828125,
        854.0
      ],
      "bbox_max": [
        -120.43939971923828,
        -2287.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.300048828125,
      "bbox_min": [
        -123.0,
        -2240.5,
        854.0
      ],
      "bbox_max": [
        -120.45671081542969,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        -123.0,
        -2240.5,
        854.0
      ],
      "bbox_max": [
        -123.0,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -123.9921646118164,
        -2292.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2213.58837890625,
        854.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -119.36579895019531,
        -2239.39990234375,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2239.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -499.0059814453125,
      "bbox_min": [
        -123.0,
        -2292.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2213.58837890625,
        854.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        -123.0,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2239.300048828125,
        854.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2264.300048828125,
      "bbox_min": [
        -123.0,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2239.300048828125,
        854.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2287.300048828125,
      "bbox_min": [
        -123.0,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2264.300048828125,
        854.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -123.0,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2287.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -123.0,
        -2269.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2264.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.300048828125,
      "bbox_min": [
        -123.0,
        -2244.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2239.300048828125,
        854.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -123.0,
        -2244.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2239.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 854.0,
      "bbox_min": [
        -214.0574188232422,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -171.0,
        -2240.5,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -184.0,
      "bbox_min": [
        -184.0,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -171.0,
        -2240.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -182.38668823242188,
        -2240.5,
        854.0
      ],
      "bbox_max": [
        -171.0,
        -2240.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28734785318374634,
        -0.0,
        -0.9578262567520142
      ],
      "plane_d": 773.7799682617188,
      "bbox_min": [
        -127.32233428955078,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2211.562744140625,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -85.5,
      "bbox_min": [
        -127.32233428955078,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2211.562744140625,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -743.253662109375,
      "bbox_min": [
        -127.32233428955078,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2211.562744140625,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        -118.0,
        -2294.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2239.39990234375,
        836.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -827.5,
      "bbox_min": [
        -89.0,
        -2294.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2283.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -89.0,
      "bbox_min": [
        -89.0,
        -2294.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2283.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2283.0,
      "bbox_min": [
        -89.0,
        -2283.0,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2283.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        -122.5,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -115.5,
        -2242.2861328125,
        836.5
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2294.34033203125,
      "bbox_min": [
        -118.0,
        -2294.34033203125,
        825.0
      ],
      "bbox_max": [
        -115.5,
        -2279.84033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.3579343557357788,
        0.9337468147277832
      ],
      "plane_d": 44.75830078125,
      "bbox_min": [
        -118.0,
        -2285.84033203125,
        825.0
      ],
      "bbox_max": [
        -116.5,
        -2279.84033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2279.84033203125,
      "bbox_min": [
        -118.0,
        -2279.84033203125,
        825.0
      ],
      "bbox_max": [
        -116.5,
        -2279.84033203125,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3579343557357788,
        -0.9337468147277832
      ],
      "plane_d": 1593.190673828125,
      "bbox_min": [
        -118.0,
        -2285.84033203125,
        828.2999877929688
      ],
      "bbox_max": [
        -116.5,
        -2279.84033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2279.84033203125,
      "bbox_min": [
        -118.0,
        -2279.84033203125,
        832.2999877929688
      ],
      "bbox_max": [
        -116.5,
        -2279.84033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2285.84033203125,
      "bbox_min": [
        -118.0,
        -2285.84033203125,
        828.2999877929688
      ],
      "bbox_max": [
        -116.5,
        -2285.84033203125,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9444968700408936,
        0.0,
        0.32852062582969666
      ],
      "plane_d": -386.7303771972656,
      "bbox_min": [
        -122.5,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -118.0,
        -2294.34033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2294.34033203125,
      "bbox_min": [
        -122.5,
        -2294.34033203125,
        825.0
      ],
      "bbox_max": [
        -118.0,
        -2294.34033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -142.3841094970703,
        -2213.484619140625,
        724.793212890625
      ],
      "bbox_max": [
        113.528564453125,
        -2157.62939453125,
        847.1929321289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -142.3841094970703,
        -2213.484619140625,
        819.0640869140625
      ],
      "bbox_max": [
        -121.76889038085938,
        -2208.415771484375,
        826.3350219726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36875930428504944,
        0.824822723865509,
        0.4285838007926941
      ],
      "plane_d": 1509.3642578125,
      "bbox_min": [
        108.4993896484375,
        -2158.119384765625,
        724.793212890625
      ],
      "bbox_max": [
        113.528564453125,
        -2157.62939453125,
        728.4032592773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9630944132804871,
        0.2227189689874649,
        -0.15114662051200867
      ],
      "plane_d": 699.9846801757812,
      "bbox_min": [
        -106.53463745117188,
        -2204.010009765625,
        721.414306640625
      ],
      "bbox_max": [
        120.03185272216797,
        -2140.243408203125,
        854.3977661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9362152218818665,
        0.2509586215019226,
        -0.2460101991891861
      ],
      "plane_d": 826.9634399414062,
      "bbox_min": [
        113.528564453125,
        -2157.653076171875,
        721.414306640625
      ],
      "bbox_max": [
        120.03185272216797,
        -2140.243408203125,
        733.1575927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10146033763885498,
        0.9581761956214905,
        0.2675895094871521
      ],
      "plane_d": 1884.0174560546875,
      "bbox_min": [
        113.528564453125,
        -2157.653076171875,
        723.808837890625
      ],
      "bbox_max": [
        115.1250991821289,
        -2156.200927734375,
        728.4032592773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -106.53463745117188,
        -2204.010009765625,
        723.9014282226562
      ],
      "bbox_max": [
        114.55083465576172,
        -2156.28759765625,
        836.4595336914062
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.36875930428504944,
        0.824822723865509,
        0.4285838007926941
      ],
      "plane_d": 1509.3642578125,
      "bbox_min": [
        109.38591766357422,
        -2157.653076171875,
        724.5084228515625
      ],
      "bbox_max": [
        113.528564453125,
        -2156.85595703125,
        728.4032592773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24286268651485443,
        0.915098249912262,
        0.3218894898891449
      ],
      "plane_d": 1720.4425048828125,
      "bbox_min": [
        -188.94747924804688,
        -2247.94970703125,
        759.2772216796875
      ],
      "bbox_max": [
        10.76284408569336,
        -2179.60009765625,
        965.2910766601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.086369089782238,
        0.9781539440155029,
        0.18909035623073578
      ],
      "plane_d": 2005.18896484375,
      "bbox_min": [
        -188.91696166992188,
        -2233.716796875,
        759.2772216796875
      ],
      "bbox_max": [
        10.76284408569336,
        -2185.397216796875,
        934.54248046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -188.91696166992188,
        -2233.716796875,
        818.7000122070312
      ],
      "bbox_max": [
        -118.89990234375,
        -2201.177490234375,
        867.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.055179059505462646,
        0.9984764456748962
      ],
      "plane_d": -743.3090209960938,
      "bbox_min": [
        -129.73455810546875,
        -2219.5,
        866.9457397460938
      ],
      "bbox_max": [
        -118.89990234375,
        -2216.708740234375,
        867.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -188.91696166992188,
        -2226.99267578125,
        825.0
      ],
      "bbox_max": [
        -122.89964294433594,
        -2204.381103515625,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -128.56640625,
        -2221.324462890625,
        825.0
      ],
      "bbox_max": [
        -122.89964294433594,
        -2204.381103515625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -743.253662109375,
      "bbox_min": [
        -128.56640625,
        -2221.324462890625,
        825.0
      ],
      "bbox_max": [
        -122.89964294433594,
        -2204.381103515625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -499.0059814453125,
      "bbox_min": [
        -126.70217895507812,
        -2221.324462890625,
        836.5
      ],
      "bbox_max": [
        -122.89964294433594,
        -2207.233642578125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -126.70217895507812,
        -2221.324462890625,
        854.5
      ],
      "bbox_max": [
        -124.02630615234375,
        -2213.794189453125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 135.5439453125,
      "bbox_min": [
        -126.70217895507812,
        -2220.219970703125,
        854.5
      ],
      "bbox_max": [
        -124.02630615234375,
        -2213.794189453125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.138129323720932,
        0.9765928387641907,
        0.16488416492938995
      ],
      "plane_d": 2002.7279052734375,
      "bbox_min": [
        -128.04714965820312,
        -2210.680419921875,
        759.2772216796875
      ],
      "bbox_max": [
        10.76284408569336,
        -2186.02587890625,
        934.54248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17143665254116058,
        0.9780559539794922,
        0.11838870495557785
      ],
      "plane_d": 2043.5338134765625,
      "bbox_min": [
        -89.64111328125,
        -2210.680419921875,
        847.1929321289062
      ],
      "bbox_max": [
        -65.38194274902344,
        -2204.348876953125,
        872.276611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07853952795267105,
        0.978276252746582,
        0.19185161590576172
      ],
      "plane_d": 2002.348876953125,
      "bbox_min": [
        -128.04714965820312,
        -2210.680419921875,
        759.2772216796875
      ],
      "bbox_max": [
        -85.23542785644531,
        -2186.02587890625,
        872.276611328125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.086369089782238,
        0.9781539440155029,
        0.18909035623073578
      ],
      "plane_d": 2005.18896484375,
      "bbox_min": [
        -188.94747924804688,
        -2247.94970703125,
        763.703125
      ],
      "bbox_max": [
        -89.64111328125,
        -2179.60009765625,
        937.2014770507812
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -129.67066955566406,
        -2216.487548828125,
        825.0
      ],
      "bbox_max": [
        -123.98490905761719,
        -2198.0068359375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -743.253662109375,
      "bbox_min": [
        -129.67066955566406,
        -2216.487548828125,
        825.0
      ],
      "bbox_max": [
        -123.98490905761719,
        -2198.0068359375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -128.5823974609375,
        -2216.487548828125,
        836.5
      ],
      "bbox_max": [
        -123.98490905761719,
        -2200.623046875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 135.5439453125,
      "bbox_min": [
        -128.5823974609375,
        -2215.142578125,
        836.5
      ],
      "bbox_max": [
        -123.98490905761719,
        -2200.623046875,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -499.0059814453125,
      "bbox_min": [
        -125.21743774414062,
        -2207.738037109375,
        836.5
      ],
      "bbox_max": [
        -123.98490905761719,
        -2200.623046875,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.055179059505462646,
        0.9984764456748962
      ],
      "plane_d": -743.3090209960938,
      "bbox_min": [
        -155.38954162597656,
        -2206.830078125,
        861.0
      ],
      "bbox_max": [
        -121.2672119140625,
        -2202.722900390625,
        866.3998413085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -155.38954162597656,
        -2203.318359375,
        861.0
      ],
      "bbox_max": [
        -148.3314971923828,
        -2202.722900390625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041594594717026,
        -0.9981732964515686
      ],
      "plane_d": 951.2976684570312,
      "bbox_min": [
        -170.35745239257812,
        -2206.74951171875,
        820.029052734375
      ],
      "bbox_max": [
        -121.0,
        -2179.60009765625,
        866.3953857421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -168.5838623046875,
        -2206.74951171875,
        821.0
      ],
      "bbox_max": [
        -121.0,
        -2179.60009765625,
        866.3953857421875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.055179059505462646,
        0.9984764456748962
      ],
      "plane_d": -743.3090209960938,
      "bbox_min": [
        -168.5838623046875,
        -2206.74951171875,
        825.0
      ],
      "bbox_max": [
        -121.28227233886719,
        -2181.5,
        866.3953857421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -168.5838623046875,
        -2205.07421875,
        825.0
      ],
      "bbox_max": [
        -125.16641998291016,
        -2181.5,
        861.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9927337765693665,
        -0.0,
        -0.12033136934041977
      ],
      "plane_d": -25.735870361328125,
      "bbox_min": [
        -130.31439208984375,
        -2187.44677734375,
        834.6912231445312
      ],
      "bbox_max": [
        -127.5,
        -2181.5,
        855.5180053710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -127.5,
      "bbox_min": [
        -130.31439208984375,
        -2187.44677734375,
        834.6912231445312
      ],
      "bbox_max": [
        -127.5,
        -2181.5,
        855.5180053710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 432.67938232421875,
      "bbox_min": [
        -130.31439208984375,
        -2187.44677734375,
        854.5
      ],
      "bbox_max": [
        -129.5,
        -2183.1328125,
        855.5180053710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -147.56275939941406,
        -2205.07421875,
        825.0
      ],
      "bbox_max": [
        -125.16641998291016,
        -2181.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 135.5439453125,
      "bbox_min": [
        -132.10870361328125,
        -2204.288818359375,
        825.0
      ],
      "bbox_max": [
        -125.16641998291016,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 432.67938232421875,
      "bbox_min": [
        -132.10870361328125,
        -2187.44677734375,
        854.5
      ],
      "bbox_max": [
        -129.5,
        -2183.4580078125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -132.10870361328125,
        -2187.44677734375,
        857.0
      ],
      "bbox_max": [
        -131.5,
        -2183.931396484375,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -743.253662109375,
      "bbox_min": [
        -131.5,
        -2200.917724609375,
        825.0
      ],
      "bbox_max": [
        -125.16641998291016,
        -2181.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9444968104362488,
        0.0,
        0.32852062582969666
      ],
      "plane_d": -395.2308349609375,
      "bbox_min": [
        -131.5,
        -2187.44677734375,
        825.0
      ],
      "bbox_max": [
        -127.5,
        -2181.5,
        836.8875732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -127.5,
      "bbox_min": [
        -127.5,
        -2187.44677734375,
        836.5
      ],
      "bbox_max": [
        -127.5,
        -2186.3974609375,
        836.8875732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -499.0059814453125,
      "bbox_min": [
        -127.5,
        -2200.917724609375,
        836.5
      ],
      "bbox_max": [
        -125.16641998291016,
        -2186.668701171875,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -127.5,
      "bbox_min": [
        -127.5,
        -2187.44677734375,
        836.5
      ],
      "bbox_max": [
        -127.5,
        -2186.668701171875,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -147.56275939941406,
        -2187.44677734375,
        857.0
      ],
      "bbox_max": [
        -131.5,
        -2183.932861328125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        0.5900004506111145
      ],
      "plane_d": 1274.8353271484375,
      "bbox_min": [
        -146.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -146.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -146.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -146.0,
      "bbox_min": [
        -146.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -146.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31125202775001526,
        0.42113131284713745,
        0.8519217371940613
      ],
      "plane_d": 103.43341064453125,
      "bbox_min": [
        -427.18609619140625,
        -2457.307861328125,
        770.7368774414062
      ],
      "bbox_max": [
        -142.74118041992188,
        -2165.850830078125,
        1005.6622924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5552207231521606,
        0.3105274438858032,
        0.7715587019920349
      ],
      "plane_d": -146.06512451171875,
      "bbox_min": [
        -427.18609619140625,
        -2457.307861328125,
        770.7368774414062
      ],
      "bbox_max": [
        -142.74118041992188,
        -2165.850830078125,
        1005.6622924804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6538359522819519,
        0.3617154061794281,
        0.6645753979682922
      ],
      "plane_d": 32.34027099609375,
      "bbox_min": [
        -427.18609619140625,
        -2399.99365234375,
        770.7368774414062
      ],
      "bbox_max": [
        -142.74118041992188,
        -2165.850830078125,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1865149885416031,
        0.7565726637840271,
        0.6267455220222473
      ],
      "plane_d": 1086.4886474609375,
      "bbox_min": [
        -370.31365966796875,
        -2301.85986328125,
        770.7368774414062
      ],
      "bbox_max": [
        -142.74118041992188,
        -2165.850830078125,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -370.31365966796875,
        -2301.85986328125,
        770.7368774414062
      ],
      "bbox_max": [
        -143.82920837402344,
        -2165.850830078125,
        937.2014770507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.055179059505462646,
        0.9984764456748962
      ],
      "plane_d": -743.3090209960938,
      "bbox_min": [
        -310.88970947265625,
        -2247.94970703125,
        861.0
      ],
      "bbox_max": [
        -143.82920837402344,
        -2188.406982421875,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -310.88970947265625,
        -2233.296630859375,
        861.0
      ],
      "bbox_max": [
        -154.5874481201172,
        -2206.34033203125,
        867.8624267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011264197528362274,
        0.8631103038787842,
        0.5048899054527283
      ],
      "plane_d": 1468.667236328125,
      "bbox_min": [
        -277.6429138183594,
        -2219.5,
        861.0
      ],
      "bbox_max": [
        -154.5874481201172,
        -2206.34033203125,
        866.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.6429138183594,
        -2219.5,
        861.0
      ],
      "bbox_max": [
        -277.4001159667969,
        -2218.526123046875,
        862.9827880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -306.70843505859375,
        -2232.0068359375,
        861.0
      ],
      "bbox_max": [
        -277.3228454589844,
        -2217.8828125,
        867.7911987304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -306.70843505859375,
        -2232.0068359375,
        861.0
      ],
      "bbox_max": [
        -299.7816162109375,
        -2227.839599609375,
        867.7911987304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -306.70843505859375,
        -2232.0068359375,
        861.0
      ],
      "bbox_max": [
        -301.5079040527344,
        -2229.72119140625,
        867.7911987304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.4501647949219,
        -2219.5,
        861.0
      ],
      "bbox_max": [
        -277.3228454589844,
        -2217.8828125,
        862.9827880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.4001159667969,
        -2219.5,
        861.0
      ],
      "bbox_max": [
        -277.2821350097656,
        -2217.677001953125,
        863.17236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011262818239629269,
        0.8631109595298767,
        0.5048885345458984
      ],
      "plane_d": 1468.6697998046875,
      "bbox_min": [
        -303.925537109375,
        -2247.94970703125,
        866.3333129882812
      ],
      "bbox_max": [
        -144.019287109375,
        -2205.627197265625,
        937.2014770507812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.1917705088853836,
        0.7642001509666443,
        0.615810215473175
      ],
      "plane_d": 1111.511474609375,
      "bbox_min": [
        -303.925537109375,
        -2233.3134765625,
        867.0999755859375
      ],
      "bbox_max": [
        -264.1787109375,
        -2219.5,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -303.925537109375,
        -2233.3134765625,
        867.7911987304688
      ],
      "bbox_max": [
        -297.98779296875,
        -2232.0068359375,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -302.0498352050781,
        -2233.3134765625,
        867.6195068359375
      ],
      "bbox_max": [
        -294.67291259765625,
        -2228.899658203125,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -302.0498352050781,
        -2233.3134765625,
        867.7208251953125
      ],
      "bbox_max": [
        -297.98779296875,
        -2230.7333984375,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -301.5079040527344,
        -2233.3134765625,
        867.7208251953125
      ],
      "bbox_max": [
        -297.98779296875,
        -2230.7333984375,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -370.31365966796875,
        -2301.85986328125,
        770.7368774414062
      ],
      "bbox_max": [
        -145.38064575195312,
        -2165.850830078125,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -354.6549377441406,
        -2301.85986328125,
        817.8739624023438
      ],
      "bbox_max": [
        -145.38064575195312,
        -2179.60009765625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -354.6549377441406,
        -2301.85986328125,
        817.8739624023438
      ],
      "bbox_max": [
        -145.38064575195312,
        -2181.5,
        861.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -354.6549377441406,
        -2233.172119140625,
        817.8739624023438
      ],
      "bbox_max": [
        -268.1400451660156,
        -2182.24951171875,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -354.6549377441406,
        -2233.172119140625,
        817.8739624023438
      ],
      "bbox_max": [
        -312.5693359375,
        -2209.878173828125,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -330.51251220703125,
        -2219.548828125,
        818.80322265625
      ],
      "bbox_max": [
        -312.5693359375,
        -2209.878173828125,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -286.6089782714844,
        -2202.405517578125,
        819.84765625
      ],
      "bbox_max": [
        -270.515625,
        -2194.963623046875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2294.34033203125,
      "bbox_min": [
        -347.42327880859375,
        -2301.85986328125,
        825.0
      ],
      "bbox_max": [
        -145.38064575195312,
        -2183.96728515625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -276.5,
        -2301.85986328125,
        834.7999877929688
      ],
      "bbox_max": [
        -214.60037231445312,
        -2294.34033203125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2297.300048828125,
      "bbox_min": [
        -276.5,
        -2301.85986328125,
        834.7999877929688
      ],
      "bbox_max": [
        -216.45657348632812,
        -2297.300048828125,
        857.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 834.7999877929688,
      "bbox_min": [
        -230.800048828125,
        -2301.85986328125,
        834.7999877929688
      ],
      "bbox_max": [
        -227.94046020507812,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -222.0,
      "bbox_min": [
        -347.42327880859375,
        -2291.0,
        825.0
      ],
      "bbox_max": [
        -145.38064575195312,
        -2183.96728515625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 854.0,
      "bbox_min": [
        -222.0,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -145.38064575195312,
        -2183.96728515625,
        858.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -222.0,
        -2246.371826171875,
        854.0
      ],
      "bbox_max": [
        -145.38064575195312,
        -2183.96728515625,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -222.0,
        -2246.371826171875,
        857.0
      ],
      "bbox_max": [
        -180.3175506591797,
        -2240.5,
        858.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -184.0,
      "bbox_min": [
        -184.0,
        -2246.371826171875,
        857.0
      ],
      "bbox_max": [
        -184.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -222.0,
        -2245.546875,
        854.0
      ],
      "bbox_max": [
        -180.8348388671875,
        -2240.5,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -184.0,
      "bbox_min": [
        -184.0,
        -2245.546875,
        854.0
      ],
      "bbox_max": [
        -184.0,
        -2240.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -347.42327880859375,
        -2233.276611328125,
        825.0
      ],
      "bbox_max": [
        -270.1554870605469,
        -2186.09765625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -326.8420104980469,
        -2229.72119140625,
        825.0
      ],
      "bbox_max": [
        -270.1554870605469,
        -2186.09765625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -326.8420104980469,
        -2229.72119140625,
        825.0
      ],
      "bbox_max": [
        -272.6896667480469,
        -2198.4482421875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -280.60009765625,
        -2219.5,
        825.0
      ],
      "bbox_max": [
        -272.6896667480469,
        -2198.4482421875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3437800109386444,
        0.839401125907898,
        0.4209762513637543
      ],
      "plane_d": 1404.3909912109375,
      "bbox_min": [
        -291.0722351074219,
        -2224.105224609375,
        825.0
      ],
      "bbox_max": [
        -270.1554870605469,
        -2186.09765625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -284.0493469238281,
        -2218.526123046875,
        825.0
      ],
      "bbox_max": [
        -270.1554870605469,
        -2186.09765625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -278.2578125,
        -2206.77099609375,
        825.0
      ],
      "bbox_max": [
        -270.1554870605469,
        -2186.09765625,
        837.2224731445312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -278.2578125,
        -2206.77099609375,
        825.0
      ],
      "bbox_max": [
        -272.6656188964844,
        -2198.3310546875,
        837.0676879882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -284.0493469238281,
        -2206.77099609375,
        825.0
      ],
      "bbox_max": [
        -278.05419921875,
        -2200.33251953125,
        837.0676879882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        0.5900004506111145
      ],
      "plane_d": 1274.8353271484375,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -261.0,
        -2180.941162109375,
        822.1744995117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -370.31365966796875,
        -2233.1513671875,
        770.7368774414062
      ],
      "bbox_max": [
        -170.35752868652344,
        -2165.850830078125,
        820.8666381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -370.31365966796875,
        -2233.1513671875,
        778.934326171875
      ],
      "bbox_max": [
        -235.501708984375,
        -2165.850830078125,
        820.8666381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -370.31365966796875,
        -2233.1513671875,
        779.7890014648438
      ],
      "bbox_max": [
        -245.962646484375,
        -2165.850830078125,
        820.8666381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4140956699848175,
        0.7585507035255432,
        0.5031157732009888
      ],
      "plane_d": 1141.6068115234375,
      "bbox_min": [
        -370.31365966796875,
        -2233.1513671875,
        779.7890014648438
      ],
      "bbox_max": [
        -245.962646484375,
        -2165.850830078125,
        820.8666381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36162224411964417,
        0.8005647659301758,
        0.4778340458869934
      ],
      "plane_d": 1267.4736328125,
      "bbox_min": [
        -370.31365966796875,
        -2233.1513671875,
        783.396728515625
      ],
      "bbox_max": [
        -252.22021484375,
        -2177.188720703125,
        820.6678466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -370.31365966796875,
        -2233.1513671875,
        798.7385864257812
      ],
      "bbox_max": [
        -347.122802734375,
        -2220.012451171875,
        818.1638793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -354.308349609375,
        -2228.361328125,
        785.8125
      ],
      "bbox_max": [
        -270.515625,
        -2183.931884765625,
        820.1851196289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -354.308349609375,
        -2228.361328125,
        791.80322265625
      ],
      "bbox_max": [
        -314.28076171875,
        -2198.047119140625,
        819.2825317382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -354.308349609375,
        -2228.361328125,
        796.3135986328125
      ],
      "bbox_max": [
        -330.51251220703125,
        -2211.443115234375,
        818.80322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -302.4618225097656,
        -2200.54150390625,
        785.8125
      ],
      "bbox_max": [
        -270.515625,
        -2183.931884765625,
        820.1851196289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0863649919629097,
        0.9781539440155029,
        0.18909214437007904
      ],
      "plane_d": 2005.18701171875,
      "bbox_min": [
        -235.501708984375,
        -2193.500732421875,
        770.7368774414062
      ],
      "bbox_max": [
        -170.35752868652344,
        -2179.7744140625,
        820.6962890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25527524948120117,
        0.9336197376251221,
        0.25137388706207275
      ],
      "plane_d": 1895.1923828125,
      "bbox_min": [
        -235.501708984375,
        -2188.4384765625,
        773.529541015625
      ],
      "bbox_max": [
        -209.0651397705078,
        -2179.7744140625,
        820.6962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20032097399234772,
        0.7389717102050781,
        0.6432669162750244
      ],
      "plane_d": 1029.450439453125,
      "bbox_min": [
        -277.37689208984375,
        -2247.94970703125,
        820.9546508789062
      ],
      "bbox_max": [
        -142.74118041992188,
        -2179.60009765625,
        937.2014770507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.055179059505462646,
        0.9984764456748962
      ],
      "plane_d": -743.3090209960938,
      "bbox_min": [
        -277.2162780761719,
        -2247.94970703125,
        820.9546508789062
      ],
      "bbox_max": [
        -142.74118041992188,
        -2179.60009765625,
        937.2014770507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -277.2162780761719,
        -2216.41015625,
        820.9546508789062
      ],
      "bbox_max": [
        -154.07594299316406,
        -2179.60009765625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.2162780761719,
        -2216.41015625,
        820.9546508789062
      ],
      "bbox_max": [
        -154.07594299316406,
        -2179.60009765625,
        859.4903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -276.244873046875,
        -2197.723876953125,
        820.9546508789062
      ],
      "bbox_max": [
        -251.5053253173828,
        -2179.60009765625,
        837.2395629882812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -268.3478698730469,
        -2184.45703125,
        820.9546508789062
      ],
      "bbox_max": [
        -251.5053253173828,
        -2179.60009765625,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -268.1400451660156,
        -2184.45703125,
        820.9546508789062
      ],
      "bbox_max": [
        -251.50534057617188,
        -2181.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -268.1400451660156,
        -2182.24951171875,
        820.9546508789062
      ],
      "bbox_max": [
        -264.94683837890625,
        -2181.5,
        821.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        0.5900004506111145
      ],
      "plane_d": 1274.8353271484375,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -252.8496856689453,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -253.87985229492188,
        -2179.60009765625,
        824.4364013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -255.55990600585938,
        -2179.60009765625,
        824.4364013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -261.0,
        -2179.60009765625,
        824.4364013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011262818239629269,
        0.8631109595298767,
        0.5048885345458984
      ],
      "plane_d": 1468.6697998046875,
      "bbox_min": [
        -215.23876953125,
        -2247.94970703125,
        866.3297729492188
      ],
      "bbox_max": [
        -144.019287109375,
        -2205.56298828125,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.055179059505462646,
        0.9984764456748962
      ],
      "plane_d": -743.3090209960938,
      "bbox_min": [
        -277.37689208984375,
        -2219.5,
        822.14794921875
      ],
      "bbox_max": [
        -148.6685333251953,
        -2180.755615234375,
        867.0999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -277.37689208984375,
        -2219.5,
        822.14794921875
      ],
      "bbox_max": [
        -165.52450561523438,
        -2180.755615234375,
        867.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.37689208984375,
        -2219.5,
        861.0
      ],
      "bbox_max": [
        -270.9947814941406,
        -2187.942138671875,
        867.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8180076479911804,
        0.18297654390335083,
        0.5453283786773682
      ],
      "plane_d": -291.77178955078125,
      "bbox_min": [
        -277.300048828125,
        -2219.5,
        862.4619140625
      ],
      "bbox_max": [
        -270.9947814941406,
        -2191.251220703125,
        867.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -277.2821350097656,
        -2217.677001953125,
        822.14794921875
      ],
      "bbox_max": [
        -165.72781372070312,
        -2180.755615234375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.2821350097656,
        -2217.677001953125,
        857.0
      ],
      "bbox_max": [
        -270.9993896484375,
        -2184.293701171875,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -277.0851745605469,
        -2214.206787109375,
        822.14794921875
      ],
      "bbox_max": [
        -259.18975830078125,
        -2180.755615234375,
        857.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2181.5,
      "bbox_min": [
        -276.0447998046875,
        -2196.723388671875,
        822.14794921875
      ],
      "bbox_max": [
        -259.18975830078125,
        -2180.755615234375,
        848.2384033203125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9390894770622253,
        0.19267703592777252,
        -0.2845814824104309
      ],
      "plane_d": 402.2903747558594,
      "bbox_min": [
        -276.0447998046875,
        -2196.723388671875,
        822.14794921875
      ],
      "bbox_max": [
        -259.18975830078125,
        -2181.5,
        837.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -263.5,
        -2182.66845703125,
        825.0
      ],
      "bbox_max": [
        -259.18975830078125,
        -2181.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        0.5900004506111145
      ],
      "plane_d": 1274.8353271484375,
      "bbox_min": [
        -261.0,
        -2181.5,
        823.5812377929688
      ],
      "bbox_max": [
        -260.47467041015625,
        -2180.755615234375,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        823.5812377929688
      ],
      "bbox_max": [
        -261.0,
        -2180.755615234375,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5879413485527039,
        0.423933207988739,
        0.6889162063598633
      ],
      "plane_d": 185.86029052734375,
      "bbox_min": [
        -427.18609619140625,
        -2399.99365234375,
        821.1808471679688
      ],
      "bbox_max": [
        -387.445068359375,
        -2348.869140625,
        876.422607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.055179059505462646,
        0.9984764456748962
      ],
      "plane_d": -743.3090209960938,
      "bbox_min": [
        -271.8732604980469,
        -2197.5283203125,
        859.7774047851562
      ],
      "bbox_max": [
        -258.21820068359375,
        -2185.1748046875,
        865.8857421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8180076479911804,
        0.18297654390335083,
        0.5453283786773682
      ],
      "plane_d": -291.77178955078125,
      "bbox_min": [
        -271.8732604980469,
        -2197.5283203125,
        859.7774047851562
      ],
      "bbox_max": [
        -269.013671875,
        -2185.1748046875,
        865.8857421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9739722609519958,
        0.19275443255901337,
        0.11926361918449402
      ],
      "plane_d": 54.71598815917969,
      "bbox_min": [
        -271.8732604980469,
        -2191.251220703125,
        859.7774047851562
      ],
      "bbox_max": [
        -270.8542175292969,
        -2185.1748046875,
        862.4619140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.440481036901474,
        -0.8977619409561157,
        0.0
      ],
      "plane_d": -1797.645263671875,
      "bbox_min": [
        -597.4422607421875,
        -2303.484619140625,
        711.775390625
      ],
      "bbox_max": [
        138.8248291015625,
        -1739.924072265625,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -480.0,
        -2067.07470703125,
        711.775390625
      ],
      "bbox_max": [
        131.89161682128906,
        -1739.924072265625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -150.0,
        -1943.7169189453125,
        822.0950927734375
      ],
      "bbox_max": [
        -119.52893829345703,
        -1865.0,
        1010.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -51.42585754394531,
        -2067.07470703125,
        711.775390625
      ],
      "bbox_max": [
        131.89161682128906,
        -1977.1312255859375,
        797.1386108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661781549453735,
        -0.4989537298679352,
        -0.027941754087805748
      ],
      "plane_d": -897.239013671875,
      "bbox_min": [
        126.47466278076172,
        -2067.07470703125,
        711.775390625
      ],
      "bbox_max": [
        131.89161682128906,
        -2057.659423828125,
        760.272216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        -480.0,
        -1847.093994140625,
        895.0
      ],
      "bbox_max": [
        -313.5917663574219,
        -1739.924072265625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9610140919685364,
        -0.24711816012859344,
        0.12403468042612076
      ],
      "plane_d": -877.0769653320312,
      "bbox_min": [
        -465.3614196777344,
        -1847.093994140625,
        895.0
      ],
      "bbox_max": [
        -313.5917663574219,
        -1739.924072265625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36369356513023376,
        -0.9232238531112671,
        0.12403438985347748
      ],
      "plane_d": -1887.0693359375,
      "bbox_min": [
        -465.3614196777344,
        -1847.093994140625,
        895.0
      ],
      "bbox_max": [
        -313.5917663574219,
        -1739.924072265625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27259883284568787,
        -0.954099178314209,
        0.12403497099876404
      ],
      "plane_d": -1706.5380859375,
      "bbox_min": [
        -370.0,
        -1778.0,
        895.0
      ],
      "bbox_max": [
        -334.8726501464844,
        -1757.5634765625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.579657914087875e-06,
        -0.9383420348167419,
        -0.34570831060409546
      ],
      "plane_d": -1346.9508056640625,
      "bbox_min": [
        -369.8363342285156,
        -1777.00439453125,
        915.8659057617188
      ],
      "bbox_max": [
        -361.5999755859375,
        -1772.8873291015625,
        927.0407104492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7892892360687256,
        -0.6013632416725159,
        0.12403453886508942
      ],
      "plane_d": -820.4692993164062,
      "bbox_min": [
        -465.3614196777344,
        -1847.093994140625,
        895.0
      ],
      "bbox_max": [
        -313.5917663574219,
        -1739.924072265625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9085974097251892,
        0.4001162648200989,
        0.11982358247041702
      ],
      "plane_d": 334.5862731933594,
      "bbox_min": [
        -377.5999755859375,
        -1847.093994140625,
        895.0
      ],
      "bbox_max": [
        -313.5917663574219,
        -1772.3857421875,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9128968119621277,
        0.3866746425628662,
        0.13077570497989655
      ],
      "plane_d": 297.8227844238281,
      "bbox_min": [
        -317.5520935058594,
        -1847.093994140625,
        965.7921752929688
      ],
      "bbox_max": [
        -313.5917663574219,
        -1840.3223876953125,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9383427500724792,
        -0.3457062244415283
      ],
      "plane_d": -1346.9554443359375,
      "bbox_min": [
        -377.5999755859375,
        -1823.5711669921875,
        914.5042114257812
      ],
      "bbox_max": [
        -361.5999755859375,
        -1772.3857421875,
        933.9417724609375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8472549915313721,
        0.03998080641031265,
        -0.5296797156333923
      ],
      "plane_d": 876.25927734375,
      "bbox_min": [
        -364.93896484375,
        -1823.5711669921875,
        932.9944458007812
      ],
      "bbox_max": [
        -364.40289306640625,
        -1822.5078125,
        933.8118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8642076253890991,
        0.49060776829719543,
        -0.11157596111297607
      ],
      "plane_d": 1246.207275390625,
      "bbox_min": [
        -597.4422607421875,
        -2303.484619140625,
        711.9805908203125
      ],
      "bbox_max": [
        138.8248291015625,
        -1766.85400390625,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3700557053089142,
        -0.9290096163749695,
        0.0
      ],
      "plane_d": -1855.8043212890625,
      "bbox_min": [
        -597.4422607421875,
        -2303.484619140625,
        711.9805908203125
      ],
      "bbox_max": [
        138.8248291015625,
        -1766.85400390625,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -480.0,
        -1977.1312255859375,
        770.0
      ],
      "bbox_max": [
        -51.42585754394531,
        -1766.85400390625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -171.66697692871094,
        -1951.1494140625,
        770.0
      ],
      "bbox_max": [
        -116.65182495117188,
        -1920.0,
        877.8367919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -171.66697692871094,
        -1922.31591796875,
        770.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        -480.0,
        -1929.899169921875,
        770.0
      ],
      "bbox_max": [
        -170.0,
        -1766.85400390625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -180.0,
        -1929.899169921875,
        770.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7892892360687256,
        -0.6013632416725159,
        0.12403453886508942
      ],
      "plane_d": -820.4692993164062,
      "bbox_min": [
        -478.33013916015625,
        -1868.02734375,
        895.0
      ],
      "bbox_max": [
        -316.4599914550781,
        -1774.036376953125,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.991968035697937,
        -0.024799127131700516,
        0.12403471022844315
      ],
      "plane_d": 308.7403564453125,
      "bbox_min": [
        -478.33013916015625,
        -1868.02734375,
        895.0
      ],
      "bbox_max": [
        -316.4599914550781,
        -1790.5142822265625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9085974097251892,
        0.4001162648200989,
        0.11982358247041702
      ],
      "plane_d": 334.5862731933594,
      "bbox_min": [
        -398.227294921875,
        -1868.02734375,
        895.0
      ],
      "bbox_max": [
        -316.4599914550781,
        -1822.5780029296875,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9128968119621277,
        0.3866746425628662,
        0.13077570497989655
      ],
      "plane_d": 297.8227844238281,
      "bbox_min": [
        -330.0039367675781,
        -1868.02734375,
        936.84130859375
      ],
      "bbox_max": [
        -316.4599914550781,
        -1846.55810546875,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -1846.9259033203125,
      "bbox_min": [
        -398.227294921875,
        -1847.1510009765625,
        895.0
      ],
      "bbox_max": [
        -362.0,
        -1822.5780029296875,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999086856842041,
        0.0,
        0.013512278907001019
      ],
      "plane_d": -377.0601501464844,
      "bbox_min": [
        -393.1310729980469,
        -1835.0,
        895.0
      ],
      "bbox_max": [
        -364.099853515625,
        -1822.5780029296875,
        938.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472549915313721,
        0.03998080641031265,
        -0.5296797156333923
      ],
      "plane_d": 876.25927734375,
      "bbox_min": [
        -364.4867248535156,
        -1832.5,
        932.9812622070312
      ],
      "bbox_max": [
        -364.099853515625,
        -1823.53466796875,
        933.7893676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300142765045166,
        -7.227063179016113e-07,
        -0.8479887247085571
      ],
      "plane_d": 597.75927734375,
      "bbox_min": [
        -393.1310729980469,
        -1834.861572265625,
        905.2467651367188
      ],
      "bbox_max": [
        -364.4773864746094,
        -1822.5780029296875,
        938.311767578125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8472549915313721,
        0.03998080641031265,
        -0.5296797156333923
      ],
      "plane_d": 876.25927734375,
      "bbox_min": [
        -364.911376953125,
        -1832.5,
        932.7999267578125
      ],
      "bbox_max": [
        -364.4773864746094,
        -1823.3216552734375,
        933.6729125976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1061839610338211,
        -0.05535433813929558,
        -0.9928045868873596
      ],
      "plane_d": 838.9097900390625,
      "bbox_min": [
        -393.1310729980469,
        -1834.861572265625,
        905.2467651367188
      ],
      "bbox_max": [
        -364.5,
        -1828.6898193359375,
        932.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922616481781006,
        -0.0,
        -0.12416519969701767
      ],
      "plane_d": -245.95741271972656,
      "bbox_min": [
        -364.60009765625,
        -1834.5,
        932.0
      ],
      "bbox_max": [
        -364.5,
        -1832.5,
        932.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1061839610338211,
        -0.05535433813929558,
        -0.9928045868873596
      ],
      "plane_d": 838.9097900390625,
      "bbox_min": [
        -398.227294921875,
        -1847.1510009765625,
        904.9318237304688
      ],
      "bbox_max": [
        -362.5,
        -1834.4173583984375,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300138592720032,
        1.3651326298713684e-05,
        -0.8479889631271362
      ],
      "plane_d": 597.7859497070312,
      "bbox_min": [
        -386.6792907714844,
        -1847.1510009765625,
        906.42333984375
      ],
      "bbox_max": [
        -362.5,
        -1834.4173583984375,
        939.1119384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8472556471824646,
        -0.03996013477444649,
        -0.5296801328659058
      ],
      "plane_d": 729.688232421875,
      "bbox_min": [
        -373.4189453125,
        -1844.4921875,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1834.5,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03390716016292572,
        -0.9992004632949829,
        0.021187448874115944
      ],
      "plane_d": -1875.1595458984375,
      "bbox_min": [
        -373.4189453125,
        -1844.4921875,
        933.01171875
      ],
      "bbox_max": [
        -364.43896484375,
        -1844.092041015625,
        939.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1834.4998779296875,
      "bbox_min": [
        -364.60009765625,
        -1834.5,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1834.5,
        933.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17790639400482178,
        -0.2584279775619507,
        -0.949507474899292
      ],
      "plane_d": 453.013671875,
      "bbox_min": [
        -386.6792907714844,
        -1847.1510009765625,
        906.42333984375
      ],
      "bbox_max": [
        -363.32025146484375,
        -1834.4891357421875,
        932.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1834.4998779296875,
      "bbox_min": [
        -364.60009765625,
        -1834.5,
        932.0
      ],
      "bbox_max": [
        -363.32025146484375,
        -1834.4891357421875,
        932.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922616481781006,
        -0.0,
        -0.12416519969701767
      ],
      "plane_d": -245.95741271972656,
      "bbox_min": [
        -364.60009765625,
        -1834.5,
        932.0
      ],
      "bbox_max": [
        -364.5,
        -1834.4891357421875,
        932.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9042837023735046,
        0.4269319474697113,
        0.0
      ],
      "plane_d": 999.3490600585938,
      "bbox_min": [
        -597.4422607421875,
        -2303.484619140625,
        711.9805908203125
      ],
      "bbox_max": [
        138.8248291015625,
        -1806.415771484375,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9630944132804871,
        0.2227189689874649,
        -0.15114662051200867
      ],
      "plane_d": 699.9846801757812,
      "bbox_min": [
        63.3701171875,
        -2206.544921875,
        711.9805908203125
      ],
      "bbox_max": [
        138.8248291015625,
        -2066.00927734375,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9362152218818665,
        0.2509586215019226,
        -0.2460101991891861
      ],
      "plane_d": 826.9634399414062,
      "bbox_min": [
        115.94408416748047,
        -2143.981201171875,
        712.1194458007812
      ],
      "bbox_max": [
        138.8248291015625,
        -2066.00927734375,
        760.272216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661781549453735,
        -0.4989537298679352,
        -0.027941754087805748
      ],
      "plane_d": -897.239013671875,
      "bbox_min": [
        129.7200469970703,
        -2079.12548828125,
        712.1194458007812
      ],
      "bbox_max": [
        138.8248291015625,
        -2066.00927734375,
        760.272216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.138129323720932,
        0.9765928387641907,
        0.16488416492938995
      ],
      "plane_d": 2002.7279052734375,
      "bbox_min": [
        63.3701171875,
        -2206.544921875,
        711.9805908203125
      ],
      "bbox_max": [
        135.55726623535156,
        -2066.00927734375,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661781549453735,
        -0.4989537298679352,
        -0.027941754087805748
      ],
      "plane_d": -897.239013671875,
      "bbox_min": [
        129.7200469970703,
        -2073.446044921875,
        711.9805908203125
      ],
      "bbox_max": [
        135.55726623535156,
        -2066.00927734375,
        760.272216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -597.4422607421875,
        -2303.484619140625,
        725.9998168945312
      ],
      "bbox_max": [
        72.51788330078125,
        -1806.415771484375,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -118.56556701660156,
        -2197.409423828125,
        725.9998168945312
      ],
      "bbox_max": [
        72.51788330078125,
        -1950.38720703125,
        925.469970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -87.22331237792969,
        -1993.5772705078125,
        725.9998168945312
      ],
      "bbox_max": [
        -17.906570434570312,
        -1971.048828125,
        797.1386108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.138129323720932,
        0.9765928387641907,
        0.16488416492938995
      ],
      "plane_d": 2002.7279052734375,
      "bbox_min": [
        54.186500549316406,
        -2197.409423828125,
        868.8673706054688
      ],
      "bbox_max": [
        72.51788330078125,
        -2187.1689453125,
        925.469970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -156.7864990234375,
        -1964.927001953125,
        735.3753662109375
      ],
      "bbox_max": [
        -103.21552276611328,
        -1940.0272216796875,
        819.6739501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.138129323720932,
        0.9765928387641907,
        0.16488416492938995
      ],
      "plane_d": 2002.7279052734375,
      "bbox_min": [
        10.762889862060547,
        -2206.544921875,
        885.9989624023438
      ],
      "bbox_max": [
        67.68318176269531,
        -2192.654296875,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1926385760307312,
        -0.9812697768211365,
        0.0
      ],
      "plane_d": -1914.5927734375,
      "bbox_min": [
        -597.4422607421875,
        -2217.946533203125,
        741.6661376953125
      ],
      "bbox_max": [
        63.3701171875,
        -1806.415771484375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        -480.0,
        -1887.239013671875,
        895.0
      ],
      "bbox_max": [
        -317.0,
        -1806.415771484375,
        975.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.991968035697937,
        -0.024799127131700516,
        0.12403471022844315
      ],
      "plane_d": 308.7403564453125,
      "bbox_min": [
        -479.5778503417969,
        -1885.7939453125,
        895.0
      ],
      "bbox_max": [
        -325.3266906738281,
        -1807.0809326171875,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9128968119621277,
        0.3866746425628662,
        0.13077570497989655
      ],
      "plane_d": 297.8227844238281,
      "bbox_min": [
        -441.44793701171875,
        -1885.7939453125,
        895.0
      ],
      "bbox_max": [
        -325.3266906738281,
        -1829.67529296875,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9085974097251892,
        0.4001162648200989,
        0.11982358247041702
      ],
      "plane_d": 334.5862731933594,
      "bbox_min": [
        -343.265869140625,
        -1884.114990234375,
        895.0
      ],
      "bbox_max": [
        -330.0039367675781,
        -1864.294189453125,
        936.8412475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999086856842041,
        -0.0,
        0.013512278907001019
      ],
      "plane_d": 349.87347412109375,
      "bbox_min": [
        -441.44793701171875,
        -1879.628662109375,
        895.0
      ],
      "bbox_max": [
        -362.0,
        -1829.67529296875,
        942.0552368164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999086856842041,
        0.0,
        0.013512278907001019
      ],
      "plane_d": -377.0601501464844,
      "bbox_min": [
        -441.44793701171875,
        -1879.628662109375,
        895.0
      ],
      "bbox_max": [
        -362.0,
        -1829.67529296875,
        942.0552368164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -1887.4222412109375,
      "bbox_min": [
        -365.0,
        -1879.628662109375,
        895.0
      ],
      "bbox_max": [
        -362.0,
        -1863.0078125,
        933.8118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472549915313721,
        0.03998080641031265,
        -0.5296797156333923
      ],
      "plane_d": 877.8784790039062,
      "bbox_min": [
        -364.4867248535156,
        -1873.0,
        932.9812622070312
      ],
      "bbox_max": [
        -364.099853515625,
        -1863.0078125,
        933.8118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472556471824646,
        -0.03996013477444649,
        -0.5296801328659058
      ],
      "plane_d": 728.06982421875,
      "bbox_min": [
        -364.5,
        -1879.628662109375,
        932.0
      ],
      "bbox_max": [
        -362.5,
        -1875.0,
        933.6981811523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40026214718818665,
        -0.32412514090538025,
        -0.8571658134460449
      ],
      "plane_d": 13.6763916015625,
      "bbox_min": [
        -441.44793701171875,
        -1879.58447265625,
        895.0
      ],
      "bbox_max": [
        -364.476318359375,
        -1829.67529296875,
        942.0552368164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8394879698753357,
        -0.27731165289878845,
        -0.46728816628456116
      ],
      "plane_d": -443.591064453125,
      "bbox_min": [
        -441.44793701171875,
        -1879.58447265625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.476318359375,
        -1829.67529296875,
        942.0552368164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17219054698944092,
        -0.4629462659358978,
        -0.8695005774497986
      ],
      "plane_d": -1.14617919921875,
      "bbox_min": [
        -441.44793701171875,
        -1879.58447265625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.476318359375,
        -1829.67529296875,
        942.0552368164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8337720036506653,
        -0.07279076427221298,
        -0.5472894310951233
      ],
      "plane_d": 10.568115234375,
      "bbox_min": [
        -441.44793701171875,
        -1879.58447265625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.476318359375,
        -1829.67529296875,
        942.0552368164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08989904820919037,
        -0.6377612948417664,
        -0.7649697661399841
      ],
      "plane_d": -454.40386962890625,
      "bbox_min": [
        -439.3348083496094,
        -1879.58447265625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.476318359375,
        -1833.4615478515625,
        942.0552368164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7677624821662903,
        -0.48038429021835327,
        -0.42399489879608154
      ],
      "plane_d": -829.48046875,
      "bbox_min": [
        -439.3348083496094,
        -1879.58447265625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.476318359375,
        -1833.4615478515625,
        942.0552368164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05644569545984268,
        -0.7562670707702637,
        -0.6518236398696899
      ],
      "plane_d": -837.777099609375,
      "bbox_min": [
        -431.9927062988281,
        -1879.58447265625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.476318359375,
        -1833.4615478515625,
        940.444091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17790639400482178,
        -0.2584279775619507,
        -0.949507474899292
      ],
      "plane_d": 453.013671875,
      "bbox_min": [
        -431.9927062988281,
        -1879.58447265625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.476318359375,
        -1833.4615478515625,
        940.444091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6295140981674194,
        -0.6511096954345703,
        -0.4239906668663025
      ],
      "plane_d": -1088.3922119140625,
      "bbox_min": [
        -431.9927062988281,
        -1879.58447265625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.476318359375,
        -1833.4615478515625,
        940.444091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9666560292243958,
        -0.11235125362873077,
        0.23011593520641327
      ],
      "plane_d": -53.79853820800781,
      "bbox_min": [
        -430.927001953125,
        -1879.58447265625,
        904.7818603515625
      ],
      "bbox_max": [
        -364.476318359375,
        -1833.4615478515625,
        938.311767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8443467020988464,
        -0.3719113767147064,
        0.38569480180740356
      ],
      "plane_d": -727.1732177734375,
      "bbox_min": [
        -430.927001953125,
        -1875.205810546875,
        904.7818603515625
      ],
      "bbox_max": [
        -379.49224853515625,
        -1833.4615478515625,
        927.3629150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1061839610338211,
        -0.05535433813929558,
        -0.9928045868873596
      ],
      "plane_d": 838.9097900390625,
      "bbox_min": [
        -430.927001953125,
        -1871.650390625,
        904.7818603515625
      ],
      "bbox_max": [
        -386.6792907714844,
        -1833.4615478515625,
        927.3629150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24455657601356506,
        -0.8004148006439209,
        -0.5472918748855591
      ],
      "plane_d": -1092.8800048828125,
      "bbox_min": [
        -430.927001953125,
        -1871.650390625,
        904.7818603515625
      ],
      "bbox_max": [
        -395.8721008300781,
        -1833.4615478515625,
        927.3629150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4457895755767822,
        -0.7634869813919067,
        -0.46728917956352234
      ],
      "plane_d": -1180.87939453125,
      "bbox_min": [
        -430.927001953125,
        -1869.93994140625,
        904.7818603515625
      ],
      "bbox_max": [
        -395.8721008300781,
        -1833.4615478515625,
        927.3629150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4891117215156555,
        -0.145236536860466,
        -0.8600442409515381
      ],
      "plane_d": 311.82666015625,
      "bbox_min": [
        -430.927001953125,
        -1869.0877685546875,
        904.7818603515625
      ],
      "bbox_max": [
        -395.8721008300781,
        -1833.4615478515625,
        924.491455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5407828092575073,
        -0.1870790719985962,
        -0.820094645023346
      ],
      "plane_d": 176.46441650390625,
      "bbox_min": [
        -430.927001953125,
        -1869.0877685546875,
        904.7818603515625
      ],
      "bbox_max": [
        -395.8721008300781,
        -1833.4615478515625,
        924.491455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.546542227268219,
        -0.3926725387573242,
        -0.7396619915962219
      ],
      "plane_d": -280.09307861328125,
      "bbox_min": [
        -430.927001953125,
        -1869.0877685546875,
        904.7818603515625
      ],
      "bbox_max": [
        -395.8721008300781,
        -1833.4615478515625,
        924.491455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5718569755554199,
        -0.32099810242652893,
        -0.7549435496330261
      ],
      "plane_d": -143.89202880859375,
      "bbox_min": [
        -430.927001953125,
        -1869.0877685546875,
        904.7818603515625
      ],
      "bbox_max": [
        -395.8721008300781,
        -1833.4615478515625,
        924.491455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5698388814926147,
        -0.24880445003509521,
        -0.7831858992576599
      ],
      "plane_d": 16.4239501953125,
      "bbox_min": [
        -430.927001953125,
        -1869.0877685546875,
        904.7818603515625
      ],
      "bbox_max": [
        -395.8721008300781,
        -1833.4615478515625,
        924.491455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21471019089221954,
        -0.3865227997303009,
        -0.8969390392303467
      ],
      "plane_d": 12.32232666015625,
      "bbox_min": [
        -426.1455993652344,
        -1869.0877685546875,
        904.7818603515625
      ],
      "bbox_max": [
        -395.8721008300781,
        -1833.4615478515625,
        924.491455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2868136465549469,
        -0.1823684126138687,
        -0.9404678344726562
      ],
      "plane_d": 400.27362060546875,
      "bbox_min": [
        -426.1455993652344,
        -1869.0877685546875,
        904.7818603515625
      ],
      "bbox_max": [
        -395.8721008300781,
        -1833.4615478515625,
        924.491455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42272278666496277,
        -0.12965497374534607,
        -0.8969364166259766
      ],
      "plane_d": 401.8604736328125,
      "bbox_min": [
        -426.1455993652344,
        -1869.0877685546875,
        904.7818603515625
      ],
      "bbox_max": [
        -395.8721008300781,
        -1833.4615478515625,
        924.491455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3516809046268463,
        -0.14269132912158966,
        -0.9251809120178223
      ],
      "plane_d": 432.92877197265625,
      "bbox_min": [
        -426.1455993652344,
        -1869.0877685546875,
        904.7818603515625
      ],
      "bbox_max": [
        -395.8721008300781,
        -1833.4615478515625,
        924.491455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2126915007829666,
        -0.31433331966400146,
        -0.9251794219017029
      ],
      "plane_d": 172.6290283203125,
      "bbox_min": [
        -426.1455993652344,
        -1869.0877685546875,
        904.7818603515625
      ],
      "bbox_max": [
        -395.8721008300781,
        -1840.953125,
        924.491455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2380163073539734,
        -0.24262867867946625,
        -0.9404677152633667
      ],
      "plane_d": 308.8880615234375,
      "bbox_min": [
        -426.1455993652344,
        -1869.0877685546875,
        904.7818603515625
      ],
      "bbox_max": [
        -397.0157165527344,
        -1840.953125,
        924.491455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2954280376434326,
        -0.49007007479667664,
        -0.8200936317443848
      ],
      "plane_d": -283.0264892578125,
      "bbox_min": [
        -426.1455993652344,
        -1869.0877685546875,
        910.8653564453125
      ],
      "bbox_max": [
        -397.3967590332031,
        -1852.5081787109375,
        924.491455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24375806748867035,
        -0.4482286274433136,
        -0.8600425124168396
      ],
      "plane_d": -147.6673583984375,
      "bbox_min": [
        -426.1455993652344,
        -1869.0877685546875,
        910.8653564453125
      ],
      "bbox_max": [
        -397.3967590332031,
        -1852.5081787109375,
        924.491455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.497726172208786,
        -0.4529552161693573,
        -0.739662230014801
      ],
      "plane_d": -371.5120849609375,
      "bbox_min": [
        -426.1455993652344,
        -1869.0877685546875,
        911.374267578125
      ],
      "bbox_max": [
        -407.1524353027344,
        -1852.5081787109375,
        924.491455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.361839234828949,
        -0.505656361579895,
        -0.7831882834434509
      ],
      "plane_d": -373.09027099609375,
      "bbox_min": [
        -420.5672607421875,
        -1869.0877685546875,
        911.374267578125
      ],
      "bbox_max": [
        -407.1524353027344,
        -1852.5081787109375,
        923.7413330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4328785538673401,
        -0.4926200807094574,
        -0.7549447417259216
      ],
      "plane_d": -404.15673828125,
      "bbox_min": [
        -420.5672607421875,
        -1869.0877685546875,
        911.374267578125
      ],
      "bbox_max": [
        -413.8978576660156,
        -1852.5081787109375,
        923.7413330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6661583185195923,
        -0.5394244194030762,
        0.5150285959243774
      ],
      "plane_d": -1751.376220703125,
      "bbox_min": [
        -416.93450927734375,
        -1860.2283935546875,
        915.7816162109375
      ],
      "bbox_max": [
        -414.4456481933594,
        -1857.4951171875,
        916.1380615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293261647224426,
        -0.7771412134170532,
        9.447147022001445e-06
      ],
      "plane_d": -1185.3472900390625,
      "bbox_min": [
        -415.90264892578125,
        -1860.672119140625,
        914.0799560546875
      ],
      "bbox_max": [
        -411.9338684082031,
        -1858.717529296875,
        916.21044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6661583185195923,
        -0.5394244194030762,
        0.5150285959243774
      ],
      "plane_d": -1751.376220703125,
      "bbox_min": [
        -415.90264892578125,
        -1860.672119140625,
        915.8359375
      ],
      "bbox_max": [
        -414.0971984863281,
        -1858.717529296875,
        916.21044921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6661583185195923,
        -0.5394244194030762,
        0.5150285959243774
      ],
      "plane_d": -1751.376220703125,
      "bbox_min": [
        -418.6181640625,
        -1860.3162841796875,
        915.5504150390625
      ],
      "bbox_max": [
        -414.5531311035156,
        -1855.5006103515625,
        915.906982421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6293339729309082,
        -0.7771350145339966,
        1.597722621227149e-05
      ],
      "plane_d": -1185.3385009765625,
      "bbox_min": [
        -410.1022033691406,
        -1857.3544921875,
        911.178466796875
      ],
      "bbox_max": [
        -408.18115234375,
        -1855.798828125,
        912.53369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293267011642456,
        -0.7771408557891846,
        7.825320835763705e-07
      ],
      "plane_d": -1185.338623046875,
      "bbox_min": [
        -416.0355224609375,
        -1860.8724365234375,
        911.7913208007812
      ],
      "bbox_max": [
        -409.2228698730469,
        -1856.6424560546875,
        915.9921264648438
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.6661583185195923,
        -0.5394244194030762,
        0.5150285959243774
      ],
      "plane_d": -1751.376220703125,
      "bbox_min": [
        -416.0355224609375,
        -1860.8724365234375,
        915.4625854492188
      ],
      "bbox_max": [
        -414.19915771484375,
        -1858.8260498046875,
        915.9921264648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.666171133518219,
        0.5394450426101685,
        -0.5149903893470764
      ],
      "plane_d": 1739.18505859375,
      "bbox_min": [
        -410.52301025390625,
        -1850.8131103515625,
        909.3016357421875
      ],
      "bbox_max": [
        -408.94635009765625,
        -1848.9451904296875,
        909.42431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6661423444747925,
        0.5394482612609863,
        -0.5150243043899536
      ],
      "plane_d": 1739.2099609375,
      "bbox_min": [
        -409.8028259277344,
        -1853.3729248046875,
        909.2586059570312
      ],
      "bbox_max": [
        -406.6152648925781,
        -1849.87255859375,
        909.7581787109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6661616563796997,
        0.5394300222396851,
        -0.5150184035301208
      ],
      "plane_d": 1739.1788330078125,
      "bbox_min": [
        -414.0414123535156,
        -1847.0146484375,
        909.42431640625
      ],
      "bbox_max": [
        -412.02227783203125,
        -1844.202392578125,
        909.7581787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6661616563796997,
        0.5394300222396851,
        -0.5150184035301208
      ],
      "plane_d": 1739.1788330078125,
      "bbox_min": [
        -414.3072814941406,
        -1845.818603515625,
        909.4773559570312
      ],
      "bbox_max": [
        -412.9498596191406,
        -1843.952880859375,
        909.801513671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6661616563796997,
        0.5394300222396851,
        -0.5150184035301208
      ],
      "plane_d": 1739.1788330078125,
      "bbox_min": [
        -414.1578369140625,
        -1850.8758544921875,
        908.7357788085938
      ],
      "bbox_max": [
        -409.0236511230469,
        -1844.2608642578125,
        909.54638671875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6661587357521057,
        0.5394434928894043,
        -0.5150080323219299
      ],
      "plane_d": 1739.193115234375,
      "bbox_min": [
        -413.41632080078125,
        -1860.0382080078125,
        907.478271484375
      ],
      "bbox_max": [
        -405.98822021484375,
        -1848.262451171875,
        914.2586059570312
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6293280720710754,
        -0.7771397233009338,
        1.0289868441759609e-05
      ],
      "plane_d": -1185.344482421875,
      "bbox_min": [
        -413.41632080078125,
        -1860.0382080078125,
        907.478271484375
      ],
      "bbox_max": [
        -405.98822021484375,
        -1854.0230712890625,
        914.2586059570312
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.6661365628242493,
        -0.5393994450569153,
        0.5150827765464783
      ],
      "plane_d": -1751.37060546875,
      "bbox_min": [
        -422.4215393066406,
        -1853.43896484375,
        915.7816162109375
      ],
      "bbox_max": [
        -420.2190856933594,
        -1850.517578125,
        916.12841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293280720710754,
        -0.7771397233009338,
        1.0289868441759609e-05
      ],
      "plane_d": -1185.344482421875,
      "bbox_min": [
        -422.4280090332031,
        -1861.5155029296875,
        908.624267578125
      ],
      "bbox_max": [
        -408.5957336425781,
        -1850.6026611328125,
        915.9035034179688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6661518812179565,
        -0.5394379496574402,
        0.5150227546691895
      ],
      "plane_d": -1751.3935546875,
      "bbox_min": [
        -422.4280090332031,
        -1861.5155029296875,
        913.7618408203125
      ],
      "bbox_max": [
        -414.4464111328125,
        -1850.6026611328125,
        915.9035034179688
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.6661518812179565,
        -0.5394379496574402,
        0.5150227546691895
      ],
      "plane_d": -1751.3935546875,
      "bbox_min": [
        -422.6275634765625,
        -1861.11181640625,
        913.7618408203125
      ],
      "bbox_max": [
        -415.5675048828125,
        -1850.60791015625,
        915.8896484375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6661587357521057,
        0.5394434928894043,
        -0.5150080323219299
      ],
      "plane_d": 1739.193115234375,
      "bbox_min": [
        -423.42169189453125,
        -1859.1639404296875,
        907.478271484375
      ],
      "bbox_max": [
        -407.48968505859375,
        -1844.0318603515625,
        915.4623413085938
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.6661518812179565,
        -0.5394379496574402,
        0.5150227546691895
      ],
      "plane_d": -1751.3935546875,
      "bbox_min": [
        -423.42169189453125,
        -1859.1639404296875,
        913.7618408203125
      ],
      "bbox_max": [
        -417.14483642578125,
        -1850.76953125,
        915.4623413085938
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5300142765045166,
        -7.227063179016113e-07,
        -0.8479887247085571
      ],
      "plane_d": 597.7592163085938,
      "bbox_min": [
        -373.4189453125,
        -1879.58447265625,
        932.0
      ],
      "bbox_max": [
        -364.476318359375,
        -1863.0078125,
        938.311767578125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8472549915313721,
        0.03998080641031265,
        -0.5296797156333923
      ],
      "plane_d": 877.8784790039062,
      "bbox_min": [
        -364.93896484375,
        -1879.58447265625,
        932.7311401367188
      ],
      "bbox_max": [
        -364.476318359375,
        -1863.0078125,
        933.7521362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472556471824646,
        -0.03996013477444649,
        -0.5296801328659058
      ],
      "plane_d": 728.06982421875,
      "bbox_min": [
        -364.7537536621094,
        -1879.58447265625,
        932.7575073242188
      ],
      "bbox_max": [
        -364.48193359375,
        -1875.0,
        933.3348999023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1874.9998779296875,
      "bbox_min": [
        -364.60009765625,
        -1875.0,
        932.7575073242188
      ],
      "bbox_max": [
        -364.4867248535156,
        -1875.0,
        932.9812622070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1874.9998779296875,
      "bbox_min": [
        -364.5322265625,
        -1875.0,
        932.7311401367188
      ],
      "bbox_max": [
        -364.4888000488281,
        -1875.0,
        932.826904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922616481781006,
        -0.0,
        -0.12416519969701767
      ],
      "plane_d": -245.95741271972656,
      "bbox_min": [
        -364.60009765625,
        -1875.0,
        932.0
      ],
      "bbox_max": [
        -364.4901123046875,
        -1873.0,
        932.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1874.9998779296875,
      "bbox_min": [
        -364.60009765625,
        -1875.0,
        932.0
      ],
      "bbox_max": [
        -364.4901123046875,
        -1875.0,
        932.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -903.0,
      "bbox_min": [
        -430.11572265625,
        -1867.11572265625,
        895.0
      ],
      "bbox_max": [
        -405.484375,
        -1842.484375,
        912.0621337890625
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 405.484375,
      "bbox_min": [
        -430.11572265625,
        -1867.11572265625,
        895.0
      ],
      "bbox_max": [
        -405.484375,
        -1845.784423828125,
        903.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        3.699045555549674e-05,
        -1.0,
        0.0
      ],
      "plane_d": -1867.10009765625,
      "bbox_min": [
        -430.11572265625,
        -1867.11572265625,
        895.0
      ],
      "bbox_max": [
        -405.484375,
        -1845.784423828125,
        903.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500045895576477,
        -0.8659989833831787,
        -0.0
      ],
      "plane_d": -1827.48974609375,
      "bbox_min": [
        -430.11572265625,
        -1867.11572265625,
        895.0
      ],
      "bbox_max": [
        -405.484375,
        -1845.784423828125,
        903.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660150170326233,
        -0.5000181198120117,
        0.0
      ],
      "plane_d": -577.9281005859375,
      "bbox_min": [
        -430.11572265625,
        -1867.115478515625,
        895.0
      ],
      "bbox_max": [
        -405.484375,
        -1845.784423828125,
        903.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660150170326233,
        0.5000181198120117,
        0.0
      ],
      "plane_d": 1276.9390869140625,
      "bbox_min": [
        -430.11572265625,
        -1867.115478515625,
        895.0
      ],
      "bbox_max": [
        -405.484375,
        -1845.784423828125,
        903.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999040365219116,
        -0.8660310506820679,
        0.0
      ],
      "plane_d": -1409.7340087890625,
      "bbox_min": [
        -430.11572265625,
        -1867.115478515625,
        895.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1858.10009765625,
        903.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660057783126831,
        -0.5000341534614563,
        -0.0
      ],
      "plane_d": -1301.59619140625,
      "bbox_min": [
        -430.11572265625,
        -1863.8154296875,
        895.0
      ],
      "bbox_max": [
        -426.815673828125,
        -1858.10009765625,
        903.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.485130250453949,
        -0.8401674628257751,
        0.2424197494983673
      ],
      "plane_d": -1991.88330078125,
      "bbox_min": [
        -430.11572265625,
        -1867.11572265625,
        903.0
      ],
      "bbox_max": [
        -405.484375,
        -1844.2431640625,
        912.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 174.3679656982422,
      "bbox_min": [
        -430.11572265625,
        -1867.11572265625,
        903.0
      ],
      "bbox_max": [
        -405.484375,
        -1844.2431640625,
        912.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4850599765777588,
        -0.8401700854301453,
        0.2425508350133896
      ],
      "plane_d": -1586.66064453125,
      "bbox_min": [
        -430.11572265625,
        -1867.11572265625,
        903.0
      ],
      "bbox_max": [
        -405.484375,
        -1844.2431640625,
        912.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4850674867630005,
        0.8401495814323425,
        0.24260728061199188
      ],
      "plane_d": 1551.90380859375,
      "bbox_min": [
        -430.11572265625,
        -1867.11572265625,
        903.0
      ],
      "bbox_max": [
        -405.484375,
        -1844.2431640625,
        912.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -905.0,
      "bbox_min": [
        -426.00146484375,
        -1867.11572265625,
        903.0
      ],
      "bbox_max": [
        -420.56396484375,
        -1862.9765625,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9370622634887695,
        -0.25119492411613464,
        0.24251866340637207
      ],
      "plane_d": -293.4073181152344,
      "bbox_min": [
        -421.414306640625,
        -1867.11572265625,
        903.0
      ],
      "bbox_max": [
        -420.56396484375,
        -1865.11572265625,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701425433158875,
        -0.0,
        0.24253563582897186
      ],
      "plane_d": 196.3236083984375,
      "bbox_min": [
        -430.11572265625,
        -1867.115478515625,
        903.0
      ],
      "bbox_max": [
        -405.484375,
        -1844.2431640625,
        912.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -904.9999389648438,
      "bbox_min": [
        -430.11572265625,
        -1858.10009765625,
        903.0
      ],
      "bbox_max": [
        -428.11572265625,
        -1852.15185546875,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2511908710002899,
        -0.9370471835136414,
        0.2425812929868698
      ],
      "plane_d": -1852.13720703125,
      "bbox_min": [
        -430.11572265625,
        -1858.10009765625,
        903.0
      ],
      "bbox_max": [
        -428.11572265625,
        -1857.180419921875,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701425433158875,
        0.0,
        0.24253563582897186
      ],
      "plane_d": -614.32763671875,
      "bbox_min": [
        -426.8154296875,
        -1867.115478515625,
        903.0
      ],
      "bbox_max": [
        -405.484375,
        -1844.2431640625,
        912.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -905.0,
      "bbox_min": [
        -407.484375,
        -1858.10009765625,
        903.0
      ],
      "bbox_max": [
        -405.484375,
        -1852.15185546875,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2511959671974182,
        -0.9370661973953247,
        0.24250248074531555
      ],
      "plane_d": -2061.99853515625,
      "bbox_min": [
        -407.484375,
        -1858.10009765625,
        903.0
      ],
      "bbox_max": [
        -405.484375,
        -1857.180419921875,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.629315972328186,
        -0.7771496772766113,
        -1.1473895256131073e-06
      ],
      "plane_d": -1183.0574951171875,
      "bbox_min": [
        -426.8154296875,
        -1867.115478515625,
        903.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1844.2431640625,
        912.0621337890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6661390066146851,
        -0.5394330024719238,
        0.5150444507598877
      ],
      "plane_d": -1748.0985107421875,
      "bbox_min": [
        -426.8154296875,
        -1859.568359375,
        903.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1844.2431640625,
        912.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4850674867630005,
        -0.8401495814323425,
        0.24260728061199188
      ],
      "plane_d": -1970.0377197265625,
      "bbox_min": [
        -426.8154296875,
        -1859.568359375,
        903.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1844.2431640625,
        909.2294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.68598473072052,
        -0.68598473072052,
        0.2425900548696518
      ],
      "plane_d": -1204.81884765625,
      "bbox_min": [
        -410.330810546875,
        -1847.24853515625,
        903.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1845.784423828125,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293194890022278,
        -0.7771466374397278,
        -3.342030083786085e-07
      ],
      "plane_d": -1173.05126953125,
      "bbox_min": [
        -426.8154296875,
        -1859.568359375,
        903.0
      ],
      "bbox_max": [
        -410.8258361816406,
        -1844.2431640625,
        909.2294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48506924510002136,
        -0.8401526212692261,
        0.24259306490421295
      ],
      "plane_d": -1564.707275390625,
      "bbox_min": [
        -426.8154296875,
        -1852.6136474609375,
        903.0
      ],
      "bbox_max": [
        -418.7412414550781,
        -1844.2431640625,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6860514283180237,
        -0.6859369874000549,
        0.2425360530614853
      ],
      "plane_d": -1777.919189453125,
      "bbox_min": [
        -426.8154296875,
        -1847.24853515625,
        903.0
      ],
      "bbox_max": [
        -425.269287109375,
        -1845.784423828125,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7276643514633179,
        0.5892499685287476,
        0.351125568151474
      ],
      "plane_d": 1076.8787841796875,
      "bbox_min": [
        -425.3659973144531,
        -1852.6136474609375,
        903.0
      ],
      "bbox_max": [
        -418.7412414550781,
        -1846.5802001953125,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7276657819747925,
        -0.5892511010169983,
        0.3511207103729248
      ],
      "plane_d": -1717.09619140625,
      "bbox_min": [
        -425.3659973144531,
        -1852.6136474609375,
        903.0
      ],
      "bbox_max": [
        -422.6269836425781,
        -1849.726806640625,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6661451458930969,
        0.5394249558448792,
        -0.5150449872016907
      ],
      "plane_d": 1742.586669921875,
      "bbox_min": [
        -421.9276123046875,
        -1859.568359375,
        904.0018310546875
      ],
      "bbox_max": [
        -410.8258361816406,
        -1848.3751220703125,
        909.2294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29274579882621765,
        0.23705703020095825,
        -0.9263390302658081
      ],
      "plane_d": 1399.258544921875,
      "bbox_min": [
        -421.9276123046875,
        -1859.568359375,
        904.0018310546875
      ],
      "bbox_max": [
        -412.8271484375,
        -1849.9957275390625,
        907.7763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4002443253993988,
        -0.3241121768951416,
        -0.8571790456771851
      ],
      "plane_d": 6.7198486328125,
      "bbox_min": [
        -421.9276123046875,
        -1859.568359375,
        904.0018310546875
      ],
      "bbox_max": [
        -414.626953125,
        -1851.1033935546875,
        907.7763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7730792164802551,
        -0.6260285973548889,
        -0.10216037184000015
      ],
      "plane_d": -1393.3846435546875,
      "bbox_min": [
        -421.9276123046875,
        -1859.568359375,
        905.0
      ],
      "bbox_max": [
        -416.29241943359375,
        -1851.1033935546875,
        907.7763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7771310806274414,
        -0.6293386816978455,
        -0.0
      ],
      "plane_d": -1492.864013671875,
      "bbox_min": [
        -421.9276123046875,
        -1852.26904296875,
        905.0
      ],
      "bbox_max": [
        -420.983642578125,
        -1851.1033935546875,
        906.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293194890022278,
        -0.7771466374397278,
        -3.342030083786085e-07
      ],
      "plane_d": -1187.0511474609375,
      "bbox_min": [
        -416.5555114746094,
        -1867.115478515625,
        903.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1857.460205078125,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7276643514633179,
        0.5892499685287476,
        0.351125568151474
      ],
      "plane_d": 1076.87890625,
      "bbox_min": [
        -416.5555114746094,
        -1863.49365234375,
        903.0
      ],
      "bbox_max": [
        -409.9307556152344,
        -1857.460205078125,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7276657819747925,
        -0.5892511010169983,
        0.3511207103729248
      ],
      "plane_d": -1717.09619140625,
      "bbox_min": [
        -416.5555114746094,
        -1863.49365234375,
        903.0
      ],
      "bbox_max": [
        -413.8164978027344,
        -1860.6068115234375,
        907.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -904.9999389648438,
      "bbox_min": [
        -415.0361328125,
        -1867.115478515625,
        903.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1862.3515625,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6859986186027527,
        0.6859986186027527,
        0.24251124262809753
      ],
      "plane_d": 1340.0128173828125,
      "bbox_min": [
        -415.0361328125,
        -1867.115478515625,
        903.0
      ],
      "bbox_max": [
        -408.784423828125,
        -1862.3515625,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9370298981666565,
        -0.25121691823005676,
        0.24262097477912903
      ],
      "plane_d": -1076.53662109375,
      "bbox_min": [
        -415.0361328125,
        -1867.115478515625,
        903.0
      ],
      "bbox_max": [
        -414.185791015625,
        -1865.11572265625,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5634797811508179,
        -0.8261274099349976,
        -0.002011953853070736
      ],
      "plane_d": -1353.20361328125,
      "bbox_min": [
        -597.4422607421875,
        -2217.946533203125,
        741.6661376953125
      ],
      "bbox_max": [
        63.3701171875,
        -1856.906494140625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5680782794952393,
        -0.8229745030403137,
        0.0
      ],
      "plane_d": -1346.862060546875,
      "bbox_min": [
        -495.131103515625,
        -1978.3544921875,
        780.299072265625
      ],
      "bbox_max": [
        -354.0003356933594,
        -1856.906494140625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        -484.5012512207031,
        -1940.0,
        780.299072265625
      ],
      "bbox_max": [
        -354.7975158691406,
        -1856.906494140625,
        975.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -893.5,
      "bbox_min": [
        -440.5,
        -1921.3162841796875,
        892.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 1884.4998779296875,
      "bbox_min": [
        -430.0,
        -1921.3162841796875,
        892.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        893.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -412.5,
        -1921.3162841796875,
        892.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1912.0,
      "bbox_min": [
        -412.5,
        -1921.3162841796875,
        892.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -360.0,
        -1884.8155517578125,
        892.0023193359375
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 412.5,
      "bbox_min": [
        -412.5,
        -1921.3162841796875,
        892.0
      ],
      "bbox_max": [
        -412.5,
        -1912.0,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        -440.5,
        -1921.3162841796875,
        893.5
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 412.5,
      "bbox_min": [
        -412.5,
        -1921.3162841796875,
        893.5
      ],
      "bbox_max": [
        -412.5,
        -1912.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1886.0,
      "bbox_min": [
        -440.5,
        -1910.0,
        893.5
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        895.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 1884.4998779296875,
      "bbox_min": [
        -430.0,
        -1884.8155517578125,
        893.5
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        895.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -360.0,
        -1884.8155517578125,
        893.5
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1893.0,
      "bbox_min": [
        -440.5,
        -1910.0,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -894.5,
      "bbox_min": [
        -438.1666564941406,
        -1893.0,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        895.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 427.5,
      "bbox_min": [
        -430.0,
        -1893.0,
        893.5
      ],
      "bbox_max": [
        -423.0,
        -1886.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.0,
      "bbox_min": [
        -430.0,
        -1893.0,
        893.5
      ],
      "bbox_max": [
        -430.0,
        -1886.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -423.0,
      "bbox_min": [
        -423.0,
        -1893.0,
        893.5
      ],
      "bbox_max": [
        -423.0,
        -1886.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1890.0,
      "bbox_min": [
        -420.5,
        -1893.0,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 386.5,
      "bbox_min": [
        -386.5,
        -1890.0,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -380.0,
        -1890.0,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -380.0,
        -1890.0,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 370.0,
      "bbox_min": [
        -370.0,
        -1890.0,
        893.5
      ],
      "bbox_max": [
        -370.0,
        -1888.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -365.0,
        -1888.5283203125,
        894.0
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1063.84228515625,
      "bbox_min": [
        -420.5,
        -1893.0,
        893.5
      ],
      "bbox_max": [
        -386.5,
        -1890.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1634.4774169921875,
      "bbox_min": [
        -420.5,
        -1893.0,
        893.5
      ],
      "bbox_max": [
        -386.5,
        -1890.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 386.5,
      "bbox_min": [
        -386.5,
        -1891.0,
        893.5
      ],
      "bbox_max": [
        -386.5,
        -1890.0,
        894.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1887.0,
      "bbox_min": [
        -438.1666564941406,
        -1893.0,
        894.5
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 420.5,
      "bbox_min": [
        -431.1666564941406,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650791347026825,
        -0.7592566013336182,
        0.0
      ],
      "plane_d": -1152.11767578125,
      "bbox_min": [
        -431.1666564941406,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -423.0,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 427.5,
      "bbox_min": [
        -430.0,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -423.0,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.0,
      "bbox_min": [
        -430.0,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -430.0,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -423.0,
      "bbox_min": [
        -423.0,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -423.0,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        -416.5,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -370.0,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 370.0,
      "bbox_min": [
        -370.0,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -370.0,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 390.5,
      "bbox_min": [
        -416.5,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -416.5,
      "bbox_min": [
        -416.5,
        -1887.0,
        894.5
      ],
      "bbox_max": [
        -416.5,
        -1886.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650791347026825,
        -0.7592566013336182,
        0.0
      ],
      "plane_d": -1152.11767578125,
      "bbox_min": [
        -438.1666564941406,
        -1893.0,
        894.5
      ],
      "bbox_max": [
        -365.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 420.5,
      "bbox_min": [
        -430.0,
        -1893.0,
        894.5
      ],
      "bbox_max": [
        -365.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 427.5,
      "bbox_min": [
        -430.0,
        -1893.0,
        894.5
      ],
      "bbox_max": [
        -423.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.0,
      "bbox_min": [
        -430.0,
        -1893.0,
        894.5
      ],
      "bbox_max": [
        -430.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -423.0,
      "bbox_min": [
        -423.0,
        -1893.0,
        894.5
      ],
      "bbox_max": [
        -423.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1888.0,
      "bbox_min": [
        -380.0,
        -1888.5283203125,
        894.5
      ],
      "bbox_max": [
        -365.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 370.0,
      "bbox_min": [
        -380.0,
        -1888.0,
        894.5
      ],
      "bbox_max": [
        -365.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        -380.0,
        -1888.0,
        894.5
      ],
      "bbox_max": [
        -380.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -365.0,
        -1888.0,
        894.5
      ],
      "bbox_max": [
        -365.0,
        -1887.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -365.0,
        -1888.5283203125,
        894.5
      ],
      "bbox_max": [
        -365.0,
        -1888.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 440.5,
      "bbox_min": [
        -440.5,
        -1910.0,
        893.5
      ],
      "bbox_max": [
        -420.5,
        -1893.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650791347026825,
        -0.7592566013336182,
        0.0
      ],
      "plane_d": -1152.11767578125,
      "bbox_min": [
        -440.5,
        -1895.0,
        893.5
      ],
      "bbox_max": [
        -420.5,
        -1893.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1894.5,
      "bbox_min": [
        -430.0,
        -1894.5,
        893.5
      ],
      "bbox_max": [
        -427.5,
        -1893.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.44721364974975586,
        -0.0
      ],
      "plane_d": -1231.40283203125,
      "bbox_min": [
        -430.0,
        -1894.5,
        893.5
      ],
      "bbox_max": [
        -427.5,
        -1893.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 427.5,
      "bbox_min": [
        -430.0,
        -1893.5,
        893.5
      ],
      "bbox_max": [
        -427.5,
        -1893.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.0,
      "bbox_min": [
        -430.0,
        -1893.5,
        893.5
      ],
      "bbox_max": [
        -430.0,
        -1893.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1894.5,
      "bbox_min": [
        -423.0,
        -1894.5,
        893.5
      ],
      "bbox_max": [
        -420.5,
        -1893.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.44721364974975586,
        0.0
      ],
      "plane_d": -470.6923828125,
      "bbox_min": [
        -423.0,
        -1894.5,
        893.5
      ],
      "bbox_max": [
        -420.5,
        -1893.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.44721364974975586,
        -0.0
      ],
      "plane_d": -1225.141845703125,
      "bbox_min": [
        -423.0,
        -1894.5,
        893.5
      ],
      "bbox_max": [
        -420.5,
        -1893.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 420.5,
      "bbox_min": [
        -423.0,
        -1893.5,
        893.5
      ],
      "bbox_max": [
        -420.5,
        -1893.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -423.0,
      "bbox_min": [
        -423.0,
        -1893.5,
        893.5
      ],
      "bbox_max": [
        -423.0,
        -1893.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.987808108329773,
        -0.09407690167427063,
        0.12403467297554016
      ],
      "plane_d": 176.9586639404297,
      "bbox_min": [
        -484.5012512207031,
        -1935.8033447265625,
        895.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1856.989501953125,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.991968035697937,
        -0.024799127131700516,
        0.12403471022844315
      ],
      "plane_d": 308.7403564453125,
      "bbox_min": [
        -479.9881286621094,
        -1874.0,
        895.0
      ],
      "bbox_max": [
        -469.62359619140625,
        -1856.989501953125,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8741573691368103,
        0.4856429696083069
      ],
      "plane_d": 1204.4432373046875,
      "bbox_min": [
        -442.0,
        -1935.8033447265625,
        895.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1866.1319580078125,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1884.5,
      "bbox_min": [
        -442.0,
        -1935.8033447265625,
        895.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        953.920654296875
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -360.0,
        -1885.076904296875,
        909.8001098632812
      ],
      "bbox_max": [
        -359.6213684082031,
        -1884.5,
        913.038330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5888015031814575,
        0.7065618634223938,
        0.3925343453884125
      ],
      "plane_d": 1185.4930419921875,
      "bbox_min": [
        -360.0,
        -1885.076904296875,
        912.0
      ],
      "bbox_max": [
        -359.6213684082031,
        -1884.5,
        913.038330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 921.0,
      "bbox_min": [
        -442.0,
        -1935.8033447265625,
        895.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06320959329605103,
        0.9902623891830444,
        0.12403582036495209
      ],
      "plane_d": 1743.04296875,
      "bbox_min": [
        -441.3722229003906,
        -1933.440673828125,
        921.0
      ],
      "bbox_max": [
        -422.18267822265625,
        -1903.3736572265625,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -436.0,
        -1933.440673828125,
        921.0
      ],
      "bbox_max": [
        -430.0,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        -442.0,
        -1935.8033447265625,
        895.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        921.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -442.0,
        -1935.8033447265625,
        912.0
      ],
      "bbox_max": [
        -430.0646057128906,
        -1928.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 412.5,
      "bbox_min": [
        -412.5,
        -1921.3162841796875,
        895.0
      ],
      "bbox_max": [
        -412.5,
        -1912.0,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1886.0,
      "bbox_min": [
        -441.5740966796875,
        -1910.0,
        895.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        921.0
      ],
      "face_count": 17
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 906.0,
      "bbox_min": [
        -418.5,
        -1885.0,
        895.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        910.1367797851562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -360.0,
        -1884.8155517578125,
        906.0
      ],
      "bbox_max": [
        -359.6213684082031,
        -1884.5,
        910.1367797851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -899.0,
      "bbox_min": [
        -418.5,
        -1885.0,
        895.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9908301830291748,
        -0.0,
        -0.1351132094860077
      ],
      "plane_d": -245.68084716796875,
      "bbox_min": [
        -380.0,
        -1885.0,
        895.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        899.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -360.0,
        -1884.8155517578125,
        895.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        899.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9908301830291748,
        0.0,
        -0.1351132094860077
      ],
      "plane_d": 497.4418029785156,
      "bbox_min": [
        -380.0,
        -1885.0,
        895.0
      ],
      "bbox_max": [
        -379.4545593261719,
        -1884.5,
        899.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9908301830291748,
        0.0,
        -0.1351132094860077
      ],
      "plane_d": 497.4418029785156,
      "bbox_min": [
        -418.5,
        -1885.0,
        899.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -388.5,
      "bbox_min": [
        -418.5,
        -1885.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000000238418579,
        -0.0,
        0.800000011920929
      ],
      "plane_d": -469.29998779296875,
      "bbox_min": [
        -418.5,
        -1885.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000000238418579,
        0.0,
        -0.800000011920929
      ],
      "plane_d": 974.7000122070312,
      "bbox_min": [
        -418.5,
        -1885.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        0.800000011920929
      ],
      "plane_d": -953.5,
      "bbox_min": [
        -390.5,
        -1885.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        -0.800000011920929
      ],
      "plane_d": 490.5,
      "bbox_min": [
        -390.5,
        -1885.0,
        904.5
      ],
      "bbox_max": [
        -388.5,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9908301830291748,
        -0.0,
        -0.1351132094860077
      ],
      "plane_d": -245.68084716796875,
      "bbox_min": [
        -371.5,
        -1885.0,
        899.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -360.0,
        -1884.8155517578125,
        899.0
      ],
      "bbox_max": [
        -359.621337890625,
        -1884.5,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 906.0,
      "bbox_min": [
        -418.5,
        -1886.0,
        895.0
      ],
      "bbox_max": [
        -370.0,
        -1885.0,
        906.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -899.0,
      "bbox_min": [
        -418.5,
        -1886.0,
        895.0
      ],
      "bbox_max": [
        -370.0,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9908301830291748,
        -0.0,
        -0.1351132094860077
      ],
      "plane_d": -245.68084716796875,
      "bbox_min": [
        -380.0,
        -1886.0,
        895.0
      ],
      "bbox_max": [
        -370.0,
        -1885.0,
        899.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9908301830291748,
        0.0,
        -0.1351132094860077
      ],
      "plane_d": 497.4418029785156,
      "bbox_min": [
        -380.0,
        -1886.0,
        895.0
      ],
      "bbox_max": [
        -379.4545593261719,
        -1885.0,
        899.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9908301830291748,
        0.0,
        -0.1351132094860077
      ],
      "plane_d": 497.4418029785156,
      "bbox_min": [
        -418.5,
        -1886.0,
        899.0
      ],
      "bbox_max": [
        -370.5454406738281,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -388.5,
      "bbox_min": [
        -418.5,
        -1886.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000000238418579,
        -0.0,
        0.800000011920929
      ],
      "plane_d": -469.29998779296875,
      "bbox_min": [
        -418.5,
        -1886.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000000238418579,
        0.0,
        -0.800000011920929
      ],
      "plane_d": 974.7000122070312,
      "bbox_min": [
        -418.5,
        -1886.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        0.800000011920929
      ],
      "plane_d": -953.5,
      "bbox_min": [
        -390.5,
        -1886.0,
        899.0
      ],
      "bbox_max": [
        -388.5,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        -0.800000011920929
      ],
      "plane_d": 490.5,
      "bbox_min": [
        -390.5,
        -1886.0,
        904.5
      ],
      "bbox_max": [
        -388.5,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9908301830291748,
        -0.0,
        -0.1351132094860077
      ],
      "plane_d": -245.68084716796875,
      "bbox_min": [
        -371.5,
        -1886.0,
        899.0
      ],
      "bbox_max": [
        -370.5454406738281,
        -1885.0,
        906.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 918.5,
      "bbox_min": [
        -441.5740966796875,
        -1910.0,
        895.0
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        921.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1898.5,
      "bbox_min": [
        -441.4325866699219,
        -1910.0,
        918.5
      ],
      "bbox_max": [
        -396.0,
        -1892.65625,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1896.0,
      "bbox_min": [
        -432.734375,
        -1898.5,
        918.5
      ],
      "bbox_max": [
        -396.0,
        -1892.65625,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -919.0,
      "bbox_min": [
        -432.734375,
        -1898.5,
        918.5
      ],
      "bbox_max": [
        -396.0,
        -1896.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -429.0,
      "bbox_min": [
        -432.734375,
        -1898.5,
        918.5
      ],
      "bbox_max": [
        -396.0,
        -1896.0,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 396.0,
      "bbox_min": [
        -396.0,
        -1898.5,
        918.5
      ],
      "bbox_max": [
        -396.0,
        -1896.0,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6747682690620422,
        0.0,
        -0.7380296587944031
      ],
      "plane_d": 969.8756713867188,
      "bbox_min": [
        -432.734375,
        -1898.5,
        918.5
      ],
      "bbox_max": [
        -432.1875,
        -1896.0,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6747682690620422,
        0.0,
        -0.7380296587944031
      ],
      "plane_d": 969.8756713867188,
      "bbox_min": [
        -432.1875,
        -1898.5,
        919.0
      ],
      "bbox_max": [
        -430.0,
        -1896.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5301920771598816,
        -0.6185574531555176,
        -0.5798990726470947
      ],
      "plane_d": -410.09674072265625,
      "bbox_min": [
        -432.734375,
        -1896.0,
        918.5
      ],
      "bbox_max": [
        -430.0,
        -1892.65625,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6747682690620422,
        0.0,
        -0.7380296587944031
      ],
      "plane_d": 969.8756713867188,
      "bbox_min": [
        -432.734375,
        -1896.0,
        918.5
      ],
      "bbox_max": [
        -430.0,
        -1895.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1906.5,
      "bbox_min": [
        -441.4325866699219,
        -1910.0,
        918.5
      ],
      "bbox_max": [
        -396.0,
        -1898.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -919.0,
      "bbox_min": [
        -432.734375,
        -1910.0,
        918.5
      ],
      "bbox_max": [
        -396.0,
        -1906.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1909.0,
      "bbox_min": [
        -432.734375,
        -1910.0,
        918.5
      ],
      "bbox_max": [
        -396.0,
        -1906.5,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -429.0,
      "bbox_min": [
        -432.734375,
        -1909.0,
        918.5
      ],
      "bbox_max": [
        -396.0,
        -1906.5,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 396.0,
      "bbox_min": [
        -396.0,
        -1909.0,
        918.5
      ],
      "bbox_max": [
        -396.0,
        -1906.5,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6747682690620422,
        0.0,
        -0.7380296587944031
      ],
      "plane_d": 969.8756713867188,
      "bbox_min": [
        -432.734375,
        -1909.0,
        918.5
      ],
      "bbox_max": [
        -432.1875,
        -1906.5,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6747682690620422,
        0.0,
        -0.7380296587944031
      ],
      "plane_d": 969.8756713867188,
      "bbox_min": [
        -432.734375,
        -1910.0,
        918.5
      ],
      "bbox_max": [
        -432.1875,
        -1909.0,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6747682690620422,
        0.0,
        -0.7380296587944031
      ],
      "plane_d": 969.8756713867188,
      "bbox_min": [
        -432.1875,
        -1910.0,
        919.0
      ],
      "bbox_max": [
        -430.0,
        -1906.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6747682690620422,
        0.0,
        -0.7380296587944031
      ],
      "plane_d": 969.8756713867188,
      "bbox_min": [
        -441.4325866699219,
        -1906.5,
        918.5
      ],
      "bbox_max": [
        -430.0,
        -1898.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06320959329605103,
        0.9902623891830444,
        0.12403582036495209
      ],
      "plane_d": 1743.04296875,
      "bbox_min": [
        -441.4325866699219,
        -1903.716552734375,
        918.5
      ],
      "bbox_max": [
        -436.0,
        -1903.1668701171875,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6747682690620422,
        0.0,
        -0.7380296587944031
      ],
      "plane_d": 969.8756713867188,
      "bbox_min": [
        -441.5740966796875,
        -1910.0,
        895.0
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06320959329605103,
        0.9902623891830444,
        0.12403582036495209
      ],
      "plane_d": 1743.04296875,
      "bbox_min": [
        -441.5740966796875,
        -1903.4072265625,
        912.6388549804688
      ],
      "bbox_max": [
        -437.6666564941406,
        -1902.68212890625,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 440.5,
      "bbox_min": [
        -440.5,
        -1910.0,
        895.0
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        918.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.650791347026825,
        -0.7592566013336182,
        0.0
      ],
      "plane_d": -1152.11767578125,
      "bbox_min": [
        -440.5,
        -1895.0,
        895.0
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        918.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 420.5,
      "bbox_min": [
        -440.5,
        -1895.0,
        895.0
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 427.5,
      "bbox_min": [
        -440.5,
        -1895.0,
        895.0
      ],
      "bbox_max": [
        -420.5,
        -1886.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5301920771598816,
        -0.6185574531555176,
        -0.5798990726470947
      ],
      "plane_d": -410.09674072265625,
      "bbox_min": [
        -440.5,
        -1895.0,
        895.0
      ],
      "bbox_max": [
        -427.5,
        -1886.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -430.0,
      "bbox_min": [
        -430.0,
        -1894.5,
        895.0
      ],
      "bbox_max": [
        -427.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1894.5,
      "bbox_min": [
        -430.0,
        -1894.5,
        895.0
      ],
      "bbox_max": [
        -427.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.44721364974975586,
        0.0
      ],
      "plane_d": -464.431396484375,
      "bbox_min": [
        -430.0,
        -1894.5,
        895.0
      ],
      "bbox_max": [
        -427.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.44721364974975586,
        -0.0
      ],
      "plane_d": -1231.40283203125,
      "bbox_min": [
        -430.0,
        -1894.5,
        895.0
      ],
      "bbox_max": [
        -427.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271206855774,
        -0.0,
        0.4472135603427887
      ],
      "plane_d": -23.255126953125,
      "bbox_min": [
        -430.0,
        -1894.5,
        907.0
      ],
      "bbox_max": [
        -427.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": -790.2264404296875,
      "bbox_min": [
        -430.0,
        -1894.5,
        907.0
      ],
      "bbox_max": [
        -427.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -908.0,
      "bbox_min": [
        -430.0,
        -1894.5,
        907.0
      ],
      "bbox_max": [
        -427.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": 1281.2669677734375,
      "bbox_min": [
        -430.0,
        -1894.5,
        907.0
      ],
      "bbox_max": [
        -427.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -2100.114990234375,
      "bbox_min": [
        -430.0,
        -1894.5,
        907.0
      ],
      "bbox_max": [
        -427.5,
        -1893.3818359375,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8000162839889526,
        -0.4000081419944763,
        0.44717705249786377
      ],
      "plane_d": -820.998046875,
      "bbox_min": [
        -430.0,
        -1894.5,
        907.0
      ],
      "bbox_max": [
        -427.5,
        -1893.3818359375,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.799981415271759,
        -0.3999907076358795,
        0.4472552537918091
      ],
      "plane_d": -1507.034912109375,
      "bbox_min": [
        -430.0,
        -1894.5,
        907.0
      ],
      "bbox_max": [
        -429.1910400390625,
        -1893.3818359375,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -423.0,
      "bbox_min": [
        -423.0,
        -1894.5,
        895.0
      ],
      "bbox_max": [
        -420.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1894.5,
      "bbox_min": [
        -423.0,
        -1894.5,
        895.0
      ],
      "bbox_max": [
        -420.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.44721364974975586,
        0.0
      ],
      "plane_d": -470.6923828125,
      "bbox_min": [
        -423.0,
        -1894.5,
        895.0
      ],
      "bbox_max": [
        -420.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.44721364974975586,
        -0.0
      ],
      "plane_d": -1225.141845703125,
      "bbox_min": [
        -423.0,
        -1894.5,
        895.0
      ],
      "bbox_max": [
        -420.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271206855774,
        -0.0,
        0.4472135603427887
      ],
      "plane_d": -29.51611328125,
      "bbox_min": [
        -423.0,
        -1894.5,
        907.0
      ],
      "bbox_max": [
        -420.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": -783.9654541015625,
      "bbox_min": [
        -423.0,
        -1894.5,
        907.0
      ],
      "bbox_max": [
        -420.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -908.0,
      "bbox_min": [
        -423.0,
        -1894.5,
        907.0
      ],
      "bbox_max": [
        -420.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": 1281.2669677734375,
      "bbox_min": [
        -423.0,
        -1894.5,
        907.0
      ],
      "bbox_max": [
        -420.5,
        -1886.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -2100.114990234375,
      "bbox_min": [
        -423.0,
        -1894.5,
        907.0
      ],
      "bbox_max": [
        -420.5,
        -1893.3818359375,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8000162839889526,
        -0.4000081419944763,
        0.44717705249786377
      ],
      "plane_d": -826.59814453125,
      "bbox_min": [
        -423.0,
        -1894.5,
        907.0
      ],
      "bbox_max": [
        -420.5,
        -1893.3818359375,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.799981415271759,
        -0.3999907076358795,
        0.4472552537918091
      ],
      "plane_d": -1501.43505859375,
      "bbox_min": [
        -423.0,
        -1894.5,
        907.0
      ],
      "bbox_max": [
        -422.1910400390625,
        -1893.3818359375,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277936935425,
        0.9486833810806274
      ],
      "plane_d": -1449.11376953125,
      "bbox_min": [
        -416.5,
        -1892.11865234375,
        895.0
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        914.0969848632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1887.0,
      "bbox_min": [
        -416.5,
        -1888.5283203125,
        895.0
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        898.8331909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -898.5,
      "bbox_min": [
        -416.5,
        -1887.0,
        895.0
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        898.8331909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 390.5,
      "bbox_min": [
        -416.5,
        -1887.0,
        895.0
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        898.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -416.5,
      "bbox_min": [
        -416.5,
        -1887.0,
        895.0
      ],
      "bbox_max": [
        -416.5,
        -1886.0,
        898.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -365.0,
        -1887.0,
        895.0
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        898.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -365.0,
        -1887.0,
        898.4998779296875
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        898.8331909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 897.5,
      "bbox_min": [
        -416.5,
        -1888.5283203125,
        895.0
      ],
      "bbox_max": [
        -365.0,
        -1887.0,
        898.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1888.5,
      "bbox_min": [
        -416.5,
        -1888.5283203125,
        897.5
      ],
      "bbox_max": [
        -365.0,
        -1887.0,
        898.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 390.5,
      "bbox_min": [
        -416.5,
        -1888.5,
        897.5
      ],
      "bbox_max": [
        -365.0,
        -1887.0,
        898.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -416.5,
      "bbox_min": [
        -416.5,
        -1888.5,
        897.5
      ],
      "bbox_max": [
        -416.5,
        -1887.0,
        898.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -365.0,
        -1888.5,
        897.5
      ],
      "bbox_max": [
        -365.0,
        -1887.0,
        898.4998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -365.0,
        -1888.5283203125,
        897.5
      ],
      "bbox_max": [
        -365.0,
        -1888.5,
        897.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -365.0,
        -1888.5283203125,
        895.0
      ],
      "bbox_max": [
        -365.0,
        -1887.0,
        897.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -415.5,
        -1892.11865234375,
        897.9904174804688
      ],
      "bbox_max": [
        -365.0,
        -1886.0,
        914.0969848632812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.4345989525318146,
        0.9006240963935852
      ],
      "plane_d": -1640.487548828125,
      "bbox_min": [
        -415.5,
        -1892.11865234375,
        905.73291015625
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 401.0,
      "bbox_min": [
        -415.5,
        -1892.11865234375,
        905.73291015625
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 411.0,
      "bbox_min": [
        -415.5,
        -1892.11865234375,
        905.73291015625
      ],
      "bbox_max": [
        -401.0,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7771530747413635,
        -0.6293116211891174
      ],
      "plane_d": -898.7658081054688,
      "bbox_min": [
        -415.5,
        -1892.11865234375,
        905.73291015625
      ],
      "bbox_max": [
        -411.0,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -415.5,
      "bbox_min": [
        -415.5,
        -1892.11865234375,
        905.73291015625
      ],
      "bbox_max": [
        -411.0,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -908.4000244140625,
      "bbox_min": [
        -415.5,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -411.0,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 907.5999755859375,
      "bbox_min": [
        -415.5,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -411.0,
        -1886.0,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 412.5999755859375,
      "bbox_min": [
        -415.5,
        -1888.39990234375,
        907.5999755859375
      ],
      "bbox_max": [
        -411.0,
        -1886.0,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -415.5,
        -1888.39990234375,
        907.5999755859375
      ],
      "bbox_max": [
        -412.5999755859375,
        -1886.0,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -413.4000244140625,
      "bbox_min": [
        -413.4000244140625,
        -1888.39990234375,
        907.5999755859375
      ],
      "bbox_max": [
        -413.4000244140625,
        -1887.3140869140625,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -413.4000244140625,
      "bbox_min": [
        -413.4000244140625,
        -1888.0946044921875,
        907.5999755859375
      ],
      "bbox_max": [
        -413.4000244140625,
        -1886.0,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -412.5999755859375,
        -1888.0947265625,
        907.5999755859375
      ],
      "bbox_max": [
        -411.0,
        -1887.314208984375,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -415.5,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -411.0,
        -1888.0947265625,
        907.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.777115523815155,
        0.6293579936027527
      ],
      "plane_d": 894.4027709960938,
      "bbox_min": [
        -415.5,
        -1888.1865234375,
        908.4000244140625
      ],
      "bbox_max": [
        -411.0,
        -1886.927734375,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -415.5,
        -1887.314208984375,
        908.4000244140625
      ],
      "bbox_max": [
        -411.0,
        -1886.927734375,
        908.796142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7771530747413635,
        -0.6293116211891174
      ],
      "plane_d": -898.7658081054688,
      "bbox_min": [
        -405.5,
        -1892.11865234375,
        905.73291015625
      ],
      "bbox_max": [
        -401.0,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -405.5,
      "bbox_min": [
        -405.5,
        -1892.11865234375,
        905.73291015625
      ],
      "bbox_max": [
        -401.0,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -908.4000244140625,
      "bbox_min": [
        -405.5,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -401.0,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 907.5999755859375,
      "bbox_min": [
        -405.5,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -401.0,
        -1886.0,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 402.5999755859375,
      "bbox_min": [
        -405.5,
        -1888.39990234375,
        907.5999755859375
      ],
      "bbox_max": [
        -401.0,
        -1886.0,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -405.5,
        -1888.39990234375,
        907.5999755859375
      ],
      "bbox_max": [
        -402.5999755859375,
        -1886.0,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -403.4000244140625,
      "bbox_min": [
        -403.4000244140625,
        -1888.39990234375,
        907.5999755859375
      ],
      "bbox_max": [
        -403.4000244140625,
        -1887.3140869140625,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -403.4000244140625,
      "bbox_min": [
        -403.4000244140625,
        -1888.0946044921875,
        907.5999755859375
      ],
      "bbox_max": [
        -403.4000244140625,
        -1886.0,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -402.5999755859375,
        -1888.0947265625,
        907.5999755859375
      ],
      "bbox_max": [
        -401.0,
        -1887.314208984375,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -405.5,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -401.0,
        -1888.0947265625,
        907.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.777115523815155,
        0.6293579936027527
      ],
      "plane_d": 894.4027709960938,
      "bbox_min": [
        -405.5,
        -1888.1865234375,
        908.4000244140625
      ],
      "bbox_max": [
        -401.0,
        -1886.927734375,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -405.5,
        -1887.314208984375,
        908.4000244140625
      ],
      "bbox_max": [
        -401.0,
        -1886.927734375,
        908.796142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7771530747413635,
        -0.6293116211891174
      ],
      "plane_d": -898.7658081054688,
      "bbox_min": [
        -395.0,
        -1892.11865234375,
        905.73291015625
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 390.5,
      "bbox_min": [
        -395.0,
        -1892.11865234375,
        905.73291015625
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -395.0,
      "bbox_min": [
        -395.0,
        -1892.11865234375,
        905.73291015625
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -908.4000244140625,
      "bbox_min": [
        -395.0,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -392.800048828125,
      "bbox_min": [
        -395.0,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 907.5999755859375,
      "bbox_min": [
        -392.800048828125,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -392.800048828125,
        -1888.39990234375,
        907.5999755859375
      ],
      "bbox_max": [
        -390.5,
        -1886.0,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 392.0,
      "bbox_min": [
        -392.0,
        -1888.39990234375,
        907.5999755859375
      ],
      "bbox_max": [
        -392.0,
        -1887.3140869140625,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 392.0,
      "bbox_min": [
        -392.0,
        -1888.0946044921875,
        907.5999755859375
      ],
      "bbox_max": [
        -392.0,
        -1886.0,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -392.800048828125,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -390.5,
        -1888.0947265625,
        907.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -395.0,
        -1889.916015625,
        905.73291015625
      ],
      "bbox_max": [
        -392.800048828125,
        -1887.314208984375,
        908.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.777115523815155,
        0.6293579936027527
      ],
      "plane_d": 894.4027709960938,
      "bbox_min": [
        -395.0,
        -1888.1865234375,
        908.4000244140625
      ],
      "bbox_max": [
        -390.5,
        -1886.927734375,
        910.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 1985.289306640625,
      "bbox_min": [
        -395.0,
        -1887.314208984375,
        908.4000244140625
      ],
      "bbox_max": [
        -390.5,
        -1886.927734375,
        908.796142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06320825219154358,
        0.990262508392334,
        0.12403613328933716
      ],
      "plane_d": 1743.04345703125,
      "bbox_min": [
        -441.1549072265625,
        -1907.789306640625,
        930.0
      ],
      "bbox_max": [
        -383.2629699707031,
        -1901.134765625,
        953.920654296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.06320825219154358,
        0.990262508392334,
        0.12403613328933716
      ],
      "plane_d": 1743.04345703125,
      "bbox_min": [
        -440.5773620605469,
        -1910.3970947265625,
        921.3309936523438
      ],
      "bbox_max": [
        -364.2569274902344,
        -1866.1319580078125,
        975.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.24455657601356506,
        -0.8004148006439209,
        -0.5472918748855591
      ],
      "plane_d": -1092.8800048828125,
      "bbox_min": [
        -433.007080078125,
        -1884.9921875,
        921.3309936523438
      ],
      "bbox_max": [
        -364.2569274902344,
        -1866.1319580078125,
        942.136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6295140981674194,
        -0.6511096954345703,
        -0.4239906668663025
      ],
      "plane_d": -1088.3922119140625,
      "bbox_min": [
        -433.007080078125,
        -1884.9921875,
        921.3309936523438
      ],
      "bbox_max": [
        -364.2569274902344,
        -1866.1319580078125,
        942.136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05644569545984268,
        -0.7562670707702637,
        -0.6518236398696899
      ],
      "plane_d": -837.777099609375,
      "bbox_min": [
        -433.007080078125,
        -1884.9921875,
        921.3309936523438
      ],
      "bbox_max": [
        -364.2569274902344,
        -1866.1319580078125,
        942.136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300138592720032,
        1.3651326298713684e-05,
        -0.8479889631271362
      ],
      "plane_d": 597.7864990234375,
      "bbox_min": [
        -433.007080078125,
        -1884.9921875,
        923.8720703125
      ],
      "bbox_max": [
        -364.2569274902344,
        -1866.1319580078125,
        942.136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472556471824646,
        -0.03996013477444649,
        -0.5296801328659058
      ],
      "plane_d": 728.06982421875,
      "bbox_min": [
        -364.9289245605469,
        -1884.9921875,
        932.89599609375
      ],
      "bbox_max": [
        -364.2569274902344,
        -1879.5311279296875,
        933.8118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7677624821662903,
        -0.48038429021835327,
        -0.42399489879608154
      ],
      "plane_d": -829.48046875,
      "bbox_min": [
        -433.007080078125,
        -1875.2379150390625,
        923.8720703125
      ],
      "bbox_max": [
        -386.78643798828125,
        -1866.1319580078125,
        942.136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08989904820919037,
        -0.6377612948417664,
        -0.7649697661399841
      ],
      "plane_d": -454.40386962890625,
      "bbox_min": [
        -386.8975524902344,
        -1875.2379150390625,
        923.8720703125
      ],
      "bbox_max": [
        -386.78643798828125,
        -1875.18408203125,
        923.96484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8443467020988464,
        -0.3719113767147064,
        0.38569480180740356
      ],
      "plane_d": -727.1732177734375,
      "bbox_min": [
        -386.8122863769531,
        -1875.2379150390625,
        923.9033203125
      ],
      "bbox_max": [
        -386.78643798828125,
        -1875.2008056640625,
        923.96484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300138592720032,
        1.3651326298713684e-05,
        -0.8479889631271362
      ],
      "plane_d": 597.7864990234375,
      "bbox_min": [
        -365.50933837890625,
        -1884.9921875,
        933.0054321289062
      ],
      "bbox_max": [
        -364.7384338378906,
        -1884.6959228515625,
        933.3682250976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8472556471824646,
        -0.03996013477444649,
        -0.5296801328659058
      ],
      "plane_d": 728.06982421875,
      "bbox_min": [
        -364.93896484375,
        -1884.9921875,
        933.0054321289062
      ],
      "bbox_max": [
        -364.7384338378906,
        -1884.6959228515625,
        933.3326416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.970703125,
        -1937.517578125,
        872.4360961914062
      ],
      "bbox_max": [
        -354.0003356933594,
        -1881.4857177734375,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -893.5,
      "bbox_min": [
        -433.48736572265625,
        -1935.858642578125,
        872.4360961914062
      ],
      "bbox_max": [
        -354.0003356933594,
        -1881.4857177734375,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -433.4872741699219,
        -1935.832763671875,
        872.4360961914062
      ],
      "bbox_max": [
        -359.18780517578125,
        -1884.8155517578125,
        893.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1912.0,
      "bbox_min": [
        -412.5,
        -1921.539794921875,
        892.0
      ],
      "bbox_max": [
        -359.18780517578125,
        -1884.8155517578125,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -359.621337890625,
        -1885.1767578125,
        892.0023193359375
      ],
      "bbox_max": [
        -359.18780517578125,
        -1884.8155517578125,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 412.5,
      "bbox_min": [
        -412.5,
        -1921.539794921875,
        892.0
      ],
      "bbox_max": [
        -412.5,
        -1921.3162841796875,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 921.0,
      "bbox_min": [
        -433.48736572265625,
        -1935.858642578125,
        893.5
      ],
      "bbox_max": [
        -354.0003356933594,
        -1881.4857177734375,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -430.0646057128906,
        -1933.5,
        921.0
      ],
      "bbox_max": [
        -365.4277038574219,
        -1889.5,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -430.0646057128906,
        -1933.5,
        921.0
      ],
      "bbox_max": [
        -430.0,
        -1933.3961181640625,
        921.1698608398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -433.48736572265625,
        -1935.858642578125,
        893.5
      ],
      "bbox_max": [
        -354.0003356933594,
        -1881.4857177734375,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -433.48736572265625,
        -1935.858642578125,
        893.5
      ],
      "bbox_max": [
        -359.15802001953125,
        -1884.8155517578125,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 904.0,
      "bbox_min": [
        -433.48736572265625,
        -1935.858642578125,
        893.5
      ],
      "bbox_max": [
        -359.15802001953125,
        -1884.8155517578125,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7295363545417786,
        -0.6839420795440674
      ],
      "plane_d": -752.5606689453125,
      "bbox_min": [
        -433.48736572265625,
        -1935.858642578125,
        904.0
      ],
      "bbox_max": [
        -359.15802001953125,
        -1884.8155517578125,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8741573691368103,
        0.4856429696083069
      ],
      "plane_d": 1204.4432373046875,
      "bbox_min": [
        -366.4078674316406,
        -1889.5,
        912.0
      ],
      "bbox_max": [
        -359.15802001953125,
        -1884.8155517578125,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5888015031814575,
        0.7065618634223938,
        0.3925343453884125
      ],
      "plane_d": 1185.4930419921875,
      "bbox_min": [
        -360.0,
        -1885.7816162109375,
        912.0
      ],
      "bbox_max": [
        -359.15802001953125,
        -1884.8155517578125,
        914.3068237304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -433.48736572265625,
        -1935.858642578125,
        904.0
      ],
      "bbox_max": [
        -365.0,
        -1888.5283203125,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        -430.0,
        -1933.5428466796875,
        904.0
      ],
      "bbox_max": [
        -365.0,
        -1888.5283203125,
        921.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -430.0,
        -1933.5428466796875,
        920.9298095703125
      ],
      "bbox_max": [
        -429.9368591308594,
        -1933.5,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -365.0,
        -1889.1932373046875,
        904.0
      ],
      "bbox_max": [
        -365.0,
        -1888.5283203125,
        914.8060913085938
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        -412.5,
        -1921.5653076171875,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1888.5283203125,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1912.0,
      "bbox_min": [
        -412.5,
        -1921.5653076171875,
        893.5
      ],
      "bbox_max": [
        -398.4761657714844,
        -1912.0,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 412.5,
      "bbox_min": [
        -412.5,
        -1921.5653076171875,
        893.5
      ],
      "bbox_max": [
        -412.5,
        -1921.3162841796875,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -365.0,
        -1889.1668701171875,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1888.5283203125,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        -359.621337890625,
        -1885.1788330078125,
        895.0
      ],
      "bbox_max": [
        -354.0003356933594,
        -1881.4857177734375,
        895.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.06320825219154358,
        0.990262508392334,
        0.12403613328933716
      ],
      "plane_d": 1743.04345703125,
      "bbox_min": [
        -392.2603759765625,
        -1907.345458984375,
        930.0
      ],
      "bbox_max": [
        -382.3698425292969,
        -1901.0777587890625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.160947784781456,
        -0.9869629144668579,
        0.0
      ],
      "plane_d": -1824.285400390625,
      "bbox_min": [
        -597.4422607421875,
        -2217.946533203125,
        741.6661376953125
      ],
      "bbox_max": [
        63.3701171875,
        -1881.6422119140625,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -401.16046142578125,
        -1913.8016357421875,
        766.0
      ],
      "bbox_max": [
        -325.4910888671875,
        -1881.6422119140625,
        975.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.06320825219154358,
        0.990262508392334,
        0.12403613328933716
      ],
      "plane_d": 1743.04345703125,
      "bbox_min": [
        -401.16046142578125,
        -1913.8016357421875,
        892.0
      ],
      "bbox_max": [
        -348.0,
        -1881.6422119140625,
        975.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320502638816833,
        -0.0,
        0.5547001957893372
      ],
      "plane_d": -216.33306884765625,
      "bbox_min": [
        -401.16046142578125,
        -1913.8016357421875,
        892.0
      ],
      "bbox_max": [
        -348.0,
        -1894.151123046875,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 921.0,
      "bbox_min": [
        -401.16046142578125,
        -1913.8016357421875,
        892.0
      ],
      "bbox_max": [
        -348.0,
        -1894.151123046875,
        921.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1912.0,
      "bbox_min": [
        -398.51904296875,
        -1913.1578369140625,
        892.0
      ],
      "bbox_max": [
        -348.0,
        -1894.151123046875,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -396.4999694824219,
      "bbox_min": [
        -396.5,
        -1913.0416259765625,
        892.0
      ],
      "bbox_max": [
        -396.5,
        -1912.0,
        893.0416259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        -401.104248046875,
        -1913.7926025390625,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1894.3253173828125,
        921.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 390.5,
      "bbox_min": [
        -401.104248046875,
        -1913.7926025390625,
        893.5
      ],
      "bbox_max": [
        -383.0,
        -1910.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1911.0,
      "bbox_min": [
        -401.104248046875,
        -1913.7926025390625,
        893.5
      ],
      "bbox_max": [
        -390.5,
        -1910.0,
        921.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 395.0,
      "bbox_min": [
        -395.0,
        -1911.0,
        893.5
      ],
      "bbox_max": [
        -390.5,
        -1910.0,
        921.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 392.0,
      "bbox_min": [
        -392.0,
        -1911.0,
        893.5
      ],
      "bbox_max": [
        -390.5,
        -1910.0,
        903.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8865849375724792,
        0.0,
        0.4625660479068756
      ],
      "plane_d": -67.09133911132812,
      "bbox_min": [
        -392.0,
        -1911.0,
        893.5
      ],
      "bbox_max": [
        -390.5,
        -1910.0,
        903.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8865849375724792,
        0.0,
        -0.4625660479068756
      ],
      "plane_d": 764.1976318359375,
      "bbox_min": [
        -392.0,
        -1911.0,
        900.75
      ],
      "bbox_max": [
        -390.5,
        -1910.0,
        903.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 395.0,
      "bbox_min": [
        -401.104248046875,
        -1913.7926025390625,
        893.5
      ],
      "bbox_max": [
        -395.0,
        -1911.0,
        921.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1912.0,
      "bbox_min": [
        -401.104248046875,
        -1913.7926025390625,
        893.5
      ],
      "bbox_max": [
        -396.5,
        -1912.0,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -398.4000244140625,
      "bbox_min": [
        -398.4000244140625,
        -1913.3514404296875,
        893.5
      ],
      "bbox_max": [
        -396.5,
        -1912.0,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9032753705978394,
        0.0,
        -0.42906132340431213
      ],
      "plane_d": 24.574005126953125,
      "bbox_min": [
        -398.4000244140625,
        -1913.3514404296875,
        893.5
      ],
      "bbox_max": [
        -396.5,
        -1912.0,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -396.5,
      "bbox_min": [
        -396.5,
        -1913.0416259765625,
        902.6111450195312
      ],
      "bbox_max": [
        -396.5,
        -1912.0,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 904.0,
      "bbox_min": [
        -401.104248046875,
        -1913.7926025390625,
        904.0
      ],
      "bbox_max": [
        -396.5,
        -1912.0,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1911.0,
      "bbox_min": [
        -384.5,
        -1911.0,
        893.5
      ],
      "bbox_max": [
        -383.0,
        -1910.0,
        921.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -384.5,
      "bbox_min": [
        -384.5,
        -1911.0,
        893.5
      ],
      "bbox_max": [
        -383.0,
        -1910.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -383.0,
      "bbox_min": [
        -384.5,
        -1911.0,
        893.5
      ],
      "bbox_max": [
        -383.0,
        -1910.0,
        903.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8865849375724792,
        0.0,
        -0.4625660479068756
      ],
      "plane_d": 77.09432983398438,
      "bbox_min": [
        -384.5,
        -1911.0,
        893.5
      ],
      "bbox_max": [
        -383.0,
        -1910.0,
        903.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8865849375724792,
        0.0,
        0.4625660479068756
      ],
      "plane_d": -754.1947021484375,
      "bbox_min": [
        -384.5,
        -1911.0,
        893.5
      ],
      "bbox_max": [
        -383.0,
        -1910.0,
        896.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9983712434768677,
        -0.05704978480935097
      ],
      "plane_d": 1957.4351806640625,
      "bbox_min": [
        -381.5,
        -1910.0,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1894.3253173828125,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9899495244026184,
        -0.0,
        -0.1414213627576828
      ],
      "plane_d": -247.41665649414062,
      "bbox_min": [
        -381.5,
        -1910.0,
        903.5
      ],
      "bbox_max": [
        -368.5,
        -1908.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9899495244026184,
        0.0,
        -0.1414213627576828
      ],
      "plane_d": 495.04547119140625,
      "bbox_min": [
        -379.0,
        -1910.0,
        903.5
      ],
      "bbox_max": [
        -368.5,
        -1908.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 903.5,
      "bbox_min": [
        -379.0,
        -1910.0,
        903.5
      ],
      "bbox_max": [
        -371.7152099609375,
        -1909.0,
        903.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -365.0,
        -1907.9049072265625,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1894.3253173828125,
        921.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -348.2095642089844,
        -1894.5,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1894.3253173828125,
        895.0009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401843428611755,
        0.7682213187217712,
        -0.0
      ],
      "plane_d": 1678.179443359375,
      "bbox_min": [
        -382.3697814941406,
        -1901.07763671875,
        892.0023193359375
      ],
      "bbox_max": [
        -348.0,
        -1881.6422119140625,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5888015031814575,
        0.7065618634223938,
        0.3925343453884125
      ],
      "plane_d": 1185.4930419921875,
      "bbox_min": [
        -382.3697814941406,
        -1901.07763671875,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1885.20166015625,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        -0.0,
        0.5547001957893372
      ],
      "plane_d": -216.33306884765625,
      "bbox_min": [
        -382.3697814941406,
        -1901.07763671875,
        893.5
      ],
      "bbox_max": [
        -348.0,
        -1885.7816162109375,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8741573691368103,
        0.4856429696083069
      ],
      "plane_d": 1204.4432373046875,
      "bbox_min": [
        -382.3697814941406,
        -1901.07763671875,
        893.5
      ],
      "bbox_max": [
        -360.0,
        -1885.7816162109375,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        -382.3697814941406,
        -1901.07763671875,
        893.5
      ],
      "bbox_max": [
        -360.0,
        -1889.1412353515625,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 921.0,
      "bbox_min": [
        -380.58184814453125,
        -1899.8363037109375,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1889.1412353515625,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -375.118896484375,
        -1898.8416748046875,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1889.1412353515625,
        921.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.7295363545417786,
        -0.6839420795440674
      ],
      "plane_d": -752.5606689453125,
      "bbox_min": [
        -375.118896484375,
        -1896.0430908203125,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1889.1412353515625,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -893.5,
      "bbox_min": [
        -375.118896484375,
        -1896.0430908203125,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1889.1412353515625,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        -359.1853332519531,
        -1894.5,
        895.0
      ],
      "bbox_max": [
        -348.0,
        -1881.6422119140625,
        895.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9128968119621277,
        0.3866746425628662,
        0.13077570497989655
      ],
      "plane_d": 297.8227844238281,
      "bbox_min": [
        -348.0,
        -1904.5203857421875,
        895.0
      ],
      "bbox_max": [
        -325.4910888671875,
        -1882.8201904296875,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        -348.0,
        -1894.5,
        895.0
      ],
      "bbox_max": [
        -325.4910888671875,
        -1883.7169189453125,
        910.3347778320312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9085974097251892,
        0.4001162648200989,
        0.11982358247041702
      ],
      "plane_d": 334.5862731933594,
      "bbox_min": [
        -348.0,
        -1894.5,
        895.0
      ],
      "bbox_max": [
        -341.4044494628906,
        -1883.7496337890625,
        910.3347778320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06317062675952911,
        0.990265429019928,
        0.12403205037117004
      ],
      "plane_d": 1743.0657958984375,
      "bbox_min": [
        -348.0,
        -1904.5203857421875,
        895.0
      ],
      "bbox_max": [
        -340.66888427734375,
        -1882.8201904296875,
        975.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        -348.0,
        -1894.5,
        895.0
      ],
      "bbox_max": [
        -343.4325866699219,
        -1882.8201904296875,
        895.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5015454292297363,
        -0.8651313185691833,
        0.0
      ],
      "plane_d": -1457.548095703125,
      "bbox_min": [
        -597.4422607421875,
        -2217.946533203125,
        741.6661376953125
      ],
      "bbox_max": [
        63.3701171875,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -433.6276550292969,
        -1935.9715576171875,
        780.2833251953125
      ],
      "bbox_max": [
        -392.67535400390625,
        -1912.41796875,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        -433.427001953125,
        -1935.9715576171875,
        892.0
      ],
      "bbox_max": [
        -392.67535400390625,
        -1912.41796875,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -433.427001953125,
        -1935.9715576171875,
        892.0
      ],
      "bbox_max": [
        -392.6755676269531,
        -1912.4180908203125,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 395.0,
      "bbox_min": [
        -433.427001953125,
        -1935.9715576171875,
        904.0
      ],
      "bbox_max": [
        -392.6755676269531,
        -1912.4180908203125,
        921.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -433.427001953125,
        -1935.9715576171875,
        912.0
      ],
      "bbox_max": [
        -430.0,
        -1933.5428466796875,
        920.9298095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 921.0,
      "bbox_min": [
        -395.0,
        -1913.765625,
        921.0
      ],
      "bbox_max": [
        -392.6755676269531,
        -1912.4180908203125,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 412.5,
      "bbox_min": [
        -412.5,
        -1923.910888671875,
        892.0
      ],
      "bbox_max": [
        -392.6755676269531,
        -1912.4180908203125,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 395.0,
      "bbox_min": [
        -398.4000244140625,
        -1914.63525390625,
        892.0
      ],
      "bbox_max": [
        -392.6755676269531,
        -1912.4180908203125,
        904.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9032753705978394,
        0.0,
        -0.42906132340431213
      ],
      "plane_d": 24.574005126953125,
      "bbox_min": [
        -398.4000244140625,
        -1914.63525390625,
        892.0
      ],
      "bbox_max": [
        -395.0,
        -1913.0416259765625,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9032753705978394,
        0.0,
        0.42906132340431213
      ],
      "plane_d": -746.0201416015625,
      "bbox_min": [
        -398.4000244140625,
        -1914.63525390625,
        892.0
      ],
      "bbox_max": [
        -395.0,
        -1913.0416259765625,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -398.4000244140625,
      "bbox_min": [
        -398.4000244140625,
        -1914.63525390625,
        892.0
      ],
      "bbox_max": [
        -395.0,
        -1913.0416259765625,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -396.5,
      "bbox_min": [
        -398.4000244140625,
        -1914.63525390625,
        892.0
      ],
      "bbox_max": [
        -395.0,
        -1913.0416259765625,
        904.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1913.5,
      "bbox_min": [
        -396.5,
        -1914.6351318359375,
        893.5
      ],
      "bbox_max": [
        -395.0,
        -1913.5,
        902.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -893.5,
      "bbox_min": [
        -396.5,
        -1914.6351318359375,
        893.5
      ],
      "bbox_max": [
        -395.0,
        -1913.5,
        902.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 902.0,
      "bbox_min": [
        -396.5,
        -1914.6351318359375,
        902.0
      ],
      "bbox_max": [
        -395.0,
        -1913.5,
        902.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1913.5,
      "bbox_min": [
        -398.4000244140625,
        -1913.5,
        892.0
      ],
      "bbox_max": [
        -396.5,
        -1913.5,
        904.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -893.5,
      "bbox_min": [
        -395.0,
        -1913.765625,
        893.5
      ],
      "bbox_max": [
        -392.6755676269531,
        -1912.4180908203125,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.05517389252781868,
        0.9984767436981201
      ],
      "plane_d": -743.320556640625,
      "bbox_min": [
        -597.4422607421875,
        -2217.946533203125,
        741.6661376953125
      ],
      "bbox_max": [
        63.3701171875,
        -1895.00830078125,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -597.4422607421875,
        -2186.925537109375,
        741.6661376953125
      ],
      "bbox_max": [
        -122.45878601074219,
        -1901.3677978515625,
        865.2998046875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -271.6905212402344,
        -2186.925537109375,
        848.1939697265625
      ],
      "bbox_max": [
        -128.8770751953125,
        -2181.5,
        865.2998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739686846733093,
        0.19277054071426392,
        0.11926654726266861
      ],
      "plane_d": 54.74974822998047,
      "bbox_min": [
        -271.16510009765625,
        -2186.925537109375,
        857.0
      ],
      "bbox_max": [
        -268.0,
        -2181.5,
        865.2998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8179989457130432,
        0.18297025561332703,
        0.5453435182571411
      ],
      "plane_d": -291.79620361328125,
      "bbox_min": [
        -270.8542175292969,
        -2186.925537109375,
        862.0
      ],
      "bbox_max": [
        -268.0,
        -2181.5,
        865.2998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739686846733093,
        0.19277054071426392,
        0.11926654726266861
      ],
      "plane_d": 54.74974822998047,
      "bbox_min": [
        -271.6905212402344,
        -2184.293701171875,
        848.1939697265625
      ],
      "bbox_max": [
        -128.8770751953125,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 432.67938232421875,
      "bbox_min": [
        -131.5,
        -2183.931396484375,
        854.5
      ],
      "bbox_max": [
        -129.5,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06079954281449318,
        -0.8831871151924133,
        0.4650632441043854
      ],
      "plane_d": -2091.9970703125,
      "bbox_min": [
        -597.4422607421875,
        -2181.5,
        741.6661376953125
      ],
      "bbox_max": [
        -134.0,
        -1901.3677978515625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -359.5250549316406,
        -1956.10107421875,
        741.6661376953125
      ],
      "bbox_max": [
        -150.88082885742188,
        -1901.3677978515625,
        849.5562744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -359.5250549316406,
        -1948.689453125,
        757.1981201171875
      ],
      "bbox_max": [
        -170.0,
        -1905.1326904296875,
        834.8331909179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -359.5250549316406,
        -1938.564697265625,
        767.0492553710938
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        791.4063720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -300.0,
        -1948.689453125,
        757.1981201171875
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        770.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -300.0,
        -1948.689453125,
        757.1981201171875
      ],
      "bbox_max": [
        -286.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -300.0,
        -1945.2093505859375,
        765.0
      ],
      "bbox_max": [
        -300.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -247.49774169921875,
        -1946.7664794921875,
        770.0
      ],
      "bbox_max": [
        -224.73558044433594,
        -1945.6300048828125,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -239.13368225097656,
        -1951.5257568359375,
        768.1051025390625
      ],
      "bbox_max": [
        -150.88082885742188,
        -1905.971923828125,
        840.3576049804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -239.13368225097656,
        -1951.5257568359375,
        770.0
      ],
      "bbox_max": [
        -170.0,
        -1941.3095703125,
        770.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -597.4422607421875,
        -2181.5,
        749.8746337890625
      ],
      "bbox_max": [
        -134.0,
        -1901.391845703125,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -433.3038330078125,
        -1959.678955078125,
        769.8370361328125
      ],
      "bbox_max": [
        -348.0,
        -1905.1326904296875,
        850.236572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -430.0,
        -1958.4722900390625,
        769.8370361328125
      ],
      "bbox_max": [
        -348.0,
        -1905.1326904296875,
        850.236572265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -360.0,
        -1939.0,
        769.8370361328125
      ],
      "bbox_max": [
        -348.0,
        -1905.1326904296875,
        850.236572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -360.0,
        -1939.0,
        769.8370361328125
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        818.5172119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1958.4722900390625,
        771.2595825195312
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        832.4522705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -417.9999694824219,
        -1958.4722900390625,
        771.2595825195312
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        804.5499267578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1950.0,
        771.2595825195312
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        804.1194458007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -414.0,
        -1958.4722900390625,
        778.9569702148438
      ],
      "bbox_max": [
        -371.6431579589844,
        -1950.0,
        802.4315795898438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -414.0,
        -1953.6666259765625,
        778.9569702148438
      ],
      "bbox_max": [
        -414.0,
        -1950.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -414.0,
        -1957.127685546875,
        780.0
      ],
      "bbox_max": [
        -388.1759033203125,
        -1950.0,
        802.4315795898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 412.0,
      "bbox_min": [
        -412.0,
        -1957.127685546875,
        780.0
      ],
      "bbox_max": [
        -388.1759033203125,
        -1950.0,
        801.372314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45812103152275085,
        0.0,
        0.8888899087905884
      ],
      "plane_d": -878.9483642578125,
      "bbox_min": [
        -404.0,
        -1957.127685546875,
        780.5999755859375
      ],
      "bbox_max": [
        -388.1759033203125,
        -1950.0,
        788.7554931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1959.678955078125,
        779.3433837890625
      ],
      "bbox_max": [
        -408.7575378417969,
        -1945.875,
        816.502685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1959.678955078125,
        779.3433837890625
      ],
      "bbox_max": [
        -408.7575378417969,
        -1950.0,
        806.9330444335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -414.0,
        -1959.678955078125,
        779.3433837890625
      ],
      "bbox_max": [
        -408.7575378417969,
        -1953.6666259765625,
        793.9251708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 412.0,
      "bbox_min": [
        -412.0,
        -1959.21240234375,
        780.0
      ],
      "bbox_max": [
        -408.7575378417969,
        -1955.5,
        788.612548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -412.0,
        -1959.21240234375,
        780.0
      ],
      "bbox_max": [
        -408.7575378417969,
        -1955.5,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4577594995498657,
        -0.8173955082893372,
        0.3497438430786133
      ],
      "plane_d": -1698.0321044921875,
      "bbox_min": [
        -597.4422607421875,
        -2181.5,
        749.8746337890625
      ],
      "bbox_max": [
        -134.0,
        -1914.3275146484375,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -597.4422607421875,
        -2061.258056640625,
        778.6002197265625
      ],
      "bbox_max": [
        -366.13958740234375,
        -1922.1614990234375,
        855.94482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.476491779088974,
        -0.7905871868133545,
        0.3846135139465332
      ],
      "plane_d": -1664.8924560546875,
      "bbox_min": [
        -505.3973388671875,
        -1994.70654296875,
        778.6002197265625
      ],
      "bbox_max": [
        -366.13958740234375,
        -1922.1614990234375,
        854.6781616210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47970375418663025,
        -0.768060028553009,
        0.42422646284103394
      ],
      "plane_d": -1652.64599609375,
      "bbox_min": [
        -475.3267822265625,
        -1977.0572509765625,
        779.9769287109375
      ],
      "bbox_max": [
        -371.0,
        -1922.1614990234375,
        853.7029418945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -433.3038330078125,
        -1972.0,
        779.9769287109375
      ],
      "bbox_max": [
        -371.0,
        -1935.971435546875,
        851.933837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        830.8653564453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 412.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        830.8653564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        780.9847412109375
      ],
      "bbox_max": [
        -412.0,
        -1972.0,
        788.1215209960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -412.0,
        -1972.0,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        811.9246215820312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -1959.9998779296875,
      "bbox_min": [
        -405.16424560546875,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        786.4166870117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -371.0,
      "bbox_min": [
        -371.0,
        -1950.0345458984375,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        780.0711059570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1970.0,
      "bbox_min": [
        -405.16424560546875,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -404.22381591796875,
        -1970.0,
        780.3477783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.4000244140625,
      "bbox_min": [
        -412.0,
        -1972.0,
        780.0
      ],
      "bbox_max": [
        -396.3739318847656,
        -1950.0,
        811.9246215820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        0.0,
        -0.8804711103439331
      ],
      "plane_d": 902.4287109375,
      "bbox_min": [
        -412.0,
        -1961.123779296875,
        807.4000244140625
      ],
      "bbox_max": [
        -396.3739318847656,
        -1950.0,
        811.9246215820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -808.0,
      "bbox_min": [
        -412.0,
        -1961.123779296875,
        808.0
      ],
      "bbox_max": [
        -396.7113952636719,
        -1950.0,
        811.9246215820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4740998446941376,
        0.0,
        0.8804711103439331
      ],
      "plane_d": -902.9569702148438,
      "bbox_min": [
        -404.0,
        -1956.30224609375,
        808.0
      ],
      "bbox_max": [
        -396.7113952636719,
        -1950.0,
        811.9246215820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1970.0,
      "bbox_min": [
        -412.0,
        -1972.0,
        780.0
      ],
      "bbox_max": [
        -404.489501953125,
        -1970.0,
        789.7544555664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -412.0,
        -1972.0,
        780.4204711914062
      ],
      "bbox_max": [
        -408.1161193847656,
        -1972.0,
        785.5038452148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -433.3038330078125,
        -1950.0,
        802.4315795898438
      ],
      "bbox_max": [
        -414.0,
        -1935.971435546875,
        851.933837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1950.0,
        802.4315795898438
      ],
      "bbox_max": [
        -414.0,
        -1950.0,
        842.955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -433.3038330078125,
        -1939.0,
        832.4522094726562
      ],
      "bbox_max": [
        -422.5,
        -1935.971435546875,
        851.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -433.3038330078125,
        -1939.0,
        836.4241943359375
      ],
      "bbox_max": [
        -430.0,
        -1935.971435546875,
        851.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703570008277893,
        -0.7688688039779663,
        0.433133989572525
      ],
      "plane_d": -1666.133544921875,
      "bbox_min": [
        -422.6108093261719,
        -1950.0,
        833.3430786132812
      ],
      "bbox_max": [
        -379.3594055175781,
        -1922.1614990234375,
        851.9896850585938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.39795103669166565,
        -0.8249620795249939,
        0.40133827924728394
      ],
      "plane_d": -1778.376953125,
      "bbox_min": [
        -422.6108093261719,
        -1950.0,
        833.3430786132812
      ],
      "bbox_max": [
        -414.0,
        -1943.3056640625,
        851.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1950.0,
        842.955078125
      ],
      "bbox_max": [
        -422.5,
        -1945.0556640625,
        851.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1949.548828125,
        844.8010864257812
      ],
      "bbox_max": [
        -422.5,
        -1945.515869140625,
        851.9896850585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -422.5,
        -1972.0,
        778.6002197265625
      ],
      "bbox_max": [
        -366.13958740234375,
        -1926.01708984375,
        852.1721801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39795103669166565,
        -0.8249620795249939,
        0.40133827924728394
      ],
      "plane_d": -1778.376953125,
      "bbox_min": [
        -414.000732421875,
        -1950.0,
        831.3602905273438
      ],
      "bbox_max": [
        -412.0,
        -1943.821044921875,
        843.8018188476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703570008277893,
        -0.7688688039779663,
        0.433133989572525
      ],
      "plane_d": -1666.133544921875,
      "bbox_min": [
        -414.000732421875,
        -1945.5858154296875,
        840.4337158203125
      ],
      "bbox_max": [
        -412.0,
        -1943.821044921875,
        843.8018188476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -412.0,
        -1970.0,
        778.6002197265625
      ],
      "bbox_max": [
        -366.13958740234375,
        -1926.01708984375,
        843.5662841796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        778.6002197265625
      ],
      "bbox_max": [
        -366.6461181640625,
        -1939.0,
        840.4337158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1950.787353515625,
        778.6002197265625
      ],
      "bbox_max": [
        -369.0,
        -1949.3966064453125,
        780.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -366.6461181640625,
        -1939.0,
        840.4337158203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.39795103669166565,
        -0.8249620795249939,
        0.40133827924728394
      ],
      "plane_d": -1778.376953125,
      "bbox_min": [
        -412.0,
        -1950.0,
        818.3564453125
      ],
      "bbox_max": [
        -398.885498046875,
        -1945.5858154296875,
        840.4337158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1939.0,
        802.8728637695312
      ],
      "bbox_max": [
        -366.6461181640625,
        -1939.0,
        805.4290161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45812103152275085,
        0.0,
        0.8888899087905884
      ],
      "plane_d": -878.9483642578125,
      "bbox_min": [
        -412.0,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -369.0,
        -1950.0,
        813.2741088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -371.0,
      "bbox_min": [
        -392.7138366699219,
        -1960.0,
        780.0
      ],
      "bbox_max": [
        -369.0,
        -1950.0,
        786.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1950.2738037109375,
        780.0
      ],
      "bbox_max": [
        -369.0,
        -1950.0,
        780.6400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -1959.9998779296875,
      "bbox_min": [
        -392.7138366699219,
        -1960.0,
        785.992919921875
      ],
      "bbox_max": [
        -391.3489685058594,
        -1960.0,
        786.9506225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        0.0,
        -0.8804711103439331
      ],
      "plane_d": 902.4287109375,
      "bbox_min": [
        -412.0,
        -1970.0,
        782.2611083984375
      ],
      "bbox_max": [
        -393.8358459472656,
        -1950.0,
        813.2741088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.4000244140625,
      "bbox_min": [
        -412.0,
        -1962.631103515625,
        807.4000244140625
      ],
      "bbox_max": [
        -404.0,
        -1956.593994140625,
        807.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4740998446941376,
        0.0,
        0.8804711103439331
      ],
      "plane_d": -902.9569702148438,
      "bbox_min": [
        -404.0,
        -1957.8941650390625,
        808.0
      ],
      "bbox_max": [
        -394.2052307128906,
        -1950.0,
        813.2741088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1970.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        782.2611083984375
      ],
      "bbox_max": [
        -405.95135498046875,
        -1970.0,
        790.1778564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -412.0,
        -1951.1171875,
        802.5252075195312
      ],
      "bbox_max": [
        -366.13958740234375,
        -1939.0,
        836.92041015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1940.6358642578125,
        802.5252075195312
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        806.3483276367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4740998446941376,
        0.0,
        0.8804711103439331
      ],
      "plane_d": -902.9569702148438,
      "bbox_min": [
        -412.0,
        -1951.1171875,
        812.3677978515625
      ],
      "bbox_max": [
        -393.6878662109375,
        -1950.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        0.0,
        -0.8804711103439331
      ],
      "plane_d": 902.4287109375,
      "bbox_min": [
        -394.7740783691406,
        -1950.8585205078125,
        812.3677978515625
      ],
      "bbox_max": [
        -393.6878662109375,
        -1950.0,
        812.9526977539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 835.4000244140625,
      "bbox_min": [
        -412.0,
        -1950.6505126953125,
        835.4000244140625
      ],
      "bbox_max": [
        -410.8384094238281,
        -1950.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -836.0,
      "bbox_min": [
        -412.0,
        -1950.393798828125,
        836.0
      ],
      "bbox_max": [
        -411.29681396484375,
        -1950.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1950.0,
        833.3430786132812
      ],
      "bbox_max": [
        -414.0,
        -1946.0516357421875,
        852.1721801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1950.0,
        843.8735961914062
      ],
      "bbox_max": [
        -422.5,
        -1946.0516357421875,
        852.1721801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -422.5,
        -2181.5,
        749.8746337890625
      ],
      "bbox_max": [
        -134.0,
        -1914.3275146484375,
        863.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2032.0,
      "bbox_min": [
        -325.0,
        -2032.0,
        749.8746337890625
      ],
      "bbox_max": [
        -180.0,
        -1942.576416015625,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        -325.0,
        -2032.0,
        749.8746337890625
      ],
      "bbox_max": [
        -187.0,
        -1942.576416015625,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -286.0,
      "bbox_min": [
        -300.0,
        -2032.0,
        749.8746337890625
      ],
      "bbox_max": [
        -187.0,
        -1946.173095703125,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        750.1940307617188
      ],
      "bbox_max": [
        -195.0,
        -1979.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1641.902099609375,
      "bbox_min": [
        -300.0,
        -2032.0,
        769.5819702148438
      ],
      "bbox_max": [
        -290.0,
        -2022.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1972.0,
      "bbox_min": [
        -325.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1992.0,
      "bbox_min": [
        -325.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -325.0,
      "bbox_min": [
        -325.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -320.0,
        -1972.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1634.8309326171875,
      "bbox_min": [
        -325.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -320.0,
        -1972.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1168.1405029296875,
      "bbox_min": [
        -325.0,
        -1977.0,
        768.5
      ],
      "bbox_max": [
        -320.0,
        -1972.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -422.5,
        -2181.5,
        770.0
      ],
      "bbox_max": [
        -134.0,
        -1914.3275146484375,
        863.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -412.0,
        -1972.0,
        770.4967041015625
      ],
      "bbox_max": [
        -348.0,
        -1914.3275146484375,
        853.4234619140625
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 412.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        773.1744384765625
      ],
      "bbox_max": [
        -369.0,
        -1940.635986328125,
        853.31298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1970.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        773.1744384765625
      ],
      "bbox_max": [
        -369.0,
        -1940.635986328125,
        853.31298828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        773.1744384765625
      ],
      "bbox_max": [
        -369.0,
        -1940.635986328125,
        853.31298828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -373.7199401855469,
        -1950.0,
        785.9027709960938
      ],
      "bbox_max": [
        -369.0,
        -1940.635986328125,
        804.3277587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        773.1744384765625
      ],
      "bbox_max": [
        -369.0,
        -1950.0,
        853.31298828125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3979502022266388,
        -0.8249621391296387,
        0.40133896470069885
      ],
      "plane_d": -1778.3778076171875,
      "bbox_min": [
        -398.94171142578125,
        -1969.27099609375,
        773.1744384765625
      ],
      "bbox_max": [
        -369.0,
        -1954.001220703125,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47035908699035645,
        -0.7688663601875305,
        0.4331360161304474
      ],
      "plane_d": -1666.129638671875,
      "bbox_min": [
        -375.3876953125,
        -1958.8970947265625,
        773.1744384765625
      ],
      "bbox_max": [
        -369.0,
        -1954.001220703125,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -371.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -369.0,
        -1950.0,
        853.31298828125
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1962.0,
      "bbox_min": [
        -371.0,
        -1968.0,
        780.0
      ],
      "bbox_max": [
        -369.0,
        -1962.0,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1968.0,
      "bbox_min": [
        -371.0,
        -1968.0,
        780.0
      ],
      "bbox_max": [
        -369.0,
        -1968.0,
        788.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4740998446941376,
        -0.0,
        -0.8804711103439331
      ],
      "plane_d": 544.00927734375,
      "bbox_min": [
        -412.0,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        853.31298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4740998446941376,
        0.0,
        0.8804711103439331
      ],
      "plane_d": -927.6101684570312,
      "bbox_min": [
        -405.1142272949219,
        -1970.0,
        821.4000244140625
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        853.31298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        -0.0,
        0.8804711103439331
      ],
      "plane_d": -544.5374755859375,
      "bbox_min": [
        -404.0,
        -1970.0,
        821.4000244140625
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4740998446941376,
        0.0,
        0.8804711103439331
      ],
      "plane_d": -902.9569702148438,
      "bbox_min": [
        -404.0,
        -1960.0,
        821.4000244140625
      ],
      "bbox_max": [
        -376.8858947753906,
        -1950.0,
        835.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 821.4000244140625,
      "bbox_min": [
        -378.0,
        -1960.0,
        821.4000244140625
      ],
      "bbox_max": [
        -376.8858947753906,
        -1950.0,
        821.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        0.0,
        -0.8804711103439331
      ],
      "plane_d": 927.0819091796875,
      "bbox_min": [
        -404.0,
        -1970.0,
        821.4000244140625
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1960.0,
      "bbox_min": [
        -404.0,
        -1970.0,
        835.699951171875
      ],
      "bbox_max": [
        -376.8856506347656,
        -1950.0,
        850.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        -378.0,
        -1960.0,
        850.0
      ],
      "bbox_max": [
        -376.8856506347656,
        -1950.0,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4740998446941376,
        0.0,
        -0.8804711103439331
      ],
      "plane_d": 568.6624755859375,
      "bbox_min": [
        -378.55712890625,
        -1970.0,
        849.4000244140625
      ],
      "bbox_max": [
        -378.0,
        -1960.0,
        849.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -822.0,
      "bbox_min": [
        -378.0,
        -1970.0,
        821.4000244140625
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 821.4000244140625,
      "bbox_min": [
        -376.8858947753906,
        -1970.0,
        821.4000244140625
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        821.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 849.4000244140625,
      "bbox_min": [
        -378.0,
        -1970.0,
        849.4000244140625
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        -376.8856506347656,
        -1970.0,
        850.0
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -836.0,
      "bbox_min": [
        -405.1142272949219,
        -1970.0,
        836.0
      ],
      "bbox_max": [
        -378.0,
        -1950.0,
        853.31298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4740998446941376,
        0.0,
        -0.8804711103439331
      ],
      "plane_d": 568.6624755859375,
      "bbox_min": [
        -385.2668762207031,
        -1970.0,
        849.7000122070312
      ],
      "bbox_max": [
        -378.0,
        -1960.0,
        853.31298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        0.0,
        0.8804711103439331
      ],
      "plane_d": -569.1907348632812,
      "bbox_min": [
        -384.2406311035156,
        -1970.0,
        849.7000122070312
      ],
      "bbox_max": [
        -378.0,
        -1960.0,
        853.3129272460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1960.0,
      "bbox_min": [
        -384.2406311035156,
        -1960.0,
        849.7000122070312
      ],
      "bbox_max": [
        -378.0,
        -1960.0,
        852.7603759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        -0.0,
        0.8804711103439331
      ],
      "plane_d": -519.88427734375,
      "bbox_min": [
        -412.0,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1960.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        808.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -808.0,
      "bbox_min": [
        -405.1142272949219,
        -1970.0,
        789.6307983398438
      ],
      "bbox_max": [
        -371.0,
        -1960.0,
        808.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        0.0,
        0.6000000238418579
      ],
      "plane_d": -771.0999755859375,
      "bbox_min": [
        -371.4643859863281,
        -1969.5,
        789.6307983398438
      ],
      "bbox_max": [
        -371.0,
        -1960.5,
        790.3082275390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1968.0,
      "bbox_min": [
        -371.4643859863281,
        -1968.0,
        789.6307983398438
      ],
      "bbox_max": [
        -371.0,
        -1960.5,
        790.3082275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1960.5,
      "bbox_min": [
        -371.4643859863281,
        -1960.5,
        789.6307983398438
      ],
      "bbox_max": [
        -371.0,
        -1960.5,
        790.3082275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.4000244140625,
      "bbox_min": [
        -412.0,
        -1970.0,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1960.0,
        808.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -808.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        808.0
      ],
      "bbox_max": [
        -405.11419677734375,
        -1960.0,
        808.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1962.0,
      "bbox_min": [
        -372.5,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1960.5,
        789.880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1960.5,
      "bbox_min": [
        -372.5,
        -1962.0,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1960.5,
        789.880859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -372.5,
      "bbox_min": [
        -372.5,
        -1962.0,
        780.0
      ],
      "bbox_max": [
        -371.4643859863281,
        -1960.5,
        789.880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        0.0,
        0.6000000238418579
      ],
      "plane_d": -771.0999755859375,
      "bbox_min": [
        -372.5,
        -1962.0,
        788.5
      ],
      "bbox_max": [
        -371.4643859863281,
        -1960.5,
        789.880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1968.0,
      "bbox_min": [
        -372.5,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -371.0,
        -1968.0,
        789.880859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -372.5,
      "bbox_min": [
        -372.5,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -371.4643859863281,
        -1968.0,
        789.880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        0.0,
        0.6000000238418579
      ],
      "plane_d": -771.0999755859375,
      "bbox_min": [
        -372.5,
        -1969.5,
        788.5
      ],
      "bbox_max": [
        -371.4643859863281,
        -1968.0,
        789.880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45812103152275085,
        0.0,
        0.8888899087905884
      ],
      "plane_d": -878.9483642578125,
      "bbox_min": [
        -407.7602233886719,
        -1960.0,
        786.9506225585938
      ],
      "bbox_max": [
        -378.0,
        -1950.0,
        808.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -808.0,
      "bbox_min": [
        -407.7602233886719,
        -1960.0,
        807.4000244140625
      ],
      "bbox_max": [
        -403.44293212890625,
        -1957.7105712890625,
        808.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.4000244140625,
      "bbox_min": [
        -407.3018493652344,
        -1960.0,
        807.4000244140625
      ],
      "bbox_max": [
        -403.44293212890625,
        -1957.7105712890625,
        807.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        0.0,
        -0.8804711103439331
      ],
      "plane_d": 902.4287109375,
      "bbox_min": [
        -404.0,
        -1960.0,
        807.4000244140625
      ],
      "bbox_max": [
        -403.44293212890625,
        -1957.7105712890625,
        807.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        0.0,
        -0.8804711103439331
      ],
      "plane_d": 902.4287109375,
      "bbox_min": [
        -412.0,
        -1970.0,
        790.2307739257812
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4740998446941376,
        0.0,
        0.8804711103439331
      ],
      "plane_d": -902.9569702148438,
      "bbox_min": [
        -412.0,
        -1960.0,
        808.0
      ],
      "bbox_max": [
        -378.55706787109375,
        -1950.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 835.4000244140625,
      "bbox_min": [
        -412.0,
        -1960.0,
        835.4000244140625
      ],
      "bbox_max": [
        -404.0,
        -1950.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -836.0,
      "bbox_min": [
        -412.0,
        -1960.0,
        836.0
      ],
      "bbox_max": [
        -405.1142272949219,
        -1950.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 835.4000244140625,
      "bbox_min": [
        -412.0,
        -1970.0,
        835.4000244140625
      ],
      "bbox_max": [
        -404.0,
        -1960.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -836.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        836.0
      ],
      "bbox_max": [
        -405.1142272949219,
        -1960.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -794.0,
      "bbox_min": [
        -378.0,
        -1970.0,
        790.2307739257812
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        0.0,
        0.6000000238418579
      ],
      "plane_d": -771.0999755859375,
      "bbox_min": [
        -371.14385986328125,
        -1969.5,
        790.2307739257812
      ],
      "bbox_max": [
        -371.0,
        -1960.5,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1968.0,
      "bbox_min": [
        -371.14385986328125,
        -1968.0,
        790.2307739257812
      ],
      "bbox_max": [
        -371.0,
        -1960.5,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1960.5,
      "bbox_min": [
        -371.14385986328125,
        -1960.5,
        790.2307739257812
      ],
      "bbox_max": [
        -371.0,
        -1960.5,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        770.4967041015625
      ],
      "bbox_max": [
        -348.0,
        -1914.3275146484375,
        851.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -348.0,
        -1928.0,
        818.5172119140625
      ],
      "bbox_max": [
        -348.0,
        -1914.3275146484375,
        850.9920654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -369.0,
        -1972.0,
        770.4967041015625
      ],
      "bbox_max": [
        -349.0,
        -1939.5059814453125,
        802.5250854492188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -349.0,
        -1960.0,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.44721364974975586,
        0.0
      ],
      "plane_d": 1194.0604248046875,
      "bbox_min": [
        -355.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -349.0,
        -1960.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1962.0,
      "bbox_min": [
        -369.0,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1960.5,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1960.5,
      "bbox_min": [
        -369.0,
        -1962.0,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1960.5,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 367.5,
      "bbox_min": [
        -369.0,
        -1962.0,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1960.5,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.800000011920929,
        -0.0,
        0.6000000238418579
      ],
      "plane_d": -179.10000610351562,
      "bbox_min": [
        -369.0,
        -1962.0,
        788.5
      ],
      "bbox_max": [
        -367.5,
        -1960.5,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1969.5,
      "bbox_min": [
        -369.0,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1968.0,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1968.0,
      "bbox_min": [
        -369.0,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1968.0,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 367.5,
      "bbox_min": [
        -369.0,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1968.0,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.800000011920929,
        -0.0,
        0.6000000238418579
      ],
      "plane_d": -179.10000610351562,
      "bbox_min": [
        -369.0,
        -1969.5,
        788.5
      ],
      "bbox_max": [
        -367.5,
        -1968.0,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1950.0,
        839.5380859375
      ],
      "bbox_max": [
        -414.0,
        -1949.3543701171875,
        852.2078247070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1950.0,
        850.6633911132812
      ],
      "bbox_max": [
        -422.5,
        -1949.3543701171875,
        852.2078247070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -418.30963134765625,
        -2181.5,
        770.0
      ],
      "bbox_max": [
        -134.0,
        -1972.0,
        863.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -418.30963134765625,
        -1987.0,
        770.0
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        788.12158203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1977.0,
      "bbox_min": [
        -366.0,
        -1987.0,
        770.0
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4179060757160187,
        0.0,
        0.9084903001785278
      ],
      "plane_d": -574.8924560546875,
      "bbox_min": [
        -362.6666564941406,
        -1987.0,
        770.0
      ],
      "bbox_max": [
        -300.0,
        -1977.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40273821353912354,
        0.0,
        -0.9153153300285339
      ],
      "plane_d": 583.9713745117188,
      "bbox_min": [
        -362.6666564941406,
        -1987.0,
        770.0
      ],
      "bbox_max": [
        -300.0,
        -1977.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        -0.5547002553939819,
        0.0
      ],
      "plane_d": -1398.3994140625,
      "bbox_min": [
        -362.6666564941406,
        -1987.0,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1977.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -324.0,
      "bbox_min": [
        -324.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1977.400146484375,
        778.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1986.60009765625,
      "bbox_min": [
        -324.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1977.400146484375,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1977.400146484375,
      "bbox_min": [
        -324.0,
        -1977.400146484375,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1977.400146484375,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        -0.5547002553939819,
        0.0
      ],
      "plane_d": -1398.3994140625,
      "bbox_min": [
        -366.0,
        -1977.0,
        778.7999267578125
      ],
      "bbox_max": [
        -346.5,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.44721364974975586,
        0.0
      ],
      "plane_d": 1194.0604248046875,
      "bbox_min": [
        -349.0,
        -1977.0,
        778.7999267578125
      ],
      "bbox_max": [
        -346.5,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794647693634033,
        -0.8249639868736267,
        0.40133899450302124
      ],
      "plane_d": -1778.383056640625,
      "bbox_min": [
        -418.30963134765625,
        -1976.85595703125,
        780.0999145507812
      ],
      "bbox_max": [
        -405.90997314453125,
        -1972.0,
        788.12158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        -0.5900004506111145
      ],
      "plane_d": 2268.16015625,
      "bbox_min": [
        -261.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -863.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -261.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -146.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -146.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -261.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -547.7910766601562,
        -2217.946533203125,
        849.5204467773438
      ],
      "bbox_max": [
        63.3701171875,
        -1895.00830078125,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -348.0,
        -1914.3275146484375,
        849.728515625
      ],
      "bbox_max": [
        -348.0,
        -1905.1326904296875,
        871.5677490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -547.7910766601562,
        -2017.629638671875,
        851.4326171875
      ],
      "bbox_max": [
        -422.5,
        -1935.971435546875,
        880.5703735351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4577594995498657,
        -0.8173955082893372,
        0.3497438430786133
      ],
      "plane_d": -1698.0321044921875,
      "bbox_min": [
        -528.131103515625,
        -2003.739501953125,
        851.4326171875
      ],
      "bbox_max": [
        -422.5,
        -1935.971435546875,
        880.5703735351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -433.3038635253906,
        -1945.0406494140625,
        851.4326171875
      ],
      "bbox_max": [
        -422.5,
        -1935.971435546875,
        880.5703735351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -430.0,
        -1945.0406494140625,
        851.5999755859375
      ],
      "bbox_max": [
        -422.5,
        -1939.0,
        871.3511352539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1945.0406494140625,
        851.5999755859375
      ],
      "bbox_max": [
        -422.5,
        -1939.0,
        862.8701782226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.138129323720932,
        0.9765928387641907,
        0.16488416492938995
      ],
      "plane_d": 2002.7279052734375,
      "bbox_min": [
        -435.970703125,
        -2217.946533203125,
        849.5204467773438
      ],
      "bbox_max": [
        63.3701171875,
        -1895.00830078125,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24286268651485443,
        0.915098249912262,
        0.3218894898891449
      ],
      "plane_d": 1720.4425048828125,
      "bbox_min": [
        2.2432632446289062,
        -2217.946533203125,
        934.54248046875
      ],
      "bbox_max": [
        63.3701171875,
        -2206.544921875,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1938.9998779296875,
      "bbox_min": [
        -435.970703125,
        -1972.0,
        849.5204467773438
      ],
      "bbox_max": [
        -253.52130126953125,
        -1895.00830078125,
        975.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -435.970703125,
        -1939.0,
        849.5204467773438
      ],
      "bbox_max": [
        -253.52130126953125,
        -1895.00830078125,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        -435.970703125,
        -1939.0,
        849.5204467773438
      ],
      "bbox_max": [
        -253.52130126953125,
        -1895.00830078125,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -435.970703125,
        -1939.0,
        871.3511352539062
      ],
      "bbox_max": [
        -430.0,
        -1935.971435546875,
        880.78662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39795103669166565,
        -0.8249620795249939,
        0.40133827924728394
      ],
      "plane_d": -1778.376953125,
      "bbox_min": [
        -435.970703125,
        -1939.0,
        873.3723754882812
      ],
      "bbox_max": [
        -431.5664367675781,
        -1937.517578125,
        880.78662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        849.5204467773438
      ],
      "bbox_max": [
        -253.52130126953125,
        -1895.00830078125,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        850.236572265625
      ],
      "bbox_max": [
        -348.0,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320502638816833,
        -0.0,
        0.5547001957893372
      ],
      "plane_d": -216.33306884765625,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        871.6710205078125
      ],
      "bbox_max": [
        -348.0,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 921.0,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        871.6710205078125
      ],
      "bbox_max": [
        -348.0,
        -1907.9049072265625,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6160963773727417,
        -0.6721051335334778,
        0.41073092818260193
      ],
      "plane_d": -1456.00390625,
      "bbox_min": [
        -360.0,
        -1933.5,
        921.0
      ],
      "bbox_max": [
        -354.0,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1928.0,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        871.6710205078125
      ],
      "bbox_max": [
        -348.0,
        -1907.9049072265625,
        921.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        871.6710205078125
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        921.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -1719.903564453125,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        871.6710205078125
      ],
      "bbox_max": [
        -430.0,
        -1935.971435546875,
        892.0023193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 904.0,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        892.0
      ],
      "bbox_max": [
        -395.0,
        -1928.0,
        920.089599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -433.3038635253906,
        -1939.0,
        912.0
      ],
      "bbox_max": [
        -430.0,
        -1934.0562744140625,
        920.089599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1931.5,
      "bbox_min": [
        -415.0,
        -1939.0,
        892.0
      ],
      "bbox_max": [
        -395.0,
        -1928.0,
        904.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 770.1018676757812,
      "bbox_min": [
        -415.0,
        -1939.0,
        892.0
      ],
      "bbox_max": [
        -395.0,
        -1931.5,
        902.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.911921501159668,
        -0.0,
        -0.41036465764045715
      ],
      "plane_d": 5.8363037109375,
      "bbox_min": [
        -415.0,
        -1939.0,
        892.0
      ],
      "bbox_max": [
        -395.0,
        -1931.5,
        902.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 902.0,
      "bbox_min": [
        -415.0,
        -1939.0,
        892.0
      ],
      "bbox_max": [
        -395.0,
        -1931.5,
        902.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1934.5,
      "bbox_min": [
        -415.0,
        -1934.5,
        892.0
      ],
      "bbox_max": [
        -395.0,
        -1931.5,
        902.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 900.5,
      "bbox_min": [
        -409.5,
        -1934.5,
        892.0
      ],
      "bbox_max": [
        -400.0,
        -1931.5,
        900.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 409.5,
      "bbox_min": [
        -409.5,
        -1934.5,
        892.0
      ],
      "bbox_max": [
        -400.0,
        -1931.5,
        900.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        -400.0,
        -1934.5,
        892.0
      ],
      "bbox_max": [
        -400.0,
        -1931.5,
        900.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 412.5,
      "bbox_min": [
        -412.5,
        -1931.5,
        892.0
      ],
      "bbox_max": [
        -396.5,
        -1928.0,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -396.5,
      "bbox_min": [
        -396.5,
        -1931.5,
        892.0
      ],
      "bbox_max": [
        -396.5,
        -1928.0,
        904.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -893.5,
      "bbox_min": [
        -412.5,
        -1928.0,
        892.0
      ],
      "bbox_max": [
        -365.0,
        -1907.9049072265625,
        921.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -396.4999694824219,
      "bbox_min": [
        -412.5,
        -1928.0,
        892.0
      ],
      "bbox_max": [
        -396.5,
        -1914.6351318359375,
        893.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 412.5,
      "bbox_min": [
        -412.5,
        -1928.0,
        892.0
      ],
      "bbox_max": [
        -396.5,
        -1919.0,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9032753705978394,
        0.0,
        -0.42906132340431213
      ],
      "plane_d": 24.574005126953125,
      "bbox_min": [
        -397.2125244140625,
        -1920.5,
        892.0
      ],
      "bbox_max": [
        -396.5,
        -1919.0,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1920.5,
      "bbox_min": [
        -397.2125244140625,
        -1920.5,
        892.0
      ],
      "bbox_max": [
        -396.5,
        -1919.0,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 1919.0,
      "bbox_min": [
        -397.2125244140625,
        -1919.0,
        892.0
      ],
      "bbox_max": [
        -396.5,
        -1919.0,
        893.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1911.0,
      "bbox_min": [
        -412.5,
        -1928.0,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1907.9049072265625,
        921.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        -383.98052978515625,
        -1911.0,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1907.9049072265625,
        921.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -383.98052978515625,
        -1911.0,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1910.0,
        921.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -383.0,
      "bbox_min": [
        -383.98052978515625,
        -1911.0,
        894.4956665039062
      ],
      "bbox_max": [
        -383.0,
        -1910.840087890625,
        902.6293334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8865849375724792,
        0.0,
        0.4625660479068756
      ],
      "plane_d": -754.1947021484375,
      "bbox_min": [
        -383.98052978515625,
        -1911.0,
        894.4956665039062
      ],
      "bbox_max": [
        -383.0,
        -1910.840087890625,
        902.6293334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8865849375724792,
        0.0,
        -0.4625660479068756
      ],
      "plane_d": 77.09432983398438,
      "bbox_min": [
        -383.98052978515625,
        -1911.0,
        900.75
      ],
      "bbox_max": [
        -383.0,
        -1910.840087890625,
        902.6293334960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9899495244026184,
        0.0,
        -0.1414213627576828
      ],
      "plane_d": 495.04547119140625,
      "bbox_min": [
        -377.84716796875,
        -1910.0,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1907.9049072265625,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 903.5,
      "bbox_min": [
        -377.84716796875,
        -1910.0,
        903.5
      ],
      "bbox_max": [
        -370.50762939453125,
        -1908.8031005859375,
        906.9466552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9983712434768677,
        -0.05704978480935097
      ],
      "plane_d": 1957.4351806640625,
      "bbox_min": [
        -371.7152099609375,
        -1909.0,
        903.5
      ],
      "bbox_max": [
        -370.50762939453125,
        -1908.8031005859375,
        906.9466552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -365.0,
        -1910.0,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1907.9049072265625,
        921.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9899495244026184,
        -0.0,
        -0.1414213627576828
      ],
      "plane_d": -247.41665649414062,
      "bbox_min": [
        -412.5,
        -1928.0,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1911.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9899495244026184,
        0.0,
        -0.1414213627576828
      ],
      "plane_d": 495.04547119140625,
      "bbox_min": [
        -379.0,
        -1928.0,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1911.0,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 903.5,
      "bbox_min": [
        -379.0,
        -1928.0,
        903.5
      ],
      "bbox_max": [
        -371.0,
        -1911.0,
        903.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -365.0,
      "bbox_min": [
        -365.0,
        -1928.0,
        893.5
      ],
      "bbox_max": [
        -365.0,
        -1911.0,
        921.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 904.0,
      "bbox_min": [
        -412.5,
        -1928.0,
        893.5
      ],
      "bbox_max": [
        -395.0,
        -1913.7655029296875,
        921.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 395.0,
      "bbox_min": [
        -395.0,
        -1928.0,
        904.0
      ],
      "bbox_max": [
        -395.0,
        -1913.765625,
        921.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 395.0,
      "bbox_min": [
        -396.5,
        -1928.0,
        893.5
      ],
      "bbox_max": [
        -395.0,
        -1913.7655029296875,
        904.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 902.0,
      "bbox_min": [
        -396.5,
        -1919.0,
        902.0
      ],
      "bbox_max": [
        -395.0,
        -1913.7655029296875,
        902.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 412.5,
      "bbox_min": [
        -412.5,
        -1928.0,
        893.5
      ],
      "bbox_max": [
        -396.5,
        -1919.0,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1920.5,
      "bbox_min": [
        -398.4000244140625,
        -1920.5,
        893.5
      ],
      "bbox_max": [
        -396.5,
        -1919.0,
        904.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 1919.0,
      "bbox_min": [
        -398.4000244140625,
        -1920.5,
        893.5
      ],
      "bbox_max": [
        -396.5,
        -1919.0,
        904.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9032753705978394,
        0.0,
        0.42906132340431213
      ],
      "plane_d": -746.0201416015625,
      "bbox_min": [
        -398.4000244140625,
        -1920.5,
        893.5
      ],
      "bbox_max": [
        -396.5,
        -1919.0,
        904.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -398.4000244140625,
      "bbox_min": [
        -398.4000244140625,
        -1920.5,
        893.5
      ],
      "bbox_max": [
        -397.2125244140625,
        -1919.0,
        900.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9032753705978394,
        0.0,
        -0.42906132340431213
      ],
      "plane_d": 24.574005126953125,
      "bbox_min": [
        -398.4000244140625,
        -1920.5,
        893.5
      ],
      "bbox_max": [
        -397.2125244140625,
        -1919.0,
        896.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02143726870417595,
        -0.8702447414398193,
        0.49215301871299744
      ],
      "plane_d": -2067.314453125,
      "bbox_min": [
        -289.98388671875,
        -1902.015869140625,
        849.5204467773438
      ],
      "bbox_max": [
        -253.52130126953125,
        -1895.00830078125,
        862.176513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06079954281449318,
        -0.8831871151924133,
        0.4650632441043854
      ],
      "plane_d": -2091.9970703125,
      "bbox_min": [
        -289.98388671875,
        -1902.015869140625,
        849.5217895507812
      ],
      "bbox_max": [
        -280.6551818847656,
        -1895.00830078125,
        862.176513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06320825219154358,
        0.990262508392334,
        0.12403613328933716
      ],
      "plane_d": 1743.04345703125,
      "bbox_min": [
        -341.83099365234375,
        -1904.1265869140625,
        974.0792236328125
      ],
      "bbox_max": [
        -340.5271911621094,
        -1903.9140625,
        975.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9128968119621277,
        0.3866746425628662,
        0.13077570497989655
      ],
      "plane_d": 297.8227844238281,
      "bbox_min": [
        -340.66888427734375,
        -1904.0469970703125,
        974.0792236328125
      ],
      "bbox_max": [
        -340.5271911621094,
        -1903.9140625,
        975.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -433.3614501953125,
        -1972.0,
        851.5999755859375
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        896.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -433.3614501953125,
        -1972.0,
        851.5999755859375
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        896.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -433.3614501953125,
        -1972.0,
        851.5999755859375
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        892.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -433.3614501953125,
        -1950.0,
        851.5999755859375
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -433.3614501953125,
        -1950.0,
        851.5999755859375
      ],
      "bbox_max": [
        -411.5170593261719,
        -1939.0,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39795103669166565,
        -0.8249620795249939,
        0.40133827924728394
      ],
      "plane_d": -1778.376953125,
      "bbox_min": [
        -422.5,
        -1945.055908203125,
        851.837890625
      ],
      "bbox_max": [
        -418.7743835449219,
        -1942.0516357421875,
        858.1096801757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39795103669166565,
        -0.8249620795249939,
        0.40133827924728394
      ],
      "plane_d": -1778.376953125,
      "bbox_min": [
        -433.3614501953125,
        -1945.10791015625,
        851.9346313476562
      ],
      "bbox_max": [
        -422.5,
        -1939.0,
        875.1522827148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703570008277893,
        -0.7688688039779663,
        0.433133989572525
      ],
      "plane_d": -1666.133544921875,
      "bbox_min": [
        -431.5664367675781,
        -1942.0516357421875,
        858.1096801757812
      ],
      "bbox_max": [
        -422.5,
        -1939.0,
        873.3723754882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1970.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        852.2078247070312
      ],
      "bbox_max": [
        -369.0,
        -1950.0,
        892.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        853.3129272460938
      ],
      "bbox_max": [
        -369.0,
        -1970.0,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        853.3129272460938
      ],
      "bbox_max": [
        -369.0,
        -1970.0,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -414.0,
        -1970.0,
        852.2078247070312
      ],
      "bbox_max": [
        -369.0,
        -1950.0,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -371.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        852.2078247070312
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        892.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 891.4000244140625,
      "bbox_min": [
        -412.0,
        -1970.0,
        852.7603149414062
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        892.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1960.0,
      "bbox_min": [
        -404.0,
        -1970.0,
        891.4000244140625
      ],
      "bbox_max": [
        -371.0,
        -1960.0,
        892.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4740998446941376,
        -0.0,
        0.8804711103439331
      ],
      "plane_d": -593.8438720703125,
      "bbox_min": [
        -404.0,
        -1970.0,
        891.4000244140625
      ],
      "bbox_max": [
        -402.8857727050781,
        -1960.0,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4740998446941376,
        -0.0,
        -0.8804711103439331
      ],
      "plane_d": 593.315673828125,
      "bbox_min": [
        -412.0,
        -1970.0,
        852.7603149414062
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        891.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        -0.0,
        0.8804711103439331
      ],
      "plane_d": -593.8438720703125,
      "bbox_min": [
        -404.0,
        -1970.0,
        877.4000244140625
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        891.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 1960.0,
      "bbox_min": [
        -404.0,
        -1970.0,
        877.4000244140625
      ],
      "bbox_max": [
        -376.8858947753906,
        -1950.0,
        891.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 877.4000244140625,
      "bbox_min": [
        -378.0,
        -1970.0,
        877.4000244140625
      ],
      "bbox_max": [
        -376.8858947753906,
        -1960.0,
        877.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4740998446941376,
        0.0,
        0.8804711103439331
      ],
      "plane_d": -952.263427734375,
      "bbox_min": [
        -378.55706787109375,
        -1960.0,
        877.7000732421875
      ],
      "bbox_max": [
        -378.0,
        -1950.0,
        878.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -878.0,
      "bbox_min": [
        -378.0,
        -1970.0,
        877.4000244140625
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        878.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 877.4000244140625,
      "bbox_min": [
        -376.8858947753906,
        -1970.0,
        877.4000244140625
      ],
      "bbox_max": [
        -371.0,
        -1950.0,
        877.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4740998446941376,
        0.0,
        0.8804711103439331
      ],
      "plane_d": -952.263427734375,
      "bbox_min": [
        -412.0,
        -1970.0,
        852.7603149414062
      ],
      "bbox_max": [
        -378.0,
        -1950.0,
        877.7000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        0.0,
        -0.8804711103439331
      ],
      "plane_d": 951.735107421875,
      "bbox_min": [
        -405.1143493652344,
        -1970.0,
        852.7603149414062
      ],
      "bbox_max": [
        -378.0,
        -1950.0,
        877.7000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1960.0,
      "bbox_min": [
        -405.1143493652344,
        -1970.0,
        863.4000244140625
      ],
      "bbox_max": [
        -378.0,
        -1950.0,
        877.7000732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 863.4000244140625,
      "bbox_min": [
        -405.1143493652344,
        -1960.0,
        863.4000244140625
      ],
      "bbox_max": [
        -404.0,
        -1950.0,
        863.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        0.0,
        0.8804711103439331
      ],
      "plane_d": -569.1907348632812,
      "bbox_min": [
        -404.0,
        -1970.0,
        863.7000122070312
      ],
      "bbox_max": [
        -403.44287109375,
        -1960.0,
        864.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4740998446941376,
        0.0,
        0.8804711103439331
      ],
      "plane_d": -569.1907348632812,
      "bbox_min": [
        -404.0,
        -1970.0,
        852.7603149414062
      ],
      "bbox_max": [
        -383.1263122558594,
        -1960.0,
        863.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4740998446941376,
        0.0,
        -0.8804711103439331
      ],
      "plane_d": 568.6624755859375,
      "bbox_min": [
        -404.0,
        -1970.0,
        852.7603149414062
      ],
      "bbox_max": [
        -383.1263122558594,
        -1960.0,
        863.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1960.0,
      "bbox_min": [
        -404.0,
        -1960.0,
        852.7603149414062
      ],
      "bbox_max": [
        -383.1263122558594,
        -1960.0,
        863.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -864.0,
      "bbox_min": [
        -412.0,
        -1970.0,
        863.4000244140625
      ],
      "bbox_max": [
        -404.0,
        -1950.0,
        864.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 863.4000244140625,
      "bbox_min": [
        -412.0,
        -1970.0,
        863.4000244140625
      ],
      "bbox_max": [
        -405.1143493652344,
        -1950.0,
        863.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -895.9999389648438,
      "bbox_min": [
        -422.5,
        -1972.0,
        892.0
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        896.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1971.0,
      "bbox_min": [
        -422.5,
        -1972.0,
        892.0
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        896.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        892.0
      ],
      "bbox_max": [
        -369.0,
        -1971.0,
        896.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        892.0
      ],
      "bbox_max": [
        -369.0,
        -1971.0,
        896.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        -422.5,
        -1971.0,
        892.0
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        896.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1971.0,
        892.0
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        896.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 413.0,
      "bbox_min": [
        -422.5,
        -1971.0,
        892.0
      ],
      "bbox_max": [
        -413.0,
        -1939.0,
        896.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -414.0,
      "bbox_min": [
        -422.5,
        -1971.0,
        892.0
      ],
      "bbox_max": [
        -413.0,
        -1939.0,
        896.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1949.0,
      "bbox_min": [
        -414.0,
        -1949.0,
        892.0
      ],
      "bbox_max": [
        -413.0,
        -1949.0,
        896.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -422.5,
      "bbox_min": [
        -422.5,
        -1950.0,
        892.0
      ],
      "bbox_max": [
        -414.0,
        -1939.0,
        896.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1950.0,
      "bbox_min": [
        -422.5,
        -1950.0,
        892.0
      ],
      "bbox_max": [
        -414.0,
        -1939.0,
        896.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 421.39990234375,
      "bbox_min": [
        -421.39990234375,
        -1949.0,
        892.0
      ],
      "bbox_max": [
        -414.0,
        -1939.0,
        896.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 1949.0,
      "bbox_min": [
        -421.39990234375,
        -1949.0,
        892.0
      ],
      "bbox_max": [
        -414.0,
        -1949.0,
        896.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: satdr2",
      "entity_class": "CSlidingDoor",
      "piece_name": "satdr2",
      "offset": 598,
      "centroid": [
        -404.75,
        -1933.0,
        896.25
      ],
      "bbox_min": [
        -409.5,
        -1934.0,
        892.0
      ],
      "bbox_max": [
        -400.0,
        -1932.0,
        900.5
      ],
      "dimensions_source": {
        "span_x": 9.5,
        "span_y": 2.0,
        "height_z": 8.5,
        "door_width": 9.5,
        "door_depth": 2.0,
        "leaf_depth": 1.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -409.5,
          -1934.0,
          892.0
        ],
        [
          -409.5,
          -1932.0,
          892.0
        ],
        [
          -400.0,
          -1934.0,
          892.0
        ],
        [
          -400.0,
          -1932.0,
          892.0
        ],
        [
          -400.0,
          -1934.0,
          900.5
        ],
        [
          -400.0,
          -1932.0,
          900.5
        ],
        [
          -409.5,
          -1934.0,
          900.5
        ],
        [
          -409.5,
          -1932.0,
          900.5
        ]
      ],
      "plane_distance": 892.0,
      "authentic_texture": "chkptdoor1"
    }
  ],
  "tutorial_messages": []
}